/**
 * Kullanıcıya görünen tüm Türkçe metinler.
 * Anahtar: `alan.kavram` biçiminde, İngilizce. Değer: Türkçe.
 * Faz ilerledikçe prototipteki (docs/prototip/) metinler buraya taşınır.
 */
export const tr = {
  // Genel
  'common.appName': 'AquaBox',
  'logo.tagline': 'Sisteme aksın',
  'common.ok': 'Tamam',
  'common.cancel': 'Vazgeç',
  'common.save': 'Kaydet',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.search': 'Ara',
  'common.loading': 'Yükleniyor…',
  'common.confirm': 'Onayla',
  'common.error': 'Hata oluştu.',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.unknown': 'Bilinmiyor',

  // Biçim — kısaltma ekleri (panel ortak biçim yardımcıları, `packages/shared/src/format.ts`)
  'format.thousand': 'bin',
  'format.million': 'mn',

  // Hatalar
  'error.unauthorized': 'Oturum açmanız gerekiyor.',
  'error.forbidden': 'Bu işlem için yetkiniz yok.',
  'error.notFound': 'Kayıt bulunamadı.',
  'error.validation': 'Girilen bilgiler geçersiz.',
  'error.tooManyRequests': 'Çok fazla deneme yaptınız, biraz bekleyin.',
  'reload.rejectReasonRequired': 'Reddetme gerekçesi zorunludur.',
  'approval.cashTitle': '{driver} nakit teslimi',
  'approval.cashDetail': '{plate} · kapanışta depoya bırakıldı',
  'approval.reloadTitle': '{plate} ara {direction}',
  'approval.reloadAdd': 'yükleme',
  'approval.reloadRemove': 'boşaltma',
  'notification.reloadTitle': 'Ara yükleme onayı bekliyor · {plate}',
  'notification.reloadBody': '{qty} damacana · depo sayımı bekliyor',
  'notification.varianceTitle': 'Sefer farkla kapandı · {plate}',
  'notification.varianceBody': 'Dolu farkı {full} · boş farkı {empty} · yabancı farkı {foreign}',
  // Koli farkı damacana "Dolu farkı"na katılmaz; yalnız koli farkı varsa gövdeye eklenir.
  'notification.varianceCaseSuffix': ' · koli farkı {cases}',
  'notification.deliveryDeviationTitle': 'Teslimat sapması · {plate}',
  'notification.deliveryDeviationBody': '{kind} · {qty} adet',
  'notification.deliveryPhotoMissingTitle': 'Eksik teslimat fotoğrafı · {plate}',
  'notification.deliveryPhotoMissingBody': '{count} teslimat fotoğrafı sunucuya ulaşmadı.',
  'approval.deliveryDeviationTitle': 'Teslimat sapması · {plate}',
  'notification.pinResetTitle': 'Şoför PIN sıfırlama isteği',
  'notification.pinResetBody': 'Şoför PIN sıfırlama istedi. Onaylarsanız yeni geçici PIN üretilir.',
  'notification.staffPhoneMissing.title': '{name} eklendi, telefonunu girin',
  'notification.staffPhoneMissing.body':
    'Telefonsuz personel eklendi; giriş için telefonunu girin.',
  'notification.voidTitle': 'Sefer iptal edildi · {plate}',
  'notification.voidBody': 'Defter satırları terslendi.',
  // Okuma imleci (`GET /api/notifications?since=`): bozuk/çözülemeyen imleç 400.
  'notification.invalidCursor': 'Okuma imleci geçersiz.',
  // Test bildirimi (`POST /api/notifications/test`): çağıranın kendisine yazılır.
  'notification.test.title': 'Test bildirimi',
  'notification.test.body':
    'Bu bir test bildirimidir. Bildirimler düzgün görünüyorsa her şey yolundadır.',
  'notification.test.tooMany': 'Çok sık test bildirimi gönderdin; bir dakika sonra yeniden dene.',
  // Patron/yönetici → şoför kısa mesaj (POST /api/notifications/driver-message).
  // Şablon metinleri sabit; serbest `text` panelde yazıldığı için çeviri anahtarı
  // yoktur. `exactlyOne` gövde şemasının "ikisinden biri" hatasında döner; `tooMany`
  // 429, `driverNotFound` 404 mesajıdır.
  'driverMessage.title': 'Patrondan mesaj',
  'driverMessage.template.CALL_ME': 'Beni ara.',
  'driverMessage.template.RETURN_TO_DEPOT': 'Depoya dön.',
  'driverMessage.template.URGENT_ORDER': 'Acil sipariş var, listene bak.',
  'driverMessage.template.CHECK_CASH': 'Kasanı kontrol et.',
  'driverMessage.exactlyOne': 'Şablon ya da metinden yalnız birini gönder.',
  'driverMessage.tooMany': 'Bu şoföre çok sık mesaj gönderildi; bir dakika sonra yeniden dene.',
  'driverMessage.driverNotFound': 'Şoför bulunamadı.',
  // Şoför → patron/yönetici kısa mesaj (POST /api/notifications/owner-message).
  // `body` şoför adını taşır: alıcı OWNER/MANAGER, ad iş ilişkisi verisidir
  // (notification-kvkk.spec.ts'te gerekçeli istisna).
  'ownerMessage.title': 'Şoförden mesaj',
  'ownerMessage.body': '{name}: {message}',
  'ownerMessage.template.RUNNING_LATE': 'Gecikeceğim.',
  'ownerMessage.template.CALL_ME': 'Beni ara.',
  'ownerMessage.template.VEHICLE_PROBLEM': 'Araçta sorun var.',
  'ownerMessage.template.ADDRESS_HELP': 'Adresi bulamıyorum, yardım lazım.',
  'ownerMessage.template.CUSTOMER_WAITING': 'Müşteri yok, bekliyorum.',
  'ownerMessage.template.ON_MY_WAY_BACK': 'Depoya dönüyorum.',
  'ownerMessage.tooMany': 'Çok sık mesaj gönderdin; bir dakika sonra yeniden dene.',
  'ownerMessage.noRecipients': 'Mesajı alacak patron ya da yönetici bulunamadı.',
  'ownerMessage.driverNotFound': 'Şoför kaydın bulunamadı.',
  'kvkk.anonymizedName': 'Anonimleştirilmiş müşteri',
  'kvkk.anonymizedAddress': 'Anonimleştirilmiş adres',
  'error.title': 'Hata',
  'error.internal': 'Beklenmeyen bir hata oluştu.',
  'error.serverUnavailable': 'Sunucuya şu an ulaşılamıyor. Biraz sonra tekrar dene.',
  'error.recordImmutable': 'Bu kayıt silinemez; düzeltme yeni satır olarak eklenir.',
  'error.badRequest': 'İstek geçersiz.',
  // P2: personel kapısı. OWNER/MANAGER `driver/profile` açmadan sefer açamaz / sipariş çalışamaz.
  'error.noPersonnelProfile': 'Bu işlem için önce kendi personel (saha) profilini açmalısın.',
  'error.conflict': 'Bu kayıt zaten var.',
  'error.serverUnreachable.title': 'Sunucuya ulaşılamıyor',
  'error.serverUnreachable.body': 'Denenen adres: {url}',
  'error.serverUnreachable.retry': 'Tekrar dene',

  // Ürün
  'product.nameTaken': 'Bu adda bir ürün zaten var.',
  'product.inUse': 'Bu ürün siparişlerde kullanılıyor; silinemez, pasife alınır.',

  // Ürünler ekranı — damacana/koli ayrımı ve geçmişten fiyat öner (bkz. apps/panel/src/screens/Products.tsx)
  'products.groupJugs': 'Damacana',
  'products.groupCases': 'Koli ve pet su',
  'products.pending': 'Fiyat bekliyor',
  'priceSuggest.button': 'Geçmişten fiyat öner',
  'priceSuggest.title': 'Geçmişten fiyat öner',
  'priceSuggest.colProduct': 'Ürün',
  'priceSuggest.colSuggested': 'Önerilen fiyat',
  'priceSuggest.colChannels': 'Kanal fiyatları',
  'priceSuggest.colSamples': 'Örnek sayısı',
  'priceSuggest.apply': 'Uygula',
  'priceSuggest.applied': '{name} fiyatı {price} olarak yazıldı.',
  'priceSuggest.noData': 'Geçmişte veri yok',
  'priceSuggest.close': 'Kapat',
  'priceSuggest.loading': 'Geçmiş siparişler taranıyor…',
  'products.catalogItemNotFound': 'Bu satır kanalın ürün listesinde yok; kataloğu yenileyin.',
  'products.catalogInvalid': 'Kanaldan gelen ürün listesi beklenen biçimde değil; kayıt yapılmadı.',
  'products.catalogParseFailed': 'Kanalın ürün listesi okunamadı; panel arayüzü değişmiş olabilir.',
  'products.intro': 'Her ürün tek satırda: satış fiyatı, depozito ve kanal panellerindeki fiyatı birlikte görünür.',
  'products.colName': 'Ürün',
  'products.colPrice': 'Satış fiyatı',
  'products.colDeposit': 'Depozito',
  'products.colHayat': 'Hayat fiyatı',
  'products.colGetir': 'Getir fiyatı',
  'products.colStatus': 'Durum',
  'products.statusActive': 'Aktif',
  'products.differs': 'Farklı',
  'products.differsHint': 'Kanal fiyatı bizim satış fiyatımızdan farklı.',
  'products.cap': 'Tavan {price}',
  'products.commission': 'Komisyon {price}',
  'products.channelOpen': 'Kanalda açık',
  'products.channelClosed': 'Kanalda kapalı',
  'products.catalogTitle': 'Kanal ürün listeleri',
  'products.catalogIntro': 'Kanal panellerindeki ürün ve fiyatlar burada yalnız okunur; kanal paneline hiçbir şey yazılmaz.',
  'products.source.HAYAT_PANEL': 'Hayat paneli',
  'products.source.GETIR_SU': 'Getir paneli',
  'products.catalogRefresh': 'Kataloğu yenile',
  'products.catalogRefreshing': 'Yenileniyor…',
  'products.catalogRefreshed': '{channel} listesi yenilendi.',
  'products.catalogFetchedAt': 'Son yenileme: {at}',
  'products.catalogNever': 'Henüz çekilmedi.',
  'products.catalogUnmapped': '{n} satırın ürün eşlemesi yok.',
  'products.mapNone': 'Eşleme yok',
  'products.mapSaved': 'Eşleme kaydedildi.',

  // Bölge
  'region.nameTaken': 'Bu adda bir bölge zaten var.',
  'region.neighborhoodTaken': 'Bu mahalle başka bir bölgede tanımlı: {region}.',
  'region.vehicleNotFound': 'Seçilen araç bulunamadı.',

  // Araç
  'vehicle.plateTaken': 'Bu plaka zaten kayıtlı.',
  'vehicle.plateInvalid': 'Plaka biçimi geçersiz. Örnek: 34 ABC 123',

  // Zaman
  'time.now': 'şimdi',
  'time.minutesAgo': '{n} dk önce',
  'time.hoursAgo': '{n} sa önce',
  'time.daysAgo': '{n} gün önce',

  // Panel — gezinme ve düzen
  'nav.overview': 'Genel Bakış',
  'nav.orders': 'Siparişler',
  'nav.dayBoard': 'Gün tahtası',
  'nav.customers': 'Müşteriler',
  'nav.trips': 'Seferler',
  'nav.map': 'Harita',
  'nav.stock': 'Stok & Damacana',
  'nav.depot': 'Depo günü',
  'nav.accounting': 'Kasa',
  'nav.products': 'Ürünler',
  'nav.personnel': 'Personel',
  'nav.vehicles': 'Araçlar',
  'nav.integrations': 'Entegrasyonlar',
  'nav.reports': 'Raporlar',
  'nav.settings': 'Ayarlar',
  'nav.setup': 'Kurulum',
  'nav.logout': 'Çıkış',
  'nav.group.work': 'İş',
  'nav.group.people': 'Kişiler',
  'nav.group.money': 'Para',
  'nav.group.settings': 'Ayarlar',

  // Panel — giriş
  'panel.loginTitle': 'Panele gir',
  'panel.loginTagline': 'AquaBox — Sisteme aksın',
  'panel.loggingIn': 'Giriş yapılıyor…',
  'panel.driversUseMobile': 'Şoförler mobil uygulamadan giriş yapar.',
  'panel.rememberMe': 'Beni hatırla',

  // Panel — genel bakış
  'panel.todayOrders': 'Bugünkü sipariş',
  'panel.delivered': 'Teslim edilen',
  'panel.pending': 'Bekleyen',
  'panel.inProgress': 'Yolda',
  'panel.cancelled': 'İptal / başarısız',
  'panel.todayRevenue': 'Bugünkü ciro (teslim edilen)',
  // "Bugünkü ciro" KPI altı — sunucu `combinedRevenue` toplamını `ours` + `panel` olarak
  // ayrı döner; panel toplama yapmaz (kural 4). Değerler zaten `formatMoney` ile geçer.
  'panel.revenueSplit': 'Bizim {ours} · Panel {panel}',
  // "Bugünkü ciro" altında — kaynak başına teslim cirosu: "Abant ₺9.186 · Hayat ₺1.080".
  // Panel bunu `combinedRevenue.bySource`'tan okur; float toplama yok, sunucu Decimal döner.
  'panel.revenueBySource': '{abant} {abantValue} · {hayat} {hayatValue}',
  // KPI altı — yolda + yeni sayıları ayrı ayrı: "21 yolda · 2 yeni".
  'panel.inProgressAndPending': '{inProgress} yolda · {pending} yeni',
  // Teslim kartı altı — küçük "6 iptal/başarısız" notu (kaynak kırılımı dışında).
  'panel.deliveredSubnote': '{n} iptal / başarısız',
  'panel.oldestPending': 'En eskisi {n} dakikadır bekliyor',
  'panel.oldestPendingHours': 'En eskisi {h} saat {m} dakikadır bekliyor',
  // Genel Bakış üst dört kart (bugün). Eski `panel.todayRevenue` / `panel.delivered` /
  // `panel.pending` / `panel.todayOrders` anahtarları artık panelde kullanılmıyor, silinmedi.
  'dashboard.kpi.placeholder': '–',
  'dashboard.kpi.revenue': 'Ciro bugün',
  'dashboard.kpi.revenueHint':
    'Bugünkü toplam satış: bizim teslimat cirosu + panelde teslim edilen siparişlerin panel tutarı.',
  'dashboard.kpi.deliveredOfAssigned': 'Teslim / atanmış',
  'dashboard.kpi.deliveredRatio': '{delivered} / {total}',
  'dashboard.kpi.deliveredHint':
    'Bugün teslim edilen (dünden devreden dahil) / (bu teslimler + şu an atanmış ve yolda olanlar).',
  'dashboard.kpi.carriedOver': 'Devreden',
  'dashboard.kpi.carriedOverNote': 'Dünden açık sipariş',
  'dashboard.kpi.carriedOverHint':
    'Devir kaydı olan, hâlâ atanmış ya da yolda olan siparişler (siparişler listesindeki devreden rozeti).',
  'dashboard.kpi.approvals': 'Onay bekleyen',
  'dashboard.kpi.approvalsHint':
    'Ara yükleme, nakit teslimi ve diğer onay kuyruklarındaki bekleyen işlemlerin toplamı.',
  'panel.abantVehicleId': 'Araç {id}',
  'panel.liveOrders': 'Anlık gelen siparişler',
  'panel.liveOrdersSub':
    'Bugün gelen siparişler, en yeni üstte. Panel siparişinde paneldeki aşaması ve aracı görünür.',
  'panel.manualAssignTitle': 'Elle atama bekleyenler',
  'panel.liveOrdersHint':
    'Bölgesi eşleşen sipariş kendiliğinden araca düşer; yalnız eşleşmeyenler burada bekler.',
  'panel.awaitingManualAssign': '{n} elle atama bekliyor',
  'panel.noManualAssign': 'Elle atama bekleyen sipariş yok. Hepsi bölge kuralıyla araçlara düştü.',
  'panel.attentionNeeded': 'Dikkat gerektirenler',
  'panel.dormantGroup': 'Uzun süredir almayanlar',
  'panel.dormantMore': '+{n} müşteri daha',
  'panel.allGood': 'Şu an dikkat isteyen bir şey yok. İşler yolunda.',
  'panel.recentOrders': 'Son siparişler',
  'panel.autoAssign': 'Otomatik ata',
  'panel.assign': 'Ata',
  'panel.goToOrders': 'Siparişlere git',
  'panel.goToCustomers': 'Müşterilere git',
  // "Anlık gelen siparişler" sekmeleri.
  'panel.liveFilterOpen': 'Açık',
  'panel.liveFilterAll': 'Tümü',
  'panel.liveEmpty': 'Bugün hiç sipariş gelmedi.',
  'panel.liveVehicleLabel': 'Araç {id}',
  // Bölge tanımlı değil uyarısı (kartın üstünde tek satır). Rota: Layout.tsx'te `/bolgeler`.
  'panel.regionsMissing': 'Bölge tanımlı değil — Bölgeler ekranından ekleyin',
  'panel.regionsMissingLink': 'Bölgeler',
  // "Bugün bizim seferimiz yok" kart alt metni (ClosingStatusCard boşken).
  'panel.noOurTrips': 'Bugün bizim seferimiz yok',
  'panel.goToTrips': 'Seferlere git',

  // Panel — siparişler
  'panel.newOrder': '+ Sipariş gir',
  'panel.exportExcel': "Excel'e aktar",
  'panel.filtersActive': '{n} filtre aktif',
  'panel.clearFilters': 'Temizle',
  'panel.searchOrders': 'Müşteri, telefon veya adres ara',
  'panel.noOrdersFound': 'Bu filtrelerle sipariş bulunamadı.',
  'panel.showingOf': '{total} kaydın {shown} tanesi gösteriliyor',
  'panel.colTime': 'Saat',
  'panel.colChannel': 'Kanal',
  'panel.colCustomer': 'Müşteri',
  'panel.colAddress': 'Adres',
  'panel.colItems': 'Kalemler',
  'panel.colTotal': 'Tutar',
  'panel.colStatus': 'Durum',
  'panel.colVehicle': 'Araç',
  'panel.allChannels': 'Kanal',
  'panel.allVehicles': 'Araç',
  'panel.unassigned': 'Atanmamış',
  'panel.dateToday': 'Bugün',
  'panel.dateYesterday': 'Dün',
  'panel.dateWeek': 'Bu hafta',
  'panel.dateAll': 'Tümü',

  // Ortak dönem etiketleri — paneldeki dönem seçicileri bu sözlüğü kullanır
  // (`apps/panel/src/lib/periods.ts`). Ekranlar destekledikleri alt kümeyi `PERIOD_ORDER`
  // sırasına göre gösterir.
  'period.today': 'Bugün',
  'period.yesterday': 'Dün',
  'period.thisWeek': 'Bu hafta',
  'period.last7': 'Son 7 gün',
  'period.last30': 'Son 30 gün',
  'period.thisMonth': 'Bu ay',
  'period.all': 'Tümü',
  'period.custom': 'Tarih aralığı',

  // Panel — sipariş detayı
  'panel.orderDetail': 'Sipariş',
  'panel.items': 'Kalemler',
  'panel.total': 'Toplam',
  'panel.panelAmountNote':
    'Panel tutarı. Kalem fiyatları katalog fiyatıdır; panel sipariş toplamı esastır.',
  'panel.assignedVehicle': 'Atanan araç',
  'panel.notAssigned': 'Atanmadı',
  'panel.pickVehicle': 'Bir araç seç',
  'panel.timeline': 'Zaman çizelgesi',
  'panel.rawData': 'Ham veri',
  'panel.cancelOrder': 'İptal et',
  'panel.cancelReason': 'İptal gerekçesi',
  'panel.orderCancelled': 'Sipariş iptal edildi',
  'panel.assignedToast': '{plate} aracına atandı',
  'panel.orderCreated': 'Sipariş eklendi',
  'panel.orderCreatedAssigned': 'Sipariş eklendi ve {plate} aracına atandı',

  // Panel — sipariş gir
  'panel.newOrderTitle': 'Sipariş gir',
  'panel.newOrderHint': 'Telefonla gelen siparişi buradan ekle.',
  'panel.fullName': 'Ad Soyad',
  'panel.phone': 'Telefon',
  'panel.address': 'Adres',
  'panel.addressNote': 'Kapı notu',
  'panel.product': 'Ürün',
  'panel.quantity': 'Adet',
  'panel.payment': 'Ödeme',
  'panel.assignToVehicle': 'Araca ata',
  'panel.autoByRegion': 'Bölge kuralıyla',
  'panel.save': 'Kaydet',
  'panel.saveAndAssign': 'Kaydet ve ata',
  'panel.addItem': 'Kalem ekle',
  'panel.removeItem': 'Kalemi çıkar',

  // Panel — müşteriler
  'panel.registeredCustomers': 'Kayıtlı müşteri',
  'panel.totalReceivable': 'Toplam veresiye',
  'panel.jugsAtCustomers': 'Zimmetteki damacana',
  'panel.filterAll': 'Tümü',
  'panel.filterDebtors': 'Borcu olanlar',
  'panel.filterWithDeposit': 'Zimmeti olanlar',
  'panel.filterLapsed': 'Sipariş kesenler',
  'panel.searchCustomers': 'Ad, telefon veya adres ara',
  'panel.customerCard': 'Müşteri kartı',
  'panel.balance': 'Bakiye',
  'panel.deposit': 'Zimmet',
  // Müşteri listesi sütunu: aynı ekrandaki KPI ('panel.jugsAtCustomers') ile aynı kavram; metin ayrı.
  'panel.colJugsAtCustomer': 'Müşteride damacana',
  'panel.jugsWithCustomer': '{n}× 19L damacana müşteride',
  'panel.noJugsWithCustomer': 'Zimmetli damacana yok',
  'panel.ledgerEntries': 'Cari hareketler',
  'panel.noLedgerEntries': 'Henüz hareket yok.',
  'panel.lastOrder': 'Son sipariş',
  'panel.never': 'Hiç',
  'panel.noCustomersFound': 'Bu filtrelerle müşteri bulunamadı.',

  // Sipariş listesi — bölge gruplama ve toplu atama
  'panel.orders.bulkAssign': 'Toplu ata',
  'panel.orders.bulkAssignTitle': 'Toplu atama',
  'panel.orders.bulkAssignConfirm': '{n} sipariş {plate} aracına atanacak',
  'panel.orders.bulkAssignAssigned': '{n} sipariş atandı',
  'panel.orders.bulkAssignSkipped': '{n} sipariş atlanamadı',
  'panel.orders.bulkAssignSkippedReason': '{n} sipariş atlanamadı: {reasons}',
  'panel.orders.bulkAssignSkippedReason.conflict': 'Araç uygun değil',
  'panel.orders.bulkAssignSkippedReason.staleTrip': 'Aracın açık seferi bayat; önce seferi kapat',
  'panel.orders.bulkAssignSkippedReason.notFound': 'Sipariş bulunamadı',
  'panel.orders.bulkAssignSkippedReason.invalid': 'Sipariş geçersiz durumda',
  'panel.orders.bulkAssignSkippedReason.error': 'Sunucu hatası',
  'panel.orders.bulkAssignError': 'Toplu atama başarısız: {message}',
  'panel.orders.bulkAssign.unknownOrder': 'Listede olmayan sipariş',
  'panel.orders.groupByRegion': 'Bölgeye göre grupla',
  'panel.orders.groupByRegionActive': 'Bölgeye göre gruplu',
  'panel.orders.groupNone': 'Bölge eşleşmedi',
  'panel.orders.pendingAge.now': 'yeni',
  'panel.orders.pendingAge.minutes': '{n} dk',
  'panel.orders.pendingAge.hours': '{n} s',
  'panel.orders.bulkAssignCount': '{n} sipariş seçildi',
  'panel.selectAll': 'Tümünü seç',
  'panel.select': 'Seç',
  'panel.selectVehicle': 'Araç seçin',

  // Panel — sürüm bandı ve durum
  'panel.newVersionBanner': 'Yeni sürüm hazır — yenile',
  'panel.refresh': 'Yenile',
  'panel.upgradeBlocked': 'Bu sürüm artık desteklenmiyor. Devam etmek için sayfayı yenile.',
  'panel.readonlyBanner': 'Hesap salt okunur durumda. Yeni sipariş girilemez.',
  'panel.suspendedBanner':
    'Hesap askıya alındı. Verilerini görüntüleyebilir ve dışa aktarabilirsin.',
  'panel.loadFailed': 'Veri alınamadı.',
  'panel.retry': 'Yeniden dene',
  'drivers.intro':
    'Beyan edilen km, konum kaydından hesaplanan mesafeyle karşılaştırılır; fark {threshold} km eşiğini aşarsa satır kehribar olur.',
  'drivers.range.today': 'Bugün',
  'drivers.range.week': 'Son 7 gün',
  'drivers.range.all': 'Tümü',
  'drivers.kpiKm': 'Konumdan hesaplanan km',
  'drivers.kpiKmNote': 'Yalnız konum kaydı olan seferler',
  'drivers.kpiFuel': 'Mazot gideri',
  'drivers.kpiFuelNote': '{n} dolum',
  'drivers.kpiPerKm': 'Ortalama ₺/km',
  'drivers.kpiPerKmNote': 'Mazot gideri / konum km',
  'drivers.kpiUnexplained': 'Açıklanmayan fark',
  'drivers.kpiUnexplainedNote': '±{threshold} km eşiğini aşan seferler',
  'drivers.colDriver': 'Şoför / Araç',
  'drivers.colDeliveries': 'Teslimat',
  'drivers.colJugs': 'Damacana',
  'drivers.colCollected': 'Tahsilat',
  'drivers.colDeclared': 'Beyan km',
  'drivers.colGps': 'Konum km',
  // Ana tablo sütunu: konum kaydından hesaplanan km (sinyalsiz günde tire).
  'drivers.colDistance': 'Mesafe',
  'drivers.colDiff': 'Fark',
  'drivers.colFuel': 'Mazot',
  'drivers.colPer100': 'L/100km',
  'drivers.empty': 'Bu dönemde sefer yok.',
  'drivers.fuelTitle': 'Mazot dolumları',
  'drivers.addFuel': '+ Dolum gir',
  'drivers.noFuel': 'Bu dönemde dolum kaydı yok.',
  'drivers.noStation': 'İstasyon girilmedi',
  'drivers.fieldVehicle': 'Araç',
  'drivers.fieldLiters': 'Litre',
  'drivers.fieldAmount': 'Tutar ₺',
  'drivers.fieldStation': 'İstasyon / fiş no',
  'panel.notifications': 'Bildirimler',
  'panel.comingSoon': 'Sonraki fazda',
  'panel.toggleMenu': 'Menüyü aç/kapat',
  'panel.collapseMenu': 'Menüyü daralt',
  'panel.expandMenu': 'Menüyü genişlet',
  'panel.notificationsUnread': 'Bildirimler, {count} okunmamış',
  'panel.notifTabUnread': 'Okunmamış',
  'panel.notifTabAll': 'Tümü',

  // Test bildirimi (Ayarlar — bildirim bölümü)
  'panel.settings.testNotification.title': 'Test bildirimi',
  'panel.settings.testNotification.button': 'Kendime test bildirimi gönder',
  'panel.settings.testNotification.hint':
    'Bildirimlerin size ulaştığını doğrulamak için kendinize bir test bildirimi gönderin.',
  'panel.settings.testNotification.success': 'Test bildirimi gönderildi.',
  'panel.settings.testNotification.error': 'Test bildirimi gönderilemedi.',

  // Dikkat gerektirenler (uyarı motoru)
  'alert.unassignedOrders':
    '{count} sipariş {minutes} dakikadır atanmadı — en eskisi {customer}, {source}',
  'alert.lapsedCustomer': '{customer} {days} gündür sipariş vermedi',
  'alerts.manualSession.unbound': '{source} paneline bağlı oturum yok; jeton yenilenmeli.',
  'alerts.manualSession.expiring':
    '{source} paneli oturumunun süresi {minutes} dakika içinde dolacak; jeton yenilenmeli.',
  'alert.integrationError':
    '{channel} bağlantısı {minutes} dakikadır hata veriyor — siparişler düşmüyor olabilir',
  'alert.tripVariance': '{plate} farkla kapandı: {count} damacana açık, açıklama okunmadı',
  'alert.lowStock': 'Depoda dolu damacana {threshold} altına indi (şu an {count})',

  // Kiracı ayarları / bayraklar
  'tenant.updateConflict': 'Ayarlar aynı anda başka bir işlemle değişti; tekrar deneyin.',
  'tenant.unknownFlag': 'Bilinmeyen bayrak: {key}',
  // P3: Hayat Su bayi paneline yazma kipi ve kapı durumları (panel etiketleri).
  'hayatWriteMode.SHADOW': 'Gölge',
  'hayatWriteMode.CONFIRM': 'Onaylı',
  'hayatWriteMode.AUTO': 'Otonom',
  // Kullanıcı dilinde; uç adı yok. "Anladım" kutusu yetmez — kip adı iki kez aynı seçilir.
  'hayatWriteMode.confirmMismatch': 'Onay için kipi iki kez aynı seçin.',
  // Kullanıcı dilinde; uç adı yok.
  'hayatWriteMode.notFromSettings': 'Bu ayar yalnız patron tarafından, ayrı ekrandan değiştirilir.',
  // P3: kısıtlı kiracıda yazma yönü (kural 11 — yalnız kapatma serbest). Denetim
  // "değişim" üzerinden: DB'de zaten true olan alan korunur; false'tan true'ya
  // geçiş reddedilir. Mesaj hesabın kısıtlı olduğunu söyler — patrona özel açma
  // ayrı bir ekrandan yapılır.
  'tenant.flags.disableOnly': 'Hesap kısıtlıyken yalnız kapatma yapılabilir.',
  'tenant.hayatMode.disableOnly':
    'Hesap kısıtlıyken yalnız Gölge kipine geçilebilir; Onaylı/Otonom yalnız patron tarafından açılır.',
  // P3: hayatWriterEnabled yalnız OWNER true yapabilir; MANAGER yalnız false.
  // "Değişim" mantığı: zaten true olan bayrak serbesttir; açma yalnız patrona özel.
  'tenant.settings.ownerOnlyToggle': 'Bu ayarı açmak yalnız patron tarafından yapılabilir.',
  'tenant.settings.quietHoursOwnerOnly': 'Sessiz saati yalnız patron değiştirebilir.',
  'tenant.settings.aliasesOwnerOnly': 'Mahalle takma adlarını yalnız patron değiştirebilir.',
  'tenant.settings.aliasKeyInvalid':
    'Takma ad, var olan bir mahalle adı, tek başına "mah" eki ya da 3 harften kısa olamaz.',
  'tenant.settings.aliasTargetUnknown':
    'Takma adın karşılığı haritada ya da bir bölgede bulunan bir mahalle olmalı.',
  'tenant.settings.serverManaged': 'Bu alan sunucu tarafından yönetilir, gövdeden gönderilemez.',
  'tenant.writerOwnerOnly': 'Bu bayrağı açmak yalnız patron tarafından yapılabilir.',

  // Panel — müşteri tablosu ek kolon
  'panel.colRegion': 'Bölge',

  // Cari hareket türleri (panel müşteri kartı)
  'customerTxn.SALE': 'Satış',
  'customerTxn.PAYMENT': 'Tahsilat',
  'customerTxn.DEPOSIT': 'Depozito',
  'customerTxn.DEPOSIT_REFUND': 'Depozito iadesi',
  'customerTxn.ADJUSTMENT': 'Düzeltme',

  // Sipariş olay türleri (panel zaman çizelgesi)
  'orderEvent.RECEIVED': 'Sipariş geldi',
  'orderEvent.CONFIRMED': 'Onaylandı',
  'orderEvent.ASSIGNED': 'Atandı',
  'orderEvent.ON_ROUTE': 'Yola çıktı',
  'orderEvent.DELIVERED': 'Teslim edildi',
  'orderEvent.LEFT_AT_DOOR': 'Emanet bırakıldı',
  'orderEvent.FAILED': 'Teslim edilemedi',
  'orderEvent.CANCELLED': 'İptal edildi',
  // Tek atama motoru (ADR 2026-10-29) — roster ve etiket eşlemesi olayları.
  'orderEvent.ROSTER_CHANGED': 'Günün şoförü değişti',
  'orderEvent.PANEL_LABEL_CHANGED': 'Panel etiketi eşlemesi değişti',
  // P2: Sefer kapanırken yola çıkmış sipariş ertesi güne devredilir; siparişin statüsü
  // `ON_ROUTE → ASSIGNED` olur ve yeni gün başında depart'ta aynı sefere bağlanır.
  'orderEvent.CARRIED_OVER': 'Devredildi',
  // Şoför üstlendiği Hayat/panel siparişini geri bıraktı (POST /api/orders/:id/unclaim).
  'orderEvent.UNCLAIMED': 'Şoför geri bıraktı',

  // Sipariş
  'order.notFound': 'Sipariş bulunamadı.',
  'order.invalidTransition': 'Sipariş {from} durumundan {to} durumuna geçemez.',
  // FAIL-GUARD (tur 3): `POST /api/orders/:id/status` teslim/emanet yazmaz — stok satışı, boş
  // alım ve cari/kasa satırını yazan TEK yol `POST /api/trips/:id/deliver`. Bu yüzden teslim
  // hedefi elle verilemez; mesaj şoföre hangi ekrana geçmesi gerektiğini söyler.
  'order.deliveryEndpointRequired':
    'Teslim ya da kapıya bırakma yalnız sefer ekranından kaydedilir.',
  // İptal durum ucundan verilmez; gerekçe ve iptal kaydı yalnız iptal ucunda yazılır.
  'order.cancelEndpointRequired':
    'Sipariş yalnız iptal işlemiyle iptal edilir; gerekçe orada girilir.',
  'order.duplicateExternal': 'Bu sipariş zaten alınmış.',
  'order.productNotFound': 'Seçilen ürün bulunamadı.',
  'order.vehicleNotFound': 'Seçilen araç bulunamadı.',
  'order.customerRequired': 'Müşteri ya da ad ve adres girilmeli.',
  'order.customerIdRequired':
    'Sipariş için kayıtlı bir müşteri seçilmeli ya da yeni müşteri eklenmeli.',
  'order.customerAlreadyLinked': 'Bu siparişe zaten bir müşteri bağlı.',
  'order.customerLinkClosed': 'Teslim edilmiş ya da iptal edilmiş siparişe müşteri bağlanamaz.',
  'order.paymentChannelLocked': 'Kanal siparişinin ödeme türü değiştirilemez.',
  'order.paymentAssigned': 'Sipariş araçta, ödemeyi şoför teslimde seçer.',
  'order.paymentClosed': 'Teslim edilmiş ya da iptal edilmiş siparişin ödeme türü değiştirilemez.',
  'order.unknownCustomerName': 'Bilinmeyen müşteri',
  'order.alreadyAssigned': 'Bu sipariş zaten bir araca atandı.',
  'order.regionUnmatched': 'Bölge eşleşmedi',
  // Panel numarasına göre atama (panel-assign) — kiracı izolasyonu ve şoför doğrulaması
  'panelAssign.notHayat': 'Bu uç yalnız HAYAT_PANEL ve ABANT_PANEL için geçerlidir.',
  'panelAssign.unknownDriver': 'Şoför bu kiracıya ait değil veya pasif.',
  'panelAssign.driverInactive': 'Şoför pasif; atanamaz.',
  'panelAssign.emptyLabel': 'Panel etiketi boş olamaz.',
  'panelAssign.labelTooLong': 'Panel etiketi en fazla 60 karakter olabilir.',
  'panelAssign.emptyMap': 'En az bir eşleme girilmeli veya null ile silinmeli.',
  'panelAssign.tooManyOrders': 'Tek istekte en fazla 200 sipariş atanabilir.',
  'panelAssign.apply.sourceMismatch': 'Sipariş bu kaynaktan değil; atlanır.',
  'panelAssign.apply.notActive': 'Sipariş aktif değil; atlanır.',
  'panelAssign.driverMapStale':
    'Eşleme deposu başka bir işlem tarafından güncellendi; yeniden deneyin.',
  // Tek atama motoru — gerekçe rozetleri (ADR 2026-10-29)
  'assign.reason.PANEL_LABEL': 'Panel etiketi',
  'assign.reason.STREET': 'Sokak kuralı',
  'assign.reason.REGION': 'Bölge kuralı',
  'assign.reason.HISTORY': 'Geçmiş siparişler',
  'assign.reason.MANUAL': 'Elle atandı',
  'assign.reason.UNMATCHED': 'Atanamadı',
  'assign.unmatched.UNMAPPED': 'Eşleme yok',
  'assign.unmatched.STALE_MAP': 'Eşleme bayat',
  'assign.unmatched.DRIVER_INACTIVE': 'Şoför pasif',
  'assign.unmatched.NO_VEHICLE': 'Araç yok',
  'assign.unmatched.VEHICLE_BUSY': 'Araç başka seferde',
  'assign.unmatched.STALE_TRIP': 'Sefer güncel değil',
  'assign.unmatched.MODE_MANUAL': 'Otomatik atama kapalı',
  'assign.unmatched.AMBIGUOUS_STREET': 'Sokak belirsiz',
  'assign.unmatched.STREET_NO_NUMBER':
    'Sokak bölünmüş, kapı numarası yok; bölge mahalleden yazıldı, araç atanmadı',
  'assign.unmatched.RULE_TARGET_INACTIVE': 'Kuralın aracı pasif',
  'assign.unmatched.REGION_NO_VEHICLE': 'Bölgede araç yok',
  'assign.unmatched.HIST_NO_KEY': 'Geçmiş anahtarı yok',
  'assign.unmatched.HIST_THIN': 'Geçmiş yetersiz',
  'assign.unmatched.HIST_SPLIT': 'Geçmiş bölünmüş',
  'assign.unmatched.HIST_UNMAPPED': 'Geçmiş aracı eşleşmedi',
  'assign.unmatched.HIST_NOT_LOADED': 'Geçmiş yüklenmedi',
  'assign.unmatched.COORD_ONLY': 'Yalnız koordinat',
  'assign.unmatched.NO_RULE': 'Kural yok',
  // Görevlendirme ucunun 409 kodları — UNMATCHED alt kodu DEĞİLDİR.
  'assign.dayError.PAST_DAY_LOCKED': 'Geçmiş gün kilitli',
  'assign.dayError.DAY_DRIVER_TAKEN': 'Şoför o gün başka araca atanmış',
  'assign.dayError.DAY_VEHICLE_TAKEN': 'Araç o gün başka şoföre atanmış',
  'assign.dayError.DAY_OUT_OF_RANGE': 'Bu gün için görevlendirme yapılamaz; yalnız bugün ve yarın.',
  'assign.dayError.DRIVER_INACTIVE': 'Şoför pasif; görevlendirilemez.',
  'assign.dayError.VEHICLE_INACTIVE': 'Araç pasif; görevlendirilemez.',
  // Günün şoförü (görevlendirme) — roster metinleri
  'assign.roster.driver': 'Günün şoförü',
  'assign.roster.noDriver': 'Şoför atanmadı',
  'assign.roster.backup': 'Yedek şoför',
  'assign.roster.conflict': 'Sefer görevlendirmeyle çelişiyor',
  // Roster kaynak rozetleri — eşleşme hangi katmandan geldi?
  'assign.roster.source.trip': 'Seferden',
  'assign.roster.source.assignment': 'Görevlendirme',
  'assign.roster.source.default': 'Zimmet',
  'order.autoAssigned': 'Bölge kuralıyla otomatik atandı',
  'order.manuallyAssigned': 'Elle atandı',
  'order.reassignedFromTrip': 'Sefere bağlıyken başka araca atandı',
  'order.driverClaimedHayat': 'Şoför Hayat siparişini aldı',
  'order.assignedByPanelNumber': 'Panel numarasına göre atandı',

  // Sipariş durumları (kullanıcıya görünen adlar)
  'orderStatus.NEW': 'Yeni',
  'orderStatus.CONFIRMED': 'Onaylandı',
  'orderStatus.ASSIGNED': 'Atandı',
  'orderStatus.ON_ROUTE': 'Yolda',
  'orderStatus.DELIVERED': 'Teslim edildi',
  'orderStatus.LEFT_AT_DOOR': 'Emanet bırakıldı',
  'orderStatus.FAILED': 'Teslim edilemedi',
  // Aynı olay üç yerde yazılıydı ("İptal" / "İptal edildi"). Tek biçim: "İptal edildi"
  // (sefer `tripStatus.VOIDED` ve sipariş olayı `orderEvent.CANCELLED` ile aynı).
  'orderStatus.CANCELLED': 'İptal edildi',

  // Dış panel siparişlerinin genişletilmiş kategori rozetleri (03.10.2026)
  // `externalStage()` yardımcısından gelen kategoriler. `PanelStagePill` farklı ton
  // kümesi kullanır — bunlar yalnız `ExternalStagePill` içindir.
  'externalStage.NEW': 'Yeni',
  'externalStage.ON_ROUTE': 'Yolda',
  'externalStage.ON_ROUTE_LONG': 'Uzun süredir yolda',
  'externalStage.DELIVERED': 'Teslim edildi',
  'externalStage.CANCELLED': 'İptal',
  'externalStage.PAYMENT_FAILED': 'Ödeme başarısız',
  'externalStage.ageHours': '{n} sa',

  // Kanallar
  // Kaynak = BİZ NEREDEN ÇEKTİK. Kullanıcıya nadiren gösterilir; rozetler `orderChannel.*`ten
  // doldurulur (ENTEGRASYON.md §3).
  'orderSource.MANUAL': 'Elle giriş',
  'orderSource.HAYAT_PANEL': 'Hayat Su Paneli',
  'orderSource.ABANT_PANEL': 'Abant Su Paneli',
  'orderSource.GETIR_SU': 'Getir Su',
  'orderSource.LUCA': 'Luca',
  // Sipariş listesi süzgeci (kaynak harf rozeti): harf rozetinde kullanılan adlar kısa, panel
  // çubuğunda sığsın diye.
  'srcLetter.chip.HAYAT_PANEL': 'Hayat',
  'srcLetter.chip.ABANT_PANEL': 'Abant',
  'srcLetter.chip.PHONE': 'Telefon',
  'srcLetter.chip.GETIR_SU': 'Getir',
  'srcLetter.chip.other': 'Diğer',

  // Kanal = MÜŞTERİ NEREDEN SİPARİŞ VERDİ. Sipariş rozetlerinde görünen budur.
  'orderChannel.TRENDYOL': 'Trendyol',
  'orderChannel.YEMEKSEPETI': 'Yemeksepeti',
  'orderChannel.BRAND_APP': 'Marka uygulaması',
  'orderChannel.WHATSAPP': 'WhatsApp',
  'orderChannel.PHONE': 'Telefon',
  'orderChannel.GETIR_SU': 'Getir Su',
  'orderChannel.UNKNOWN': 'Belirsiz',

  // Ödeme tipleri
  'paymentType.CASH': 'Nakit',
  'paymentType.CARD': 'Kart',
  'paymentType.ONLINE': 'Online ödendi',
  'paymentType.CREDIT': 'Veresiye',

  // Sefer
  'trip.notFound': 'Sefer bulunamadı.',
  'trip.invalidTransition': 'Sefer {from} durumundan {to} durumuna geçemez.',
  'trip.alreadyOpen': 'Bu şoförün açık bir seferi zaten var.',
  'trip.vehicleBusy': 'Bu araçta başka bir şoförün açık seferi var.',
  'trip.notWritable': 'Sefer bu durumdayken kayıt yazılamaz.',
  'trip.departRaced':
    'Sefer başlatılırken siparişlerden biri değişti. Sayfayı yenileyip tekrar deneyin.',
  // P2: Kapanışta iki eşzamanlı istek yarışı — biri `ORDER_TRANSITIONS` dışı `ON_ROUTE →
  // ASSIGNED` devrini koşullu `updateMany` ile yazdı, diğeri count uyuşmazlığından 409 aldı.
  // Şoför için ayrı bir hata; mesaj `departRaced`'in kardeşi.
  'trip.closeRaced':
    'Sefer kapatılırken siparişlerden biri değişti. Sayfayı yenileyip tekrar deneyin.',
  'trip.closed': 'Kapanan sefer değiştirilemez; düzeltme panelden yeni satır olarak eklenir.',
  'trip.noVariance': 'Bu seferde okunacak bir fark kaydı yok.',
  'trip.varianceNoteRequired': 'Denklem tutmuyor; en az 10 karakterlik açıklama zorunlu.',
  'trip.cashHandoverRequired': 'Şoförün üstünde nakit var; önce depoya teslim edilmeli.',
  'trip.pendingReloadOnClose':
    'Sefer kapatılamaz: karara bağlanmamış ara yükleme isteği var. Önce patron onaylasın ya da reddetsin.',
  'trip.odometerBackwards': 'Kilometre geriye gidemez.',
  'trip.odometerBackwardsLast': 'Kilometre geriye gidemez. Son kayıt: {km} km.',
  'trip.fuelPairRequired': 'Litre ve tutarı birlikte gir.',
  'trip.noOpenTrip': 'Açık sefer yok.',
  // Bayat sefer: tripDate İstanbul bugününden önce, hâlâ açık. Yeni sipariş ona bağlanmaz.
  'trip.stale':
    'Bu aracın açık seferi eski bir güne ait (bayat). Önce o seferi kapat, sonra sipariş ata.',
  'trip.staleDepart': 'Bu sefer eski bir güne ait (bayat); yola çıkamaz. Önce seferi kapat.',
  'order.staleTripSkipped':
    'Aracın açık seferi bayat olduğu için araca atanmadı; sipariş atanmamış bekliyor.',
  'orderEvent.STALE_TRIP_SKIPPED': 'Bayat sefer: atama atlandı',
  'trips.staleBadge': 'Bayat',
  'trips.staleTitle': 'Bayat açık seferler',
  'trips.staleIntro':
    'Eski bir güne ait ama hâlâ açık sefer var. Yeni siparişler bu araca bağlanmaz; seferi kapat.',
  'trips.staleDriverHint':
    'Yolda/kapanışta olan sefer panelden iptal edilemez; şoförün uygulamadan günü kapatması gerekir.',
  'trips.staleVoidHint': 'Bu sefer henüz yola çıkmadı; aşağıdaki iptal akışıyla kapatabilirsin.',
  'dayBoard.staleTrip': 'Bayat sefer',
  // P2: Akşam dolumu yalnız `eveningLoadFromHour` saatinden SONRA açılabilir. Erken açılırsa
  // şoför gün sonu sayımını sabah yükler gibi yapar ve kapanış denklemi erken saatteki
  // satışlarla karışır.
  'trip.eveningTooEarly':
    'Akşam dolumu yalnız belirlenen saatten sonra açılabilir. Şimdi açamazsın.',
  // P2: NEXT_DAY olarak açılan sefer o günün `00:00`'ından önce depart edilemez. Şoför bugün
  // depoya dönüp "yarınki sefer"e atlamaya çalışırsa denklem yarına sarkar; bugün hâlâ
  // yarının seferidir.
  'trip.notYetDay': 'Bu sefer yarının seferi; o gün başlamadan yola çıkamazsın.',
  'trip.returnedLinesMismatch':
    'Marka bazlı dönüş toplamı ({total}) girilen toplamla ({expected}) uyuşmuyor.',
  'trip.creditNeedsCustomer':
    'Veresiye ve zimmet için müşteri kaydı gerekli; siparişi bir müşteriye bağlayın.',
  'trip.depositMismatch': 'Depozito tutarı beklenen değerle ({expected}) uyuşmuyor.',
  // Sefer iptali (ADR 2026-09-09): silme değil, ters kayıt.
  'trip.voidReasonRequired': 'Sefer iptali için en az 10 karakterlik gerekçe zorunlu.',
  'trip.voidNotAllowed':
    'Yoldaki ya da kapanıştaki sefer iptal edilemez; şoför gününü kapatsın, sonra iptal edin.',
  'trip.alreadyVoided': 'Bu sefer zaten iptal edilmiş.',
  'trip.voidBlockedByCash':
    'Bu seferin nakdi kasaya işlendi; iptal edilemez. Önce kasa düzeltmesini yapın.',
  // P7: Sefer şoför devri (tasarım §4).
  'trip.driverBusy':
    'Hedef şoförün başka bir açık seferi var; devir için seferini kapatması gerekir.',
  'trip.sameDriver': 'Sefer zaten bu şoförde; devir gerekmiyor.',
  'trip.notOpenForReassign':
    'Sefer bu durumdayken devredilemez; yalnız açık seferler (yükleme, yolda, kapanışta) devredilebilir.',
  'trip.floatAckRequired':
    'Önceki şoförün emanetinde ₺{amount} var; aracın yeni şoföre devredildiğini onaylıyor musun?',
  'trip.reassignReasonTooShort': 'Devir gerekçesi en az 10 karakter olmalı.',
  // P2: personel kapısı + sefer açılışı
  'trip.noVehicle': 'Zimmetli araç yok. Patron panelinden araç atanmalı.',
  'trip.vehicleNotFound': 'Seçilen araç bulunamadı.',
  'trip.openOnOtherVehicle': 'Bu şoförün başka bir aracında açık seferi var. Önce o seferi kapat.',
  // Şoför başka bir araçla sefer açtığında patrona yönetim uyarısı.
  'trip.vehicleChangedTitle': 'Araç değiştirildi',
  'trip.vehicleChangedBody': '{driver} seferi {fromPlate} yerine {toPlate} ile açtı.',
  // Araçta başka personelin açık seferi varken sefer açma denemesi (409 VEHICLE_BUSY).
  'trip.takeoverBody':
    '{driver} bu araçla sefer açmak istiyor; araçta başka personelin açık seferi var.',
  'trip.reassignTargetNotFound': 'Devredilecek şoför bulunamadı.',
  'trip.reassignTargetInactive': 'Devredilecek şoför pasif; önce şoförü aktifleştir.',
  'trip.reassignConflict':
    'Sefer aynı anda başka bir işlemle değişti; ekranı yenileyip tekrar dene.',
  'trip.reassignedDuringWrite':
    'Sefer işlem sırasında başka şoföre devredildi; ekranı yenileyip tekrar dene.',
  'trip.reassigned': 'Bu sefer başka şoföre devredildi; artık kayıt yazamazsın.',
  'trip.busy': 'Sefer şu an başka bir işlemle güncelleniyor; kayıt birazdan yeniden gönderilecek.',

  // Sefer durumları
  // ── Ön muhasebe ekranı (§3.13) ──
  'floatStatus.NO_CASH': 'Nakit yok',

  'cash.floatOnRoute': 'Yoldaki araçlarda',

  'cash.amountInvalid': 'Tutar geçersiz. Örnek: 1.250,75',
  'cash.exceedsDebt':
    'Tahsilat borcu aşıyor. Güncel borç {debt}. Kalanı avans olarak kaydetmek için onay gerekir.',
  'cash.advanceConfirm':
    '{amount} tutarı {debt} olan borcu aşıyor. Aradaki {excess} müşterinin alacağına (avans) yazılacak. Onaylıyor musun?',
  'cash.advanceConfirmAccept': 'Avans olarak kaydet',
  'cash.advanceBadge': 'Avans',

  'cash.tabCash': 'Kasa',
  'cash.tabAccounts': 'Cari hesaplar',
  'cash.tabFloats': 'Şoför emanet',
  'cash.tabReceipts': 'Makbuzlar',
  'cash.dailyNote': 'Günlük para akışı. Resmi muhasebe kaydı değildir.',
  'cash.inflow': 'Giren',
  'cash.outflow': 'Çıkan',
  'cash.closing': 'Gün sonu kasa',
  'cash.closingHint': 'Giren − Çıkan',
  'cash.salesBreakdown': 'Günün satışı (ciro)',
  'cash.fuelNote': '{plate} · {liters} L',
  'cash.salesHint': 'Nakit satış şoförün üstünde olabilir; kasaya teslim alınınca girer.',
  'cash.handover': 'Şoför nakit teslimi',
  'cash.customerPayment': 'Tahsilat (veresiye ödemesi)',
  'cash.addExpense': '+ Gider ekle',
  'cash.expenseAmount': 'Tutar (₺)',
  'cash.expenseNote': 'Not (isteğe bağlı)',
  'cash.noExpenses': 'Bugün gider girilmedi.',
  'cash.last7': 'Son 7 gün',
  'cash.receivable': 'Toplam alacak (veresiye)',
  'cash.receivableHint': 'Müşterilerin size borcu',
  'cash.payable': 'Toplam borç (avans)',
  'cash.payableHint': 'Müşterilere borcunuz',
  'cash.debtors': 'Borçlu müşteri',
  'cash.jugsOnHand': 'Zimmetteki damacana',
  'cash.floatsNote':
    'Şoförün gün içinde topladığı nakit onun emanetindedir. Kapanışta depoya teslim eder; siz "Teslim alındı" dediğinizde kasaya işlenir.',
  'cash.floatOnHand': 'Şoförlerde nakit',
  'cash.floatOnHandHint': 'Henüz kasaya girmedi',
  'cash.floatSettled': 'Bugün teslim alınan',
  'cash.floatSettledHint': 'Kasaya işlendi',
  'cash.confirmHandover': 'Teslim alındı',
  'cash.colVehicle': 'Araç',
  'cash.colDriver': 'Şoför',
  'cash.colCash': 'Nakit',
  'cash.colStatus': 'Durum',
  'cash.noFloats': 'Emanet kaydı yok.',
  'cash.receiptsNote':
    'Her teslimat için makbuz. 80 mm fiş yazıcıya ya da PDF olarak gider. Resmi fatura değildir.',
  'cash.colReceiptNo': 'Makbuz no',
  'cash.colTime': 'Saat',
  'cash.colCustomer': 'Müşteri',
  'cash.colItems': 'Kalem',
  'cash.colAmount': 'Tutar',
  'cash.colPayment': 'Ödeme',
  'cash.viewPdf': 'PDF',
  'cash.noReceipts': 'Makbuz yok.',
  'cash.receiptModalDate': 'Tarih',
  'cash.receiptModalChannel': 'Kanal',
  'cash.receiptModalTotal': 'TOPLAM',
  'cash.receiptModalPayment': 'Ödeme',
  'cash.receiptModalDisclaimer': 'Bu belge bilgi amaçlı satış makbuzudur; e-Fatura yerine geçmez.',
  'cash.receiptModalVoidNotice': '{no} numaralı makbuzun iptalidir.',
  'cash.receiptModalDownload': 'PDF indir',
  'cash.receiptModalLoadError': 'Makbuz yüklenemedi.',
  'cash.collect': 'Tahsilat al',
  'cash.collectAmount': 'Tutar (₺)',
  'cash.methodCash': 'Nakit',
  'cash.methodCard': 'Kart',
  'cash.depositsByBrand': 'Marka bazlı zimmet',
  'cash.notInBalance': 'bakiyeye girmez',
  // ── Harita (§3.11) ──
  'map.vehicles': 'Araçlar',
  'map.lastSeen': 'Son konum {n} saniye önce',
  'map.noSignal': 'Sinyal yok',
  'map.noSignalSince': 'Sinyal yok · son konum {n} dk önce',
  'map.neverSeen': 'Hiç konum gelmedi',
  'map.goToTrip': 'Sefere git',
  'map.refresh': 'Yenileme: 15 sn',
  'map.deliveries': 'Teslimat',
  'map.onVehicle': 'Araçta',
  'map.unknown': 'bilinmiyor',
  'map.selectVehicle': 'Soldan bir araç seçin.',
  'map.layers': 'Katmanlar',
  'map.layer.vehicles': 'Araçlar',
  'map.layer.orders': 'Açık siparişler',
  'map.ordersTruncated': 'Açık sipariş {total}; haritada yalnız ilk {shown} gösteriliyor.',
  'map.layer.regions': 'Bölge sınırları',
  'map.orderPopup.title': 'Sipariş {no}',
  'map.orderPopup.vehicle': 'Araç',
  'map.orderPopup.pick': 'Araç seçin',
  'map.orderPopup.assign': 'Ata',
  'map.orderPopup.assigned': '{plate} aracına atandı',
  'map.orderPopup.unassigned': 'Atanmamış',
  'map.orderPopup.close': 'Kapat',
  // ── Araç → şoför → sıradaki müşteri ──
  'map.tripOpen': 'Açık sefer',
  'map.tripNone': 'Açık sefer yok',
  'map.nextStop': 'Sıradaki müşteri',
  // ── Scraper kill switch (kural 10) ──
  'scraper.title': 'Marka paneli veri çekimi',
  'scraper.hint': 'Marka "durun" derse aynı gün buradan durdurulur; kod değişikliği gerekmez.',
  'scraper.off': 'Kapalı — veri çekilmiyor',
  'scraper.silent': 'Açık ama 30 dakikadır başarılı çekim yok',
  'scraper.running': 'Açık ve çalışıyor',
  'scraper.offHours': "Mesai dışı — {from}'da yeniden başlar",
  'scraper.stop': 'Durdur',
  'scraper.start': 'Başlat',
  'scraper.stopTitle': '{name} çekimi durdurulsun mu?',
  'scraper.stopBody':
    '{name} için veri çekimi durur. Yeniden başlatmak için "Başlat" düğmesine basmanız yeterli.',
  'scraper.loadError': 'Çekim durumu sunucudan alınamadı.',
  'scraper.fallbackHint':
    'Aşağıda kayıtlı bayrak durumu gösteriliyor; durdurma yine de yapılabilir.',
  // ── Raporlar (§3.16) ──
  'rep.p7': '7 gün',
  'rep.p30': '30 gün',
  'rep.pMonth': 'Bu ay',
  'rep.revenue': 'Ciro',
  'rep.deliveries': 'Teslimat',
  'rep.jugs': 'Satılan damacana',
  'rep.basket': 'Ortalama sepet',
  'rep.totalSales': 'Toplam satış',
  'rep.deliveredOrders': 'Teslim edilen sipariş',
  'rep.averageOrder': 'Ortalama sipariş',
  'rep.vsPrev': 'Önceki döneme göre {n}',
  'rep.noPrev': 'Önceki dönem verisi yok',
  'rep.perDay': 'Günlük ortalama {n}',
  'rep.dailyRevenue': 'Günlük satış',
  'rep.dailyOursLegend': 'Bizim teslimat',
  'rep.dailyPanelLegend': 'Panel',
  'rep.thisPeriod': 'Bu dönem',
  'rep.prevPeriod': 'Önceki dönem',
  'rep.channelShare': 'Kanal payı',
  'rep.driverPerf': 'Şoför performansı',
  'rep.colDriver': 'Şoför',
  'rep.colDeliveries': 'Teslimat',
  'rep.colJugs': 'Damacana',
  'rep.colCollected': 'Tahsilat',
  'rep.colEquation': 'Denklem',
  'rep.matched': 'Tuttu',
  'rep.varianceDays': '{n} farklı gün',
  'rep.hourly': 'Saat bazlı yoğunluk',
  'rep.busiest': 'En yoğun saat {from}:00–{to}:00.',
  'rep.exportLuca': "Luca'ya aktar",
  'rep.exportTrips': 'Sefer dökümü',
  'rep.exportCustomers': 'Cari ekstre',
  'rep.noData': 'Bu dönemde veri yok.',
  'rep.dayFrom': 'Başlangıç',
  'rep.dayTo': 'Bitiş',
  'rep.rangeTooWide': 'Aralık en fazla {n} gün olabilir.',
  'rep.exportFailed': 'Aktarım indirilemedi.',
  // P9: Kanal panelinde (Hayat) kapanan siparişlerin ciro kırılımı (ADR 2026-09-29).
  // Bu tutar KASA DEĞİLDİR — kendi fiyatımızla değil kanalın gözlenen tutarıyla yazılı,
  // bu yüzden ciro kartından AYRI gösterilir ve toplanmaz.
  'rep.channelHandledTitle': 'Kanal panelinde kapanan siparişler',
  'rep.channelHandledHint': 'Toplam satışa dahildir; kasaya otomatik girmez.',
  'rep.channelHandledEmpty': 'Bu dönemde kanal panelinde kapanan sipariş yok.',
  'rep.colChannel': 'Kanal',
  'rep.colOrderCount': 'Sipariş',
  'rep.colChannelAmount': 'Tutar',
  'rep.colCatalogAmount': 'Katalog fiyatıyla',
  'rep.colTotal': 'Toplam',
  // Para nasıl hesaplanır? kutusu (Genel Bakış/Raporlar, 30.09.2026).
  'rep.moneyExplainerTitle': 'Para nasıl hesaplanır?',
  'rep.moneyExplainerOurs':
    'Bizim teslimat: şoförümüz teslim eder, tahsilat kasamıza (Ön Muhasebe) girer.',
  'rep.moneyExplainerPanel':
    'Panel satışı: Hayat/Abant panelinde kapanan sipariş. Tutar panelin gösterdiği tutardır.',
  'rep.moneyExplainerExcluded': 'İptal edilen ve hâlâ açık olan siparişler hiçbir tutara katılmaz.',
  'rep.moneyExplainerDeposit': 'Panel tutarı depozito içerebilir; katalog fiyatı bunu göstermez.',
  'rep.moneyExplainerCollection':
    'Tahsilat (şoför tablosu) ile satış arasındaki fark veresiyedir; kasaya girmemiş demektir.',
  'rep.sourceChannelHint': 'Tüm siparişler; tutar yalnız teslim edilenler.',
  // Yeni rapor bölümleri (kaynak filtresi + detaylı tablolar).
  'rep.sourceAll': 'Tümü',
  'rep.sourceAbant': 'Abant',
  'rep.sourceHayat': 'Hayat',
  'rep.sourceOurs': 'Bizim',
  'rep.sourceLabel': 'Kaynak',
  'rep.colCancelled': 'İptal / başarısız',
  'rep.colPending': 'Panelde açık',
  'rep.sourceChannelTitle': 'Kaynak × kanal',
  'rep.productTableTitleNew': 'Ürün tablosu',
  'rep.colProduct': 'Ürün',
  'rep.colTotalQty': 'Toplam adet',
  'rep.colDeliveredQty': 'Teslim edilen',
  'rep.colSourceBreak': 'Kaynak kırılımı',
  'rep.unmatchedProduct': 'Eşleşmemiş ürün',
  'rep.jugsByKindTitle': 'Damacana kullanımı',
  'rep.jugsOurs': 'Bizde',
  'rep.jugsPanel': 'Panelde',
  'rep.jugKind.19L_PC': '19L',
  'rep.jugKind.19L_CAM': '15L Cam',
  'rep.jugKind.KOLI': 'Koli',
  'rep.jugsEmptyReceived': 'Boş alımı',
  'rep.jugsEmptyUnavailable': 'Panel siparişlerinde boş alımı okunmaz.',
  'rep.vehicleTitle': 'Araçlar',
  'rep.vehicleOurs': 'Bizim araçlar',
  'rep.vehiclePanel': 'Panel araçları',
  'rep.colLabel': 'Etiket',
  'rep.colPlate': 'Plaka',
  'rep.colRevenue': 'Ciro',
  'rep.colDelivered': 'Teslim adedi',
  'rep.exportTable': 'CSV indir',
  'rep.exportSourceChannel': 'Kaynak × kanal (CSV)',
  'rep.exportProducts': 'Ürünler (CSV)',
  'rep.exportVehicles': 'Araçlar (CSV)',
  'rep.descLuca': "Seçili dönemin kayıtları Luca'ya aktarılacak biçimde (CSV) iner.",
  'rep.descTrips': 'Seçili dönemdeki seferlerin dökümü (CSV) iner.',
  'rep.descCustomers': 'Tüm müşterilerin cari ekstresi (CSV) iner; dönemden bağımsızdır.',
  'rep.descSourceChannel': 'Kaynak ve kanal kırılımındaki sipariş sayıları ve tutarlar (CSV) iner.',
  'rep.descProducts': 'Seçili dönemin ürün tablosu (CSV) iner.',
  'rep.descJugs': 'Seçili dönemin damacana kullanımı tablosu (CSV) iner.',
  'rep.descVehicles': 'Seçili dönemin araç tablosu (CSV) iner.',
  'rep.exportJugs': 'Damacana kullanımı (CSV)',
  'rep.noDataShort': 'Veri yok.',
  'rep.productTableNote':
    'Çok kalemli panel siparişlerinde kalem tutarı katalog fiyatıdır; sipariş toplamı panel tutarıdır.',
  // Aktarım sorgusunun sunucu doğrulaması (`reports.schema.ts`). Panel de aynı kuralları
  // ekranda uygular; metin tek yerde dursun diye buradan okunur.
  'rep.dayInvalid': 'Takvimde olmayan bir gün seçildi.',
  'rep.futureDay': 'Gelecek bir gün için rapor istenemez.',
  'rep.rangeBothRequired': 'Tarih aralığı için başlangıç ve bitiş günü birlikte verilir.',
  'rep.rangeReversed': 'Başlangıç günü bitiş gününden sonra olamaz.',
  'rep.periodConflict': 'Dönem, tek gün ve tarih aralığından yalnız biri seçilebilir.',
  // ── Entegrasyonlar ekranı (ENTEGRASYON.md §5, §14) ──
  //
  // Model DEĞİŞTİ: hiçbir platform bize sipariş GÖNDERMİYOR (webhook yok); üç panelden de biz
  // ÇEKİYORUZ. Webhook adresi/imza anahtarı metinleri bu yüzden kaldırıldı.
  'ch.intro':
    'Siparişler üç bayi panelinden çekilir: Hayat Su, Abant Su ve Getir Su. Giriş bilgilerini ' +
    'bir kez kaydedersin, çekim aktifleştirdikten sonra kendiliğinden çalışır.',
  'ch.coldTestTitle': 'Soğuk test aşaması',
  'ch.coldTestBody':
    'Entegrasyon katmanı kurulu ama gerçek panellere hiçbir istek atılmıyor. Giriş bilgisi ' +
    'kaydedebilirsin; "Aktifleştir" yazılı marka onayı ve ayrı bir karar gelene kadar kapalıdır.',
  'ch.st.PENDING': 'Çekim kapalı',
  'ch.st.ACTIVE': 'Çekim açık',
  'ch.st.ERROR': 'Hata',
  'ch.st.DISABLED': 'Durduruldu',
  'ch.credsSaved': 'Giriş bilgisi kayıtlı',
  'ch.credsMissing': 'Giriş bilgisi girilmedi',
  'ch.configSaved': 'Panel yapılandırması kayıtlı',
  'ch.configMissing': 'Panel yapılandırması girilmedi',
  'ch.username': 'Panel kullanıcı adı',
  'ch.password': 'Panel parolası',
  'ch.credsWriteOnly':
    'Parola şifrelenerek saklanır ve panelden GERİ OKUNAMAZ. Unutulursa yenisi yazılır.',
  'ch.saveCredentials': 'Giriş bilgilerini kaydet',
  'ch.enterCredentials': 'Giriş bilgisi gir',
  'ch.activate': 'Aktifleştir',
  'ch.disable': 'Çekimi durdur',
  'ch.lastFetch': 'Son deneme',
  'ch.lastSuccess': 'Son başarılı çekim',
  'ch.never': 'Henüz yok',
  'ch.errorCount': '{n} ardışık hata',
  'ch.consent': 'Bu panelin verisini kullanmak için markadan yazılı onay aldım.',
  'ch.coldTestBlocked':
    'Bu aşamada bağlantı aktifleştirilemez. Entegrasyon katmanı kurulu ama gerçek panellere ' +
    'bağlanma yazılı marka onayı ve ayrı bir karar gerektiriyor.',
  'ch.disableTitle': '{name} çekimi durdurulsun mu?',
  'ch.disableBody':
    'Bu bağlantıdan veri çekilmez. Yeniden açmak için bağlantıyı aktifleştirmeniz gerekir.',
  'ch.err.noCredentials': 'Giriş bilgisi kayıtlı değil; bağlantı için önce kaydedin.',
  'ch.err.badConfig': 'Panel yapılandırması eksik ya da hatalı; kaydedip yeniden deneyin.',
  'ch.err.generic': 'Son denemede bağlantı kurulamadı.',
  'ch.err.technical': 'Teknik ayrıntı',
  'ch.needsCredentials': 'Önce panel giriş bilgilerini kaydet.',
  'ch.needsConfig': 'Önce panel yapılandırmasını kaydet.',
  'ch.loginNotVerified':
    'Giriş isteği (loginPath) gerçek bir yakalamayla doğrulanmadı; bu bağlantı aktifleştirilemez. ' +
    'Panelde çıkış yapıp DevTools Network açıkken tekrar giriş yaparak isteği yakalayın ' +
    '(adımlar: test/fixtures/SENTETIK.md → "Giriş isteğini yakalama"), sonra config\'i güncelleyip ' +
    '"loginVerified" alanını true yapın.',
  'ch.consentNote': 'Onayın kaydı',
  'ch.consentNoteHint':
    'Kim, ne zaman, hangi kanaldan onay verdi — ör. "Bölge müdürü A.Y., e-posta 10.09.2026".',
  'ch.dryRunConsentRequired': 'Deneme çekiminden önce bağlantı onayı notu girilmeli.',
  // ── Manuel panel oturumu (ADR 2026-10-10-getir-manuel-oturum) ──
  'ch.needsManualSession': 'Bu bağlantı için önce manuel panel oturumunu bağlamalısınız.',
  'ch.manualSessionExpired': 'Bağlı manuel oturumun süresi dolmuş; yeniden bağlayın.',
  'ch.manualSession.required': 'Bağlı manuel oturum yok; yeniden bağlayın.',
  'ch.manualSession.err.format': 'Jeton biçimi tanınmadı (üç noktayla ayrılmış JWT bekleniyordu).',
  'ch.manualSession.err.noExp': 'Jetonun geçerlilik süresi (exp) alanı okunamadı.',
  'ch.manualSession.err.expired': 'Jetonun süresi çoktan dolmuş; panelden taze jeton alın.',
  'ch.manualSession.err.tooLong':
    'Jetonun geçerlilik süresi 48 saatten uzun; daha kısa ömürlü bir jeton kullanın.',
  'ch.manualSession.err.rejected': 'Panel bu jetonu kabul etmedi; taze jetonla yeniden deneyin.',
  'ch.manualSession.err.consentNoteRequired':
    'Bağlantının onayı yok; jetonu bağlamak için önce onay notu girilmeli.',
  'ch.manualSession.err.notManual':
    'Bu bağlantı manuel oturum kullanmıyor; jetonu bağlamak için auth=manual-bearer olmalı.',
  'ch.manualSession.err.killSwitch':
    'Bu kanalın çekimi panelden kapatılmış; jeton denenmedi. Önce kanalı açın.',
  'ch.manualSession.err.backoff':
    'Panel bot doğrulaması istedi; {time} saatine kadar bekleyin, sonra yeniden deneyin.',
  'ch.manualSession.err.botChallenge':
    'Panel bot doğrulaması istedi; jeton denenemedi. Birkaç saat sonra yeniden deneyin.',
  'ch.manualSession.err.liveBlocked': 'Canlı panel erişimi bu sunucuda kapalı; jeton denenemedi.',
  'ch.manualSession.err.invalidResponse':
    'Panel yanıtı beklenen biçimde değil; jeton kabul edildi ama siparişler okunamadı.',
  'ch.manualSession.err.network':
    'Panele ulaşılamadı; jeton denenemedi. Biraz sonra yeniden deneyin.',
  'ch.manualSession.err.getirRequiresManual':
    'Getir bağlantısı yalnız manuel oturumla (auth=manual-bearer) kurulabilir; Getir girişi CAPTCHA istiyor.',
  'channel.unsafePanelUrl':
    'Yapılandırmadaki panel yolu başka bir sunucuya işaret ediyor; istek gönderilmedi.',
  'ch.manualSession.err.unguardedHost':
    'Manuel oturumda API adresi https ve korumalı bir marka alan adı olmalı.',
  // ── Manuel oturum (Getir gibi CAPTCHA'lı paneller) — panel UI metinleri ──
  // S pakete ait anahtarlar (sunucu tarafı): `ch.manualSession.err.*`,
  // `ch.manualSession.required`, `alerts.manualSession.*` — onlara DOKUNMA.
  'ch.manualSession.ui.title': 'Getir oturumunu bağla',
  'ch.manualSession.ui.intro':
    'Getir bayi hesabı girişi CAPTCHA istiyor; sistem giremiyor. Getir Su’ya kendi tarayıcından bir kez gir, ardından oturum jetonunu aşağıya yapıştır. Sunucu jetonu bir kez dener; geçerliyse şifreli saklar, 24 saate kadar otomatik çekimde kullanır.',
  'ch.manualSession.ui.helpTitle': 'Jetonu nasıl alırım?',
  'ch.manualSession.ui.helpBody':
    '1) Getir Su panelini tarayıcıda aç ve hesabınla giriş yap. 2) Giriş sonrası DevTools → Ağ sekmesini aç ve isteklerden birinin “Authorization” başlığında “Bearer …” değerini bul. 3) “…” kısmını (tırnaklar dahil DEĞİL) kopyala, aşağıdaki alana yapıştır. 4) “Bağla”ya bas; sunucu jetonu bir kez dener, geçerliyse oturum aktif olur.',
  'ch.manualSession.ui.tokenLabel': 'Getir oturum jetonu',
  'ch.manualSession.ui.tokenPlaceholder': 'Bearer …',
  'ch.manualSession.ui.connect': 'Bağla',
  'ch.manualSession.ui.connecting': 'Bağlanıyor…',
  'ch.manualSession.ui.connected': 'Getir oturumu bağlandı',
  'ch.manualSession.ui.disconnect': 'Oturumu kopar',
  'ch.manualSession.ui.disconnectTitle': 'Getir oturumunu kopar',
  'ch.manualSession.ui.disconnectBody':
    'Oturum jetonu silinir; bir sonraki çekim denemesi başarısız olur ve “Getir oturumu bağlı değil” uyarısı çıkar. Yeni jeton yapıştırmadıkça Getir siparişleri gelmez.',
  'ch.manualSession.ui.consentLabel': 'Onay kaydı',
  'ch.manualSession.ui.consentHint':
    'Getir bayi onayının nereden geldiğini yaz. Yalnız ilk bağlamada istenir; sonraki bağlamalarda bu alan görünmez.',
  'ch.manualSession.ui.consentRequired': 'Onay kaydı en az 10 karakter olmalı.',
  'ch.manualSession.ui.badge.bound': 'Oturum bağlı',
  'ch.manualSession.ui.badge.expiring': 'Oturum bitiyor',
  'ch.manualSession.ui.badge.unbound': 'Oturum bağlı değil',
  'ch.manualSession.ui.expiresAt': 'Bitiş: {time}',
  'ch.manualSession.ui.expiresAtSoon': 'Bitiş: {time} (60 dk içinde)',
  'ch.mappingTitle': 'Ürün eşleştirme',
  'ch.mappingHint':
    'Kanaldaki ürün adı → sizin ürününüz. Marka ayrımı (Hayat / Abant) buradan yapılır.',
  'ch.unmapped': '{n} eşleşme bekliyor',
  // ── Gelişmiş ayarlar (§14) ──
  'chConfig.title': 'Gelişmiş ayarlar',
  'chConfig.warning': 'Bu alan bağlantının teknik ayarıdır. Şifre burada tutulmaz.',
  'chConfig.editorNote': 'Araç ve şoför eşlemeleri burada görünmez; kendi ekranlarından yönetilir.',
  'chConfig.editorLabel': 'Kanal ayarları (JSON)',
  'chConfig.save': 'Ayarları kaydet',
  'chConfig.saved': 'Ayarlar kaydedildi.',
  'chConfig.jsonInvalid': 'Geçersiz JSON: {message}',
  'chConfig.notObject': 'Ayarlar bir nesne olmalı.',
  'chConfig.saveError': 'Ayarlar kaydedilemedi: {message}',
  // ── Deneme çekimi ──
  'chDryRun.button': 'Deneme çekimi',
  'chDryRun.disabled.noCreds': 'Deneme çekimi için giriş bilgisi gerekli.',
  'chDryRun.disabled.noConfig': 'Deneme çekimi için yapılandırma gerekli.',
  'chDryRun.modalTitle': 'Deneme çekimi',
  'chDryRun.modalBody':
    'Panele bir kez giriş yapılır ve siparişler okunur. Hiçbir sipariş kaydedilmez, otomatik çekim başlamaz.',
  'chDryRun.consentLabel': 'Bağlantı onayı notu',
  'chDryRun.consentHint':
    'Kim, ne zaman, hangi kanaldan onay verdi — ör. "Getir bayi hesabı, sahibin onayıyla".',
  'chDryRun.consentTooShort': 'En az 10 karakter girilmeli.',
  'chDryRun.run': 'Denemeyi başlat',
  'chDryRun.running': 'Deneme çalışıyor…',
  'chDryRun.ok': 'Deneme başarılı: {n} sipariş okundu.',
  'chDryRun.created': '{c} yeni',
  'chDryRun.updated': '{u} güncellenecek',
  'chDryRun.skipped': '{s} atlanacak',
  'chDryRun.unmappedProducts': 'Eşleşmeyen ürünler',
  'chDryRun.unknownChannels': 'Tanınmayan kanallar',
  'chDryRun.emptyFields': 'Boş gelen alanlar',
  'chDryRun.failed': 'Deneme başarısız: {error}',
  'chDryRun.httpError': 'Sunucu hatası: {message}',
  'ch.noMappings': 'Henüz kanaldan ürün gelmedi.',
  'ch.showAllProducts': 'Tüm ürünleri göster',
  // ── Yeni sipariş penceresi bildirimleri (Entegrasyonlar → Hayat → pencere yoklaması) ──
  'lateOrder.alert.pendingTitle': 'Hayat paneline bakın',
  'lateOrder.alert.productUnreadable':
    "{externalId} numaralı siparişin ürünü okunamadı. Hayat panelinde Tamam'a basın; sipariş sonra buraya gelir.",
  'lateOrder.alert.paymentUnmapped':
    "{externalId} numaralı siparişin ödeme tipi tanınmadı. Hayat panelinde Tamam'a basın; sipariş sonra buraya gelir.",
  'lateOrder.alert.multi':
    "{count} sipariş Hayat paneline bekliyor. Hayat panelinde Tamam'a basın; siparişler sonra buraya gelir.",
  'lateOrder.alert.unreadable': 'Hayat paneli okunamadı; panel arayüzü değişmiş olabilir.',
  'lateOrder.alert.sessionRejected':
    'Hayat sipariş penceresi oturumu reddedildi; pencere yoklaması durduruldu. Siparişler tablo turunda gelir.',
  // ── Ürünler ekranı (`urunler`) ──
  //
  // Prototipte "kapsam dışı" işaretliydi; ürün olmadan sipariş girilemediği için gerçek üründe
  // yer tutucu olamaz.
  'productKind.JUG_19L': 'Damacana',
  'productKind.JUG_15L_GLASS': '15L Cam Damacana',
  'productKind.CASE_05L': 'Koli',
  'prod.intro':
    'Sattığın ürünler, birim fiyatları ve depozito tutarları. Fiyat değişikliği yalnız YENİ ' +
    'siparişlere işler; geçmiş siparişler kendi gününün fiyatını taşımaya devam eder.',
  'prod.add': '+ Ürün ekle',
  'prod.save': 'Ürünü ekle',
  'prod.name': 'Ürün adı',
  'prod.namePlaceholder': 'ör. Hayat 19L',
  'prod.kind': 'Tür',
  'prod.brand': 'Marka',
  'prod.unitPrice': 'Birim fiyat',
  'prod.deposit': 'Depozito',
  'prod.noDeposit': 'Depozito yok',
  'prod.noDepositHint': 'Koli geri gelmez, depozitosu olmaz.',
  'prod.jugs': 'Damacanalar',
  'prod.jugsHint': 'Boşu geri alınır; depozito müşteri zimmetine yazılır.',
  'prod.cases': 'Koliler',
  'prod.casesHint': 'Kapanış denklemine girmez, dolu toplamına sayılmaz.',
  'prod.empty': 'Bu türde ürün yok.',
  'prod.inactive': 'pasif',
  'prod.deactivate': 'Pasifleştir',
  'prod.created': '{name} eklendi.',
  'prod.updated': '{name} güncellendi.',
  'prod.deactivated': '{name} pasifleştirildi — geçmiş kayıtlar duruyor.',
  // ── Markalar (Hayat/Abant ayrımı) ──
  // Marka ROZET için 1-2 harflik kod taşır; rozet gösterimi `brand.code` ile doldurulur.
  'brand.tabAll': 'Tümü',
  'brand.tabUnbranded': 'Markasız',
  'brand.badgeTitle': '{code} · {name}',
  'brand.nameLabel': 'Marka adı',
  'brand.unbrandedBadge': 'Markasız',
  'brand.createTitle': 'Marka ekle',
  'brand.namePlaceholder': 'ör. Hayat Su',
  'brand.codePlaceholder': 'Rozet kodu · ör. H',
  'brand.codeInputPlaceholder': 'H',
  'brand.activate': 'Etkinleştir',
  'brand.created': '{name} eklendi.',
  'brand.deactivated': '{name} pasifleştirildi — ürünleri duruyor.',
  'brand.reactivated': '{name} yeniden aktif.',
  'brand.nameTaken': 'Bu adda bir marka zaten var.',
  'brand.codeTaken': 'Bu kod zaten başka bir markada kullanılıyor.',
  'brand.passiveSuffix': ' (pasif)',
  'brand.productNameUniqueHint':
    'Ürün adı markalar arasında da tekil olmalı; "Hayat 19L" ile "Abant 19L" aynı kayıt olamaz.',
  'brand.intro':
    'Sattığın markalar (Hayat, Abant). Her ürün bir markaya bağlanır; markasız ürün de olabilir.',
  // ── Araçlar & Ekip ekranı (`ekip`, panel §3.14) ──
  'fleet.vehicles': 'Araçlar',
  'fleet.vehiclesHint':
    'Her araç bir sefer açar. Plaka, şoför uygulamasında göründüğü haliyle yazılır.',
  'fleet.addVehicle': '+ Araç ekle',
  'fleet.saveVehicle': 'Aracı ekle',
  'fleet.platePlaceholder': 'Plaka · 34 XYZ 678',
  'fleet.labelPlaceholder': 'Model · Beyaz Kango',
  'fleet.plateField': 'Plaka',
  'fleet.labelField': 'Model / etiket',
  'fleet.capacity': 'Kapasite',
  'fleet.retireConfirm':
    '{plate} pasifleştirilsin mi? Pasif araçla yeni sefer açılamaz; geçmiş seferleri olduğu gibi kalır.',
  'fleet.plateHint': 'Plaka sunucuda düzeltilir: 34abc123 → 34 ABC 123.',
  'fleet.noVehicles': 'Henüz araç eklenmedi.',
  'fleet.noDriver': 'Şoför atanmadı',
  'fleet.vehicleAdded': '{plate} eklendi · şoför uygulamasında araç listesinde görünür.',
  'fleet.vehicleUpdated': '{plate} güncellendi.',
  'fleet.vehicleRetired': '{plate} pasifleştirildi — geçmiş seferleri duruyor.',
  'fleet.retire': 'Pasifleştir',
  'fleet.retired': 'pasif',
  'fleet.phonePlaceholder': 'Telefon · 05xx',
  'fleet.noVehicleYet': 'Araç sonra atansın',
  'fleet.noVehicle': 'Zimmet yok',
  'fleet.assignedVehicle': 'Zimmetli araç',
  'fleet.noPhone': 'Telefon girilmedi',
  'fleet.neverIn': 'Henüz girmedi',
  'fleet.resetPin': 'PIN sıfırla',
  'fleet.driverRetired': '{name} pasifleştirildi · PIN artık çalışmaz.',
  'fleet.reactivate': 'Geri al',
  // Pasifleştirme PIN'e dokunmaz (drivers.service.ts deactivate); geri alınca ESKİ PIN
  // yeniden geçerli olur. Kullanıcı "yeni PIN üretmem mi gerek" diye sormasın diye yazılı.
  'fleet.driverReactivated': '{name} yeniden aktif · eski PIN tekrar çalışır.',
  'fleet.vehicleAssigned': '{name} → {plate} zimmetlendi.',
  'fleet.vehicleCleared': '{name} zimmeti kaldırıldı.',
  'fleet.pinReady': '{name} için PIN hazır',
  'fleet.pinOnce': 'Bu PIN bir daha gösterilmez. Şoföre ilet, ilk girişte kendisi değiştirebilir.',
  'fleet.copy': 'Kopyala',
  'fleet.copied': 'Kopyalandı ✓',
  'fleet.pinCopied': 'PIN panoya kopyalandı.',
  // ── Personel ekranı (`/personel`) ──
  //
  // "Ekip" ve "Şoförler" ayrı ekranlardan tek "Personel" ekranına toplandı (21.10 kararı).
  // Metinler burada; ekranda gömülü Türkçe yok.
  'personnel.title': 'Personel',
  'personnel.tabPeople': 'Kişiler',
  'personnel.tabPerformance': 'Performans',
  'personnel.peopleHint':
    'Personel listesi, araç zimmetleri ve telefonla giriş yapılan cihazlar. Defter rakamları sunucudan gelir.',
  'personnel.addPerson': '+ Personel ekle',
  'personnel.savePerson': 'Kaydet',
  'personnel.closeDetail': 'Kapat',
  // Yıkıcı işlem onayları (PIN sıfırla, pasifleştir): gövde kimi neyin etkilediğini söyler.
  'personnel.resetPinConfirm':
    '{name} için yeni PIN üretilir ve eski PIN çalışmaz. Bu şoför yeni PIN ile girene kadar uygulamaya giremez.',
  'personnel.retireConfirm':
    '{name} pasifleştirilsin mi? Bu şoförün PIN’i artık çalışmaz; geçmiş kayıtları olduğu gibi kalır.',
  // Telefon zorunlu (P2): numaranın son 4 hanesi giriş anahtarıdır.
  'personnel.phoneLabel': 'Telefon *',
  'personnel.phoneRequiredHint':
    'Telefon zorunlu: numaranın son 4 hanesi telefonla giriş anahtarıdır. Aynı son 4 hanesi iki personelde olamaz.',
  'personnel.phoneRequiredError': 'Telefon boş bırakılamaz.',
  'personnel.phoneTailTakenError':
    'Bu telefonun son 4 hanesi kiracıda başka bir personelde tanımlı. Farklı bir numara girin.',
  'personnel.phoneMissingBadge': 'Telefon yok — mobil giriş yapamaz',
  'personnel.addPhone': 'Telefon ekle',
  'personnel.partialSaveError': 'Ad ve telefon kaydedildi, zimmet kaydedilmedi: {error}',
  'personnel.partialSaveErrorManager': 'Ad kaydedildi, zimmet kaydedilmedi: {error}',
  'personnel.ownerProfileBadge': 'Patron profili',
  'personnel.openTripBadge': 'Seferde · {plate}',
  'personnel.neverLoggedInBadge': 'Hiç giriş yapmadı',
  'personnel.loggedIn7Days': 'Son 7 günde girdi',
  'personnel.notLoggedIn7Days': 'Son 7 günde girmedi',
  'personnel.openOwnerProfile': 'Patron profili aç',
  'personnel.ownerProfileOpened': 'Patron personeli profili açıldı.',
  'personnel.noPeople': 'Henüz personel eklenmedi.',
  'personnel.detailTitle': 'Personel detayı',
  'personnel.tabInfo': 'Bilgiler',
  'personnel.tabLedger': 'Defter',
  'personnel.tabDevices': 'Cihazlar',
  'personnel.infoFullName': 'Ad Soyad',
  'personnel.infoPhone': 'Telefon',
  'personnel.infoVehicle': 'Zimmetli araç',
  'personnel.infoSaved': 'Personel bilgileri güncellendi.',
  'personnel.infoOwnerProfileNote':
    'Patron profilinin adı ve telefonu patron hesabındadır; buradan değiştirilemez.',
  'personnel.ledgerFrom': 'Başlangıç',
  'personnel.ledgerTo': 'Bitiş',
  'personnel.ledgerRangeError': 'Aralık en fazla 31 gün olabilir.',
  'personnel.printTitle': 'Personel defteri · {name} · {from} – {to}',
  'personnel.ledgerEmpty': 'Bu aralıkta defter kaydı yok.',
  'personnel.ledgerTotal': 'Aralık toplamı',
  'personnel.ledgerTrips': 'Sefer',
  'personnel.ledgerDeliveries': 'Teslimat',
  'personnel.ledgerCollected': 'Tahsilat',
  'personnel.ledgerFloatClosing': 'Emanet kapanışı',
  'personnel.ledgerDeposit': 'Depozito',
  'personnel.ledgerDayTitle': 'Gün detayı',
  'personnel.ledgerCustomer': 'Müşteri',
  'personnel.ledgerPayment': 'Ödeme',
  'personnel.ledgerNoDeliveries': 'Bu günde teslimat yok.',
  'personnel.devicesEmpty': 'Bu personelin cihazı yok.',
  'personnel.devicesPending': 'Onay bekliyor',
  'personnel.devicesApproved': 'Onaylı',
  'personnel.devicesRevoked': 'İptal edilmiş',
  'personnel.deviceApproveCode': 'Eşleştirme kodu',
  'personnel.deviceApprove': 'Onayla',
  'personnel.deviceRevoke': 'Cihazı iptal et',
  'personnel.deviceApprovedToast': 'Cihaz onaylandı.',
  'personnel.deviceRevokedToast': 'Cihaz iptal edildi.',
  'personnel.deviceNoLabel': 'İsimsiz cihaz',
  'personnel.deviceLocked': 'Kilitli · {minutes} dk kaldı',
  'personnel.deviceUnlock': 'Kilidi kaldır',
  'personnel.deviceUnlockedToast': 'Telefonun kilidi kaldırıldı.',
  'personnel.deviceNeverSeen': 'Hiç görülmedi',
  // ── UX-C: kanal eşlemesi ve performans (blok sonu) ──
  'personnel.tabPerf': 'Performans',
  'personnel.channelTitle': 'Kanal eşlemesi',
  'personnel.channelIntro':
    'Bayi panelinden gelen siparişlerin bu kişiye düşmesi için panelde kullanılan numarayı seçin.',
  'personnel.channelAbant': 'Abant çalışan no',
  'personnel.channelAbantHint':
    'Panel Atama ekranındaki Abant eşlemesiyle aynı kayıttır; birinde değişen ötekinde de değişir.',
  'personnel.channelNone': 'Eşleme yok',
  'personnel.channelTakenBy': '{label} (şu an {ad} ile eşli)',
  'personnel.channelNoLabels': 'Abant panelinden henüz çalışan numarası görülmedi.',
  'personnel.channelSave': 'Eşlemeyi kaydet',
  'personnel.channelSaved': 'Kanal eşlemesi kaydedildi.',
  'personnel.channelOwnerOnly': 'Eşlemeyi yalnız patron değiştirebilir.',
  'personnel.channelLoadError': 'Kanal eşlemesi okunamadı.',
  'personnel.channelRematchFailed':
    'Eşleme kaydedildi ama bekleyen siparişler yeniden eşlenemedi. Panel Atama ekranından kontrol edin.',
  'personnel.perfIntro':
    'Rakamlar şoförün uygulamadan kaydettiği teslimatlardır; bayi panelinde kapanan siparişler kişiye yazılmaz. Tek bir puan yoktur, kanıtı görürsünüz.',
  'personnel.perfWindow7': 'Son 7 gün',
  'personnel.perfWindow30': 'Son 30 gün',
  'personnel.perfThisPerson': 'Bu kişi',
  'personnel.perfFleet': 'Filo ortalaması',
  'personnel.perfFleetNote': '{n} kişinin ortalaması',
  'personnel.perfNoTrips': 'Bu dönemde seferi yok.',
  'personnel.perfTrips': 'Sefer',
  'personnel.perfDeliveries': 'Teslimat',
  'personnel.perfJugs': 'Damacana',
  'personnel.perfFloat': 'Üstündeki nakit (emanet)',
  'personnel.perfDeposit': 'Alınan depozito',
  'personnel.perfBySource': 'Nereye ne kadar sattı',
  'personnel.perfSourceLine': '{n} teslimat · {jugs} damacana · {tutar}',
  'personnel.perfMismatch': 'Sayım uyuşmazlığı',
  'personnel.perfMismatchOk': 'Kapanan {n} seferin hepsi tuttu.',
  'personnel.perfMismatchBad': '{k} / {n} seferde fark var.',
  'personnel.perfMismatchNone': 'Bu dönemde kapanan sefer yok.',
  'personnel.perfMismatchShow': 'Seferleri göster',
  'personnel.perfMismatchRow': '{gun} · {plaka} · dolu fark {dolu} · boş fark {bos}',
  'personnel.perfMismatchRowHint':
    'Artı: yüklenen ya da alınan, satış ve dönüşle açıklanamadı. Eksi: fazla döndü.',
  'personnel.perfLoadError': 'Performans verisi okunamadı.',
  'personnel.perfOverviewTitle': 'Kişi bazında son 7 ve 30 gün',
  'personnel.perfColPerson': 'Kişi',
  'personnel.perfColMismatch': 'Fark olan sefer',
  // ── Ayarlar ekranı (`ayarlar`) ──
  //
  // Prototipte "kapsam dışı"ydı; gerçek üründe olamaz çünkü kill switch'in evi burasıdır
  // (CLAUDE.md kural 10): anahtar panelde bulunmazsa kural yazılı bir niyet olarak kalır.
  'tenantStatus.ACTIVE': 'Etkin',
  'tenantStatus.READONLY': 'Salt okunur',
  'tenantStatus.SUSPENDED': 'Askıda',
  'set.killSwitch': 'Marka paneli veri çekimi',
  'set.killSwitchHint':
    'Marka "durun" derse aynı gün durdurulur; kod değişikliği ve dağıtım gerekmez. ' +
    'Kapalıyken çekim işi hiç başlamaz.',
  'set.flagHayat': 'Hayat Su bayi paneli',
  'set.flagAbant': 'Abant Su bayi paneli',
  'set.flagGetir': 'Getir Su bayi paneli',
  'set.flagPos': 'POS ile tahsilat',
  'set.on': 'Açık',
  'set.off': 'Kapalı',
  'set.turnOn': 'Aç',
  'set.turnOff': 'Durdur',
  'set.flagOn': 'Açıldı.',
  'set.flagOff': 'Durduruldu · yeni çekim başlamayacak.',
  'set.flagOffTitle': '{label} kapatılsın mı?',
  'set.flagOffBody':
    'Kapatılınca bu özellik durur. Yeniden açmak için yetkili kişi "Aç" düğmesine basar.',
  'set.flagOffBodyWriter': "Kapatılınca Hayat'a yazma durur. Yeniden açma yetkisi patrondadır.",
  'set.killSwitchManage': "Entegrasyonlar'da yönet",
  'set.thresholds': 'Uyarı eşikleri',
  'set.thresholdsHint':
    'Uyarılar saklanmaz, her istekte hesaplanır; eşiği değiştirmek geçmişi değil, bundan sonra ' +
    'ne görüleceğini değiştirir.',
  'set.unassignedMinutes': 'Atanmamış sipariş uyarısı',
  'set.unassignedMinutesHint':
    'Sipariş bu süredir bir araça atanmadıysa panoda kritik uyarı çıkar.',
  'set.kmVariance': 'Açıklanmayan km eşiği',
  'set.kmVarianceHint':
    'Şoförün beyanı ile konumdan hesaplanan mesafe bu kadar ayrılırsa satır kehribar olur.',
  'set.lowStock': 'Düşük stok eşiği',
  'set.lowStockHint': 'Depodaki dolu damacana bu sayının altına inince uyarı çıkar.',
  'set.unitMinutes': 'dakika',
  'set.unitKm': 'km',
  'set.unitJugs': 'damacana',
  'set.unitDays': 'gün',
  'set.range': '{min}–{max} arası',
  'set.saved': 'Eşikler kaydedildi.',
  'set.quietHours': 'Sessiz saat',
  'set.quietHoursHint':
    'Bu saatler arasında acil olmayan bildirimler telefona gönderilmez; sessiz saat bitince tek bir özet gelir. Acil (kritik) bildirimler her zaman gönderilir. Başlangıç ve bitiş aynıysa sessiz saat kapalıdır.',
  'set.quietStart': 'Başlangıç',
  'set.quietEnd': 'Bitiş',
  'set.quietSaved': 'Sessiz saat kaydedildi.',
  'set.quietOwnerOnly': 'Sessiz saati yalnız patron değiştirebilir.',
  'set.tenant': 'Bayi bilgileri',
  'set.tenantName': 'Bayi adı',
  'set.timezone': 'Saat dilimi',
  'set.accessStatus': 'Erişim durumu',
  'set.panelVersion': 'Panel sürümü',
  'set.tenantHint':
    'Bayi adı ve saat dilimi kurulumda belirlenir. Erişim askıya alınsa bile dışa aktarma çalışır ve ' +
    'açık seferi olan şoför gününü kapatabilir.',
  // ── UX-C: ayar grupları (blok sonu) ──
  'set.group.business': 'İşletme',
  'set.group.businessHint': 'Bayi bilgileri ve yeni siparişlerin kime gideceği.',
  'set.group.hours': 'Çalışma saatleri',
  'set.group.hoursHint': 'Bildirimlerin susacağı saatler.',
  'set.group.notifications': 'Bildirimler',
  'set.group.notificationsHint': 'Telefonlara bildirim ulaşıyor mu, buradan denersiniz.',
  'set.group.advanced': 'Gelişmiş',
  'set.group.advancedHint': 'Nadiren değişen ayarlar. Ne yaptığınızdan emin değilseniz dokunmayın.',
  'set.tenantNameHint': 'Kurulumda belirlenir, buradan değiştirilmez.',
  'set.timezoneHint': 'Sefer günü ve raporlar bu saat dilimine göre kesilir.',
  'set.accessStatusHint': 'Askıya alınırsa yeni iş başlatılamaz, verilere erişim sürer.',
  'set.quietStartHint': 'Bu saatten sonra bildirim gitmez.',
  'set.quietEndHint': 'Bu saatte bildirimler yeniden başlar.',
  'set.hayatModeHint':
    'Gölge yalnız karşılaştırır, Onaylı sizin onayınızla yazar, Otonom kendi başına yazar.',
  'set.hayatConfirmHint': 'Yanlışlıkla değişmesin diye aynı kipi bir kez daha seçin.',
  // ── Kurulum sihirbazı (`kurulum`, panel §3.2) ──
  //
  // "Tamamlandı" işareti kullanıcının bastığı bir düğme değil, kaydın kendisidir: ürün varsa
  // adım yeşil. Böylece yarıda bırakılıp dönüldüğünde doğru yerden devam eder.
  'setup.title': 'Kurulum',
  'setup.step1': 'Ürünler',
  'setup.step2': 'Araçlar',
  'setup.step3': 'Ekip',
  'setup.step4': 'Kanallar',
  'setup.s1Title': 'Ürünlerini tanımla',
  'setup.s1Lead': 'Sattığın ürünler ve depozito tutarları. Sonradan her zaman değiştirebilirsin.',
  'setup.s1Note':
    'Fiyat değişikliği yalnız yeni siparişlere işler; geçmiş siparişler kendi gününün fiyatını tutar.',
  'setup.s1Cta': 'Ürünler ekranı',
  'setup.s2Title': 'Araçlarını ekle',
  'setup.s2Lead': 'Her araç bir sefer açar. Plaka, şoför uygulamasında göründüğü haliyle yazılır.',
  'setup.s2Note': 'Yedek araçları da ekle; sefer açılmadıkça hiçbir yerde sayılmaz.',
  'setup.s2Cta': 'Araçlar & Ekip',
  'setup.s3Title': 'Ekibini tanımla',
  'setup.s3Lead': 'Şoförlere 6 haneli PIN üretilir; PIN yalnız bir kez gösterilir.',
  'setup.s3Note': 'Yönetici e-posta ile, şoför telefon + PIN ile girer.',
  'setup.s3Cta': 'Ekip ekranı',
  'setup.s4Title': 'Sipariş kanallarını bağla',
  'setup.s4Lead':
    'Son adım. Üç bayi panelinin giriş bilgisini kaydedersin; çekim ayrıca aktifleştirilir.',
  'setup.s4Note':
    'Telefon ve WhatsApp siparişi her zaman açıktır, ayar gerektirmez — elle girilir.',
  'setup.s4Cta': 'Entegrasyonlar',
  'setup.emptyStep': 'Bu adımda henüz kayıt yok.',
  'setup.noLabel': 'Model girilmedi',
  'setup.chReady': 'Giriş bilgisi kayıtlı',
  'setup.chPending': 'Bağlanacak',
  'setup.back': 'Geri',
  'setup.next': 'Devam',
  'setup.finish': 'Kanallara geç',
  // ── Kanallar (Faz 6) ──
  'channel.notFound': 'Kanal bulunamadı.',
  'channel.configStale': 'Ayarlar bu sırada başka bir işlemle değişti; lütfen tekrar deneyin.',
  'channel.mappingNotFound': 'Ürün eşleştirmesi bulunamadı.',
  'channel.alreadyRunning': 'Bu kanal için zaten bir işlem sürüyor.',
  'channel.badConfig': 'Kanal yapılandırması geçersiz.',
  'channel.loginBackoff': 'Ardışık başarısız giriş nedeniyle kısa süre bekleniyor.',
  'channel.noCredentials': 'Giriş bilgileri kayıtlı değil.',
  // ── Master-data import (Hayat panel) ──
  'import.apply': 'Fiyatları güncelle',
  'import.applyConfirm': "Hayat'taki fiyatlar listedeki gibi uygulanacak. Devam edilsin mi?",
  'import.pathMissing': 'Bu kanalda ürün aktarım yolu tanımlı değil.',
  'import.summary':
    '{read} okundu · {unchanged} aynı · {priceChanges} değişecek · {unmatched} eşleşmedi',
  'import.priceChangesHeading': 'Değişecek fiyatlar',
  'import.unmatchedHeading': 'Eşleşmeyenler',
  'import.ambiguousHeading': 'Birden çok eşleşme',
  'import.colProduct': 'Ürün',
  'import.colCurrent': 'Bizdeki fiyat',
  'import.colHayat': 'Hayat fiyatı',
  'import.appliedNotice': 'Fiyatlar güncellendi.',
  'import.failedHeading': '{count} ürün güncellenemedi',
  'import.failReason.not-found': 'ürün bulunamadı',
  'import.failReason.conflict': 'çakışma',
  'import.failReason.invalid': 'geçersiz değer',
  'import.failReason.unknown': 'bilinmeyen hata',
  'import.notActive': 'Bağlantı etkin ya da onaylı değil; aktarım çalıştırılamaz.',
  'import.fetchFailed': 'Hayat fiyat sayfası okunamadı (HTTP {status}).',
  'import.candidates': '{count} aday',
  'import.multipleRows': 'birden çok Hayat satırı: {rows}',
  'import.skippedHeading': 'Atlananlar ({count})',
  'import.skipReason.inactive': 'ürün pasif',
  'import.skipReason.other-brand': 'Hayat markasında değil',
  // ── Takip (Faz 5) ──
  'scraper.disabled': '{source} veri çekimi panelden kapatılmış.',

  'tracking.tripClosed': 'Kapanmış sefere konum yazılamaz.',
  // İptal, kapanış değildir: aynı metni iki duruma vermek şoföre yanlış bilgi verirdi.
  'tracking.tripVoided': 'İptal edilmiş sefere konum yazılamaz.',
  // P4 duruş çıktısı — seferde duruş yoksa boş döner; bilinen yerler kapatılır ama rapor
  // hâlâ duruşu listeler (IGNORE görünür değildir).
  'tracking.stopsTitle': 'Sefer duruşları',
  'tracking.stopsEmpty': 'Bu seferde tespit edilen duruş yok.',
  'tracking.stopKind.DELIVERY': 'Teslimat',
  'tracking.stopKind.CUSTOMER': 'Müşteri',
  'tracking.stopKind.PLACE': 'Bilinen yer',
  'tracking.stopKind.UNMATCHED': 'Eşlenmeyen',
  'tracking.stopKind.GAP': 'Konum boşluğu',
  'tracking.deliveryWithoutStopTitle': 'Durağı olmayan teslimatlar',
  'tracking.deliveryWithoutStopEmpty': 'Durağı olmayan teslimat yok.',
  'tracking.tripAuditAlreadyDecided': 'Bu duruş inceleme kaydı zaten karara bağlanmış.',
  'tracking.tripAuditConfirmNoteRequired': 'Red için en az 10 karakter açıklama zorunlu.',
  'tracking.tripAuditNotFound': 'Duruş inceleme kaydı bulunamadı.',
  'tracking.tripAuditTitle': 'Konum denetimi — duruş işaretleri',
  'tracking.tripAuditFlagsPrefix': 'İşaretler',
  'tracking.tripAuditFlag.unmatched': 'eşlenmeyen duruş',
  'tracking.tripAuditFlag.gap': 'konum boşluğu',
  'tracking.tripAuditFlag.noLocation': 'konum hiç alınmadı',
  'tracking.tripAuditFlag.mocked': 'sahte konum',
  // ── Stok ekranı (§3.12) ──
  'stock.kpiDepotFull': 'Depoda dolu',
  'stock.kpiDepotEmpty': 'Depoda boş',
  'stock.kpiOnVehicles': 'Araçlarda',
  'stock.kpiWithCustomers': 'Müşteride açık',
  'stock.kpiForeign': 'Yabancı marka boş',
  'stock.readyForFill': 'Dolum için hazır',
  'stock.negativeBadge': 'Eksi stok',
  'stock.negativeWarning':
    'Bu satır eksi bakiyede. Fiziksel olarak imkânsızdır; büyük ihtimalle açılış stoğu ya da fabrika sevkiyatı girilmemiş.',
  'stock.nVehicles': '{n} araçta',
  'stock.openShelfAccount': 'Takas/iade hesabını aç',
  'stock.foreignTitle': 'Yabancı marka boş — takas/iade hesabı',
  'stock.foreignHint': 'Yabancı marka boş damacanaların takas ve iade takibi bu hesapta tutulur.',
  'stock.foreignExplain':
    'Müşteri farklı markanın boş damacanasını verdiğinde onu kabul ediyorsun ama fabrikaya kendi markanın boşu olarak veremiyorsun. Bu yüzden yabancı boş ayrı rafta durur; fabrika sevkiyatında karşı markaya iade edilir ya da bayiler arası takas ile kendi markanın boşuna çevrilir. Çevrilene kadar kendi boş stoğundan düşülmüş sayılır.',
  'stock.foreignReceived': 'Kabul edilen yabancı boş',
  'stock.foreignSwapped': 'Takasla çevrilen',
  'stock.foreignReturned': 'Markaya iade edilen',
  'stock.foreignOnShelf': 'Rafta bekleyen',
  'stock.swap': 'Takasla çevir',
  'stock.return': 'İade et',
  'stock.brand': 'Marka',
  'stock.qty': 'Adet',
  'stock.newShipment': '+ Fabrika sevkiyatı gir',
  'stock.shipmentTitle': 'Fabrika sevkiyatı',
  'stock.shipmentHint':
    'Fabrikadan gelen dolu damacana depoya girer; boşlar aynı araçla markaya döner.',
  'stock.qtyFull': 'Gelen dolu',
  'stock.qtyEmptyOut': 'Giden boş',
  'stock.waybill': 'İrsaliye no',
  'stock.saveShipment': 'Depoya işle',
  'stock.ledger': 'Hareket defteri',
  'stock.ledgerNote': 'Kayıtlar silinmez. Düzeltme gerekiyorsa deftere yeni satır eklenir.',
  'stock.colTime': 'Zaman',
  'stock.colMove': 'Hareket',
  'stock.colProduct': 'Ürün',
  'stock.colQty': 'Adet',
  'stock.colRef': 'Referans',
  'stock.colBy': 'Kaydeden',
  'stock.adjust': 'Düzeltme gir',
  'stock.adjustReason': 'Gerekçe (zorunlu)',
  'stock.adjustHint':
    'Kırılma, fire ya da sayım farkı. Eksi yazarsan stoktan düşer, artı yazarsan eklenir.',
  'stock.product': 'Ürün',
  'stock.location': 'Konum',
  'stock.condition': 'Durum',
  'stock.full': 'Dolu',
  'stock.empty': 'Boş',
  'stock.depot': 'Depo',
  'stock.vehicle': 'Araç',
  'stock.noMoves': 'Hareket yok.',
  'stock.noForeign': 'Rafta yabancı marka boş yok.',
  'stock.pendingApprovals': '{n} onay bekliyor',
  'moveType.DEPOT_TO_VEHICLE': 'Depodan araca',
  'moveType.VEHICLE_TO_DEPOT': 'Araçtan depoya',
  'moveType.SALE': 'Araçtan müşteriye',
  'moveType.EMPTY_PICKUP': 'Müşteriden araca (boş)',
  'moveType.FACTORY_IN': 'Fabrikadan depoya (dolu)',
  'moveType.FACTORY_OUT': 'Depodan fabrikaya (boş)',
  'moveType.FOREIGN': 'Yabancı marka',
  'moveType.LOSS': 'Kırılma / fire',
  'moveType.ADJUSTMENT': 'Düzeltme',
  // ── Stok (Faz 4, §3.12) ──
  'stock.brandNotFound': 'Marka bulunamadı.',
  'stock.foreignTooMany': 'Rafta yalnız {onShelf} adet var; daha fazlası kapatılamaz.',
  'stock.vehicleRequired': 'Araç stoğu düzeltmesi için araç seçilmeli.',
  'stock.qtyNonZero': 'Adet sıfır olamaz.',
  // ── Stok sayımı (P2, §3-4) ──
  'stockCount.tripRequired': 'Araç sayımı için sefer zorunlu.',
  'stockCount.vehicleRequired': 'Araç sayımı için araç zorunlu.',
  'stockCount.vehicleMismatch': 'Araç seferle eşleşmiyor.',
  'stockCount.tripClosed':
    'Sefer sayıma açık değil; yükleme, yolda ya da kapanış aşamasında olmalı.',
  'stockCount.duplicateLine': 'Aynı kalem sayımda iki kez yazılamaz.',
  'stockCount.productRequired': 'Depo sayımında her satır için ürün seçilmeli.',
  'stockCount.productForbidden': 'Araç sayımı tür toplamıdır; satıra ürün yazılamaz.',
  'stockCount.productNotFound': 'Sayım satırındaki ürün bulunamadı.',
  'stockCount.productKindMismatch': 'Sayım satırındaki tür ürünün türüyle uyuşmuyor.',
  'stockCount.scope.DEPOT': 'Depo',
  'stockCount.scope.VEHICLE': 'Araç',
  'stockCount.diffTitle': '{scope} sayımı farkla kaydedildi',
  'stockCount.diffBody': '{scope} sayımında toplam fark {diff} adet.',
  'stockCount.uncountedTitle': '{scope} sayımında {count} kalem sayılmadı',
  'stockCount.uncountedNote': '{count} kalem sayılmadı.',
  'stockCount.adjustmentWarning':
    'Aralıkta {count} elle depo düzeltmesi var; aralık Δ yapay olarak büyüyebilir.',
  'shipment.emptyBoth': 'Gelen dolu ve giden boş birlikte sıfır olamaz.',
  'shipment.receive.waybillRequired': 'İrsaliye numarası zorunludur.',
  'shipment.receive.clientIdTaken':
    'Bu istek anahtarı başka bir sevkiyatta kullanılmış. Sayfayı yenileyip yeniden deneyin.',
  'stock.depotDay.invalidDay': 'Gün, YYYY-AA-GG biçiminde geçerli bir tarih olmalı.',
  // ── Stok tablosu bölümleri (damacana/koli ayrımı) ──
  'stock.section.jugs': 'Damacana',
  'stock.section.cases': 'Koli ve pet su',
  // ── Belgeden stok girişi ──
  'stockIntake.openButton': 'Belgeden ekle',
  'stockIntake.modalTitle': 'Belgeden stok girişi',
  'stockIntake.tabPhoto': 'Fotoğraf / PDF',
  'stockIntake.tabPaste': "Excel'den yapıştır",
  'stockIntake.filePrompt': 'Fotoğraf ya da PDF seçin',
  'stockIntake.pasteLabel': "Excel'den kopyaladığınız satırları buraya yapıştırın",
  'stockIntake.pasteHint': 'Sekmeyle ya da virgülle ayrılmış satırlar; en çok 200 satır.',
  'stockIntake.readButton': 'Oku',
  'stockIntake.reading': 'Okunuyor…',
  'stockIntake.colProduct': 'Ürün',
  'stockIntake.colFull': 'Dolu',
  'stockIntake.colEmpty': 'Boş',
  'stockIntake.colDate': 'Belge tarihi',
  'stockIntake.colWaybill': 'İrsaliye',
  'stockIntake.colConfidence': 'Güven',
  'stockIntake.confidenceHigh': 'Yüksek',
  'stockIntake.confidenceLow': 'Düşük',
  'stockIntake.removeLine': 'Satırı sil',
  'stockIntake.chooseProduct': 'Seçiniz',
  'stockIntake.noLines': 'Okunan satır yok.',
  'stockIntake.saveButton': 'Kaydet ({n} satır)',
  'stockIntake.saving': 'Kaydediliyor…',
  'stockIntake.saveDone': 'Kaydedildi.',
  'stockIntake.needOneInput': 'Fotoğraf/PDF ya da yapıştırılan metinden biri gerekli.',
  'stockIntake.aiDisabled':
    "Fotoğraftan okuma için yapay zekâ anahtarı tanımlı değil; Excel'den yapıştırabilirsiniz.",
  'stockIntake.unsupportedType': 'Desteklenmeyen dosya türü.',
  'stockIntake.tooLarge': 'Dosya en fazla 8 MB olabilir.',
  'stockIntake.unreadable': 'Belge okunamadı; satırlar tanınamadı.',
  'stockIntake.tooManyLines': 'En fazla {n} satır işlenir.',
  'stockIntake.unitWarning': '{rawName}: birim {unit}; adet olarak düzeltin.',
  'stockIntake.qtyUnrecognized': '{rawName}: adet okunamadı; düzeltin.',
  'stockIntake.dateInvalid': '{rawName}: tarih okunamadı; düzeltin.',
  'stockIntake.aiUnavailable':
    "Yapay zekâ şu an yanıt vermiyor; birazdan tekrar deneyin ya da Excel'den yapıştırın.",
  'stockIntake.aiTimeout':
    "Yapay zekâ zamanında yanıt vermedi; tekrar deneyin ya da Excel'den yapıştırın.",
  'stockIntake.confirmLow': 'Doğru',
  'stockIntake.confirmLowHint': 'Düşük güvenli satır — düzenleyin ya da "Doğru" işaretleyin.',
  'stockIntake.newDocHint':
    'Kaydedilen satırlar stoğa işlendi. Başka bir belge için pencereyi kapatıp açın; aynı belgeyi yeniden okumayın, kaydedilen satırlar iki kez yazılır.',
  // ── Çok kalemli fabrika irsaliyesi (S7) ──
  'stock.receive.waybillDuplicate':
    'Bu irsaliye ({waybillNo}) bu marka için daha önce teslim alınmış.',
  'stock.receive.duplicateProduct': 'Aynı ürün irsaliyede iki kez yer alamaz.',
  'stock.receive.productRequired': 'Ürün zorunludur.',
  'stock.receive.brandMismatch': 'İrsaliyenin kalemleri aynı markaya ait olmalıdır.',
  'stock.receive.mixedBody':
    'Çok kalemli irsaliyede adetler kalemlerin içinde yazılır; üst düzeydeki tek kalemli alanlar kullanılamaz.',
  'stock.receive.emptyLine':
    'Kalemde gelen dolu ve giden boş adedi birlikte sıfır olamaz.',
  'stock.intro':
    'Damacanalarınızın şu an nerede olduğunu tek bakışta görürsünüz: depoda, araçlarda ve müşterilerde. Rakamlar kayıtlardan otomatik hesaplanır.',
  'stock.kpiOnVehiclesFull': 'Araçlarda dolu',
  'stock.kpiOnVehiclesEmpty': 'Araçlarda boş',
  'stock.kpiCustomerHeld': 'Müşteride (zimmet)',
  'stock.customerHeldNote': 'Müşterinin elinde, henüz geri dönmemiş',
  'stock.actionsIntro': 'Stok kaydı yapmak için sırayla seçin:',
  'stock.actionStep1': '1. Fabrika sevkiyatı gir',
  'stock.actionStep2': '2. Belgeden ekle',
  'stock.actionStep3': '3. Düzeltme gir',
  // ── Panel: çok kalemli stok girişi (belgeden ekle) ──
  'panel.stockIntake.waybillLabel': 'İrsaliye no',
  'panel.stockIntake.waybillRequired': 'İrsaliye no girilmeden kaydedilemez.',
  'panel.stockIntake.docDateLabel': 'Belge tarihi',
  'panel.stockIntake.colQty': 'Adet',
  'panel.stockIntake.colEmptyOut': 'Boş çıkış',
  'panel.stockIntake.brandMismatch': 'İrsaliyenin kalemleri aynı markaya ait olmalıdır.',
  'panel.stockIntake.productWithoutBrand': 'Markası olmayan ürün kaydedilemez.',
  'panel.stockIntake.multipleWaybills': 'Belgede birden fazla irsaliye numarası var; doğru numarayı girin.',
  'panel.stockIntake.addLine': 'Satır ekle',
  'panel.stockIntake.noteDate': 'Belge tarihi: {date}',
  'panel.stockIntake.rowNeedsFull':
    'Bu satırda yalnız boş çıkış var; gelen dolu adedini girin ya da satırı silin.',
  'panel.stockIntake.rowEmpty':
    'Bu satırda ne gelen dolu ne giden boş adedi var; adet girin ya da satırı silin.',
  // ── Makbuz fişi (§3.18) ──
  'receipt.no': 'Makbuz',
  'receipt.date': 'Tarih',
  'receipt.channel': 'Kanal',
  'receipt.total': 'TOPLAM',
  'receipt.payment': 'Ödeme',
  'receipt.disclaimer': 'Bu belge bilgi amaçlı satış makbuzudur; e-Fatura yerine geçmez.',
  'receipt.voidTitle': 'İPTAL MAKBUZU',
  'receipt.voidOf': '{no} makbuzunun karşılığıdır',
  // ── Yazdırma (K2a–K2b): sipariş fişi ve sefer listesi ──
  'print.slip.title': 'SİPARİŞ FİŞİ',
  'print.slip.orderedAt': 'Sipariş zamanı',
  'print.slip.channel': 'Kanal',
  'print.slip.externalId': 'Sipariş no',
  'print.slip.total': 'TOPLAM',
  'print.slip.note': 'Not',
  'print.manifest.title': 'SEFER LİSTESİ',
  'print.manifest.day': 'Sefer günü',
  'print.manifest.vehicle': 'Araç',
  'print.manifest.driver': 'Personel',
  'print.manifest.col.seq': 'Sıra',
  'print.manifest.col.customer': 'Müşteri',
  'print.manifest.col.address': 'Adres',
  'print.manifest.col.items': 'Ürün / adet',
  'print.manifest.col.amount': 'Tutar',
  'print.manifest.col.empty': 'Boş',
  'print.manifest.col.collected': 'Tahsilat',
  'print.manifest.col.signature': 'İmza',
  // ── Müşteri cari ekstresi PDF (O2): tek müşterinin hesap dökümü ──
  'statement.title': 'CARİ HESAP EKSTRESİ',
  'statement.period': 'Dönem',
  'statement.issuedAt': 'Düzenleme zamanı',
  'statement.customer': 'Müşteri',
  'statement.phone': 'Telefon',
  'statement.address': 'Adres',
  'statement.col.date': 'Tarih',
  'statement.col.kind': 'İşlem',
  'statement.col.note': 'Açıklama',
  'statement.col.debit': 'Borç',
  'statement.col.credit': 'Alacak',
  'statement.col.balance': 'Bakiye',
  'statement.opening': 'Açılış bakiyesi',
  'statement.periodDebit': 'Dönem borç toplamı',
  'statement.periodCredit': 'Dönem alacak toplamı',
  'statement.closing': 'Kapanış bakiyesi',
  'statement.closingDebit': 'Kapanış bakiyesi (borç)',
  'statement.closingCredit': 'Kapanış bakiyesi (alacak)',
  'statement.closingNone': 'Bakiye yok',
  // Yön eki: Türk muhasebe geleneğinde bakiye işaretle değil B/A harfiyle gösterilir.
  // B = müşteri bize borçlu (pozitif bakiye), A = müşterinin bizden alacağı (negatif/avans).
  'statement.balanceSuffix.debit': 'B',
  'statement.balanceSuffix.credit': 'A',
  'statement.voidCorrection': 'İptal düzeltmesi',
  'statement.jugsOnHand': 'Zimmetinizdeki damacana',
  'statement.kind.SALE': 'Satış',
  'statement.kind.PAYMENT': 'Tahsilat',
  'statement.kind.DEPOSIT': 'Depozito',
  'statement.kind.DEPOSIT_REFUND': 'Depozito iadesi',
  'statement.kind.ADJUSTMENT': 'Düzeltme',
  'statement.depositNote':
    'Depozito hareketleri cari bakiyeye girmez; damacana adedi aşağıdadır. Bakiye satırlarındaki tutarın yönü müşterinin borçlu ya da alacaklı olduğunu gösterir.',
  // Tablonun altında tek satır açıklama: harf ekleri ne anlama gelir.
  'statement.balanceLegend':
    'B: borç (müşteri bize borçlu) · A: alacak (müşterinin bizden alacağı)',
  'statement.empty': 'Bu dönemde hareket yok.',
  'statement.dayInvalid': 'Tarih YYYY-AA-GG biçiminde ve takvimde var olmalı.',
  'statement.rangeReversed': 'Başlangıç günü bitiş gününden sonra olamaz.',
  'statement.rangeTooWide': 'Aralık en fazla {n} gün olabilir.',
  'statement.tooManyRows': 'Bu dönemde çok fazla hareket var. Daha kısa bir aralık seçin.',
  // ── Yazdırma paneli (K2c–K2d): düğmeler, kuyruk ekranı ──
  'panel.print.navQueue': 'Yazdırma kuyruğu',
  'panel.print.slipButton': 'Fiş yazdır',
  'panel.print.manifestButton': 'Sefer listesi',
  'panel.print.reprint': 'Tekrar yazdır',
  'panel.print.printSelected': 'Seçilenleri yazdır ({n})',
  'panel.print.tooMany': 'Tek seferde en fazla {max} sipariş yazdırılabilir. Seçimi azaltın.',
  'panel.print.intro':
    'Panel kanallarından (Hayat, Abant, Getir) gelen, henüz basılmamış açık siparişler.',
  'panel.print.unprintedCount': '{n} basılmamış',
  'panel.print.showPrinted': 'Basılanları da göster',
  'panel.print.printedBadge': 'Basıldı',
  'panel.print.selectRow': 'Siparişi seç',
  'panel.print.colTime': 'Saat',
  'panel.print.colChannel': 'Kanal',
  'panel.print.colCustomer': 'Müşteri',
  'panel.print.colAddress': 'Adres',
  'panel.print.colTotal': 'Tutar',
  'panel.print.colState': 'Durum',
  'panel.print.empty': 'Basılacak sipariş yok.',
  'panel.print.loadError': 'Sipariş kuyruğu alınamadı.',
  'panel.print.error': 'Belge açılamadı. Tekrar deneyin.',
  'panel.print.truncated': 'Kuyrukta {n} sipariş var; yalnız en yeni {max} tanesi gösteriliyor.',
  // ── Ön muhasebe (Faz 3, §3.13) ──
  'cash.amountPositive': 'Tutar sıfırdan büyük olmalı.',
  'float.tripNotClosed': 'Sefer kapanmadan nakit teslim alınamaz.',
  'float.nothingToHandOver': 'Bu seferde teslim alınacak nakit yok.',
  'float.alreadySettled': 'Bu seferin nakdi zaten kasaya işlendi.',
  'receipt.notFound': 'Makbuz bulunamadı.',
  'receiptKind.SALE': 'Satış',
  'receiptKind.PAYMENT': 'Tahsilat',
  'receiptKind.DEPOSIT': 'Depozito',
  'cashKind.DRIVER_HANDOVER': 'Şoför nakit teslimi',
  'cashKind.CUSTOMER_PAYMENT': 'Müşteri tahsilatı',
  'cashKind.DEPOSIT': 'Depozito tahsili',
  'cashKind.DEPOSIT_REFUND': 'Depozito iadesi',
  'cashKind.EXPENSE_FUEL': 'Mazot',
  'cashKind.EXPENSE_MEAL': 'Yemek',
  'cashKind.EXPENSE_MAINTENANCE': 'Bakım',
  'cashKind.EXPENSE_OTHER': 'Diğer',
  'cashKind.SUPPLIER_PAYMENT': 'Fabrika ödemesi',
  'cashKind.ADJUSTMENT': 'Düzeltme',
  'cashKind.OWNER_WITHDRAWAL': 'Kasadan çekim',
  'cashKind.BANK_DEPOSIT': 'Bankaya yatırma',
  'txnKind.SALE': 'Satış',
  'txnKind.PAYMENT': 'Tahsilat',
  'txnKind.DEPOSIT': 'Depozito',
  'txnKind.DEPOSIT_REFUND': 'Depozito iadesi',
  'txnKind.ADJUSTMENT': 'Düzeltme',
  'floatStatus.ON_ROUTE': 'Araçta · yolda',
  'floatStatus.AWAITING_HANDOVER': 'Depoda · teslim bekliyor',
  'floatStatus.SETTLED': 'Kasaya işlendi',
  // ── Patron ekranları (aynı uygulama, rol ayrımı) ──
  'auth.managerLogin': 'Patron girişi',
  'auth.driverLogin': 'Şoför girişi (PIN)',
  'auth.signIn': 'Giriş yap',
  'boss.offlineWrite': 'Bağlantı yok — işlem gönderilemedi. Bağlantı gelince tekrar deneyin.',
  'boss.approveConfirmTitle': 'Onaylansın mı?',
  'boss.approveConfirmBody':
    'Onay deftere işlenir ve geri alınamaz; düzeltme yeni bir kayıtla yapılır.',
  'boss.rejectReason': 'Ret gerekçesi',
  'boss.rejectReasonHint': 'Şoför bu metni görecek; neden reddettiğini yaz.',
  'boss.send': 'Gönder',
  'boss.showAllAlerts': 'Tümünü gör',
  'boss.showLessAlerts': 'Daha az göster',
  'boss.tripCount': '{n} sefer',
  'boss.kmDiff': 'Km farkı',
  'boss.kmHint': 'Beyan ve konum km karşılaştırması · eşik ±{threshold} km',
  'boss.kmLine': 'Beyan {declared} · Konum {gps}',
  'boss.offline': 'Bağlantı yok — son bilinen veriler gösteriliyor.',
  'boss.summary': 'Özet',
  'boss.map': 'Harita',
  'boss.orders': 'Siparişler',
  'boss.notifications': 'Bildirimler',
  'boss.drivers': 'Şoförler',
  'boss.kpiOrders': 'Sipariş',
  'boss.kpiDelivered': 'Teslim',
  'boss.kpiPending': 'Bekleyen',
  'boss.kpiInProgress': 'Yolda',
  'boss.kpiRevenue': 'Ciro',
  'boss.closingStatus': 'Kapanış durumu',
  'boss.todayTrips': 'Bugünün seferleri',
  'boss.diffShort': 'Dolu {full} · Boş {empty}',
  'boss.matched': 'Tuttu',
  'boss.onRoad': 'Yolda · {n}',
  'boss.awaitingClose': 'Kapanış bekliyor',
  'boss.attention': 'Dikkat gerektirenler',
  'boss.seeAll': 'Tümünü gör',
  'boss.approvals': 'Onay bekleyenler',
  'boss.noApprovals': 'Onay bekleyen kayıt yok.',
  'boss.approve': 'Onayla',
  'boss.reject': 'Reddet',
  'boss.driversShortcut': 'Şoförler · {n} araç',
  'boss.cashShortcut': 'Kasa {cash} · Şoförlerde {float}',
  'boss.noTrips': 'Bugün açılmış sefer yok.',
  'boss.noAlerts': 'Dikkat gerektiren bir şey yok.',
  'boss.noNotifications': 'Bildirim yok.',
  'boss.markAllRead': 'Tümünü okundu işaretle',
  'boss.unassigned': 'Atanmamış',
  'boss.noOrders': 'Sipariş yok.',
  'boss.vehicles': 'Araçlar',
  'boss.noSignalShort': 'Sinyal yok',
  'boss.logout': 'Çıkış',
  'boss.decideInPanel': 'Bu kayıt panelden karara bağlanır.',
  'boss.driversHint': 'Bugünün seferleri: teslimat, damacana, tahsilat.',
  'boss.cashDetail': '{count} şoför nakit teslimi bekliyor · {amount}',
  'boss.fleetLine': '{total} araç · {active} aktif',
  'boss.live': 'Canlı',
  'boss.mapNote':
    'Harita görünümü bir sonraki turda bağlanacak; liste aynı canlı konum ucundan beslenir.',
  'boss.filterAll': 'Tümü',
  'boss.filterNew': 'Yeni',
  'boss.filterAssigned': 'Atandı',
  'boss.filterOnRoute': 'Yolda',
  'boss.orderCount': '{n} sipariş',
  'boss.tripDetail': 'Sefer detayı',
  'boss.fullJugs': 'Dolu damacana',
  'boss.emptyJugs': 'Boş damacana',
  'boss.morningLoad': 'Sabah yükleme',
  'boss.midReload': 'Ara yükleme',
  'boss.sold': 'Satılan',
  'boss.returnedFull': 'Dönen dolu',
  'boss.emptyReceived': 'Alınan boş',
  'boss.returnedEmpty': 'Dönen boş',
  'boss.diff': 'Fark',
  'boss.diffNotYet': 'Fark yalnız sefer kapandığında hesaplanır.',
  'boss.noteRead': 'Okundu',
  'boss.markNoteRead': 'Okundu işaretle',
  'boss.kpiDeliveries': 'Teslimat',
  'boss.kpiJugs': 'Damacana',
  'boss.kpiEmpties': 'Boş alındı',
  'boss.kpiCollected': 'Tahsilat',
  'boss.kpiFloat': 'Şoförde',
  'boss.items': 'Kalemler',
  'boss.total': 'Toplam',
  'boss.orderTime': 'Sipariş saati',
  'boss.order': 'Sipariş',
  'boss.assign': 'Ata',
  'boss.assignTitle': 'Hangi araca?',
  'boss.autoAssign': 'Bölge kuralıyla ata',
  'boss.autoAssignHint': 'Adres bölgeyle eşleşirse varsayılan araca atanır.',
  'boss.cancelOrder': 'İptal et',
  'boss.cancelTitle': 'Siparişi iptal et?',
  'boss.cancelBody': 'Bu işlem kanala da iletilir ve geri alınamaz.',
  'boss.secondsAgo': '{n} sn önce',
  'boss.minutesAgo': '{n} dk önce',
  // ── Panel gerçeği (görev "patron mobil — panel gerçeğini göster") ──
  'boss.fleetSectionTitle': 'Panel araçları — bugün',
  'boss.fleetWaiting': '{n} bekliyor',
  'boss.fleetInProgress': '{n} yolda',
  'boss.fleetDelivered': '{n} teslim',
  'boss.fleetVehicleFallback': '{brand} araç {label}',
  'boss.openToggleOpen': 'Açık',
  'boss.openToggleAll': 'Tümü',
  // Patron mobil — bölgesel atama
  'boss.filterGetir': 'Getir',
  'boss.groupUnmatched': 'Bölge eşleşmedi',
  'boss.pendingAge': '{n} dk',
  'boss.bulkAssignAll': 'Hepsini ata',
  'boss.bulkAssignTitle': 'Toplu araç atama',
  'boss.bulkAssignResult': '{assigned} atandı, {skipped} atlanamadı',
  'boss.bulkAssignSkipped': '{orderId}: {reason}',
  'boss.skippedReason.CONFLICT': 'Zaten atanmış',
  'boss.skippedReason.NOT_FOUND': 'Sipariş bulunamadı',
  'boss.skippedReason.INVALID': 'Geçersiz',
  'boss.skippedReason.ERROR': 'Sistem hatası',
  // ── Şoför uygulaması (Faz 2.7-2.9) ──
  'driver.pendingDone': 'Bekleyen · Teslim',
  'driver.floatCash': 'Emanet nakit',
  'driver.jugsApprox': '~{n} dolu',
  'order.amount': 'Tutar',
  'driver.failed': 'Teslim edilemedi',
  'driver.deliver': 'Teslim et',
  'driver.payment': 'Ödeme',
  'driver.deliveredJugs': 'Teslim edilen damacana',
  'driver.startDay': 'Güne başla',
  'driver.openTripNote': 'Seferi açtığında araç kilometresi ve yükleme sayımı kaydedilir.',
  'driver.today': 'Bugün',
  'driver.openTrip': 'Seferi aç',
  'driver.caseSeparate': '{name} (ayrı — boş dönüşü yok)',
  'driver.saveLoad': 'Yüklemeyi kaydet',
  'driver.loaded': 'Yüklenen',
  'driver.sold': 'Satılan',
  'driver.returnedFull': 'Depoya dönen dolu',
  'driver.matched': 'Tuttu ✓',
  'driver.openN': '{n} açık',
  'driver.emptyReceived': 'Müşteriden alınan',
  'driver.returnedEmpty': 'Depoya dönen boş',
  'driver.returnedForeign': 'Dönen yabancı marka',
  'driver.kmToday': 'Bugün gidilen km',
  'driver.fuelAmount': 'Mazot tutarı',
  'driver.cashOnHand': 'Üstündeki nakit',
  'driver.varianceNote': 'Fark açıklaması',
  'driver.vehicle': 'Araç',
  'driver.soldJugs': 'Satılan damacana',
  'driver.emptyTaken': 'Alınan boş',
  'driver.cashLeft': 'Üstünde kalan nakit',
  'driver.cashHandedOver': 'Depoya teslim edildi {amount}',
  'driver.reloadPending': 'Ara yükleme',
  'driver.reloadPendingBadge': 'onay bekliyor',
  'driver.closeBlockedReload': 'Ara yükleme onaylanınca kapatabilirsin',
  'driver.closePendingFlush': 'Kapanış gönderilmeyi bekliyor — bağlantı gelince gönderilir',
  'driver.queueEmptyBody': 'Gönderilmeyi bekleyen kayıt yok',
  'driver.backHome': 'Ana ekrana dön',
  'driver.leaveAtDoor': 'Kapıya emanet bırak (veresiye)',
  'driver.emptyTakenShort': 'Alınan boş',
  'driver.foreignEmpty': 'Yabancı marka boş',
  'driver.onVehicleTitle': 'Araçta ~n dolu',
  'driver.offlineBanner': 'Çevrimdışısın — {n} kayıt bağlantı gelince gönderilecek.',
  // Kuyruk boşken "0 kayıt gönderilecek" demek şoförü yanıltır; bekleme yoksa
  // tek mesele "liste yenilenmiyor"dur. Buna göre iki ayrı metin.
  'driver.offlineBannerEmpty': 'Çevrimdışısın — bağlantı gelince liste yenilenecek.',
  'driver.syncing': 'Kayıtlar gönderiliyor…',
  'driver.deadBanner': '{n} kayıt gönderilemedi — dokun ve bak.',
  'driver.retryFailed': 'Tekrar gönderilemedi — bu kayıt sunucu tarafından reddediliyor.',
  'driver.jobUnrecoverable': 'Bu kayıt gönderilemiyor; "Kaydı at" seçeneğiyle kaldır.',
  'driver.closeBlockedBanner': 'Gün kapanışı bekliyor: önce gönderilemeyen kaydı çöz.',
  'driver.region': 'Bölge',
  'driver.onVehicleApprox': 'Araçta (yaklaşık)',
  'driver.doLoad': 'Yükleme yap',
  'driver.depart': 'Yola çık',
  'driver.returnToDepot': 'Depoya dön',
  'driver.closeDay': 'Günü kapat',
  'driver.reload': 'Araca ekle / çıkar',
  'driver.paymentLocked': ' · değiştirilemez',
  'driver.queueTitle': 'Gönderilemeyenler',
  'driver.queuePendingCount': 'Bekleyen: {n}',
  'driver.closeOrphansConfirm':
    'Kuyrukta sahibi belirsiz {n} kayıt var, gönderilmeyecek. Yine de kapat?',
  'driver.queueOrphans': 'Sahibi belirsiz {n} kayıt — patronla görüş',
  'driver.queueEmpty': 'Gönderilemeyen kayıt yok.',
  'driver.retry': 'Yeniden dene',
  'driver.discardJob': 'Kaydı at',
  'driver.sendNow': 'Şimdi gönder',
  'driver.removeFromVehicle': 'Araçtan çıkar',
  'driver.approveAndSend': 'Onayla ve gönder',
  'driver.increase': '{label} artır',
  'driver.confirmHandover': 'Nakit teslimini onayla',
  'driver.closeTrip': 'Seferi kapat',
  'driver.depositCollected': 'Depozito alındı',
  'driver.depositHint': 'Satılan {sold}, alınan {received} — gün sonunda {open} açık görünecek.',
  'queueKind.load': 'Yükleme',
  'queueKind.reload': 'Ara yükleme',
  'queueKind.deliver': 'Teslimat',
  'queueKind.fail': 'Teslim edilemedi',
  'queueKind.depart': 'Yola çıkış',
  'queueKind.start-closing': 'Depoya dönüş',
  'queueKind.close': 'Sefer kapanışı',
  'queueKind.address-correction': 'Adres düzeltme',
  'queueKind.transfer-request': 'Sipariş devri talebi',
  'queueKind.delivery-photo': 'Teslim fotoğrafı',
  'failReason.CUSTOMER_ABSENT': 'Müşteri evde yok',
  'failReason.ADDRESS_NOT_FOUND': 'Adres bulunamadı',
  'failReason.CUSTOMER_CANCELLED': 'Müşteri vazgeçti',
  'failReason.WRONG_PRODUCT': 'Yanlış ürün',
  'failReason.OTHER': 'Diğer',
  // ── Seferler ekranı (§3.9-3.10) ──
  'trips.equationOpen': '{n} açık',
  'trips.odometer': 'Sayaç',
  'trips.filterToday': 'Bugün',
  'trips.filterWeek': 'Bu hafta',
  'trips.filterAll': 'Tümü',
  'trips.kpiOnRoad': 'Yoldaki araç',
  'trips.kpiSold': 'Satılan damacana',
  'trips.kpiVariance': 'Farkla kapanan',
  'trips.kpiPendingReload': 'Onay bekleyen',
  'trips.colVehicle': 'Araç',
  'trips.colDriver': 'Şoför',
  'trips.colStatus': 'Durum',
  'trips.colSold': 'Satılan',
  'trips.colEquation': 'Denklem',
  'trips.colCollected': 'Tahsilat',
  'trips.empty': 'Bu dönemde sefer yok.',
  'trips.emptyOursPanelAbove': 'Bugün bizim şoförlerimizin seferi yok; panel araçları yukarıda.',
  'trips.equationOk': 'Tuttu',
  'trips.reloadQueue': 'Onay bekleyen ara yüklemeler',
  'trips.approve': 'Onayla',
  'trips.reject': 'Reddet',
  'trips.rejectReasonPrompt': 'Reddetme gerekçesi (şoför görecek):',
  'trips.sectionFull': 'Dolu damacana',
  'trips.sectionEmpty': 'Boş damacana',
  'trips.morningLoad': 'Sabah yüklemesi',
  'trips.midReload': 'Ara yükleme',
  'trips.sold': 'Satılan',
  'trips.returnedToDepot': 'Depoya dönen',
  'trips.diff': 'Fark',
  'trips.emptyReceived': 'Müşteriden alınan',
  'trips.foreignReceived': 'Yabancı marka alınan',
  'trips.driverNote': 'Şoför açıklaması',
  'trips.noteRead': 'Okundu',
  'trips.markNoteRead': 'Okundu işaretle',
  'trips.sectionKm': 'Kilometre ve mazot',
  'trips.declaredKm': 'Beyan edilen km',
  'trips.onVehicleApprox': 'Araçta (yaklaşık)',
  'trips.equationPendingClose': 'Sefer kapanınca hesaplanır',
  'trips.collectedCash': 'Nakit',
  'trips.collectedCard': 'Kart',
  'trips.collectedOnline': 'Online',
  'trips.collectedCredit': 'Veresiye',
  'trips.driverFloat': 'Şoförün üstündeki nakit',
  'trips.sectionCollected': 'Tahsilat',
  'trips.fuelLiters': 'Mazot {liters} L',
  'trips.unexplainedKm': 'Açıklanmayan km farkı var.',
  'trips.sectionDeliveries': 'Teslimatlar ({n})',
  'trips.noDeliveries': 'Teslimat yok.',
  'tripStatus.OPENED': 'Açıldı',
  'tripStatus.LOADING': 'Yükleme yapılıyor',
  'tripStatus.ON_ROUTE': 'Yolda',
  'tripStatus.CLOSING': 'Kapanışta',
  'tripStatus.CLOSED': 'Kapandı',
  'tripStatus.VOIDED': 'İptal edildi',

  // Teslimat
  'delivery.orderNotInTrip': 'Bu sipariş bu sefere ait değil.',
  'delivery.jugNotInOrder': 'Siparişte damacana yok; damacana teslimatı yazılamaz.',
  'delivery.caseNotInOrder': 'Siparişte koli yok; koli teslimatı yazılamaz.',
  'delivery.partialNotAllowed':
    '{source} siparişinde tutar kilitlidir; eksik teslimat yazılamaz. Teslim edilemediyse "Teslim edilemedi" seçin.',
  'delivery.alreadyDelivered': 'Bu sipariş zaten teslim edilmiş.',
  'delivery.alreadyDeliveredCannotFail':
    'Bu sipariş zaten teslim edildi; başarısız olarak işaretlenemez.',
  'delivery.shortfall.SHORT': 'Eksik boş',
  'delivery.shortfall.REASON_MISSING': 'Eksik boş (sebep girilmemiş)',
  'delivery.shortfall.OVER': 'Fazla boş',
  'delivery.shortfall.FOREIGN_UNEXPECTED': 'Beklenmeyen yabancı boş',
  'delivery.shortfall.DEPOSIT_UNTRACKED': 'Depozito deftere işlenemedi',
  'delivery.deviationShort': 'Beklenen {expected}, alınan {got}; {missing} eksik.',
  'delivery.deviationReasonMissing':
    'Beklenen {expected}, alınan {got}; {missing} eksik, sebep girilmemiş.',
  'delivery.deviationOver': 'Beklenen {expected}, alınan {got}; {extra} fazla.',
  'delivery.deviationForeignUnexpected':
    'Beklenen yabancı {expected}, alınan {got}; {extra} fazla.',
  'delivery.depositUntracked':
    '{qty} damacana depozitosu alındı ama ödeme tipi nakit ya da kart değil.',
  'delivery.paymentLocked': '{source} üzerinden ödendi — değiştirilemez.',
  'delivery.jugCountRequired': 'Teslim edilen damacana adedi girilmeli.',
  'delivery.mixedJugsNotSupported':
    'Bu siparişte birden çok damacana ürünü (marka ya da tür) var; şoför uygulamasından teslim edilemiyor. Panelden düzenleyin.',
  'delivery.partialMixNotSupported':
    'Siparişin tamamını bir kalemde teslim edin; karışık türlerde kısmi teslimat kapatılamaz.',

  // Ara yükleme
  'reload.notFound': 'Ara yükleme kaydı bulunamadı.',
  'reload.alreadyDecided': 'Bu ara yükleme zaten sonuçlandırılmış.',
  'reload.tripClosed':
    'Sefer kapandı; bu ara yükleme artık karara bağlanamaz. Düzeltme yeni satır olarak girilir.',
  'reload.emptyRequest': 'En az bir üründe adet girilmeli.',
  'reload.manager.duplicateLine': 'Aynı ürün birden fazla satırda girilemez.',
  'reload.manager.notEnoughOnVehicle':
    'Araçta bu kadar dolu yok; indirilecek adet araçtaki stoktan fazla olamaz.',
  'load.lineTotalTooLarge': 'Aynı ürünün toplam adedi 400 değerini aşamaz.',
  'reload.manager.clientIdTaken': 'Bu işlem anahtarı başka bir kayıtta kullanılmış.',

  // Şoför
  'driver.notFound': 'Şoför bulunamadı.',
  'driver.pinGenerationFailed': 'PIN üretilemedi, tekrar deneyin.',
  'driver.hasOpenTrip': 'Şoförün açık seferi var; önce sefer kapatılmalı.',
  'driver.noVehicle': 'Zimmetli araç yok. Patron panelinden araç atanmalı.',
  // P2: personel kaydı telefon kuralları
  'driver.phoneRequired': 'Telefon zorunlu (4 haneli son ek için).',
  'driver.phoneOwnerOnly': 'Şoför telefonunu yalnız patron girebilir ve değiştirebilir.',
  'driver.phoneTailTaken': 'Bu telefonun son 4 hanesi kiracıda zaten başka bir şoförde tanımlı.',
  'driver.ownerProfileExists': 'Bu patron için zaten bir personel profili açık.',
  // Patron profilinde ad ve telefon patronun kullanıcı hesabındadır; personel ekranından değişmez.
  'driver.ownerProfileUserFields': 'Patron profilinin adı ve telefonu buradan değiştirilemez.',
  'driver.ownerProfileNoPin': "Patron profilinin PIN'i yok; patron kendi parolasıyla girer.",

  // Müşteri
  'customer.notFound': 'Müşteri bulunamadı.',
  'customer.hasBalance': 'Bakiyesi veya zimmeti olan müşteri kapatılamaz.',
  'customer.phoneInvalid': 'Telefon numarası geçersiz. Örnek: 0532 418 22 07',
  // PATCH isActive:false reddedilir — kapatma yalnız DELETE uçtan, bakiye/zimmet kontrolüyle.
  'customer.deactivateUseEndpoint': 'Pasifleştirme için kapatma işlemini kullanın',
  // K3: anonimleştirilmiş kayıt geri açılamaz; tüm PATCH'ler reddedilir.
  'customer.anonymizedLocked': 'Anonimleştirilmiş müşteri değiştirilemez',
  // BE-3: Şoförün kapıda müşteri adresini düzeltmesi (tasarım §6 — şemasız uygulama).
  // Anonimleştirilmiş kayıt yeniden canlandırılamaz (KVKK kural 7); bu özel bir 409 mesajı —
  // genel `anonymizedLocked` ile karışmasın.
  'customer.addressCorrection.anonymized': 'Anonimleştirilmiş müşterinin adresi düzeltilemez.',
  // Sipariş yok ya da DRIVER için kapsam dışı — varlığı sızdırmamak için tek mesaj.
  'customer.addressCorrection.coordsPair': 'Enlem ve boylam birlikte gönderilmelidir.',
  'customer.addressCorrection.orderNotFound': 'Bu sipariş bu müşteriye bağlı değil.',

  // Doğrulama (zod issue.code → metin)
  'validation.invalid_type': 'Geçersiz değer.',
  'validation.too_small': 'Çok kısa ya da çok küçük.',
  'validation.too_big': 'Çok uzun ya da çok büyük.',
  'validation.invalid_format': 'Biçim geçersiz.',
  'validation.invalid_value': 'İzin verilen değerlerden biri değil.',
  'validation.unrecognized_keys': 'Tanınmayan alan.',
  'validation.custom': 'Geçersiz değer.',
  // Koda değil, tek bir şemaya ait doğrulama metni (`zod.pipe.ts#csvArray`).
  'validation.listItemInvalid': 'Listede geçersiz değer: {value}',
  // KVKK-N1: panelden girilen not `void:` önekiyle başlayamaz. İç yazıcılar (`trip-void.ts`,
  // `external-ledger.service.ts#reverse`) etkilenmez — bu önek onların eşleşme anahtarıdır.
  'validation.noteVoidPrefix': 'Not "void:" ile başlayamaz.',

  // Sürüm denetimi (GUNCELLEME-VE-SURUM.md)
  'version.upgradeRequired': 'Uygulamanızı güncellemeniz gerekiyor.',
  'version.upgradeBody':
    'Uygulamanın bu sürümü artık kullanılamıyor. Güncellemeyi kurduktan sonra kaldığın yerden devam edebilirsin; gönderilmemiş kayıtların cihazda duruyor, kaybolmadı.',
  'version.upgradeContact': 'Güncelleme için patronla iletişime geç.',
  'version.headerMissing': 'İstemci sürüm bilgisi eksik.',
  'version.newVersionReady': 'Yeni sürüm hazır — yenile',

  // Erişim durumu (Tenant.status)
  'access.readonly': 'Hesap salt okunur durumda. Yeni işlem başlatılamaz.',
  'access.suspended': 'Hesap askıya alındı. Veri dışa aktarımı açık kalır.',

  // Giriş
  'auth.login': 'Giriş yap',
  'auth.logout': 'Çıkış yap',
  'auth.email': 'E-posta',
  'auth.password': 'Şifre',
  'auth.showPassword': 'Şifreyi göster',
  'auth.hidePassword': 'Şifreyi gizle',
  'auth.pin': 'PIN',
  'auth.pinHint': '6 haneli PIN',
  'auth.invalidCredentials': 'E-posta veya şifre hatalı.',
  'auth.invalidPin': 'PIN hatalı.',
  'auth.userInactive': 'Bu hesap devre dışı.',
  'auth.refreshInvalid': 'Oturum süresi doldu, yeniden giriş yapın.',
  'auth.pinTaken': 'Bu PIN başka bir şoförde kullanılıyor.',
  'auth.weakPin': 'PIN çok zayıf. Başka bir PIN deneyin.',
  'auth.currentPinRequired': 'Mevcut PIN girilmeli.',
  'auth.passwordTooShort': 'Parola en az 10 karakter olmalı.',
  'auth.passwordResetInvalid':
    'Sıfırlama bağlantısı geçersiz ya da süresi dolmuş. Yeni bir bağlantı isteyin.',
  // Plakalı giriş (şoför telefonu eşleştirmesi)
  'auth.invalidPlate': 'Bu plakayla kayıtlı araç bulunamadı.',
  'auth.deviceRevoked': 'Bu telefonun onayı kaldırıldı. Yeniden onay iste ve kodu patrona göster.',
  'auth.tripOpenOnOtherVehicle':
    '{plate} aracında açık seferin var. Önce o seferi kapat ya da patrona devrettir.',
  'auth.vehicleBusy':
    '{plate} aracında başka bir şoförün açık seferi var. Patron seferi sana devredince girebilirsin.',
  'auth.tooManyPendingDevices':
    'Şu an onay bekleyen çok fazla telefon var. Patrondan bekleyenleri onaylamasını iste.',

  // PIN sıfırlama istekleri
  'pinReset.notFound': 'PIN sıfırlama isteği bulunamadı.',
  'pinReset.alreadyDecided': 'Bu istek zaten karara bağlanmış.',
  'pinReset.rejectReasonRequired': 'Ret gerekçesi zorunlu.',

  // Roller
  'role.OWNER': 'Patron',
  'role.MANAGER': 'Yönetici',
  'role.DRIVER': 'Şoför',

  // Şoför app — Ortak
  'common.back_day': '← Gün',
  'common.back_day_screen': '← Gün ekranı',
  'common.back_loading': '← Yükleme',
  'common.back_delivery': '← Teslimat',
  'common.go_back': 'Geri dön',
  'common.close': 'Kapat',
  'common.approved': '✓ Onaylı',
  'common.approved_plain': 'Onaylandı',
  'common.pending_approval': '⏳ Onay bekliyor',
  'common.difference': 'Fark',
  'common.phone': 'Telefon',
  // Arka plan konum toplama bildirimi (Android foreground service). Şoförün takip edildiğini
  // görmesi zorunluluk değil dürüstlüktür — gizli takip yazma.
  'driver.locationNotificationTitle': 'AquaBox',
  'driver.locationNotificationBody': 'Sefer sürüyor — konum kaydediliyor',

  // Şoför app — Ağ
  'net.offline': 'Çevrimdışısın — {n} kayıt bağlantı gelince gönderilecek.',
  'net.sent': 'Kayıtlar gönderildi.',

  // Şoför app — Giriş
  'login.logo_alt': 'AquaBox — Sisteme aksın',
  'login.signing_in': 'Giriş yapılıyor…',
  'login.forgot_pin': "PIN'imi unuttum",
  'login.error_wrong_pin': 'PIN hatalı, tekrar dene.',

  // Şoför app — Araç
  'vehicle.greeting': 'Günaydın, {name}',
  'vehicle.assigned_label': 'Zimmetli aracın',
  'vehicle.desc': '{label} · kapasite {n} damacana',
  'vehicle.zone': '{zone} bölgesi',
  'vehicle.location_notice':
    'Sefer açıkken konumun patrona görünür. Sefer kapanınca paylaşım durur.',
  'vehicle.carryover': 'Dünden kalan',
  'vehicle.full_on_vehicle': 'Araçta dolu',
  'vehicle.empty_on_vehicle': 'Araçta boş',
  'vehicle.odometer': 'Km sayacı',
  'vehicle.change_notice':
    "Araç değişikliği patrondan yapılır. Bugün başka araç kullanacaksan {person}'yı ara.",
  'vehicle.open_trip': 'Seferi aç',
  'vehicle.in_use_by': '{name} kullanıyor',

  // Şoför app — Yükleme
  'load.title_morning': 'Araca yükle',
  'load.title_add': 'Araca ekle',
  'load.title_remove': 'Araçtan çıkar',
  'load.sub_morning': 'Sabah yüklemesi. Ürün başına adet gir ya da rakamı doğrudan yaz.',
  'load.sub_mid':
    'Gün içinde depoya uğradın. Eklediğin ya da indirdiğin doluyu gir; depo görevlisi onaylar.',
  'load.seg_add': 'Araca ekle',
  'load.seg_remove': 'Araçtan çıkar',
  'load.on_vehicle': 'Araçta {n} dolu',
  'load.koli_on_vehicle': '{n} koli · boş dönüşü yok',
  'load.quick': '+{n}',
  'load.info_morning':
    'Depo görevlisiyle birlikte say. Rakamı kutuya yazabilir ya da +5 / +10 kısayollarını kullanabilirsin.',
  'load.info_mid': 'Onayladığında kayıt patron paneline düşer ve kapanış denklemine eklenir.',
  'load.moves_today': 'Bugünkü yükleme hareketleri',
  'load.move_none': 'Değişiklik yok',
  'load.total_full': 'Araçta toplam dolu',
  'load.koli_separate': 'Koli ayrı: {n}',
  'load.btn_depart': 'Yola çık',
  'load.btn_confirm_add': 'Eklemeyi onayla',
  'load.btn_confirm_remove': 'Çıkarmayı onayla',
  'load.back_to_day': 'Güne dön',
  'load.confirm_title_morning': 'Yükleme doğru mu?',
  'load.confirm_title_mid': 'Onaylıyor musun?',
  'load.confirm_text_morning': '{n} dolu damacana ile çıkıyorsun.',
  'load.confirm_text_mid':
    'Depo görevlisiyle birlikte sayıldı. Kayıt geri alınamaz; düzeltme yeni satır olarak eklenir.',
  'load.confirm_goods_add': 'Araca eklenecek: {goods}.',
  'load.confirm_goods_remove': 'Araçtan çıkarılacak: {goods}.',
  'load.goods_jugs': '{n} damacana',
  'load.goods_cases': '{cases} koli',
  'load.goods_jugs_cases': '{n} damacana ve {cases} koli',
  'load.confirm_send': 'Onayla ve gönder',
  'load.confirm_footnote':
    'Onaylayınca kayıt patron paneline düşer, depo görevlisi sayımı onaylar.',
  'load.toast_saved': 'Yükleme kaydedildi',
  'load.toast_sent_pending': 'Kayıt patron paneline gönderildi · depo onayı bekliyor',
  'load.overCapacityWarning': 'Araç kapasitesi {capacity} damacana; {entered} girdin.',

  // Şoför app — Yola çıkış
  'depart.title': '{n} dolu ile çıkıyorsun, doğru mu?',
  'depart.loaded_label': 'Araca yüklenen',
  'depart.total_full': 'Toplam dolu',
  'depart.koli_separate': '0,5L Koli (ayrı)',
  'depart.location_notice':
    'Konumun sefer boyunca patrona görünür. Sefer kapanınca paylaşım durur.',
  'depart.confirm': 'Onayla, sefere başla',

  // Şoför app — Gün
  'day.chip_pending': '{n} bekliyor',
  'day.chip_delivered': '{n} teslim',
  'day.chip_on_vehicle': 'Araçta ~{n} dolu',
  'day.chip_float': 'Emanet {amount}',
  'day.chip_zone': '{zone} bölgesi',
  'day.assigned_to_zone': 'Bölgenize düştü',
  'day.line': '{qty}× {product}',
  'day.line_koli': ' · 1× 0,5L Koli',
  'day.directions': 'Yol tarifi',
  'day.deliver': 'Teslim et',
  'day.empty_title': 'Şimdilik bekleyen yok',
  'day.empty_sub': 'Yeni sipariş düşünce titreriz.',
  'day.fab_return': 'Depoya dön',
  'day.left_at_door_status': 'Emanet bırakıldı · tutar müşteri hesabına yazıldı',

  // Şoför app — Menü
  'menu.history': 'Sefer geçmişi',
  'menu.reload': 'Araca ekle / araçtan çıkar',
  'menu.offline_demo': 'Çevrimdışı modu göster',
  'menu.logout': 'Çıkış yap',

  // Şoför app — Müşteri
  'customer.balance': 'Bakiye',
  'customer.bottles': 'Zimmet',
  'customer.bottles_value': '{n} damacana',
  'customer.last_order': 'Son sipariş',
  'customer.habit': 'Ortalama {d} günde bir sipariş · genelde {line} · {day}',
  'customer.past_deliveries': 'Geçmiş teslimatlar',
  'customer.door_note': 'Kapı notu',
  'customer.toast_calling': 'Aranıyor: {name}',
  'customer.toast_whatsapp': 'WhatsApp sohbeti açıldı · "Kapıdayım, 2 dk" mesajı hazır',
  'customer.wa_template': 'Kapıdayım, 2 dk',
  'customer.relative_yesterday': 'Dün',
  'customer.relative_days_ago': '{n} gün önce',

  // Şoför app — Yol tarifi
  'nav.turn_right_in': '{m} m sonra sağa dön',
  'nav.eta': '{street} · varış {min} dk',
  'nav.open_maps': "Haritalar'da aç",
  'nav.toast_maps': 'Telefonun harita uygulamasına yönlendiriliyor',

  // Şoför app — Teslimat
  'delivery.section_items': '1 · Satılan kalemler',
  'delivery.koli_line': '1× 0,5L Koli',
  'delivery.koli_no_return': 'Boş dönüşü yok',
  'delivery.section_empties': '2 · Alınan boş damacana',
  'delivery.empties_label': 'Müşteriden alınan boş',
  'delivery.empties_warning': 'Satılan {sold}, alınan {got} — gün sonunda {open} açık görünecek.',
  'delivery.foreign_title': 'Yabancı marka boş',
  'delivery.foreign_sub': 'Başka markanın damacanası, ayrı stok',
  'delivery.foreign_brand_prompt': 'Hangi marka?',
  'delivery.foreign_brand_other': 'Diğer',
  'delivery.foreign_brand_placeholder': 'Marka adını yaz…',
  'delivery.section_deposit': '3 · Depozito',
  'delivery.deposit_off': 'Alınmadı',
  'delivery.deposit_on': 'Alındı · ₺{amount}',
  'delivery.section_payment': '4 · Ödeme tipi',
  'delivery.payment_locked': '{channel} üzerinden ödendi — değiştirilemez.',
  'delivery.payment_credit_note':
    'Müşterinin cari hesabına yazılır; patron panelinde Cari sekmesinde görünür.',
  'delivery.payment_cash_note': 'Nakit şoför emanetine eklenir, kapanışta depoya teslim edilir.',
  'delivery.pos_button': 'Telefonla kart çek',
  'delivery.failed_link': 'Teslim edilemedi',
  'delivery.complete': 'Teslimatı tamamla',
  'delivery.saved': 'Teslimat kaydedildi',

  // Şoför app — POS
  'pos.title': 'Sanal POS',
  'pos.to_collect': 'Tahsil edilecek',
  'pos.instruction':
    'Müşterinin kartını telefonun arkasına yaklaştır. Temassız ödeme, banka altyapısı üzerinden alınır.',
  'pos.start': 'Kart okumayı başlat',
  'pos.reading': 'Kart okutuluyor…',
  'pos.reading_sub': '{amount} · {bank} sanal POS',
  'pos.success': 'Ödeme alındı',
  'pos.receipt_line': 'Onay kodu {code} · **** {last4}',
  'pos.receipt_bank': '{bank} · temassız',
  'pos.complete': 'Teslimatı tamamla',
  'pos.send_receipt': "Makbuzu WhatsApp'tan gönder",
  'pos.toast_receipt': "Makbuz WhatsApp'tan gönderildi",

  // Şoför app — Teslim edilemedi
  'fail.title': 'Neden teslim edilemedi?',
  'fail.reason.left_at_door': 'Kapıya / komşuya emanet bırakıldı',
  'fail.reason.absent': 'Müşteri evde yok',
  'fail.reason.address': 'Adres bulunamadı',
  'fail.reason.cancelled': 'Müşteri vazgeçti',
  'fail.reason.wrong_product': 'Ürün yanlış',
  'fail.reason.other': 'Diğer',
  'fail.toast_left_at_door': 'Emanet kaydı patron paneline iletildi',

  // Şoför app — Kapanış
  'close.title': 'Günü kapat',
  'close.returned_full': 'Depoya dönen dolu',
  'close.returned_empty': 'Depoya dönen boş',
  'close.minus10': '−10',
  'close.plus10': '+10',
  'close.full_section': 'Dolu damacana',
  'close.morning_load': 'Sabah yükleme',
  'close.mid_reload': 'Ara yükleme ({n} kez)',
  // ClosingEquation ara yükleme olay SAYISINI değil yalnız net miktarı döndürür; bu yüzden
  // `close.mid_reload`in "{n} kez" biçimiyle KARIŞTIRILMASIN — bu, sayaçsız satır etiketidir.
  'close.mid_reload_net': 'Ara yükleme',
  'close.sold': 'Satılan',
  'close.returned_full_row': 'Dönen dolu',
  'close.empty_section': 'Boş damacana',
  'close.empties_received': 'Alınan boş',
  'close.returned_empty_row': 'Dönen boş',
  'close.foreign_section': 'Yabancı marka boş',
  'close.foreign_sub': 'Alınan {n} · ayrı rafa',
  'close.km_fuel_section': 'Günün kilometresi ve mazot',
  'close.km_today': 'Bugün km',
  'close.fuel_liters': 'Mazot litre',
  'close.fuel_amount': 'Mazot ₺',
  'close.gps_note': 'Konumdan hesaplanan mesafe: {km}. Fark varsa patron sorabilir.',
  'close.float_label': 'Şoförde nakit (emanet)',
  'close.float_handover': 'Depoya teslim ettim',
  'close.float_handed': 'Teslim edildi',
  'close.float_note':
    'Gün içinde nakit tahsilat şoförün emanetinde sayılır; kapanışta depoya teslim edilir, kasaya işlenir.',
  'close.toast_cash': 'Nakit teslimi kasaya işlendi',
  'close.variance_title': 'Fark nereden?',
  'close.required': '(zorunlu)',
  'close.variance_placeholder': "Örn: 2 damacana Yıldız Apt. 5'te kaldı, yarın alacağım.",
  'close.variance_counter': 'En az 10 karakter — {n}/10',
  'close.variance_ok': 'Açıklama yeterli.',
  'close.no_variance': 'Fark yok, her şey yerinde.',
  'close.location_stops': 'Seferi kapattığında konum paylaşımı durur.',
  'close.btn_close': 'Seferi kapat',
  'close.lock_cash': 'Nakit teslimini onayla',
  'close.lock_note': 'Açıklama gerekiyor',
  // Tür başına kapanış (ADR 2026-09-20). Eski `returnedFull/returnedEmpty` 19L ile sınırlı;
  // 15L dönüşleri `returnedByKind` ile gelir. Şoför tek tür yüklediyse o türün satırı görünür.
  'close.byKind_section': 'Tür bazlı dönüş',
  'close.byKind_kind_jug19': '19L damacana',
  'close.byKind_kind_jug15': '15L cam damacana',
  'close.byKind_full': 'Dönen dolu',
  'close.byKind_empty': 'Dönen boş',
  'close.byKind_estimated': 'Dağılım tahmini',
  'close.byKind_conflict':
    'Hem eski alanlar hem tür bazlı alanlar gönderildi ve 19L rakamları uyuşmuyor; birini seçin.',
  'close.byKind_duplicate': 'Aynı tür iki kez gönderildi.',
  'close.missingKindRow':
    'Bu seferde {kind} hareketi var ama dönüş satırı eksik; tür başına dönüş zorunlu.',
  // P1 koli denklemi: koli (CASE_05L) damacana değildir; satılır ve döner TAM KOLİ, içinden
  // şişe dağıtımı yok (D3). Bu yüzden CASE satırında `empty > 0` reddedilir.
  'close.caseNoEmpty': 'Koli damacana değildir; dönen boş kabul edilmez (0 olmalı).',
  'close.case_section': 'Koli',
  'close.case_expected': 'Beklenen koli',
  'close.case_loaded': 'Yüklenen koli',
  'close.case_returned_row': 'Depoya dönen koli',

  // Şoför app — Ara yükleme (eski varyant)
  'reload.title': 'Ara yükleme / boşaltma',
  'reload.sub': 'Depoya uğradın; araca eklenen ya da indirilen doluyu gir. Eksi değer boşaltmadır.',
  'reload.on_vehicle_now': 'Araçta şu an ~{n} dolu',
  'reload.info':
    'Depo görevlisi {person} ile birlikte sayın. Onayladığında kayıt patron paneline düşer ve kapanış denklemine eklenir.',
  'reload.moves_today': 'Bugünkü ara hareketler',
  'reload.confirm_btn': 'Yüklemeyi onayla',
  'reload.confirm_title': 'Onaylıyor musun?',
  'reload.confirm_text':
    '{summary} — depo görevlisiyle birlikte sayıldı. Kayıt geri alınamaz; düzeltme yeni satır olarak eklenir.',
  'reload.confirm_yes': 'Evet, onayla',
  'reload.toast': 'Yükleme kaydedildi · patron paneline iletildi',

  // Şoför app — Gün özeti
  'summary.title': 'Günün tamam.',
  'summary.sub': '{plate} · {date}',
  'summary.deliveries': 'Teslimat',
  'summary.bottles': 'Damacana',
  'summary.empties': 'Boş alındı',
  'summary.collected': 'Tahsilat',
  'summary.cash': 'Nakit',
  'summary.card': 'Kart',
  'summary.online': 'Online',
  'summary.work_time': 'Çalışma süresi',
  'summary.goodnight': 'İyi akşamlar.',
  'summary.close': 'Kapat',

  // Şoför app — Geçmiş
  'history.title': 'Sefer geçmişi',
  'history.row_title': '{date} · {plate}',
  'history.row_sub': '{deliveries} teslimat · {bottles} damacana',
  'history.balanced': 'Tuttu',
  'history.open': '{n} açık',
  'history.note':
    'Kapanan seferler değiştirilemez. Düzeltme gerekiyorsa patronun panelden düzeltme satırı ekler.',

  // Patron app — Genel / gezinme
  'app.name': 'AquaBox',
  'app.tagline': 'Sisteme aksın',
  'nav.summary': 'Özet',
  'nav.back.summary': '← Özet',
  'nav.back.orders': '← Siparişler',
  'common.now': 'şimdi',
  'common.later': 'Sonra',
  'common.call': 'Ara',
  'common.whatsapp': 'WhatsApp',
  'common.total': 'Toplam',
  'common.seeAll': 'Tümünü gör',

  // Patron app — Giriş
  'login.face.title': 'Yüzünle giriş yap',
  'login.face.hint': 'Telefonun yüz tanımasıyla saniyede gir. Dokun ve kameraya bak.',
  'login.face.scanning': 'Yüz taranıyor…',
  'login.face.keepLooking': 'Kameraya bakmayı sürdür',
  'login.face.welcome': 'Hoş geldin, {ad}',
  'login.face.opening': 'Panel açılıyor…',
  'login.orEmail': 'ya da e-posta ile',
  'login.email': 'E-posta',
  'login.password': 'Parola',
  'login.forgot': 'Parolamı unuttum',
  'login.submit': 'Giriş yap',
  'login.submitting': 'Giriş yapılıyor…',

  // Panel — parola sıfırlama
  'panel.loginForgotHelp':
    'Parolanızı unuttuysanız patronunuzdan ya da sistem yöneticisinden sıfırlama bağlantısı isteyin.',
  'panel.passwordReset.title': 'Yeni parola belirle',
  'panel.passwordReset.password': 'Yeni parola',
  'panel.passwordReset.confirm': 'Yeni parola (tekrar)',
  'panel.passwordReset.hint': 'En az 10 karakter.',
  'panel.passwordReset.mismatch': 'Parolalar eşleşmiyor.',
  'panel.passwordReset.submit': 'Parolayı kaydet',
  'panel.passwordReset.submitting': 'Kaydediliyor…',
  'panel.passwordReset.success': 'Parolanız değiştirildi. Yeni parolanızla giriş yapabilirsiniz.',
  'panel.passwordReset.noToken': 'Sıfırlama bağlantısı eksik. Yeni bir bağlantı isteyin.',
  'panel.passwordReset.backToLogin': 'Girişe dön',

  // Patron app — Özet
  'summary.kpi.orders': 'Sipariş',
  'summary.kpi.delivered': 'Teslim',
  'summary.kpi.pending': 'Bekleyen',
  'summary.kpi.revenue': 'Ciro',
  'summary.chip.getir': 'Getir {n}',
  'summary.chip.tygo': 'TY GO {n}',
  'summary.chip.ys': 'YS {n}',
  'summary.chip.phone': 'Telefon {n}',
  'summary.closing.title': 'Kapanış durumu',
  'summary.closing.subtitle': 'Bugünün seferleri',

  // Patron app — Trip statüsü
  'trip.status.open': '{n} açık',
  'trip.status.balanced': 'Tuttu',
  'trip.status.onRoad': 'Yolda · {n}',
  'trip.status.awaitingClose': 'Kapanış bekliyor',

  // Patron app — Dikkat / Onaylar
  'summary.attention.title': 'Dikkat gerektirenler',
  'summary.approvals.title': 'Onay bekleyenler',
  'approval.approve': 'Onayla',
  'approval.ask': 'Sor',
  'approval.approvedBy': 'Onaylandı · {ad}',
  'approval.empty': 'Onay bekleyen kayıt yok.',

  // Patron app — Şoförler
  'summary.drivers.title': 'Şoförler · {n} araç',
  'summary.drivers.subtitle': '{km} km · mazot {tutar} · {n} açıklanmayan fark',

  // Patron app — Kasa
  'summary.cash.title': 'Kasa {kasa} · Şoförlerde {soforlerde}',
  'summary.cash.subtitle': '{n} araç nakit teslim etti · veresiye tahsilatı {tutar}',

  // Patron app — Uyarılar
  'alert.unassigned': '{n} sipariş {dk} dakikadır atanmadı — en eskisi {ad}',
  'alert.midLoadPending': '{sofor} ara yükleme +{n} {urun} girdi — depo onayı bekliyor',

  // Patron app — Sefer detayı
  'trip.badge.closed': 'Kapandı',
  'trip.meta': '{sofor} · {arac} · {bas} – {bit}',
  'trip.full.title': 'Dolu damacana',
  'trip.empty.title': 'Boş damacana',
  'trip.badge.balanced': 'Tuttu',
  'trip.badge.open': 'Açık',
  'trip.row.morningLoad': 'Sabah yükleme',
  'trip.row.midLoad': 'Ara yükleme {saat}',
  'trip.row.sold': 'Satılan',
  'trip.row.returnedFull': 'Dönen dolu',
  'trip.row.collectedEmpty': 'Alınan boş',
  'trip.row.returnedEmpty': 'Dönen boş',
  'trip.row.diff': 'Fark',
  'trip.note.markRead': 'Okundu işaretle',
  'trip.note.read': 'Okundu · şimdi',
  'trip.daySummary': 'Gün özeti',
  'trip.kpi.deliveries': 'Teslimat',
  'trip.kpi.bottles': 'Damacana',
  'trip.kpi.emptiesCollected': 'Boş alındı',
  'trip.kpi.collection': 'Tahsilat',

  // Patron app — Ödeme
  'pay.cash': 'Nakit',
  'pay.card': 'Kart',
  'pay.online': 'Online',
  'pay.onlinePaid': 'Online ödendi',
  'pay.credit': 'Veresiye',

  // Patron app — Harita
  'map.fleetPill': '{n} araç · {aktif} aktif',
  'map.lastLocation': 'Son konum {n} saniye önce',
  'map.kpi.deliveries': 'Teslimat',
  'map.kpi.waiting': 'Bekliyor',
  'map.kpi.onBoard': 'Araçta',
  'map.onBoardApprox': '~{n} dolu',
  'map.callDriver': 'Şoförü ara',

  // Patron app — Siparişler
  'orders.title': 'Siparişler',
  'orders.filter.all': 'Tümü {n}',
  'orders.filter.new': 'Yeni {n}',
  'orders.filter.assigned': 'Atandı {n}',
  'orders.filter.onRoad': 'Yolda {n}',
  'orders.filterDate': 'Tarih',
  'orders.filterVehicle': 'Araç',
  'orders.filterSearch': 'Arama',
  'orders.loadFailed': 'Siparişler alınamadı.',
  'orders.assign': 'Ata',

  // Patron app — Sipariş detayı
  'order.region.matched': '{bolge} bölgesi',
  'order.region.unmatched': 'Bölge eşleşmedi',
  'order.status.new': 'Yeni',
  'order.status.approved': 'Onaylandı',
  'order.status.assigned': 'Atandı',
  'order.status.onRoad': 'Yolda',
  'order.status.delivered': 'Teslim edildi',
  'order.status.cancelled': 'İptal edildi',
  'order.status.leftAtDoor': 'Emanet bırakıldı',
  'order.items': 'Kalemler',
  'order.timeline': 'Zaman çizelgesi',
  'order.tl.received': 'Sipariş geldi',
  'order.tl.approved': 'Onaylandı',
  'order.tl.approvedAuto': 'otomatik',
  'order.tl.assigned': 'Atandı',
  'order.tl.assignedBy': '{kisi} → {plaka}',
  'order.tl.notAssigned': 'henüz atanmadı',
  'order.tl.departed': 'Yola çıktı',
  'order.tl.delivered': 'Teslim edildi',
  'order.tl.emptiesTaken': '{n} boş alındı',
  'order.tl.leftAtDoor': 'Kapıya emanet bırakıldı',
  'order.tl.leftAtDoorDetail': 'Müşteri evde yoktu · tutar cari hesaba yazıldı',
  'order.cancel': 'İptal et',
  'order.cancel.title': 'Siparişi iptal et?',
  'order.cancel.body': 'Bu işlem kanala da iletilecek ve geri alınamaz.',
  'order.cancel.panelBody': 'Sipariş iptal edilir; gerekçe sipariş kaydına yazılır.',
  'order.rawRecord': 'Teknik kayıt',

  // Patron app — Atama
  'assign.title': 'Hangi araca?',
  'assign.info': '{ad} · {kalem}',
  'assign.suggested': '{bolge} bölgesi · önerilen',
  'assign.vehicleInfo': '{sofor} · araçta ~{n} dolu · {km} km',
  'assign.noSignal': '{sofor} · sinyal yok · mesafe bilinmiyor',

  // Patron app — Toast
  'toast.assigned': "{plaka}'e atandı",
  'toast.cancelled': 'Sipariş iptal edildi',
  'toast.orderAdded': 'Sipariş eklendi',
  'toast.approved': 'Onaylandı · kayıt deftere işlendi',
  'toast.midLoadApproved': 'Ara yükleme onaylandı · deftere işlendi',
  'toast.askedOnWhatsapp': "WhatsApp'ta soruldu: {baslik}",

  // Patron app — Sipariş gir
  'newOrder.title': 'Sipariş gir',
  'newOrder.subtitle': 'Telefonla gelen siparişi buradan ekle.',
  'newOrder.requiredHint':
    'Kayıtlı bir müşteri seçilmeli (yoksa aşağıdan yeni müşteri ekleyin); veresiye ve zimmet yalnız kayıtlı müşteriye yazılır.',
  'newOrder.customer.label': 'Müşteri',
  'newOrder.customer.search.ph': 'Ad veya telefonla ara',
  'newOrder.customer.none': 'Eşleşen müşteri yok.',
  'newOrder.customer.new': 'Yeni müşteri',
  'newOrder.customer.newName': 'Ad Soyad',
  'newOrder.customer.newPhone': 'Telefon',
  'newOrder.customer.newAddress': 'Adres',
  'newOrder.customer.create': 'Kaydet ve seç',
  'newOrder.customer.cancelNew': 'Vazgeç',
  'newOrder.customer.change': 'Değiştir',
  'newOrder.customer.selected': 'Seçili müşteri',
  'newOrder.customer.required': 'Göndermek için müşteri seçin ya da yeni müşteri ekleyin.',
  'newOrder.customer.phoneTaken': 'Bu telefon zaten kayıtlı; aramadan seçin.',
  'newOrder.customer.fieldsRequired': 'Ad, telefon ve adres zorunlu.',
  'dayBoard.linkCustomer': 'Müşteri bağla',
  'dayBoard.linkCustomerFor': 'Müşteri bağla: {name}',
  'dayBoard.linkCustomerTitle': 'Siparişe müşteri bağla',
  'dayBoard.linkCustomerHint':
    'Bu siparişte kayıtlı müşteri yok; veresiye ve zimmet yazılabilmesi için bir müşteri bağlayın.',
  'dayBoard.linkCustomerDone': 'Müşteri bağlandı.',
  'newOrder.name': 'Ad Soyad',
  'newOrder.name.ph': 'Ayşe Demir',
  'newOrder.phone': 'Telefon',
  'newOrder.phone.ph': '0532 418 22 07',
  'newOrder.address': 'Adres',
  'newOrder.address.ph': 'Karaçayır Mah. Gül Sk. No:12/4',
  'newOrder.product': 'Ürün',
  'newOrder.product.hayat19': 'Hayat 19L',
  'newOrder.payment': 'Ödeme',
  'newOrder.default.name': 'Yeni müşteri',
  'newOrder.default.address': 'Adres girilmedi',
  'newOrder.itemSummary': '{n}× Hayat 19L',

  // Patron app — Bildirimler
  'notif.title': 'Bildirimler',
  'notif.markAllRead': 'Tümünü okundu işaretle',
  'notif.section.today': 'Bugün',
  'notif.tripClosedWithDiff': '{plaka} farkla kapandı · {n} damacana',
  'notif.integrationError': 'Abant Su Paneli bağlantısı hata veriyor',
  'notif.newOrder': 'Yeni sipariş · {ad}',
  'notif.midLoadPending': '{plaka} ara yükleme +{n} Abant — depo onayı bekliyor',
  'notif.leftAtDoor': '{ad}: kapıya emanet bırakıldı · {tutar} cari hesaba yazıldı',
  'notif.unmatchedProduct': 'Eşleşmeyen ürün: "{urun}"',
  'notif.bulkAssigned': '{n} sipariş atandı · {kisi}',
  'notif.tripBalanced': '{plaka} denklem tuttu',

  // Patron app — Push bildirimleri
  'push.approvalPending': 'Onay bekliyor · {sofor} ara yükleme',
  'push.approvalBody': '+{n} {urun} · {plaka} · depo sayımı onayına düştü',
  'push.newOrder': 'Yeni sipariş · {kanal} · {ad}',
  'push.newOrderBody': '{kalem} · {mahalle} · {bolge} bölgesi kuralıyla {plaka} aracına atandı',
  'push.viewOrder': 'Siparişi gör',

  // Patron app — Şoförler
  'drivers.title': 'Şoförler',
  'drivers.hint':
    'Beyan edilen km, konumdan hesaplanan mesafeyle karşılaştırılır. Fark büyükse kart kehribar olur.',
  'drivers.kpi.totalKm': 'Toplam km',
  'drivers.kpi.fuel': 'Mazot',
  'driver.kpi.deliveries': 'Teslimat',
  'driver.kpi.bottles': 'Damacana',
  'driver.kpi.collection': 'Tahsilat',
  'driver.kpi.kmDiff': 'Km fark',
  'driver.kmDiffValue': '+{n} km',
  'driver.status.closed': 'Kapandı',
  'driver.status.diff': 'Fark var',
  'driver.status.onRoad': 'Yolda',
  'driver.status.closing': 'Kapanışta',
  'driver.loc.closedShareStopped': 'Sefer kapandı {saat} · paylaşım durdu',
  'driver.loc.closedUnexplained': 'Sefer kapandı {saat} · {n} km açıklanmadı',
  'driver.loc.openLastSeen': 'Sefer açık · konum {n} sn önce',
  'driver.loc.atDepot': 'Depoda · kapanış bekliyor',
  'driver.trip': 'Sefer',

  // Patron app — Kanallar
  'channel.trendyolGo': 'Trendyol GO',
  'channel.hayatPanel': 'Hayat Su Paneli',
  'channel.abantPanel': 'Abant Su Paneli',

  // ── Panel — PANEL-EKRANLAR.md şartname farkları (İş 0 + İş 1) ──

  // Panel — Ön Muhasebe / Cari hesaplar tablosu (§3.13.2)
  'cash.colLastMove': 'Son hareket',
  'cash.statement': 'Ekstre',
  'cash.statementReady': '{customer} için ekstre hazırlandı.',
  // Ekstre penceresi (O2): dönem seçimi ve PDF açma
  'cash.statementDialog': 'Ekstre dönemi',
  'cash.statementFor': 'Ekstre — {customer}',
  'cash.statementFrom': 'Başlangıç',
  'cash.statementTo': 'Bitiş',
  'cash.statementOpen': 'PDF aç',
  'cash.statementDateHint': 'Dönem İstanbul günlerine göre seçilir. En fazla {n} gün.',
  'cash.statementInvalid':
    'Tarihler geçersiz. Başlangıç bitişten sonra olamaz, aralık en fazla {n} gün olabilir.',

  // Panel — Genel Bakış (§3.3 C)
  'panel.channelDistribution': 'Kanal dağılımı',
  'overview.orderCount': '{n} sipariş',
  'overview.summaryTitle': 'Bugün bir bakışta',
  'overview.summaryOrders': 'Bugünkü sipariş',
  'overview.summaryJugs': 'Teslim edilen damacana',
  'overview.summaryOpenTrips': 'Açık sefer',
  'overview.summaryApprovals': 'Bekleyen onay',
  'panel.closingStatus': 'Kapanış durumu',
  'panel.todaysTrips': 'Bugünün seferleri',
  'panel.equationMatched': 'Denklem tuttu',
  'panel.onRouteDeliveries': 'Yolda · {n} teslimat',
  'panel.awaitingClose': 'Kapanış bekliyor',
  'panel.jugsOpen': '{n} damacana açık',

  // Panel — Şoförler (§3.15 C/D)
  'drivers.colLocation': 'Konum paylaşımı',
  'drivers.locationLive': 'Sefer açık · konum {n} sn önce',
  'drivers.locationClosed': 'Sefer kapandı {saat} · paylaşım durdu',
  'drivers.locationVariance': 'Sefer kapandı {saat} · {n} km açıklanmadı',
  'drivers.locationWaiting': 'Depoda · kapanış bekliyor',
  'drivers.viewRoute': 'Rotayı gör',
  'drivers.ask': 'Sor',
  'drivers.askToast': '{driver} · WhatsApp mesajı hazırlandı: {n} km fark var, açıklar mısın?',
  'drivers.locationAuditTitle': 'Konum denetimi',
  'drivers.locationAuditHint':
    'Konum yalnız sefer açıkken paylaşılır. Sefer kapanınca paylaşım durur; şoför uygulamasında da böyle yazar.',

  // Panel — Seferler KPI ve tablo (§3.9)
  'trips.kpiOpened': 'Açılan sefer',
  'trips.kpiClosed': 'Kapanan',
  'trips.kpiDeliveries': 'Toplam teslimat',
  'trips.colDeliveries': 'Teslimat',
  'trips.colHours': 'Saatler',
  'trips.deliveriesCount': '{n} teslimat',
  'trips.jugsSoldCount': '{n} damacana',

  // Panel — Açık seferler kartları (Seferler ekranının üstü) ve kapanmış seferler özeti.
  'trips.live.title': 'Açık seferler',
  'trips.live.empty': 'Şu an açık sefer yok.',
  'trips.live.step': 'Adım {n}/{total}',
  'trips.live.delivered': 'Teslim edilen: {n}',
  'trips.live.remaining': 'Kalan sipariş: {n}',
  'trips.live.onVehicle': 'Araçta olmalı: {n}',
  'trips.live.pendingReload': '{n} onay bekliyor',
  'trips.live.collected': 'Tahsilat',
  'trips.live.locationUnavailable': 'Konum alınamadı',
  'trips.live.closedSummary':
    'Kapanmış {n} sefer · toplam mutlak fark — dolu: {full} · boş: {empty} (bu listedeki seferler)',

  // Panel — Sefer iptali (ADR 2026-09-09). Panel paketi (P3) bunları okur.
  'trips.voidButton': 'Seferi iptal et',
  'trips.voidPrompt':
    'Bu seferin bütün defter satırları terslenecek, hiçbir kayıt silinmeyecek. Gerekçe (en az 10 karakter):',
  'trips.voidConfirm': 'Sefer iptal edildi; karşı kayıtlar deftere yazıldı.',

  // Panel — Sefer iptali onayı ve özeti (ADR 2026-09-09 §1). Geri alınamayan şey İPTALİN
  // KENDİSİDİR: defterden kayıt silinmez (kural 1), her satırın karşısına ters kayıt yazılır —
  // ama iptal edilen sefer yeniden açılamaz. `stock.ledgerNote` bunu SÖYLEMİYORDU.
  'trips.voidIrreversible':
    'İptal geri alınamaz: sefer yeniden açılamaz. Defterden hiçbir kayıt silinmez, karşı kayıtlar yazılır.',
  'trips.voidedDeliveries': '{n} teslimat iptal edildi',
  'trips.voidedOrders': '{n} sipariş teslim edilemedi durumuna döndü',
  'trips.voidReceiptCount': '{n} iptal makbuzu kesildi',

  // Panel — Müşteri kartı (§3.8 D.6)
  'panel.orderHabit': 'Sipariş alışkanlığı',

  // Sipariş geldi bildirimleri (sipariş yazımıyla aynı transaction'da).
  // Gövdede müşteri adı, telefonu ve açık adresi YAZILMAZ (CLAUDE.md kural 7: bildirim tablosu
  // KVKK anonimleştirmesinin uğramadığı ikinci bir kişisel veri deposu olur). Ekran `targetId`
  // ile siparişin detayını çekip kişisel veriyi ORADA gösterir.
  'notification.orderReceivedTitle': 'Yeni sipariş · {channel}',
  'notification.orderReceivedBodyAssigned':
    '{items} · {total} · {region} bölgesi · {plate} aracına atandı',
  'notification.orderReceivedBodyAssignedNoRegion': '{items} · {total} · {plate} aracına atandı',
  'notification.orderReceivedBodyUnassigned':
    '{items} · {total} · {region} bölgesi · henüz atanmadı',
  'notification.orderReceivedBodyUnmatched':
    '{items} · {total} · bölge eşleşmedi · elle atama bekliyor',

  // Kiracı ayarı — atama kipi (panel §3.6)
  'set.orderAssignment': 'Yeni siparişlerin atanması',
  'set.orderAssignmentHint':
    'Otomatik: bölge eşleşen sipariş kendiliğinden araca düşer. Elle: sipariş beklemede kalır, sen atarsın. Otomatiğe geçiş için gölge uyum kapısı sağlanmalı; yalnız patron açar.',
  'set.orderAssignment.auto': 'Otomatik',
  'set.orderAssignment.manual': 'Elle',
  'orderAssignment.AUTO': 'Otomatik',
  'orderAssignment.MANUAL': 'Elle',
  'assignment.autoOwnerOnly': 'Otomatik atamayı yalnız patron açabilir.',
  'assignment.autoGateNotMet':
    'Otomatik atama açılamadı: gölge uyum en az %{rate}, en az {days} günlük veri ve {samples} karşılaştırılabilir sipariş gerekir.',
  'assignment.gateRateLow': 'Gölge uyum %{rate} altında.',
  'assignment.gateDaysLow': 'Karşılaştırılabilir veri {days} günden az.',
  'assignment.gateSamplesLow': 'Karşılaştırılabilir sipariş {samples} adetten az.',
  'set.autoAssign.open': 'Otomatik atamayı aç',
  'set.autoAssign.close': 'Kapat',
  'set.autoAssign.stateOn': 'Otomatik atama açık.',
  'set.autoAssign.stateOff': 'Otomatik atama kapalı; siparişleri sen atarsın.',
  'set.autoAssign.rate': 'Uyum %{rate}',
  'set.autoAssign.rateNone': 'Uyum verisi yok',
  'set.autoAssign.daysShort': '{days}/{min} günlük veri, {min} gün gerekli',
  'set.autoAssign.samplesShort': '{n}/{min} sipariş örneği, {min} gerekli',
  'set.autoAssign.loadError': 'Otomatik atama kapısı okunamadı.',
  'set.autoAssign.ready': 'Koşullar sağlandı',
  'set.autoAssign.ownerOnly': 'Otomatik atamayı yalnız patron açabilir.',
  'region.manualBanner': 'Kurallar yalnız otomatik atama açıkken uygulanır. Şu an elle atama açık.',
  'region.manualBannerLink': 'Ayarlar',

  // --- Paket B: panel bölge ekranı (yalnız bu bölüme yaz) ---
  'nav.regions': 'Bölgeler',
  'region.title': 'Bölgeler',
  'region.intro':
    'Bir bölge seç, sonra haritada mahallelere tıklayarak boya. Adres eşleşince sipariş bölgenin varsayılan aracına düşer.',
  'region.name': 'Bölge adı',
  'region.namePlaceholder': 'Üst Bölge',
  'region.add': 'Yeni Bölge',
  'region.empty': 'Henüz bölge tanımlı değil.',
  'region.neighborhoods': 'Mahalleler',
  'region.neighborhoodsHint':
    'Her satıra bir mahalle adı yaz. " mah." / " mh." soneklerini yazma; sunucu kırpar.',
  'region.defaultVehicle': 'Varsayılan Araç',
  'region.noVehicle': 'Araç seçme (otomatik atama yok)',
  'region.autoAssign': 'Otomatik atama',
  'region.autoAssignHint': 'Adres eşleşince sipariş varsayılan araca kendiliğinden düşer.',
  'region.color': 'Renk',
  'region.colorHint': 'Liste ve haritada görünen rozet rengi.',
  'region.sortOrder': 'Sıra',
  'region.saveNew': 'Bölgeyi Kaydet',
  'region.saveEdit': 'Kaydet',
  'region.cancel': 'Vazgeç',
  'region.created': '{name} bölgesi eklendi.',
  'region.updated': '{name} bölgesi güncellendi.',
  'region.deactivated': '{name} bölgesi kapatıldı.',
  'region.deactivate': 'Bölgeyi kapat',
  'region.deactivate.confirmTitle': 'Bölgeyi kapat',
  'region.deactivate.confirmBody':
    '{name} bölgesi kapatılacak; mahalleleri bölgesiz kalır. Devam edilsin mi?',
  'region.deactivate.confirmOk': 'Kapat',
  'region.deactivate.error': '{name} bölgesi kapatılamadı. Tekrar dene.',
  'region.deactivatedLabel': 'Pasif',
  'region.customersCount': '{count} müşteri',
  'region.noCustomers': 'Müşteri yok',
  'region.matcher': 'Adres Dene',
  'region.matcherHint': 'Bir adres yaz; eşleşen bölge ve aracı burada gör.',
  'region.matcherPlaceholder': 'Örn. İzzet Baysal Mah. 4509 Sok. No 12',
  'region.matcherTry': 'Dene',
  'region.matcherEmpty': 'Adres boş olamaz.',
  'region.match.matchedRegion': 'Bölge: {name}',
  'region.match.matchedVehicle': 'Araç: {plate}',
  'region.match.matchedAuto': 'Otomatik atanır',
  'region.match.matchedManual': 'Bölge bulundu; araç elle atanacak',
  'region.match.unmatched': 'Bu adres hiçbir bölgeyle eşleşmedi. Sipariş beklemede kalır.',
  'region.neighborhoodTakenField': 'Bu mahalle başka bir bölgede tanımlı: {region}.',
  'region.fieldRequired': 'Bölge adı zorunlu.',
  'region.paintMode': 'Bölge boyanıyor — mahallelere tıkla',
  'region.archiveAll.button': 'Tümünü arşivle',
  'region.archiveAll.confirmTitle': 'Tüm bölgeleri arşivle',
  'region.archiveAll.confirmBody':
    '{regions} aktif bölge arşivlenecek (daha önce pasifleştirilmiş bölgeler de arşiv adı alır) ve {customers} müşterinin bölge bağı kalkacak. Bölge kayıtları silinmez; geçmiş sipariş ve seferlerin bölge bilgisi ile araç atamaları değişmez. Mesai ortasında çalıştırma: açık siparişlerin bölge bilgisi değişmez ama yeni atama pasif bölgeyi atlar. Devam edilsin mi?',
  'region.archiveAll.confirmOk': 'Arşivle',
  'region.archiveAll.done':
    '{regions} bölge arşivlendi, {customers} müşterinin bölge bağı kaldırıldı.',
  'region.archiveAll.error': 'Bölgeler arşivlenemedi. Tekrar dene.',
  'region.archiveAll.stepDone':
    '{regions} bölge arşivlendi. Öneriler yenilendi; taslakları seçip yeniden uygula.',
  'region.suggest.archiveFirst':
    'Önce mevcut bölgeleri arşivle ({regions} aktif bölge, {customers} müşteri bağı); öneriler yenilenir, sonra taslakları yeniden onaylarsın.',
  'region.suggest.archiveOk': 'Arşivle',
  'streetMap.paint.timeout': 'İstek zaman aşımına uğradı, liste yenileniyor.',
  'region.paintDone': 'Bitti',
  'region.paintEscHint': 'Çıkmak için Bitti düğmesine ya da Esc tuşuna bas.',
  'region.paintHint':
    'Haritada mahalleye tıkla: mahalle bu bölgeye eklenir. Bir daha tıklarsan çıkar.',
  'region.advanced.toggle': 'Gelişmiş: sokak istisnaları',
  'region.advanced.open': 'Gelişmiş aç',
  'region.advanced.close': 'Gelişmiş kapat',
  'region.rematch.button': 'Bekleyen siparişleri yeniden dağıt',
  'region.rematch.confirmTitle': 'Bekleyen siparişleri yeniden eşle',
  'region.rematch.confirmBody':
    'Bekleyen siparişler güncel bölgelere göre yeniden dağıtılacak. Devam edilsin mi?',
  'region.rematch.confirmOk': 'Yeniden dağıt',
  'region.rematch.confirmCancel': 'Vazgeç',
  'region.rematch.done': 'Bekleyen siparişler güncellendi.',
  'region.rematch.result': '{regionSet} sipariş bölgeye bağlandı, {assigned} sipariş araca atandı.',
  'region.rematch.failed':
    'Bekleyen siparişler yeniden eşlenemedi; "Bekleyen siparişleri yeniden dağıt" ile tekrar dene.',
  'region.rematch.error': 'Bekleyen siparişler yeniden dağıtılamadı. Tekrar dene.',
  'region.card.addVehicle': 'Araç seç',
  'region.suggest.nameFormat': '{hood} çevresi',
  'region.suggest.descPlate': 'Panelde {orders} sipariş; çoğunlukla {plate} etiketiyle işaretli.',
  'region.suggest.descLabel': 'Panelde {orders} sipariş; aynı panel etiketi altında toplanıyor.',
  'region.suggest.descNone': 'Panelde {orders} sipariş; etiketi yok.',
  'region.suggest.nameQuadrant': '{dir} · {hood}',
  'region.suggest.dir.NW': 'Kuzeybatı',
  'region.suggest.dir.NE': 'Kuzeydoğu',
  'region.suggest.dir.SW': 'Güneybatı',
  'region.suggest.dir.SE': 'Güneydoğu',
  'region.suggest.vehicleInvalid': 'Seçilen araç bulunamadı ya da pasif.',
  'region.suggest.vehicleLabel': 'Araç',
  'region.suggest.vehicleNone': 'Araç yok',
  'region.suggest.vehicleNoMapping': 'Araç eşlemesi bulunamadı',
  'region.suggest.vehicleAmbiguous': 'İki bölge aynı araca düşüyor',
  'region.suggest.border': 'Sınır mahallesi',
  'region.suggest.button': 'Verilerden bölge öner',
  'region.suggest.title': 'Önerilen bölgeler',
  'region.suggest.intro':
    'Son 30 günün Hayat ve Abant siparişlerinde mahalle ile panel etiketi birlikte incelendi. Öneriler taslaktır; uygulamadan önce gözden geçir.',
  'region.suggest.loading': 'Öneriler hazırlanıyor…',
  'region.suggest.empty': 'Öneri çıkarmaya yetecek veri yok.',
  'region.suggest.loadError': 'Bölge önerileri yüklenemedi. Tekrar dene.',
  'region.suggest.confidence': 'Güven %{pct}',
  'region.suggest.orders': '{count} sipariş',
  'region.suggest.select': '{name} taslağını seç',
  'region.suggest.close': 'Kapat',
  'region.suggest.applySelected': 'Seçilenleri uygula',
  'region.suggest.noneSelected': 'Uygulamak için en az bir taslak seç.',
  'region.suggest.ownerOnly': 'Taslakları yalnız patron uygulayabilir.',
  'region.suggest.confirmTitle': 'Önerilen bölgeleri uygula',
  'region.suggest.confirmBody':
    '{count} bölge oluşturulacak. Yalnız bölge kaydı yazılır; müşteri, sipariş ve seferler değişmez. Devam edilsin mi?',
  'region.suggest.confirmOk': 'Uygula',
  'region.suggest.applied': '{count} bölge eklendi.',
  'region.suggest.applyError': 'Bölgeler eklenemedi. Tekrar dene.',
  'region.card.paintMode': 'Bitti',
  'region.card.paintModeOff': 'Haritada boya',
  'region.card.edit': 'Bilgileri düzenle',
  'region.card.noVehicleWarning': 'Araç seçilmedi — siparişler bölgeye düşer ama araca atanmaz.',
  'region.card.vehicleSaved': '{name} bölgesinin aracı güncellendi.',
  'region.card.saveError': '{name} bölgesi kaydedilemedi. Tekrar dene.',
  'region.card.neighborhoodCount': '{count} mahalle',
  'region.card.noNeighborhoods': 'Mahalle yok',
  'region.addForm.colorAuto': 'Otomatik (paletten boş renk)',

  // --- Paket C: kanal siparişinden müşteri (yalnız bu bölüme yaz) ---

  // --- Paket D: şoför app otomatik yenileme (yalnız bu bölüme yaz) ---
  'day.newOrders': '{n} yeni sipariş',

  // --- Paket G: Hayat uzlaştırıcı / "Hayat'a gönder" (yalnız bu bölüme yaz) ---
  // Eylem etiketleri — uzlaştırıcı sonucu patrona gösterilirken etikete çevrilir.
  'channelPushAction.CONFIRM_VEHICLE': 'Araç onayı',
  'channelPushAction.SEND_TO_VEHICLE': 'Araca gönderildi',
  'channelPushAction.MARK_DELIVERED': 'Teslim edildi',
  'channelPushAction.CHANGE_VEHICLE': 'Araç değiştir',
  'channelPushAction.CANCEL': 'İptal',
  // Sonuç etiketleri — UI'ın "Hayat'a gönder" düğmesinin yanında gösterdiği özet.
  'channelPushResult.SENT': 'Gönderildi',
  'channelPushResult.SKIPPED_ALREADY_DONE': 'Zaten yapılmış',
  'channelPushResult.SHADOW_ONLY': 'Gölge',
  'channelPushResult.BLOCKED': 'Engellendi',
  'channelPushResult.FAILED': 'Başarısız',
  'channelPushResult.UNCERTAIN': 'Belirsiz',
  'channelPushResult.PENDING': 'Gönderiliyor',
  // BLOKE gerekçeleri — patron bunu görür: "neden gönderilmedi?"
  'hayatPush.reason.scraper-disabled': 'Hayat çekimi kapalı.',
  'hayatPush.reason.writer-disabled': 'Hayat yazma yetkisi kapalı.',
  'hayatPush.reason.tenant-restricted': 'Hesap askıda; yalnız açık vardiya kapatılabilir.',
  'hayatPush.reason.unknown-action': 'Eylem tanınmadı.',
  'hayatPush.reason.no-action-needed': 'Henüz yapılacak bir şey yok.',
  'hayatPush.reason.no-vehicle-mapping':
    'Bu aracın paneldeki eşlemesi girilmemiş. Ayarlar → Araç eşleme.',
  'hayatPush.reason.writer-not-configured':
    'Hayat yazıcısı yapılandırılmamış. Bu PR kapsamı dışında; canlı yazma ayrı paket.',
  'hayatPush.reason.last-attempt-uncertain':
    'Önceki deneme belirsiz kaldı. Yeniden göndermek için "Hayat’a gönder" düğmesine bas.',
  'hayatPush.reason.hayat-cancelled': 'Hayat panelinde bu sipariş iptal edilmiş. Yazma yok.',
  'hayatPush.reason.hayat-delivered': 'Hayat panelinde bu sipariş teslim edilmiş. Yazma yok.',
  'hayatPush.reason.not-hayat-order': 'Bu sipariş Hayat kanalından gelmiyor.',
  'hayatPush.reason.unknown-observed':
    'Hayat panelindeki durum tanınmadı. Panel durumu bilinmeden yazma yok.',
  'hayatPush.reason.retry-backoff':
    'Önceki deneme başarısız oldu; otomatik yeniden deneme için bekleniyor.',
  'hayatPush.reason.retry-limit':
    'Üst üste başarısız denemeler nedeniyle otomatik gönderim durdu. Yeniden denemek için "Hayat’a gönder" düğmesine bas.',
  'hayatPush.reason.hayat-vehicle-mismatch':
    'Hayat panelinde bu sipariş başka bir araca atanmış. Araç çelişkisi çözülmeden yazma yok.',
  // P3 / G2 — Hayat yazıcısının iç reason kodları. Uzlaştırıcının `error` kolonuna
  // yazılır, kullanıcıya "Sebep: …" olarak gösterilir. Bilinçli olarak kısa ve teknik:
  // bu kodlar yapının içinde mantık taşır (yazma hangi kapıda kesildi?).
  'hayatPush.reason.prompter-no-pending': 'Hayat panelinde bekleyen sipariş yok.',
  'hayatPush.reason.prompter-other-order':
    'Hayat panelinde başka bir sipariş bekliyor; bu siparişe yazılmadı.',
  'hayatPush.reason.prompter-multiple':
    'Hayat panelinde birden çok bekleyen sipariş var; tek-çoklu biçim henüz yakalanmadı.',
  'hayatPush.reason.prompter-malformed':
    'Hayat panelinin yeni sipariş penceresi beklenen yapıda değil; panel arayüzü değişmiş olabilir.',
  'hayatPush.reason.vehicle-option-missing':
    'Seçilen araç Hayat panelinde bulunamadı. Araç eşlemesini kontrol edin.',
  'hayatPush.reason.delivery-time-missing': 'Hayat panelinde teslim süresi seçeneği boş.',
  'hayatPush.reason.write-format-unknown': 'Bu eylem için Hayat yazma biçimi henüz tanımlı değil.',
  'hayatPush.reason.prompter-get-failed': 'Hayat panelinden yeni sipariş sayfası okunamadı.',
  'hayatPush.reason.confirm-post-failed': 'Hayat paneli onay isteğini yanıtlamadı.',
  'hayatPush.reason.confirm-server-error': 'Hayat paneli onay sırasında sunucu hatası döndü.',
  'hayatPush.reason.confirm-rejected':
    'Hayat paneli onay isteğine hata döndü; işlenip işlenmediği belirsiz. Paneli kontrol edin.',
  'hayatPush.reason.confirm-not-verified':
    'Onaydan sonra Hayat panelinde siparişin aracı beklenen araç olarak görünmüyor. Paneli kontrol edin.',
  'hayatPush.reason.verify-get-failed': 'Hayat panelinde onay sonrası doğrulama yapılamadı.',
  'hayatPush.reason.session-expired':
    'Hayat paneli oturumu düşmüş; yazma yapılmadı. Sonraki çekimde oturum yenilenir.',
  'hayatPush.reason.session-not-ready':
    'Hayat paneli oturumu henüz açılmadı; yazma yapılmadı. Önce çekimin çalışması gerekiyor.',
  'hayatPush.reason.orders-read-failed':
    'Hayat panelinden aktif siparişler okunamadı; yazma yapılmadı.',
  'hayatPush.reason.target-row-missing':
    'Sipariş Hayat panelinin aktif siparişler listesinde bulunamadı; yazma yapılmadı.',
  'hayatPush.reason.target-vehicle-changed':
    'Hayat panelinde siparişin aracı son okumadan beri değişmiş; yazma yapılmadı.',
  'hayatPush.reason.target-already-confirmed':
    'Hayat panelinde bu siparişe zaten araç atanmış; yazma yapılmadı.',
  'hayatPush.reason.live-access-blocked': 'Canlı panel erişimi kapalı; yazma yapılmadı.',
  'hayatPush.reason.confirm-url-foreign':
    'Hayat panelinin onay adresi beklenen alan adında değil; yazma yapılmadı.',
  'hayatPush.reason.verify-session-expired':
    'Onay gönderildi ama ardından Hayat oturumu düştü; işlenip işlenmediği belirsiz. Paneli kontrol edin.',
  'hayatPush.reason.other-row-changed':
    'Onay sırasında Hayat panelinde başka bir siparişin aracı da değişti. Paneli kontrol edin.',
  // Patron bildirimleri — kişisel veri yok (kural 7). Yalnız sipariş no + eylem + plaka/etiket.
  'hayatPush.notify.sentTitle': 'Hayat gönderildi · #{orderId}',
  'hayatPush.notify.sentBody': '{action} · {plate}',
  'hayatPush.notify.failedTitle': 'Hayat gönderilemedi · #{orderId}',
  'hayatPush.notify.failedBody': 'Sebep: {error}',
  'hayatPush.notify.conflictTitle': 'Hayat panelinde sipariş farklı durumda · #{orderId}',
  'hayatPush.notify.retryLimitTitle': 'Hayat otomatik gönderimi durdu · #{orderId}',
  // UI düğme etiketleri (panel §P3 sonradan)
  'hayatPush.ui.pushButton': 'Hayat’a gönder',
  'hayatPush.ui.attemptsTitle': 'Son Hayat denemeleri',
  'hayatPush.ui.attemptsEmpty': 'Bu sipariş için henüz Hayat denemesi yok.',

  // --- Paket H: panel + patron app Hayat ekranları (yalnız bu bölüme yaz) ---
  // Sipariş listesi/detayı üzerindeki "Hayat durumu" satırı. Ham metin siparişin
  // kendi durumunu Hayat'taki kendi adıyla taşır; patron "orada ne görünüyor" sorusunu
  // buradan okur. Sunucu tarafı `observedRaw`'ı ham olarak yazar; çeviri/anonimleştirme yok.
  'hayatPush.ui.statusLabel': 'Hayat durumu',
  'hayatPush.ui.statusEmpty': '—',
  // Butonun kendisi: Gölge kipinde de görünür — düğme "gönderir", kip yazıp yazmamayı seçer.
  // Düğme onay diyaloğunu AÇMADAN istek atmaz (kural: benden habersiz Hayat'a yazma olmaz).
  'hayatPush.ui.confirmTitle': 'Hayat’a gönder',
  'hayatPush.ui.confirmBody': 'Bu işlem Hayat bayi paneline yazar: {action}. Devam?',
  'hayatPush.ui.confirmBodyShadow':
    'Gölge kip: Hayat’a gitmez, yalnız kaydedilir. Yine de gönderilsin mi?',
  // Düğme onay diyaloğundan sonraki sonuç kutusu: ya tek kısa mesaj ya reason + eylem.
  'hayatPush.ui.resultToast': '{result} · {action}',
  'hayatPush.ui.resultToastReason': '{result} · {reason}',
  // Deneme geçmişi (saat GG.AA.YYYY SS:dd, eylem, kip, tetik, sonuç)
  'hayatPush.ui.attemptsColTime': 'Saat',
  'hayatPush.ui.attemptsColAction': 'Eylem',
  'hayatPush.ui.attemptsColMode': 'Kip',
  'hayatPush.ui.attemptsColTrigger': 'Tetik',
  'hayatPush.ui.attemptsColResult': 'Sonuç',
  'hayatPush.ui.attemptsColCode': 'Kod',
  'hayatPush.ui.attemptsColHttp': 'HTTP',
  'hayatPush.ui.attemptCodeUnknown': 'Bilinmeyen kod',
  'hayatPush.ui.triggerBUTTON': 'Düğme',
  'hayatPush.ui.triggerSCHEDULER': 'Zamanlayıcı',
  // Ayar ekranı — Hayat yazma kipi bölümü
  'hayatPush.setting.title': 'Hayat’a yazma',
  'hayatPush.setting.intro':
    'Hayat Su bayi paneline yazma yetkisi. Kural: düğmeye basmadan Habersiz Yazma yok.',
  'hayatPush.setting.modeLabel': 'Yazma kipi',
  'hayatPush.setting.confirmLabel': 'Onay için kipi yeniden yaz',
  'hayatPush.setting.confirmPlaceholder': 'Gölge / Onaylı / Otonom',
  'hayatPush.setting.mismatch': 'Kip adı iki kez aynı seçilmedi.',
  'hayatPush.setting.autoWarning':
    'Otonom: siparişler bizde ilerledikçe Hayat’a kendiliğinden yazılır, her gönderim size bildirilir.',
  'hayatPush.setting.writerEnabled': 'Hayat’a yazma yetkisi',
  'hayatPush.setting.writerEnabledHint':
    'Acil kapatma. Kapalıyken hiçbir tetikleyici Hayat’a yazmaz; Gölge kipi dahil düğme de kayıt düşürür ama yazmaz.',
  // Patron uygulaması (mobil) — kip ayarı yok, yalnız küçük etiket
  'hayatPush.mobile.modeLabel': 'Hayat kipi: {mode}',
  'hayatPush.mobile.statusLabel': 'Hayat durumu',

  // Yeni sipariş izleyici (görev: panel yeni sipariş anında görünsün ve SESLİ uyarsın)
  'panel.newOrderToast': 'Yeni sipariş · {channel} · {customer}',
  'panel.newOrderToastClose': 'Bildirimi kapat',
  'panel.soundOn': 'Sesli bildirim: Açık',
  'panel.soundOff': 'Sesli bildirim: Kapalı',

  // Hayat kanal tutarı ve Hayat'ta kapanan sipariş (ADR 2026-09-29-hayat-kanal-tutari-ve-dis-kapanis)
  // 2026-09-30 (W3): Abant kapanış uzlaştırması da bu duruma geçtiği için metin kaynak-nötr
  // "Panelde" oldu — kaynak zaten H/A harfiyle ayrıca görünür. Tam sonuç etiketi (teslim /
  // iptal / işlemde) panelOutcome'a göre `orderStatus.HANDLED_EXTERNALLY.<sonuç>`'tan okunur;
  // genel anahtar filtre çiplerinde ve ham durum boşsa kullanılır.
  'orderStatus.HANDLED_EXTERNALLY': 'Panelde',
  'orderStatus.HANDLED_EXTERNALLY.delivered': 'Panelde teslim edildi',
  'orderStatus.HANDLED_EXTERNALLY.cancelled': 'Panelde iptal',
  'orderStatus.HANDLED_EXTERNALLY.pending': 'Panelde işlemde',
  'panelStage.brand.HAYAT_PANEL': 'Hayat',
  'panelStage.brand.ABANT_PANEL': 'Abant',
  // Panel araçları özeti (Seferler + Araçlar & Ekip ekranları). Defter DEĞİŞMEZ; salt okunur.
  'panelFleet.title.today': 'Panel araçları — bugün',
  'panelFleet.empty': 'Bugün panel araç siparişi yok.',
  'panelFleet.unassigned': 'Araç atanmamış',
  'panelFleet.vehicle.label': 'Plaka {plate}',
  'panelFleet.vehicle.abantName': 'Abant: {name}',
  'panelFleet.vehicle.abantId': 'Abant araç {id}',
  'panelFleet.countsLine': '{progress} yolda · {done} teslim · {new} yeni · {cancelled} iptal',
  // Sıfır sayaçlar yazılmaz (30.09.2026 karar); yalnız sıfırdan büyük olanlar gösterilir.
  'panelFleet.countsProgress': '{n} yolda',
  'panelFleet.countsDone': '{n} teslim',
  'panelFleet.countsNew': '{n} yeni',
  'panelFleet.countsCancelled': '{n} iptal',
  'panelFleet.countsAllZero': 'Bugün iş yok',
  'panelFleet.revenueLine': '{amount} ciro',
  'panelFleet.lastActivity': 'Son hareket: {time}',
  'panelFleet.lastActivity.none': 'Henüz hareket yok',
  'panelFleet.openCount': '{n} açık sipariş',
  // Araçlar & Ekip sekmesindeki panel bölümü
  'panelFleet.sectionTitle': 'Panel araçları',
  'panelFleet.sectionHint':
    'Bayi panelinde (Hayat/Abant) son 7 günde sipariş almış araçlar. Şoförlerin mobil uygulaması olmayan panel araçları burada görünür.',
  'panelFleet.weeklyCountsTitle': 'Son 7 gün — etiket başına sipariş sayısı',
  'panelFleet.weeklyCount': '{n} sipariş',
  // Mahalle → panel aracı öneri kartı (Araçlar & Ekip ekranı) ve satır ipuçları.
  'panelFleet.suggest.title': 'Mahalle → araç (son {days} gün)',
  'panelFleet.suggest.hint':
    'Geçmişte aynı mahalleye en sık hangi panel aracı gittiyse onu önerir. Siparişe YAZMAZ; yalnız bilgi.',
  'panelFleet.suggest.columnNeighborhood': 'Mahalle',
  'panelFleet.suggest.columnVehicle': 'Araç',
  'panelFleet.suggest.columnShare': 'Pay',
  'panelFleet.suggest.columnSamples': 'Örnek',
  'panelFleet.suggest.sharePct': '%{pct}',
  'panelFleet.suggest.shareSummary': 'Bu mahallede son {days} günde {total} siparişin %{pct}’si',
  'panelFleet.suggest.label': 'Öneri: {name}',
  'orderEvent.HANDLED_EXTERNALLY': 'Panele devredildi',
  'orderEvent.CHANNEL_PRICE_WARNING': 'Kanal tutarı uyarısı',
  'order.handledExternallySystemOnly':
    'Bu durum yalnız Hayat panelinden okunarak verilir; elle seçilemez.',
  'order.channelPriceWarning.deposit':
    'Depozitolu sipariş: liste fiyatı korundu. Kanal ürün tutarı {channel}, liste tutarı {list}.',
  'order.channelPriceWarning.multiItem':
    'Çok kalemli sipariş: liste fiyatı korundu. Kanal ürün tutarı {channel}, liste tutarı {list}.',
  'order.channelPriceWarning.indivisible':
    'Kanal tutarı adede kuruşu kuruşuna bölünmüyor: liste fiyatı korundu. Kanal ürün tutarı {channel}, liste tutarı {list}.',
  'order.channelPriceWarning.zero':
    'Kanal ürün tutarı sıfır: liste fiyatı korundu. Kanal ürün tutarı {channel}, liste tutarı {list}.',
  'order.channelPriceWarning.unreadable':
    'Kanal tutarı okunamadı: liste fiyatı yazıldı ({list}). Hayat’taki tutarı kontrol edin.',
  'order.channelPriceWarning.inProgress':
    'Sipariş atanmış ya da yolda: fiyat değiştirilmedi. Kanal ürün tutarı {channel}, sipariş tutarı {list}.',
  'scraper.channelAmountUnreadable':
    '{count} siparişin kanal tutarı okunamadı; liste fiyatı yazıldı. Panelin tutar sütunları değişmiş olabilir.',
  'order.reopenAction': 'Yeniden aç',
  'order.reopened': 'Sipariş yeniden açıldı.',
  'hayatClosed.notify.title': 'Hayat’ta sipariş bizden farklı ilerledi · #{orderId}',
  'hayatClosed.notify.body':
    'Hayat durumu: {observed}. Bizdeki durum: {status}. Sahadaki gerçek bizde; durum değiştirilmedi.',
  // Getir Su kapanan siparişler (görev: mm/aqua-getir-kapanan, hakem U3/U4)
  'getirClosed.notify.title': 'Getir siparişi bizden farklı ilerledi · #{orderId}',
  'getirClosed.notify.body':
    'Getir durumu: {observed}. Bizdeki durum: {status}. Sahadaki gerçek bizde; durum değiştirilmedi.',
  'getirClosed.status.delivered': 'Teslim edildi',
  'getirClosed.cancelReason': 'Getir tarafında iptal',
  'getirClosed.cancelEvent': 'Getir tarafında iptal ({code})',
  'getirClosed.overflow.title': 'Getir kapanan sipariş listesi sınırı aşıldı',
  'getirClosed.overflow.body':
    'Kapanan sipariş listesi {pages} sayfayı aştı; kalan kayıtlar okunmadı. Kapanışları Getir panelinden kontrol edin.',
  'hayatPush.reason.hayat-dispatched':
    'Hayat panelinde sipariş araç listesine geçmiş. İptal yazılmadı; iptali bayi Hayat’ta yapmalı.',
  // Siparişler — tarih aralığı (serbest seçim)
  'panel.dateRange': 'Tarih aralığı',
  'panel.dateFrom': 'Başlangıç',
  'panel.dateTo': 'Bitiş',
  'panel.dateRangeInvalid': 'Başlangıç tarihi bitişten büyük olamaz.',
  // İki tarihten biri eksikse yükleme göstergesi yerine gösterilen ipucu (siparişler ekranı).
  'panel.dateRangeIncomplete': 'Başlangıç ve bitiş tarihlerini seçin.',

  // Müşteriler — ekle / düzenle / pasifleştir
  'cust.add': '+ Yeni müşteri',
  'cust.edit': 'Düzenle',
  'cust.deactivate': 'Pasifleştir',
  'cust.deactivateConfirm':
    '{name} pasifleştirilsin mi? Geçmiş siparişleri ve cari kayıtları durur.',
  'cust.regionAuto': 'Adresten otomatik',
  'cust.formTitleNew': 'Yeni müşteri',
  'cust.formTitleEdit': 'Müşteriyi düzenle',
  'cust.fullName': 'Ad Soyad',
  'cust.phone': 'Telefon',
  'cust.phone2': '2. telefon',
  'cust.address': 'Adres',
  'cust.addressNote': 'Adres notu',
  'cust.region': 'Bölge',
  'cust.notes': 'Not',
  'cust.saveFailed': 'Müşteri kaydedilemedi.',
  'cust.created': '{name} eklendi.',
  'cust.updated': '{name} güncellendi.',
  'cust.deactivated': '{name} pasifleştirildi.',
  'cust.reactivate': 'Yeniden etkinleştir',
  'cust.reactivated': '{name} yeniden etkinleştirildi.',
  // U3: yeniden etkinleştirme onayında "ne yapıyoruz?" sorusu — bağlamsız isim tek başına yetmez.
  'cust.reactivateConfirm': '{name} yeniden etkinleştirilsin mi? Tekrar sipariş alabilir.',
  'cust.includeInactive': 'Pasifleri göster',
  'cust.clearFilter': 'Filtreyi temizle',
  // "Pasif" rozet — listenin sağ üstündeki aç/kapa ile beraber görünür.
  'cust.inactive': 'Pasif',

  // Sütun genişliği — sürükleme tutamağı
  'columns.resizeHint': 'Genişliği değiştirmek için sürükleyin · çift tık: sıfırla',

  // Geçmiş sipariş aktarımı — Hayat "Sipariş Sorgulama" (entegrasyonlar ekranı + API hataları)
  'historyImport.disabled': 'Bu kaynakta geçmiş sipariş aktarımı yok.',
  'historyImport.invalidDay': 'Geçersiz tarih.',
  'historyImport.invalidRange': 'Başlangıç tarihi bitiş tarihinden sonra olamaz.',
  'historyImport.futureDay': 'Bitiş tarihi bugünden ileri olamaz.',
  'historyImport.rangeTooLong': 'Tek seferde en fazla {max} gün aktarılabilir.',
  'historyImport.notActive': 'Bağlantı aktif ve onaylı değil.',
  'historyImport.badConfig': 'Bağlantı yapılandırması geçersiz.',
  'historyImport.alreadyRunning':
    'Bu kanalda şu anda başka bir çekim sürüyor; biraz sonra yeniden deneyin.',
  'historyImport.loginBackoff':
    'Art arda başarısız giriş nedeniyle giriş geçici olarak durduruldu; süre dolunca yeniden deneyin.',
  'historyImport.fetchFailed': 'Hayat panelinden geçmiş okunamadı. Hiçbir sipariş yazılmadı.',
  'historyImport.dayMismatch':
    'Hayat {day} araması başka güne ait ya da tarihi okunamayan satır döndürdü. Hiçbir sipariş yazılmadı.',
  'historyImport.title': 'Geçmiş siparişleri aktar',
  'historyImport.hint':
    "Hayat'ın Sipariş Sorgulama ekranından seçilen günlerin kapanmış ve iptal edilmiş siparişlerini alır. Açık siparişler ve bizde zaten olanlar aktarılmaz. Önce önizleyin.",
  'historyImport.from': 'Başlangıç',
  'historyImport.to': 'Bitiş',
  'historyImport.preview': 'Önizle',
  'historyImport.apply': 'Aktar',
  'historyImport.confirm':
    '{from} – {to} arası {n} sipariş Hayat’ta işlenmiş olarak aktarılacak. Onaylıyor musunuz?',
  'historyImport.killSwitchOff': 'Çekim anahtarı kapalı; aktarım yapılamaz.',
  'historyImport.previewTitle': 'Önizleme',
  'historyImport.doneTitle': 'Aktarım tamamlandı',
  'historyImport.rows': 'Panelde {n} satır',
  'historyImport.createdDry': '{n} aktarılacak',
  'historyImport.created': '{n} aktarıldı',
  'historyImport.existing': '{n} zaten var',
  'historyImport.openSkipped': '{n} açık (aktarılmaz)',
  'historyImport.unmappedCount': '{n} sipariş ürün eşleşmesi bekliyor',
  'historyImport.unmappedList': 'Eşleşmeyen ürünler: {names}',
  'historyImport.skippedLine': 'Atlanan: {reason} ({n})',
  'historyImport.otherDay': 'Panelin tarihi yok saydığı satırlar (atlandı): {entries}',
  'historyImport.skip.no-external-id': 'sipariş numarası yok',
  'historyImport.skip.unknown-channel': 'tanınmayan kanal',
  'historyImport.skip.unknown-payment': 'tanınmayan ödeme',
  'historyImport.skip.invalid-row': 'okunamayan satır',
  'historyImport.skip.ingest-failed': 'yazılamadı',
  'historyImport.skip.detail-failed': 'sipariş detayı okunamadı',
  // 15L cam damacana — hakem turu (ADR 2026-09-20).
  'close.returnedLineNotReturnable':
    'Marka dökümündeki bir ürün depoya dönüş olarak yazılamaz (koli ya da bu seferde hareketi olmayan tür).',
  // Patron rozeti, birden çok türde: "15L Cam Damacana: Dolu +2 · Boş 0".
  'boss.diffShortKind': '{kind}: {diff}',
  'boss.diffKindSeparator': ' / ',
  // Ürün seçeneği türüyle: "Hayat 15L Cam · 15L Cam Damacana" — yanlış türe eşlemeyi önler.
  'prod.nameWithKind': '{name} · {kind}',
  // P1 koli denklemi: hareketi olan ürünün türü değiştirilemez; geriye dönük tür değişikliği
  // defteri kirletir (eski satırlar eski türden, yeni satırlar yeni türden SUM'a girer).
  // Yeni ürün açılıp eskisi pasife alınmalıdır.
  'product.kindChangeBlocked':
    'Defter hareketi olan ürünün türü değiştirilemez ({moves} satır). Yeni tür için ayrı ürün açın ve eskisini pasife alın.',

  // ── Fiyat eşitleme (otomatik, Hayat) ──
  // Gövdede ürün başına "ad: eski → yeni" satırları + gerekirse "+n ürün daha" ve
  // "{n} ürün güncellenemedi" satırları sıralanır. Ad ve fiyat kullanıcıya bildirimde
  // gösterilir; sunucu loguna ise girmez (kural 6).
  'priceSync.title': 'Hayat fiyatları güncellendi',
  // Değişiklik hiç yoksa ve yalnız başarısızlık varsa bu başlık kullanılır (scheduler.service).
  'priceSync.titleFailed': 'Hayat fiyatları güncellenemedi',
  'priceSync.more': '+{n} ürün daha',
  'priceSync.failed': '{n} ürün güncellenemedi',

  // Sipariş geçmişi ve "Sipariş alışkanlığı" kutusu (§3.8 D.6).
  'custHist.title': 'Sipariş alışkanlığı',
  'custHist.empty': 'Henüz sipariş yok',
  // Üst satır parçaları — yalnız değeri varsa gösterilir; " · " ile ayrılır.
  'custHist.avgInterval': 'Ortalama {n} günde bir',
  'custHist.typicalWeekday': 'çoğunlukla {weekday}',
  'custHist.lastOrder': 'son sipariş {date}',
  // Haftanın günleri — istemci tipikWeekday'i 0=Pazar..6=Cumartesi (Europe/Istanbul) ile alır.
  'custHist.weekday.0': 'Pazar',
  'custHist.weekday.1': 'Pazartesi',
  'custHist.weekday.2': 'Salı',
  'custHist.weekday.3': 'Çarşamba',
  'custHist.weekday.4': 'Perşembe',
  'custHist.weekday.5': 'Cuma',
  'custHist.weekday.6': 'Cumartesi',
  // Ürün satırı + "daha fazla".
  'custHist.productLine': '{name} · {kind}',
  'custHist.productStats': '{qty} adet · {orderCount} sipariş',
  'custHist.moreProducts': '+{n} ürün daha',
  'custHist.channelLine': '{n} sipariş',
  // Sayaçlar — sıfır olanlar gizlenir.
  'custHist.count.completed': '{n} teslim',
  // `externalCount` artık yalnız Hayat'ta TESLİM edilenleri sayar (iptal/işlemde girmez,
  // ADR 2026-09-29); metin buna göre "kapandı" değil "teslim" der.
  'custHist.count.external': '{n} Hayat’ta teslim',
  'custHist.count.cancelled': '{n} iptal',
  'custHist.completedTotal': 'Tamamlanan siparişler toplamı: {amount}',
  // OrderHistory listesi — LedgerEntries'in üstünde.
  'custHist.historyTitle': 'Sipariş geçmişi',
  'custHist.historyEmpty': 'Bu müşterinin siparişi yok',
  'custHist.historyLoadMore': 'Daha fazla göster',
  'custHist.itemsSummary': '{n} × {name}',
  'custHist.externalTooltip':
    'Panelde kapandı. Cari ve stoğa, Stok ekranından deftere işlenince yansır.',
  // LedgerEntries bölüm başlığı altına tek satır açıklama.
  'custHist.ledgerNote':
    'Panelde kapanan siparişler, Stok ekranından deftere işlenince cariye yansır.',
  'custHist.loading': 'Yükleniyor…',
  'custHist.error': 'Sipariş geçmişi yüklenemedi.',
  // `sampled=true`: ürün/aralık/gün en yeni 1000 tamamlanan siparişin örneklemiyle hesaplandı.
  'custHist.sampledNote':
    'Çok sipariş geçmişi olan müşterilerde ürün ve sıklık en yeni 1000 tamamlanan siparişe göre hesaplanır.',

  // Hayat paneli araç eşleme kartı (entegrasyonlar ekranı + API hataları).
  'hayatVehicles.title': 'Araç eşleme (geçiş takma adı)',
  'hayatVehicles.hint':
    "Hayat panelinin araç listesinde görünen etiketleri ('ALT BÖLGE', 'ÜST BÖLGE', …) bizdeki araçlara bağlayın. Geçiş takma adı — paneldeki ad plakaya dönünce gerekmez.",
  'hayatVehicles.colHayat': 'Hayat etiketi',
  'hayatVehicles.colOurs': 'Bizdeki araç',
  'hayatVehicles.colCount': 'Sipariş',
  'hayatVehicles.save': 'Eşlemeyi kaydet',
  'hayatVehicles.saved': 'Araç eşleme kaydedildi.',
  'hayatVehicles.placeholder': 'Araç seçin',
  'hayatVehicles.unmapped': '— Eşleşme yok —',
  'hayatVehicles.addRow': 'Araç ve şoför olarak ekle',
  'hayatVehicles.notHayat': 'Bu kaynak için araç eşleme yok.',
  'hayatVehicles.abantRetired':
    'Abant için araç eşleme kaldırıldı; çalışan eşlemesi "Şoför eşleme" ekranından yapılır.',
  'hayatVehicles.emptyValue': 'Araç ve Hayat etiketi boş olamaz.',
  'hayatVehicles.labelTooLong': 'Hayat etiketi 80 karakterden uzun olamaz.',
  'hayatVehicles.duplicateLabel': "Bu Hayat etiketi zaten başka bir araca bağlı: '{label}'.",
  'hayatVehicles.invalidVehicle': 'Bu araç bu kiracıya ait değil: {id}.',
  'hayatVehicles.killSwitchOff': 'Çekim anahtarı kapalı; panel listesi taze değil.',
  'hayatVehicles.coldTest': 'Soğuk test kipinde panelden canlı okuma yapılmaz.',
  'hayatVehicles.alreadyRunning': 'Bu kanalda başka bir işlem sürüyor; biraz sonra deneyin.',
  'hayatVehicles.loginFailed': 'Panel oturumu alınamadı.',
  'hayatVehicles.noSession': 'Panel bağlantısı henüz yok.',
  'hayatVehicles.fetchFailed': 'Panelden araç listesi okunamadı.',
  'hayatVehicles.addPlate': 'Plaka',
  'hayatVehicles.addVehicleLabel': 'Araç etiketi',
  'hayatVehicles.addDriverName': 'Şoför adı',
  'hayatVehicles.addDriverPhone': 'Telefon',
  'hayatVehicles.createAndMap': 'Araç + şoför oluştur ve eşle',
  'hayatVehicles.createAndMapDone': 'Araç, şoför ve eşleme kaydedildi.',
  'hayatVehicles.noConsent': 'Bağlantının onayı kaldırılmış; panelden canlı okuma yapılmaz.',
  'hayatVehicles.autoWriteNote':
    "Bu eşleme yalnızca 'Hayat'a gönder' düğmesinde kullanılır; Hayat'a kendiliğinden hiçbir şey gitmez.",

  // ── Mobil: patron + şoför, panelde teslim kartı ve kaynak harf rozeti ──
  // Sunum: HAYAT/ABANT panelinde `Teslim Edildi` sonucu kapanan siparişler. Defter yazılmaz.
  'mobilePanel.cardTitle': 'Panelde teslim (bugün)',
  'mobilePanel.bySource': '{n} sipariş · {revenue}',
  'mobilePanel.sourceStatus': 'Panelde: {status}',
  'mobilePanel.hayatVehicle': "Hayat'ta: {label}",
  // Sipariş detayı: panel aşaması bölümünün başlığı. Kaynağa göre değişir — Hayat'ta
  // "Hayat durumu", Abant'ta "Abant durumu".
  'mobilePanel.abantStatusLabel': 'Abant durumu',
  // Patron siparişler ekranı kaynak süzgeci (sunucuya `source` parametresi gider).
  'mobilePanel.filterAll': 'Tümü',
  'mobilePanel.filterHayat': 'Hayat',
  'mobilePanel.filterAbant': 'Abant',
  'mobilePanel.filterPhone': 'Telefon',

  // Hayat'ta teslim edilen siparişlerin rapor/pano/stok sunumu (ADR 2026-09-29,
  // kullanıcı kararı 29.09.2026). Defter DEĞİŞMEZ; bu metinler yalnız sunumdur.
  'hayatRep.cancelledPending': 'İptal: {cancelled} · Panelde işlemde: {pending}',
  'hayatRep.paymentTypeTitle': 'Ödeme tipine göre',
  'hayatRep.colPayment': 'Ödeme tipi',
  'hayatRep.jugsLabel': 'Damacana',
  'hayatRep.combinedRevenueLine':
    "Bizim teslimatlar {ours} · Hayat'ta teslim {hayat} · Toplam {total}",
  'hayatRep.todayTitle': "Hayat'ta teslim (bugün)",
  'hayatRep.todayValue': '{count} sipariş · {revenue} · {jugs} damacana',
  'hayatRep.notPosted': 'İşlenmeyenler Stok ekranından deftere alınır',
  'hayatRep.stockBanner':
    "Hayat'ta teslim edilen siparişler stok defterine henüz işlenmiyor. Bugün: {list}",

  // Bayi panelinde (Hayat/Abant) kapanan siparişlerin ana rakamlara taşınması (29.09.2026).
  // Defter DEĞİŞMEZ; `hayatRep.*` geriye dönük kalır, bu yeni ekranlar `panelRep.*` kullanır.
  'panelRep.sectionTitle': 'Panelde kapanan siparişler',
  'panelRep.combinedRevenueThree':
    'Bizim teslimat {ours} · Panelde kapanan {panel} · Toplam {total}',
  'panelRep.deliveriesFootnote': 'Bizim {ours} · Panel {panel} · günde ortalama {perDay}',
  'panelRep.revenueFootnote': 'Bizde {ours} · Panelde {panel}',
  'panelRep.sourceHayat': 'Hayat',
  'panelRep.sourceAbant': 'Abant',
  // "Bizim" = panel DIŞI kaynaklar (MANUAL + GETIR_SU + telefon). Genel Bakış kartlarında
  // üçüncü kırılım satırı olarak görünür; bayi paneli olmadığı için H/A harfi yok.
  'panelRep.sourceBizim': 'Bizim',
  'panelRep.todayTitle': 'Panelde teslim (bugün)',
  'panelRep.todayEmpty': 'Bugün panelde teslim yok.',
  'panelRep.colSource': 'Kaynak',
  'panelRep.colDelivered': 'Teslim',
  'panelRep.colCancelled': 'İptal',
  'panelRep.colPending': 'İşlemde',
  'panelRep.rowFormat': '{code} {name} {count} sipariş · {amount}',
  'panelRep.productColOurs': 'Bizde',
  'panelRep.productColPanel': 'Panelde',
  'panelRep.productColTotal': 'Toplam',
  'panelRep.productTableTitle': 'Ürün bazlı damacana',
  'panelRep.sourceBreakdownTitle': 'Kaynak kırılımı',
  'panelRep.customerOrdersTitle': 'Siparişler',
  'panelRep.customerOrdersSummary': 'Toplam {total}',
  'panelRep.customerOrdersPanel': 'Panelde {panel}',

  // ── Panel sade: Siparişler tablosu sadeleştirme, Hayat aracı, eşleme kartı geri bildirimi ──
  'ordersView.groupLabel': 'Görünüm',
  'ordersView.simple': 'Sade',
  'ordersView.advanced': 'Gelişmiş',
  'orderVehicle.hayatLabel': 'Hayat: {label}',
  'orderVehicle.hayatBadge': 'Hayat',
  'orderVehicle.hayatOnly': "Hayat'ta: {label}",
  'orderVehicle.ours': 'Bizde: {plate}',
  'hayatVehicles.mappedBadge': '✓ Eşlendi',
  'hayatVehicles.noChanges': 'Kaydedilecek değişiklik yok',
  'hayatVehicles.tableIntro':
    'Her Hayat etiketi bizde bir araca bağlanır. Eşleşen etiketlerin siparişleri o aracın adıyla görünür.',

  // ── Geçmiş aktarımı: kaynak seçici (Hayat/Abant) ──
  // Kart tek; kaynak değişince gövde, kapı ve metin aynı çekirdek üzerinden çalışır.
  // "hint"/"hintAbant" kartın açıklamasıdır; "confirm"/"confirmAbant" aktarım onayıdır.
  // Hayat: tarih aralığı Telerik'e yazılır, panel HTML döner.
  // Abant: aynı panel uçları JSON'la konuşur (kullanıcıya fark yok, sunucu ayırır).
  'historyImport.source': 'Kaynak',
  'historyImport.sourceHayat': 'Hayat Su',
  'historyImport.sourceAbant': 'Abant Su',
  'historyImport.hintAbant':
    'Abant panelinden (Sipariş Sorgulama) seçili tarih aralığındaki geçmiş siparişleri çeker. JSON uçtan uç; aynı yazma kuralları uygulanır.',
  'historyImport.confirmAbant':
    '{from} – {to} arası Abant panelinden {n} sipariş aktarılacak. Onaylıyor musunuz?',
  // ── Kanal ürün kataloğu (ürün eşleştirme kartı + master-data import + Ürünler ekranı) ──
  'channel.mappingAlreadyLinked': 'Bu eşleme zaten bir ürüne bağlı. Önce "Değiştir" ile boşaltın.',
  'catalog.addAsProduct': 'Yeni ürün olarak ekle',
  'catalog.changeMapping': 'Değiştir',
  'catalog.cancelAdd': 'Vazgeç',
  'catalog.addedAndLinked':
    'Ürün eklendi ve eşlendi. Bekleyen siparişler bir sonraki çekimde gelir.',
  'catalog.noBrandHint': 'Bu markada ürün yok — "Yeni ürün olarak ekle"yi kullanın.',
  'catalog.brandEmpty':
    "Henüz ürün yok. Entegrasyonlar → Fiyatları karşılaştır'dan Hayat ürünlerini, Ürün eşleştirme'den Abant ürünlerini ekleyebilirsiniz.",
  'catalog.inactiveSection': 'Pasif ürünler ({n})',
  'catalog.activate': 'Aktifleştir',
  'catalog.activated': '{name} yeniden aktif.',
  'catalog.addAsProductTitle': 'Yeni ürün ekle',
  'catalog.suggestionMissing': 'Öneri yok',
  'import.compareTitle': 'Fiyatları karşılaştır',
  'import.dryRun': 'Fiyatları karşılaştır',
  'import.dryRunHelp':
    'Hiçbir şey değiştirmez, yalnız karşılaştırır. Listede eşleşmeyen satırları işaretler.',
  'import.unmatchedAddOne': 'Ürün olarak ekle',
  'import.unmatchedAddAll': 'Eksiklerin hepsini ekle',
  'import.unknownKindSkipped':
    'Türü bilinmediği için eklenmedi: {name}. Ürünler ekranından açabilirsiniz.',
  'import.createdFromUnmatched': '{n} ürün açıldı, bir sonraki karşılaştırmada eşleşecek.',
  'import.createFailed': 'Açılamadı: {name} ({reason})',

  // ── Panelde kapanan siparişin deftere işlenmesi (ADR 2026-09-30) ──
  // Önizleme/onay ekranının başlıkları, HOLD kodlarının kısa etiketleri.
  // Tek tek yazılmazsa deftere işlenen siparişin neden HOLD'da beklediği panelde
  // görünmez ve patron "neden işlenmedi" diye sorar.
  'externalLedger.title': 'Panelde kapanan siparişleri deftere işle',
  'externalLedger.hint':
    'Hayat/Abant panelinde kapanmış ama bizde defter hareketi yazılmamış siparişler. Sipariş başına tek onay ile depolar, kasa ve zimmet güncellenir.',
  'externalLedger.columnOrder': 'Sipariş',
  'externalLedger.columnChannel': 'Kanal',
  'externalLedger.columnStatus': 'Sonuç',
  'externalLedger.columnHold': 'Engel',
  'externalLedger.columnPolicy': 'Politika',
  'externalLedger.columnProjected': 'İşlem sonrası',
  'externalLedger.ledgerRefill': 'Boş takas',
  'externalLedger.ledgerNewJug': 'Yeni damacana',
  'externalLedger.ledgerForeignSwap': 'Yabancı marka',
  'externalLedger.stateReady': 'İşlenebilir',
  'externalLedger.stateHold': 'Bekliyor',
  'externalLedger.statePosted': 'İşlendi',
  'externalLedger.stateReversed': 'Terslendi',
  'externalLedger.stateNeedsReversal': 'Ters kayıt gerekli',
  'externalLedger.holdNotDelivered': 'Panelde iptal/işlemde',
  'externalLedger.holdNoPolicy': 'Politika yok',
  'externalLedger.holdItemMismatch': 'Ürün eşleşmedi',
  'externalLedger.holdMixedJugs': 'Karışık damacana',
  'externalLedger.holdNeedsCustomer': 'Müşteri gerekli',
  'externalLedger.holdPaymentUnsupported': 'Ödeme tipi uyumsuz',
  'externalLedger.holdAmountUnread': 'Kanal tutarı okunmadı',
  'externalLedger.holdDepositConflict': 'Depozito çakışması',
  'externalLedger.holdTripDay': 'Araç o gün seferde',
  'externalLedger.alreadyPosted': 'Bu sipariş zaten deftere işlenmiş.',
  'externalLedger.negativeProjection':
    'İşlem sonrası depo eksiye düşecek. Onay bayrağıyla devam edin.',
  'externalLedger.alreadyReversed': 'Bu siparişin defter hareketi zaten terslenmiş.',
  'externalLedger.reverseOnlyPosted': 'Yalnız işlenmiş siparişler terslenebilir.',
  'externalLedger.alreadyReopened': 'İşlenmiş sipariş geri açılamaz; önce ters kayıt uygulayın.',
  'externalLedger.policyRefill': 'Boş takas',
  'externalLedger.policyNewJug': 'Yeni damacana',
  'externalLedger.policyForeignSwap': 'Yabancı marka',
  'externalLedger.maxRange': 'Aralık en fazla 31 gün olabilir.',

  // ── Panelde kapanan siparişleri deftere işleme (panel-kapanan defter akışı) ──
  'extLedgerUi.title': 'Panelde kapanan siparişleri deftere işle',
  'extLedgerUi.hint':
    'Hayat ve Abant panelinde teslim edilen siparişler stok, kasa ve cariye işlenir. Önce önizleyin.',
  'extLedgerUi.from': 'Başlangıç',
  'extLedgerUi.to': 'Bitiş',
  'extLedgerUi.preview': 'Önizle',
  'extLedgerUi.refresh': 'Yenile',
  'extLedgerUi.selectAll': 'Tümünü seç',
  'extLedgerUi.deselectAll': 'Tümünü bırak',
  'extLedgerUi.summary': '{ready} işlenmeye hazır · {hold} beklemede · {posted} işlendi',
  'extLedgerUi.summaryNeedReversal': ' · {k} ters kayıt gerekli',
  'extLedgerUi.summaryReversed': ' · {k} geri alındı',
  'extLedgerUi.depotFullOut': 'Depodan dolu çıkışı: {list}',
  'extLedgerUi.depotEmptyIn': 'Depoya boş girişi: {list}',
  'extLedgerUi.cash': 'Kasa: {amount}',
  'extLedgerUi.depositUnits': 'Zimmet: +{n}',
  'extLedgerUi.foreignUnits': 'Yabancı boş: +{n}',
  'extLedgerUi.projection': 'İşlem sonrası depo dolusu: {list}',
  'extLedgerUi.negativeWarning': 'Depo stoğu eksiye düşecek (açılış stoğu girilmemiş olabilir)',
  'extLedgerUi.negativeAck': 'Anladım, yine de işle',
  'extLedgerUi.postSelected': 'Seçilenleri deftere işle ({n})',
  'extLedgerUi.postConfirm': 'Seçilenleri deftere işle',
  'extLedgerUi.postResult': '{posted} sipariş işlendi · {already} zaten işliydi · {hold} beklemede',
  'extLedgerUi.noRows': 'Bu aralıkta deftere alınacak sipariş yok.',
  'extLedgerUi.colSelect': 'Seç',
  'extLedgerUi.colTime': 'Tarih/saat',
  'extLedgerUi.colSource': 'Kaynak',
  'extLedgerUi.colCustomer': 'Müşteri',
  'extLedgerUi.colItems': 'Kalemler',
  'extLedgerUi.colAmount': 'Tutar',
  'extLedgerUi.colState': 'Durum',
  'extLedgerUi.stateReady': 'Hazır',
  'extLedgerUi.stateHold': 'Beklemede',
  'extLedgerUi.statePosted': 'İşlendi',
  'extLedgerUi.stateReversed': 'Geri alındı',
  'extLedgerUi.stateNeedsReversal': 'Ters kayıt gerekli',
  'extLedgerUi.holdReason.NOT_DELIVERED': 'Teslim edilmemiş',
  'extLedgerUi.holdReason.NO_POLICY': 'Ürün için boş/depozito kuralı seçilmemiş',
  'extLedgerUi.holdReason.ITEM_MISMATCH': 'Ürün eşlemesi kalemle uyuşmuyor',
  'extLedgerUi.holdReason.MIXED_JUGS': 'Birden çok damacana türü',
  'extLedgerUi.holdReason.NEEDS_CUSTOMER': 'Müşteri kaydı bağlı değil',
  'extLedgerUi.holdReason.PAYMENT_UNSUPPORTED': 'Ödeme türü desteklenmiyor',
  'extLedgerUi.holdReason.AMOUNT_UNREAD': 'Kanal tutarı okunamadı',
  'extLedgerUi.holdReason.DEPOSIT_CONFLICT': 'Depozito tutarı çelişkili',
  'extLedgerUi.holdReason.TRIP_DAY': 'O gün sefer var, çift sayım riski',
  'extLedgerUi.policyLabel': 'Deftere işleme:',
  'extLedgerUi.policyOptionRefill': 'Dolum (1 dolu ↔ 1 boş)',
  'extLedgerUi.policyOptionNewJug': 'Yeni damacana (depozito)',
  'extLedgerUi.policyOptionForeignSwap': 'Yabancı marka takas',
  'extLedgerUi.policyUnselected': '— seçilmedi',
  'extLedgerUi.policyHint': 'Seçilmezse bu ürünün siparişleri deftere işlenmez.',
  'extLedgerUi.policySaved': 'Deftere işleme kuralı kaydedildi.',
  'extLedgerUi.errorNegative':
    'Projeksiyon eksi çıkıyor. İşaret kutusunu işaretleyin ya da aralığı daraltın.',
  'extLedgerUi.postFailed': 'İşlem başarısız: {message}',
  'extLedgerUi.postedBadge': 'Deftere işlendi · {date}',
  'extLedgerUi.reversedBadge': 'Defter kaydı geri alındı',
  'extLedgerUi.reverseAction': 'Ters kayıt',
  'extLedgerUi.reverseReasonLabel': 'Gerekçe',
  'extLedgerUi.reverseReasonPlaceholder': 'En az 10 karakter',
  'extLedgerUi.reverseConfirm':
    'Bu siparişin stok, kasa ve cari satırları ters kayıtla geri alınır. Silme yapılmaz.',
  'extLedgerUi.reverseDone': 'Defter kaydı geri alındı.',
  'extLedgerUi.stockBanner': 'Panelde teslim edilen {n} sipariş henüz deftere işlenmedi.',
  'extLedgerUi.stockBannerLink': 'İşle',

  // Abant çalışan → araç eşlemesi (paket mm/aqua-abant-calisan)
  'abantEmp.title': 'Abant çalışanları',
  'abantEmp.hint':
    'Her Abant çalışanı bizde bir araca bağlanır. Siparişleri o aracın adıyla görünür.',
  'abantEmp.nameHint':
    'Abant çalışan adları yalnız gösterim içindir. Siparişler Panel ataması ekranındaki çalışan → şoför eşlemesiyle araca bağlanır.',
  'abantEmp.colName': 'Çalışan',
  'abantEmp.colCount': 'Sipariş',
  'abantEmp.colOurs': 'Bizdeki araç',
  'abantEmp.placeholder': 'Araç seçin',
  'abantEmp.passive': 'Pasif',
  'abantEmp.mappedBadge': '✓ Eşlendi',
  'abantEmp.unmapped': '— Eşleşme yok —',
  'abantEmp.save': 'Eşlemeyi kaydet',
  'abantEmp.saved': 'Çalışan eşlemesi kaydedildi.',
  'abantEmp.noChanges': 'Kaydedilecek değişiklik yok',

  // Abant araç/çalışan hücresi (Siparişler + Sipariş detayı) ve KVKK ipuçları
  'orderVehicle.abantLabel': 'Abant: {label}',
  'orderVehicle.abantBadge': 'Abant',
  'orderVehicle.abantOnly': 'Abant: {label}',
  'extLedgerUi.holdReason.CUSTOMER_ANONYMIZED': 'Müşteri kaydı anonimleştirilmiş',
  'extLedgerUi.reasonNoPersonal': 'Gerekçeye kişisel veri (ad, telefon, adres) yazmayın.',

  // Defter işleme — hakem U-a/U-b/U-c (an/aqua-defter-f3)
  'extLedgerUi.holdReason.AMOUNT_MISMATCH': 'Kanal tutarı kalem toplamıyla uyuşmuyor',
  'extLedgerUi.postResultConflict':
    '{n} sipariş eşzamanlı işlem nedeniyle işlenemedi, tekrar deneyin',
  'extLedgerUi.postResultNotFound': '{n} sipariş bulunamadı',
  'externalLedger.concurrentRetry':
    'Eşzamanlı bir işlemle çakıştı, hiçbir kayıt yazılmadı. Tekrar deneyin.',
  'externalLedger.reversedAnonymizedCustomer': 'Anonim müşteri',
  'orderEvent.EXTERNAL_LEDGER_REVERSED': 'Defter kaydı terslendi',

  // Entegrasyonlar ekranı — sekmelere bölme (W1). `ch.intro` SİLİNMEDİ, yalnız Bağlantılar
  // sekmesinde tek cümlelik kısa metinle değiştirildi.
  'intTabs.connectionsIntro':
    'Siparişler üç bayi panelinden otomatik çekilir; giriş bilgilerini bir kez kaydetmen yeterli.',
  'intTabs.connections': 'Bağlantılar',
  'intTabs.productPrice': 'Ürün ve fiyat',
  'intTabs.vehicleMapping': 'Araç eşleme',
  'intTabs.historyImport': 'Geçmiş aktarımı',
  'intTabs.luca': 'Luca',
  'intTabs.priceCompareTitle': 'Hayat fiyat karşılaştırma',
  'intTabs.priceCompareUnavailable':
    'Fiyat karşılaştırma yalnız Hayat bağlantısı etkinken kullanılabilir.',
  // Mobil görsel sadeleştirme (an/aqua-gece-2) — hardcode metinlerin taşındığı tek blok
  'mobileUi.refresh': 'Yenile',
  'mobileUi.koli': 'Koli',
  'mobileUi.sectionCustomer': 'Müşteri',
  'mobileUi.sectionPayment': 'Ödeme',

  // Görsel sadeleştirme (W3) — Genel Bakış "Panelde teslim (bugün)" kartı
  'panelUi.deliveredCount': '{count} sipariş',
  'panelUi.jugsTotal': '{n} damacana',
  // Abant kapanış uzlaştırması (A4) — bildirim metinleri
  'abantClosed.notify.title': 'Abant’ta sipariş bizden farklı ilerledi · #{orderId}',
  'abantClosed.notify.body':
    'Abant durumu: {observed}. Bizdeki durum: {status}. Sahadaki gerçek bizde; durum değiştirilmedi.',
  // Abant siparişi TESLİMDEN SONRA iptal etti (21.10.2026 ölçümü: 20.10 siparişi "Yolda"
  // görüldü, 18:24 "Teslim Edildi" okundu, Abant sonra iptal etti). Metinlerde YALNIZ sipariş
  // no ve kanal durum metni var — müşteri adı/telefon/adres YOK (kural 7).
  //
  // Bu iki bildirim metni artık YALNIZ "teslimden SONRA iptal" dalında kullanılır; "Yolda →
  // İptal"de bildirim GİTMEZ (normal akış), orada sipariş yine iptal edilir.
  'abantCancelledAfterClose.notify.title': 'Abant siparişi iptal etti · #{orderId}',
  'abantCancelledAfterClose.notify.body':
    'Abant, teslim edildikten sonra siparişi iptal etti. Abant durumu: {observed}. Sipariş iptal edildi; defterde yazıldıysa ters kayıt gerekir.',
  'abantCancelledAfterClose.cancelReason': 'Abant tarafında teslimden sonra iptal',
  // Hayat sözlüğünde de 'İptal*' var (statusMap: 'İptal Edildi', 'İptal-Müşteri Vazgeçti',
  // …) ve Hayat canlı çekimi KAPALI satırları da döndürür; aynı dal iki panelde de yürür.
  // Yine kural 7: metinde yalnız sipariş no ve kanal durum metni.
  'hayatCancelledAfterClose.notify.title': 'Hayat siparişi iptal etti · #{orderId}',
  'hayatCancelledAfterClose.notify.body':
    'Hayat, teslim edildikten sonra siparişi iptal etti. Hayat durumu: {observed}. Sipariş iptal edildi; defterde yazıldıysa ters kayıt gerekir.',
  // `Order.cancelReason` — sipariş HANGİ panelde iptal edilirse edilsin nötr metin.
  // Marka adı buraya girmez: gerekçe "panel bize iptal etti" demektir, "teslimden sonra"
  // demek değildir (o uyarı metni, teslim-sonrası dalına özeldir).
  'channelCancelled.cancelReason': 'Panelde iptal edildi',

  // Görsel sadeleştirme (W4) — Siparişler süzgeç grubu, birleşik sayım satırı, Hayat durumu
  // başlığı ayrımı
  'panelUi.filterChannelLabel': 'Kanal',
  'panelUi.filterSourceLabel': 'Kaynak',
  'panelUi.filteredShowing': '{n} filtre · {shown}/{total} gösteriliyor',
  'panelUi.showingCount': '{shown}/{total} gösteriliyor',
  'panelUi.hayatPanelStatusLabel': 'Hayat panelindeki durum',

  // Görsel sadeleştirme (W6) — Stok ve Kasa ekranı tutarlılık
  'panelUi.salesBreakdownTitle': 'Günün satışı (ciro)',

  // Eşleşme bekleyen ürün uyarısı (W7)
  'panelUi.unmappedAlert':
    '{n} ürün adı eşleşme bekliyor. Bu ürünleri içeren panel siparişleri eşleşene kadar alınmaz.',
  'panelUi.unmappedAlertLink': 'Eşleştir',

  // Genel Bakış KPI kutuları "i" ipucu (30.09.2026 kullanıcı kararı — "daha anlaşılır olsun").
  'panelUi.attentionShowAll': 'Tümünü göster ({n})',
  'panelUi.attentionShowLess': 'Daha az göster',
  'panelUi.kpiHintOrders': 'Bugün alınan tüm siparişler: bizim + panelden gelen (Abant/Hayat).',
  'panelUi.kpiHintDelivered':
    'Bugün teslim edilenler: bizim şoförümüzün teslim ettikleri + panelde "teslim edildi" görünenler.',
  'panelUi.kpiHintPending':
    'Bekleyen: panelde Yeni ya da bizde atanmamış. Yolda: panelde Yolda/Araç Listesinde ya da bizde atanmış.',
  'panelUi.kpiHintRevenue':
    'Bugünkü toplam satış: bizim teslimat cirosu + panelde teslim edilen siparişlerin panel tutarı.',

  // ── Kanal pill: marka adı rozet metni (kısa, panel çubuğuna sığar) ──
  // BRAND_APP + HAYAT_PANEL/ABANT_PANEL kombinasyonunda "Marka uygulaması" yerine
  // marka adı gösterilir; bu anahtarlar o metni taşır.
  'channelBrand.hayatApp': 'Hayat uygulaması',
  'channelBrand.abantApp': 'Abant uygulaması',

  // ── Sipariş detayı: ham veriden çıkarılan panel alanları ──
  // Bu bölüm `panelFields(order)` yardımcısının ürettiği etiketlerdir; OrderDetail
  // ham `JSON.stringify(order.rawPayload)` yerine bu çeviriyi kullanır.
  'panelFields.sectionTitle': 'Panel bilgisi',
  'panelFields.orderNumber': 'Panel sipariş no',
  'panelFields.requestedDeliveryAt': 'İstenen teslim zamanı',
  'panelFields.paymentName': 'Ödeme adı',
  'panelFields.customerNote': 'Müşteri notu',
  'panelFields.specialConditions': 'Özel koşul',
  'panelFields.addressNote': 'Adres notu',
  'panelFields.region': 'Mahalle',
  'panelFields.campaign': 'Kampanya',

  // ── Şoför gün başı iş listesi / yükleme önerisi / Hayat panel siparişini alma ──
  // `GET /api/orders/worklist` sözleşmesine bağlı ekranlar (open-trip, load, day).
  'driverWork.vehicleLabel': 'Aracın',
  'driverWork.todayJobs': 'Bugünkü işlerin ({n})',
  'driverWork.carriedOverJobs': 'Yarına devreden işler ({n})',
  'driverWork.noJobsYet': 'Şu an aracına atanmış sipariş yok',
  'driverWork.suggestedLoad': 'Yüklemen gereken',
  'driverWork.suggestedLoadLine': '{name} × {qty}',
  'driverWork.suggestedQtyBadge': 'Öneri: {qty}',
  'driverWork.suggestedLoadTotal': 'Toplam {n} damacana',
  'driverWork.unmatchedLoadLine': '{name} × {qty} (ürün eşleşmedi)',
  'driverWork.fillSuggestion': 'Öneriyi doldur',
  'driverWork.panelSectionTitle': "Hayat'ta aracına verilen",
  'driverWork.panelAutoClaimHint': 'Yola çıkınca otomatik alınır',
  'driverWork.claim': 'Al',
  'driverWork.claimError': 'Sipariş alınamadı, tekrar dene.',
  'driverWork.midReloadWarning':
    'Ara yükleme gerekebilir: bugünkü işlerin araca yüklenenden fazla.',
  'driverWork.midReloadLink': 'Ara yükleme ekranına git',

  // ── Patron mobil: Stok + fabrika sevkiyatı ──
  // Panelin Stok sayfasıyla AYNI üç uç (`/api/stock/levels|vehicles|moves`) ve AYNI sevkiyat
  // gövdesi (`POST /api/stock/shipments`) — patron telefondan yazınca web panelde AYNEN görünür.
  'patronStock.shortcutGlyph': 'St',
  'patronStock.shortcutTitle': 'Stok',
  'patronStock.shortcutSubtitle': 'Depo ve araç stoğu, fabrika sevkiyatı',
  'patronStock.title': 'Stok',
  'patronStock.newShipment': 'Fabrikadan giriş',
  'patronStock.depotTitle': 'Depo',
  'patronStock.vehiclesTitle': 'Araçlar',
  'patronStock.movesTitle': 'Son hareketler',
  'patronStock.depotRow': 'Depo',
  'patronStock.vehicleRow': 'Araçlar',
  'patronStock.customerOpenRow': 'Müşteride zimmet',
  'patronStock.noLevels': 'Ürün bazlı stok kaydı yok.',
  'patronStock.noVehicles': 'Araç kaydı yok.',
  'patronStock.noMoves': 'Hareket yok.',
  'patronStock.loc.DEPOT': 'Depo',
  'patronStock.loc.VEHICLE': 'Araç',
  'patronStock.loc.CUSTOMER': 'Müşteri',
  'patronStock.loc.FACTORY': 'Fabrika',
  'patronStock.loc.EXTERNAL': 'Dış',
  'patronStock.loc.LOSS': 'Kayıp/Fire',
  'patronStock.condition.FULL': 'dolu',
  'patronStock.condition.EMPTY': 'boş',
  'patronStock.shipmentTitle': 'Fabrika sevkiyatı',
  'patronStock.shipmentIntro': 'Fabrikadan gelen dolu ve fabrikaya verilen boş adedini gir.',
  'patronStock.brandLabel': 'Marka',
  'patronStock.brandPlaceholder': 'Marka seç',
  'patronStock.brandSupplierLabel': 'Hangi firmadan geldi?',
  'patronStock.brandRequiredLock':
    'Bu ürünün markası yok. Kaydetmek için hangi firmadan geldiğini seç.',
  'patronStock.productLabel': 'Ürün',
  'patronStock.productPlaceholder': 'Ürün seç',
  'patronStock.qtyFullLabel': 'Gelen dolu adet',
  'patronStock.qtyEmptyOutLabel': 'Fabrikaya verilen boş adet',
  'patronStock.waybillLabel': 'Belge/irsaliye no',
  'patronStock.waybillPlaceholder': 'ör. İR-2026-0001',
  'patronStock.noteLabel': 'Not',
  'patronStock.notePlaceholder': 'İsteğe bağlı not',
  'patronStock.shipmentInvalid':
    'Marka ve ürün seç; en az bir adet gir (dolu ve boş birden sıfır olamaz).',
  'patronStock.shipmentSuccess': 'Sevkiyat kaydedildi.',
  'patronStock.shipmentSubmit': 'Sevkiyatı kaydet',

  // ── Patron mobil: Ürünler (fiyat + depozito) ──
  // Panelin `apps/panel/src/screens/Products.tsx` ile AYNI uçlar; `productKind.*` etiketleri
  // zaten var olan sözlükten (prod.* bölümü) paylaşılır, burada tekrar tanımlanmadı.
  'patronProducts.shortcutGlyph': 'Ür',
  'patronProducts.shortcutTitle': 'Ürünler',
  'patronProducts.shortcutSubtitle': 'Fiyat ve depozito yönetimi',
  'patronProducts.title': 'Ürünler',
  'patronProducts.add': '+ Ürün ekle',
  'patronProducts.editTitle': 'Ürünü düzenle',
  'patronProducts.newTitle': 'Yeni ürün',
  'patronProducts.nameLabel': 'Ürün adı',
  'patronProducts.namePlaceholder': 'ör. Hayat 19L',
  'patronProducts.kindLabel': 'Tür',
  'patronProducts.brandLabel': 'Marka',
  'patronProducts.noBrand': 'Markasız',
  'patronProducts.priceLabel': 'Birim fiyat',
  'patronProducts.depositLabel': 'Depozito',
  'patronProducts.formInvalid': 'Ürün adı, fiyat ve depozito geçerli olmalı.',
  'patronProducts.activeTitle': 'Aktif ürünler',
  'patronProducts.inactiveTitle': 'Pasif ürünler ({n})',
  'patronProducts.inactiveHint': 'Pasif — geçmiş kayıtlar duruyor.',
  'patronProducts.empty': 'Ürün yok.',
  'patronProducts.deactivate': 'Pasifleştir',
  'patronProducts.activate': 'Aktifleştir',

  // Mobil uygulama (Flutter) — çekirdek durumlar ve iskelet ekranlar
  'mobile.state.loading': 'Yükleniyor…',
  'mobile.state.emptyTitle': 'Burada henüz bir şey yok',
  'mobile.state.errorTitle': 'Bir şeyler ters gitti',
  'mobile.state.offlineTitle': 'Bağlantı yok',
  'mobile.state.offlineBody':
    'Bağlantı yok. Yaptığın kayıtlar telefonda durur, bağlanınca gönderilir.',
  'mobile.state.retry': 'Tekrar dene',
  'mobile.banner.offline': 'Bağlantı yok — kayıtlar Gönderilecekler’de bekliyor',
  'mobile.banner.queue': '{n} kayıt Gönderilecekler’de bekliyor',
  'mobile.login.title': 'Giriş yap',
  'mobile.login.driverTab': 'Şoför',
  'mobile.login.ownerTab': 'Patron',
  'mobile.login.emailInvalid': 'Geçerli bir e-posta gir.',
  'mobile.login.passwordRequired': 'Parola gerekli.',
  'mobile.login.unsupportedRole': 'Bu hesap mobil uygulamayı kullanamaz.',
  // Telefonla giriş (son 4 hane) — şoför sekmesi
  'mobile.auth.phoneTail': 'Telefonunun son 4 hanesi',
  'mobile.auth.phoneTailHint': '4567',
  'mobile.auth.phoneTailInvalid': 'Telefonunun son 4 hanesini gir (4 rakam).',
  'mobile.auth.invalidPhone':
    'Numara tanınmadı. Son 4 haneyi kontrol et; doğruysa telefonun sistemde kayıtlı değil, patronuna haber ver.',
  'mobile.auth.deviceRevoked': 'Bu telefonun eşleşmesi iptal edildi. Yeniden eşleştir.',
  'mobile.auth.rePair': 'Yeniden eşleştir',
  'mobile.auth.userInactive': 'Hesabın pasif durumda.',
  'mobile.auth.deviceInUse':
    'Hesabın başka bir telefonda açık. Patronun eski telefonu iptal etmeli.',
  'mobile.auth.retryAgain': 'Tekrar dene',
  'mobile.auth.loginLocked': 'Çok fazla hatalı deneme. {time} sonra tekrar dene.',
  'mobile.auth.retryInSeconds': '{seconds} saniye kaldı.',
  'mobile.auth.tooManyPending': 'Çok fazla bekleyen eşleştirme var. Patronuna başvur.',
  'mobile.auth.tooManyAttempts': 'Çok fazla deneme, biraz bekle.',
  'mobile.ownerPersonnel.deviceLocked': 'Kilitli · {minutes} dk kaldı',
  'mobile.ownerPersonnel.unlock': 'Kilidi kaldır',
  'mobile.auth.askOwnerUnlock': 'Beklemek istemezsen patronundan kilidi kaldırmasını isteyebilirsin.',
  'mobile.auth.waitingRateLimited': 'Bekleniyor… Çok fazla deneme yapıldı, biraz sonra yeniden denenecek.',
  'mobile.auth.versionHeader': 'Uygulama sürümü okunamadı; uygulamayı güncelle.',
  'mobile.auth.unexpectedError': 'Beklenmeyen bir hata oluştu. Tekrar dene.',
  'mobile.auth.deviceInUseTitle': 'Hesabın başka telefonda açık',
  'mobile.auth.lockedTitle': 'Giriş geçici olarak kilitli',
  'mobile.auth.rememberEmail': 'E-postamı hatırla',
  'mobile.auth.rememberEmailHint': 'Ortak telefonda işareti kaldır',
  'mobile.update.title': 'Güncelleme gerekli',
  'mobile.update.body': 'Bu sürüm artık desteklenmiyor. Devam etmek için uygulamayı güncelle.',
  'mobile.update.versions': 'Yüklü sürüm {current} · gereken en düşük sürüm {min}',
  'mobile.update.checking': 'Güncellemeler denetleniyor...',
  'mobile.update.upToDate': 'Uygulaman güncel',
  'mobile.update.optionalTitle': 'Yeni sürüm var',
  'mobile.update.optionalBody': 'Sürüm {version} yayınlandı.',
  'mobile.update.optionalBodyNoVersion': 'Yeni bir sürüm yayınlandı.',
  'mobile.update.releaseNotes': 'Sürüm notları',
  'mobile.update.updateNow': 'Güncelle',
  'mobile.update.later': 'Sonra',
  'mobile.update.continue': 'Devam et',
  'mobile.update.downloading': 'İndiriliyor %{percent}',
  'mobile.update.verifying': 'Doğrulanıyor',
  'mobile.update.installing': 'Kuruluyor',
  'mobile.update.waitingTrip': 'Sefer kapanınca kurulacak',
  'mobile.update.waitingTripBody':
    'Açık sefer olduğu için güncelleme kurulmuyor. Seferini kapattığında kurulum otomatik başlar.',
  'mobile.update.queueBlocked': 'Bekleyen kayıtlar var',
  'mobile.update.queueBlockedBody': 'Önce bekleyen kayıtlar gönderilmeli. Kurulum başlatılmadı.',
  'mobile.update.goToQueue': 'Bekleyen kayıtlara git',
  'mobile.update.installSettings': 'Yükleme izni gerekli',
  'mobile.update.installSettingsBody':
    'Bu cihazda bilinmeyen uygulamaları yükleme izni kapalı. Ayarlardan aç.',
  'mobile.update.openSettings': 'Ayarları aç',
  'mobile.update.retry': 'Tekrar dene',
  'mobile.update.signatureMismatch': 'Uygulamayı silip yeniden kurmanız gerekiyor',
  'mobile.update.signatureMismatchBody':
    'İndirilen dosya bu uygulamayla aynı imzayı taşımıyor. Güvenlik için kurulum başlatılmadı.',
  'mobile.update.error': 'Bir şeyler ters gitti',
  'mobile.update.errorBody': 'Güncelleme tamamlanamadı.',
  'mobile.update.shaMismatch': 'Dosya doğrulanamadı, indirilen dosya silindi.',
  'mobile.update.noApk': 'Bu cihaz için uygun güncelleme dosyası yok.',
  'mobile.update.closeTripFirst': 'Önce seferi kapat',
  'mobile.update.waitingTripRequiredBody':
    'Güncelleme zorunlu, ama açık seferin var. Önce seferini kapat; kurulum ondan sonra başlar.',
  'mobile.update.installCancelled': 'Kurulum tamamlanmadı. Tekrar deneyebilirsin.',
  'mobile.update.installFailed': 'Kurulum başarısız oldu. Tekrar deneyebilirsin.',
  'mobile.update.installTimeout': 'Kurulum beklenenden uzun sürdü. Tekrar deneyebilirsin.',
  'mobile.update.updatedTitle': 'AquaBox güncellendi',
  'mobile.update.updatedBody': 'Açmak için dokun.',
  'mobile.update.tripUnknown': 'Sefer durumu doğrulanamadı',
  'mobile.update.tripUnknownBody':
    'Sefer durumu doğrulanamadı, kurulum ertelendi. Bağlantı gelince tekrar dene.',
  'mobile.tab.day': 'Gün',
  'mobile.steps.name.login': 'Giriş',
  'mobile.steps.name.open': 'Sefere çık',
  'mobile.steps.name.load': 'Yükle',
  'mobile.steps.name.route': 'Yolda',
  'mobile.steps.name.depot': 'Depoya dön',
  'mobile.steps.name.close': 'Kapanış',
  'mobile.steps.name.summary': 'Günün özeti',
  'mobile.steps.short': '{n}/{total} {name}',
  'mobile.steps.semantics': 'Adım {n}/{total}, {name}; {done} adım tamamlandı',
  'mobile.steps.badge.syncPending':
    '{n} kayıt Gönderilecekler’de bekliyor. Bağlanınca kendiliğinden gider; listeyi görmek için dokun.',
  'mobile.steps.badge.deadJob':
    'Gönderilemeyen kayıt var. Gönderilecekler’e gir, tekrar dene ya da kaydı sil; günü kapatmadan önce çöz.',
  'mobile.steps.badge.tomorrowTrip': 'Yarın sabah çıkılır. Yola çık düğmesi yarın açılır.',
  'mobile.steps.badge.tripVoided': 'Bu sefer iptal edilmiş. Yeni sefer açmak için patronla görüş.',
  'mobile.steps.badge.tripUnknown':
    'Seferin durumu okunamadı. Aşağı çekip yenile; sürerse patronla görüş.',
  // ── Gün başı özeti (şoför): durak · damacana · veresiye ─────────────────────
  'mobile.daySummary.line': 'Bugün {stops} durak · {jugs} damacana · {credit} veresiye',
  'mobile.daySummary.lineNoCredit': 'Bugün {stops} durak · {jugs} damacana',
  // Patron "günü gördüm" kartı — not YAZILMADAN gün zaten imzalıysa
  'mobile.dayClose.alreadySeenNoNote':
    '{name} bu günü {time} saatinde zaten gördü olarak işaretledi.',
  // ── AK2: adım 4 "Yolda" (sıradaki durak) ───────────────────────────────────
  'mobile.route.nextStops': 'Sıradaki duraklar ({n})',
  'mobile.route.allDone': 'Tüm siparişler bitti',
  'mobile.route.pendingSync': 'Senkron bekliyor',
  'mobile.route.allPending': 'Tüm açık siparişler senkron bekliyor; bağlantı gelince işlenir.',
  'mobile.route.departPendingLoadBody': 'Yükleme gönderilmeyi bekliyor. Yola çıkılsın mı?',
  'mobile.route.deadJob': 'Gönderilemedi, kuyruğa bak',
  // ── Ş4: aynı binada çoklu teslim ───────────────────────────────────────────
  'mobile.group.sameBuilding': 'Aynı binada {n} sipariş',
  'mobile.group.deliverTogether': 'Birlikte teslim et ({n})',
  'mobile.group.title': 'Birlikte teslim',
  'mobile.group.step': 'Sipariş {i} / {n}',
  'mobile.group.next': 'Sonraki: {name}',
  'mobile.group.finish': 'Hepsini teslim et ({n})',
  'mobile.group.saved': '{n} teslim kaydedildi',
  'mobile.group.undoAll': '{n} teslim geri alındı.',
  'mobile.group.undoPartial':
    '{done} teslim geri alındı, {left} teslim geri alınamadı (gönderildi ya da Gönderilecekler’de).',
  'mobile.group.partialFailed':
    '{done} teslim kaydedildi, {left} sipariş kaydedilemedi. Tekrar dene.',
  'mobile.group.invalidForm': '{name}: {problem}',
  'mobile.group.partialSaved':
    '{n} teslim kaydedildi, {m} kaydedilemedi. Kalanları tek tek teslim et.',
  'mobile.group.leaveBody': 'Doldurulan formlar kaydedilmedi, çıkılsın mı?',
  'mobile.group.leaveStay': 'Devam et',
  'mobile.group.leaveConfirm': 'Çık',
  'mobile.tab.orders': 'Siparişler',
  'mobile.tab.queue': 'Gönderilecekler',
  'mobile.tab.settings': 'Ayarlar',
  'mobile.tab.notifications': 'Bildirimler',
  'mobile.ownerSteps.approvals': 'Onaylar',
  'mobile.ownerSteps.tracking': 'Takip',
  'mobile.ownerSteps.dayEnd': 'Gün sonu',
  'mobile.ownerSteps.trackMap': 'Harita',
  'mobile.ownerSteps.trackOrders': 'Siparişler',
  'mobile.ownerSteps.menu': 'Menü',
  'mobile.ownerSteps.dayEndTitle': 'Gün sonu',
  'mobile.ownerSteps.dayEndHint':
    'Bugünün kapanışlarını, nakit teslimini ve farkları günlük raporda gör.',
  'mobile.ownerSteps.openReport': 'Günlük raporu aç',
  'mobile.ownerLive.revenueToday': 'Bugün ciro',
  'mobile.ownerLive.updatedAt': '{time} güncellendi',
  'mobile.ownerLive.stopsLeft': '{n} durak kaldı',
  'mobile.ownerLive.stopsDone': 'Tüm duraklar bitti',
  'mobile.settings.title': 'Ayarlar',
  'mobile.settings.account': 'Hesap',
  'mobile.settings.version': 'Sürüm',
  'mobile.settings.server': 'Sunucu',
  'mobile.settings.logout': 'Çıkış yap',
  'mobile.settings.logoutConfirm': 'Çıkış yapılsın mı? Gönderilmemiş işlemler cihazda kalır.',
  'mobile.settings.theme': 'Görünüm',
  'mobile.settings.theme.system': 'Sistem',
  'mobile.settings.theme.light': 'Açık',
  'mobile.settings.theme.dark': 'Koyu',
  'mobile.settings.notifications': 'Bildirimler',
  'mobile.settings.notificationsDenied':
    'Bildirim izni kapalı. Bildirimler ekranda görünür ama telefonunuzda uyarı verilmez.',
  'mobile.settings.allowNotifications': 'İzin ver',
  'mobile.settings.notifUrgent': 'Acil bildirimler',
  'mobile.settings.notifUrgentHint':
    'Sipariş, iptal, onay ve mesaj gibi işlem gerektiren bildirimler.',
  'mobile.settings.notifInfo': 'Bilgi bildirimleri',
  'mobile.settings.notifInfoHint': 'Durum ve özet gibi bilgi amaçlı bildirimler.',
  'mobile.settings.notifQuiet': 'Sessiz saat',
  'mobile.settings.notifQuietHint':
    'Sessiz saatte acil olmayan bildirimler telefonda uyarı vermez; listede görünür.',
  'mobile.settings.testNotification': 'Test bildirimi gönder',
  'mobile.settings.testNotificationSent': 'Test bildirimi gönderildi.',
  'mobile.settings.testNotificationTooMany': 'Biraz bekleyin, test bildirimi az önce gönderildi.',
  'mobile.settings.testNotificationForbidden': 'Hesap askıda, test gönderilemez.',
  'mobile.settings.testNotificationFailed': 'Test bildirimi gönderilemedi.',
  'mobile.placeholder.soon': 'Bu ekran yakında.',
  'mobile.notification.channelName': 'AquaBox bildirimleri',
  'mobile.notification.quietChannelName': 'Sessiz saat',
  'mobile.notification.urgentChannelName': 'Sipariş ve iptal',
  'mobile.notification.locationTitle': 'AquaBox',
  'mobile.notification.locationBody': 'Sefer sürüyor — konum kaydediliyor',
  'mobile.permission.locationDenied': 'Konum izni verilmedi. Sefer sırasında haritada görünmezsin.',
  'mobile.permission.cameraDenied': 'Kamera izni verilmedi.',

  // Konum onboarding
  'mobile.location.onboardingTitle': 'Konum izni',
  'mobile.location.onboardingHeading': 'Konumun nasıl kullanılır?',
  // Konum bilgi ekranı — ÜÇ madde. Kısaltma yapıldı ama bilgi ÇIKARILMADI:
  // toplama kuralı, patron haritası, saklama süresi, kayıt sıklığı, izin davranışı
  // ve Android pil izni hep duruyor.
  'mobile.location.onboardingPoint1':
    'Konum yalnız sefer açıkken toplanır, patronun haritasında aracını gösterir ve 90 gün sonra otomatik silinir.',
  'mobile.location.onboardingPoint2':
    'Araç dururken konum dakikada en çok bir kez kaydedilir; 30 dakika hareketsiz kalınca kayıt durur, araç yeniden hareket edince sürer.',
  'mobile.location.onboardingPoint3':
    'Telefon izin sorduğunda "Her zaman" seçersen ekran kilitliyken de konum gönderilir; seçmezsen konum yalnız uygulama açıkken gönderilir. İzni hiç vermezsen sefer yine açılır ama haritada görünmezsin. Android\'de AquaBox ayrıca pil optimizasyonu izni ister; böylece telefon uygulamayı arka planda kapatmaz.',
  'mobile.location.onboardingContinue': 'Anladım',
  'mobile.location.idlePaused':
    'Araç durduğu için konum kaydı duraklatıldı; hareket edince sürer. Şimdiki konumu göndermek için dokun.',
  'mobile.location.resumed': 'Şimdiki konum alındı, gönderilecek.',
  'mobile.location.resumeFailed': 'Konum alınamadı, konum servisini aç',
  // Ön plana dönüşte / soğuk açılışta açık sefere takip geri bağlandı (geri tuşu motoru
  // ayırmıştı). `mobile.location.resumed` DOKUNMA yolunun (idlePaused şeridi) mesajıdır.
  'mobile.location.restarted': 'Konum takibi durmuştu; yeniden başladı.',
  // Şoför sefer paketi (`apps/mobile/lib/features/driver_trip`).
  'mobile.driverTrip.openTomorrowHint': "Yarının seferi saat {hour}:00'dan sonra açılır.",
  // Tarihli etiketler: şoför seferin hangi güne yazılacağını görür.
  'mobile.driverTrip.dayTodayDated': 'Bugünün seferi ({date})',
  'mobile.driverTrip.dayTomorrowDated': 'Yarının seferi ({date})',
  // Gönderim onayı: sefer hangi tarihe yazılacak?
  'mobile.driverTrip.openConfirmTitle': 'Seferi aç',
  'mobile.driverTrip.openConfirmBody': 'Bu sefer {date} tarihine yazılır.',
  'mobile.driverTrip.nextDayNote':
    'Akşamdan yarının seferi açılır ve aracı doldurursun. Yola çıkış yarın yapılır.',
  'mobile.driverTrip.odometerStart': 'Sayaç (km, isteğe bağlı)',
  'mobile.driverTrip.invalidKm': 'Kilometre geçerli bir sayı olmalı.',
  'mobile.driverTrip.reloadPendingNote': 'Ara yükleme onay bekliyor',
  'mobile.driverTrip.worklistUnavailable': 'Sipariş listesi yüklenemedi, aşağı çekip tekrar dene.',
  'mobile.driverTrip.deliverAfterDepart': 'Teslim yazmak için önce yola çık.',
  'mobile.driverTrip.panelBadge': 'Panel',
  // Şoför gün ekranı — sade metin (M1a).
  'mobile.driverTrip.floatCash': 'Üstündeki nakit',
  'mobile.driverTrip.returnToDepotConfirm': 'Evet, depoya dön ve say',
  'mobile.driverTrip.queueJobFailed': 'Gönderilemedi. Tekrar dene ya da kaydı sil.',
  'mobile.driverTrip.cashHandedOver': 'Depoya teslim edildi',
  'mobile.driverTrip.cashLeft': 'Üstünde kalan nakit',
  // Ortak birim metinleri: her sayının birimi olur.
  'mobile.common.qtyUnit': '{n} adet',
  'mobile.common.qtyProduct': '{qty} adet {product}',
  // Devir rozeti — dört ekranda da (şoför günü, şoför siparişler, patron liste, patron detay)
  // AYNI iki metni kullanır; sayaç sipariş başına `carryOverCount`. `One` anlamı "devreden
  // sipariş" — aynı gün de devredebilir, "dünden" kelimesi yanıltıcı; `many` ayrık İstanbul
  // günü sayısı, "gündür devrediyor" doğru kalır.
  'mobile.order.carryOverOne': 'Devreden sipariş',
  'mobile.order.carryOverMany': '{n} gündür devrediyor',
  // Mobildeki durum rozeti metni. `orderStatus.*` PAYLAŞILANDIR (panel de kullanır) ve
  // "Emanet bırakıldı" diyor; mobilde şoför için doğrusu "Kapıda bırakıldı".
  'mobile.orderStatus.leftAtDoor': 'Kapıda bırakıldı',
  'mobile.driverTrip.departConfirmTitle': 'Yola çıkılsın mı?',
  'mobile.driverTrip.departConfirmBody': 'Araçta {n} dolu damacana var. Konum paylaşımı başlar.',
  'mobile.driverTrip.startClosingConfirm':
    'Depoya dönüp sayıma geçilsin mi? Bundan sonra teslimat yazılamaz.',
  'mobile.driverTrip.closedTodayTitle': 'Bugünkü seferin kapandı ✓',
  'mobile.driverTrip.closedAtLine': 'Kapanış: {time}',
  'mobile.driverTrip.sameAddressHint': 'Aynı adreste {n} sipariş',
  'mobile.driverTrip.addressUpdated': 'Adres güncellendi',
  'mobile.driverTrip.vehicleNote': 'Plakayla girdiğin araç: {plate}',
  // Sefer açarken araç seçimi (ADR 2026-10-21 §P2).
  'mobile.driverTrip.vehicleLabel': 'Araç',
  'mobile.driverTrip.vehicleSelectTitle': 'Araç seç',
  'mobile.driverTrip.otherVehicle': 'Başka araç',
  'mobile.driverTrip.defaultVehicle': 'Varsayılan araç',
  'mobile.driverTrip.noVehicles': 'Aktif araç yok.',
  'mobile.driverTrip.errAlreadyOpen': 'Bu araçta zaten açık seferin var',
  'mobile.driverTrip.errOpenOnOtherVehicle': '{plate} aracında açık seferin var. Önce onu kapat.',
  // Sunucu plaka göndermezse: hangi araçta açık olduğu BİLİNMEZ (seçilen araç yanlıştır).
  'mobile.driverTrip.errOpenOnOtherVehicleNoPlate': 'Başka bir araçta açık seferin var.',
  'mobile.driverTrip.errVehicleBusy':
    '{plate} aracında başka bir personelin açık seferi var. Patrona bildirildi.',
  'mobile.driverTrip.errNoVehicle': 'Atanmış aracın yok, bir araç seç',
  'mobile.driverTrip.errVehicleNotFound': 'Araç bulunamadı ya da pasif',
  'mobile.driverTrip.errNoPersonnelProfile': 'Personel profilin yok; patronundan iste.',
  'mobile.driverTrip.openDayLabel': 'Sefer günü: {day}',
  'mobile.driverTrip.departNoLoadBody': 'Araca hiç ürün yüklenmedi, yine de yola çık?',
  'mobile.driverTrip.startClosingCarry': '{n} teslim edilmemiş sipariş yarına devredecek.',
  'mobile.driverTrip.addTotal': 'Eklenecek toplam',
  'mobile.driverTrip.removeTotal': 'Çıkarılacak toplam',
  'mobile.driverTrip.loadTitle': 'Aracı doldur',
  'mobile.driverTrip.loadSub':
    'Aracı kapasitesi kadar doldur: ürün türü başına toplu adet gir. Sipariş başına yükleme yoktur.',
  'mobile.driverTrip.loadPlanInfo':
    'Önerilen yükleme yalnız bilgidir; asıl sayıyı sen belirlersin.',
  'mobile.vehicleContents.full': 'Dolu',
  'mobile.vehicleContents.empty': 'Boş',
  'mobile.vehicleContents.emptyZero': 'Boş: 0',
  // Yabancı marka boş rozeti: sayının birimi açık (damacana değil, adet).
  'mobile.vehicleContents.foreignCount': 'Yabancı: {n} adet',
  'mobile.vehicleContents.cases': 'Koli',
  'mobile.vehicleContents.casesNote': 'Kapasiteye katılmaz',
  'mobile.vehicleContents.filled': 'Doluluk {n}',
  'mobile.vehicleContents.free': 'boş yer {n}',
  'mobile.vehicleContents.overCapacity': 'Kapasite {n} aşıldı',
  // Yükleme ekranında araçtaki mevcut dolu + boş + yabancı ile girilen yeni adet toplamı
  // kapasiteyi aşıyorsa gösterilen uyarı. Koli katılmaz. Kayıt ENGELLENMEZ — yalnız uyarı.
  'mobile.vehicleContents.overCapacityWarning':
    'Araçta {occupied} damacana var (boşlar dahil); {entered} eklenince kapasite {capacity} aşılıyor. Yine de kaydedebilirsin.',
  'mobile.driverTrip.jugSection': 'Damacana',
  'mobile.driverTrip.caseSection': 'Koli (boş dönüşü yok)',
  'mobile.driverTrip.loadConfirmTitle': 'Yükleme doğru mu?',
  'mobile.driverTrip.loadConfirmBody': '{n} damacana araca yazılacak.',
  'mobile.driverTrip.loadConfirmBodyCases': '{n} damacana ve {cases} koli araca yazılacak.',
  'mobile.driverTrip.closeConfirmBody': 'Sefer kapatılsın mı? Kapanış geri alınamaz.',
  // Kapanış düğmesi kilitliyken söylediği. "Ara yükleme" uyarısı TEK yerde
  // (`mobile.driverTrip.reloadPendingNotice`); düğme yalnız bekleneni söyler.
  'mobile.driverTrip.closeLockedReload': 'Ara yükleme onayı bekleniyor',
  'mobile.driverTrip.reloadPendingNotice':
    'Ara yükleme onay bekliyor. Onaylanınca seferi kapatabilirsin.',
  // Kapanış ekranı sayıları: her sayının birimi var.
  'mobile.close.damacana': '{n} damacana',
  'mobile.close.koli': '{n} koli',
  'mobile.close.minusDamacana': '− {n} damacana',
  'mobile.close.minusKoli': '− {n} koli',
  'mobile.close.openDamacana': '{n} damacana açık',
  'mobile.close.openKoli': '{n} koli açık',
  'mobile.close.foreignSub': 'Alınan {n} damacana · ayrı rafa',
  // Kapanış ekranı başlıkları: "emanet" ve "kuyruk" gibi iç jargon yok.
  'mobile.close.floatLabel': 'Şoförde nakit',
  'mobile.close.orphansConfirm':
    'Gönderilemeyen {n} kayıt var, sahibi belirsiz oldukları için gönderilmeyecek. Yine de kapat?',
  // AK5: adım 3/6/7 tam ekranları. Düğmeler sonucu söyler; kapanış kilitleri
  // SARI bantta ne yapılacağını söyler.
  'mobile.stepScreens.loadConfirm': 'Yüklemeyi onayla',
  'mobile.stepScreens.closeDay': 'Günü kapat',
  'mobile.stepScreens.done': 'Bitti',
  'mobile.stepScreens.lockKm': 'Kapanış için bugünkü km gir.',
  'mobile.stepScreens.lockFuel': 'Kapanış için mazot bilgilerini gir.',
  'mobile.stepScreens.lockHandover': 'Kapanış için nakit teslimini onayla.',
  'mobile.stepScreens.lockNote': 'Kapanış için farkın nereden geldiğini yaz.',
  'mobile.driverTrip.carryOverTitle': 'Yarına devreden: {n} sipariş',
  'mobile.driverTrip.carryOverBody': 'Teslim edilmeyen siparişler yarına devredecek:',
  'mobile.driverTrip.summaryVariance': 'Fark var, açıklandı',
  'mobile.driverTrip.discardConfirm': 'Bu kayıt Gönderilecekler’den kalıcı olarak silinecek. Emin misin?',
  'mobile.delivery.worklistTitle': 'Siparişler',
  'mobile.delivery.worklistEmpty': 'Bugün sana düşen sipariş yok.',
  'mobile.delivery.worklistEmptyAction': 'Seferi aç',
  'mobile.worklist.newOrderTitle': 'Yeni sipariş',
  'mobile.worklist.orderRemoved': 'Bir sipariş başka araca alındı',
  'mobile.worklist.tabToday': 'Bugün',
  'mobile.worklist.tabHistory': 'Geçmiş',
  'mobile.worklist.historyEmpty': 'Bu gün teslimat yok',
  'mobile.worklist.historyPrevDay': 'Önceki gün',
  'mobile.worklist.historyNextDay': 'Sonraki gün',
  'mobile.worklist.historyDelivered': 'Teslim edildi',
  'mobile.worklist.historyFailed': 'Başarısız',
  'mobile.worklist.historyCancelled': 'İptal',
  'mobile.worklist.newOrderBadge': '{n} yeni sipariş',
  'mobile.delivery.notAvailable': 'Bu bölüm şu an kullanılamıyor. Patrona haber ver.',
  'mobile.delivery.sectionOurs': 'Araca atanan',
  'mobile.delivery.sectionPanel': 'Panel siparişleri',
  'mobile.delivery.badgePanel': 'Panel',
  'mobile.delivery.addressUpdated': 'Adres güncellendi',
  'mobile.delivery.addressUpdatedBody': 'Müşterinin yeni adresi: {address}',
  'mobile.delivery.previousAddressLabel': 'Eski adres',
  'mobile.delivery.pendingSync': 'Gönderilmeyi bekliyor',
  'mobile.delivery.claim': 'Al',
  'mobile.delivery.detailTitle': 'Sipariş',
  'mobile.custSummary.title': 'Müşteri geçmişi',
  'mobile.custSummary.lastDelivered': '{date} · {qty} damacana',
  'mobile.custSummary.lastDeliveredNone': 'Daha önce teslim yok',
  'mobile.custSummary.jugsOnHand': 'Müşteride {n} damacana',
  'mobile.custSummary.interval': 'Genelde {n} günde bir',
  'mobile.custSummary.intervalNone': 'Olağan aralık: —',
  'mobile.custSummary.openBalance': 'Veresiye var',
  'mobile.delivery.sectionAddress': 'Adres',
  'mobile.delivery.sectionItems': 'Kalemler',
  'mobile.delivery.addressNote': 'Adres tarifi',
  'mobile.delivery.orderNote': 'Sipariş notu',
  'mobile.delivery.total': 'Tutar',
  'mobile.delivery.navigate': 'Yol tarifi',
  'mobile.delivery.copied': 'Telefona uygulama açılamadı; bilgi panoya kopyalandı.',
  'mobile.delivery.copiedAddress': 'Harita uygulaması açılamadı; adres panoya kopyalandı.',
  'mobile.delivery.actionDeliver': 'Teslim et',
  'mobile.delivery.actionFail': 'Teslim edilemedi',
  'mobile.delivery.actionAddress': 'Adresi düzelt',
  'mobile.delivery.actionTransfer': 'Başka şoföre devret',
  'mobile.delivery.notOnRoute': 'Teslim için sipariş yolda olmalı. Önce seferi başlat.',
  'mobile.delivery.noTrip': 'Açık sefer yok. Önce sefer açıp yola çıkmalısın.',
  'mobile.delivery.deliverTitle': 'Teslim',
  'mobile.delivery.formItems': 'Satılan',
  'mobile.delivery.formEmpties': 'Alınan boş',
  'mobile.delivery.emptiesUnit': 'Boş damacana',
  'mobile.delivery.emptiesNone': 'Boş alınmadı — müşterinin zimmetinde kalıyor.',
  'mobile.delivery.cases': 'Koli (0,5L)',
  'mobile.delivery.foreignBrand': 'Yabancı marka boş',
  'mobile.delivery.foreignBrandName': 'Hangi marka?',
  'mobile.delivery.brandOther': 'Diğer',
  'mobile.delivery.brandOtherHint': 'Marka adını yaz',
  'mobile.delivery.deposit': 'Depozito',
  'mobile.delivery.depositYes': 'Depozito alındı',
  'mobile.delivery.depositNo': 'Depozito alınmadı',
  'mobile.delivery.depositNote': 'Boş damacana alınmadıysa müşterinin zimmetine yazılır.',
  'mobile.delivery.payment': 'Ödeme şekli',
  'mobile.delivery.payCash': 'Nakit',
  'mobile.delivery.payCard': 'Kart',
  'mobile.delivery.payCredit': 'Veresiye',
  'mobile.delivery.payDoor': 'Kapıya bırak (veresiye)',
  'mobile.delivery.payDoorNote': 'Kapıya bıraktın; boş damacana alınmaz, ödeme alınmaz.',
  'mobile.delivery.cashNote': 'Nakit sende kalır, kapanışta depoya teslim edersin.',
  'mobile.delivery.creditNote': 'Müşterinin borcuna yazılır; sonra tahsil edersin.',
  'mobile.delivery.paymentLockedNote': '{channel} üzerinden ödendi; ödeme şekli değiştirilemez.',
  'mobile.delivery.paidOnline': 'Ödeme alındı (online)',
  'mobile.delivery.qtyLocked': 'Bu siparişin adedi kanaldan kesin.',
  // Saha SB1: müşterisi olmayan siparişte veresiye ve zimmet yazılamaz (sunucu 400 döner:
  // `trip.creditNeedsCustomer`). Kapıya bırakma da CREDIT'e dönüştüğü için o seçenek de gizlenir.
  'mobile.delivery.noCustomerHint':
    'Bu siparişte kayıtlı müşteri yok; veresiye ve zimmet yazılamaz. Nakit ya da kart seç; gerekirse patron müşteriyi bağlasın.',
  'mobile.delivery.noteLabel': 'Not (isteğe bağlı)',
  'mobile.delivery.photo': 'Fotoğraf ekle (isteğe bağlı)',
  'mobile.delivery.photoRetake': 'Yeniden çek',
  'mobile.delivery.photoRemove': 'Kaldır',
  'mobile.delivery.photoForeignHint':
    'Yalnız yabancı boşları çek; kişi, kapı numarası görünmesin. Teslimden sonra arka planda yüklenir.',
  'mobile.delivery.confirmDeliverBody': '{sold} damacana · {empty} boş alındı.',
  'mobile.delivery.confirmCases': '{cases} koli',
  'mobile.delivery.confirmAmount': 'Sipariş tutarı: {amount}',
  'mobile.delivery.amountRecalc':
    'Tutar teslimde yeniden hesaplanır — makbuzdaki tutarı tahsil et.',
  'mobile.delivery.submitRejected':
    'Kayıt kabul edilmedi ve tekrar gönderilmeyecek. Patrona haber ver.',
  'mobile.delivery.confirmPayment': 'Ödeme: {payment}',
  'mobile.delivery.amountToCollect': 'Sipariş tutarı',
  'mobile.delivery.amountNotCollected': 'Sipariş tutarı (şimdi tahsil edilmeyecek)',
  'mobile.delivery.payDoorShort': 'Kapıya bırakıldı (veresiye)',
  'mobile.delivery.payDoorPrepaidShort': 'Kapıya bırakıldı (ödenmiş)',
  'mobile.delivery.saved': 'Teslim kaydedildi. Bağlantı varsa hemen gönderilir.',
  'mobile.delivery.failTitle': 'Teslim edilemedi',
  'mobile.delivery.failCarryOver': 'Sipariş yarına devreder.',
  'mobile.delivery.failOwnerQueue': 'Sipariş devretmez; patronun iş listesine düşer.',
  'mobile.delivery.failConfirmTitle': 'Teslim edilemedi olarak kaydedilsin mi?',
  'mobile.delivery.failReasonRequired': 'Bir sebep seç.',
  'mobile.delivery.failSubmit': 'Teslim edilemedi olarak kaydet',
  'mobile.delivery.failSaved': 'Kayıt alındı.',
  'mobile.delivery.addressTitle': 'Adresi düzelt',
  'mobile.delivery.addressHint':
    'Kayıtlı adres değişir; sonraki siparişlerde "adres güncellendi" notu görünür.',
  'mobile.delivery.addressHintOrderOnly':
    'Bu sipariş farklı bir adrese gidiyor; düzeltme yalnız bu siparişi günceller, müşterinin kayıtlı adresi değişmez.',
  'mobile.delivery.addressOverrideBadge': 'Siparişe özel adres',
  'mobile.delivery.addressConfirmTitle': 'Adresi değiştir',
  'mobile.delivery.addressConfirmBody': 'Müşterinin kayıtlı adresi değişecek. Emin misin?',
  'mobile.delivery.addressConfirmAction': 'Evet, adresi değiştir',
  'mobile.delivery.addressLabel': 'Doğru adres',
  'mobile.delivery.addressNoteLabel': 'Adres tarifi (isteğe bağlı)',
  'mobile.delivery.addressInvalid': 'Adres en az 5 karakter olmalı (en çok 500).',
  'mobile.delivery.addressUnchanged': 'Adreste bir değişiklik yok.',
  'mobile.delivery.noCustomer': 'Bu siparişte müşteri kaydı yok; adres düzeltilemez.',
  'mobile.delivery.addressSubmit': 'Düzeltmeyi gönder',
  'mobile.delivery.addressSaved': 'Adres güncellendi.',
  'mobile.delivery.addressQueued': 'Bağlantı gelince gönderilecek.',
  'mobile.delivery.transferTitle': 'Devir talebi',
  'mobile.delivery.transferHint':
    'Talep patrona gider. Onaylarsa sipariş başka şoföre geçer; o zamana kadar sende kalır.',
  'mobile.delivery.reasonLabel': 'Neden devrediyorsun?',
  'mobile.delivery.reasonInvalid': 'Sebep en az 3 karakter olmalı (en çok 300).',
  'mobile.delivery.transferSubmit': 'Talebi gönder',
  'mobile.delivery.transferSaved': 'Devir talebi patrona gönderildi.',
  'mobile.delivery.transferQueued': 'Devir talebi bağlantı gelince patrona gönderilecek.',
  'mobile.delivery.transferPending': 'Devir bekliyor',
  'mobile.delivery.transferReasonAny': 'Hazır nedenler',
  'mobile.delivery.reasonVehicleFull': 'Araç doldu',
  'mobile.delivery.reasonCannotReach': 'Yetişemiyorum',
  'mobile.delivery.reasonOutOfRegion': 'Adres bölgem dışında',
  // ── Mobil: teslim formu "Bu kapıda beklenen" kartı (STOK S1; yalnız ADET, tutar yok) ──
  'mobile.delivery.doorTitle': 'Bu kapıda beklenen',
  'mobile.delivery.doorSold': 'Satılan dolu',
  'mobile.delivery.doorExpectedEmpty': 'Beklenen boş',
  'mobile.delivery.doorExpectedForeign': 'Beklenen yabancı boş',
  'mobile.delivery.doorExpectedForeignBrand': 'Beklenen yabancı boş ({brand})',
  'mobile.delivery.doorCases': 'Koli',
  'mobile.delivery.doorCasesNote': 'İade edilmez',
  'mobile.delivery.doorOnHand': 'Müşteri zimmetinde',
  'mobile.delivery.doorOnHandValue': '{n} boş damacana',
  'mobile.delivery.emptiesBadge': '{expected} bekleniyor · {got} aldın',
  'mobile.delivery.shortfallTitle': 'Eksik boşun sebebi',
  'mobile.delivery.shortfallHint': '{missing} boş eksik. Sebebi seçmeden teslim kaydedilemez.',
  'mobile.delivery.shortfallRequired': 'Eksik boş için bir sebep seç.',
  'mobile.delivery.shortfall.CUSTOMER_DECLINED': 'Müşteri vermedi',
  'mobile.delivery.shortfall.NO_EMPTY': 'Boş yoktu',
  'mobile.delivery.shortfall.REJECTED_OLD_DAMAGED': 'Eski/kırık, reddetti',
  // ── Mobil: teslim "Geri al" penceresi (AK3) ──
  'mobile.undo.action': 'Geri al',
  'mobile.undo.done': 'Teslim geri alındı.',
  'mobile.undo.failed': 'Geri alınamadı, teslim gönderildi.',
  'mobile.undo.notNow': 'Şu an geri alınamadı; teslim Gönderilecekler’de duruyor, bağlanınca gönderilecek.',
  'mobile.queue.failResolvedDelivered':
    '{n} teslim edilemedi kaydı gönderilmedi: sipariş zaten teslim edilmiş görünüyor.',
  'mobile.queue.photoFileMissing': 'Fotoğraf dosyası bulunamadı; yüklenemedi.',
  'mobile.queue.photoTooLarge': 'Fotoğraf çok büyük; yüklenemedi.',
  'mobile.queue.conflictPendingDeliver':
    'Bu sipariş için teslim kaydı gönderilmeyi bekliyor; "Teslim edilemedi" yazılamaz. Yanlışlıkla teslim yazdıysan ilk 5 saniyede "Geri al"ı kullan.',
  'mobile.queue.conflictPendingFail':
    'Bu sipariş için "Teslim edilemedi" kaydı var; teslim yazılamaz. Teslim edeceksen önce patronuna haber ver, sipariş sana yeniden atansın.',
  // ── Mobil: "Geri çek" (kuyruktaki fail kaydını kaldırma) ve kapı metinleri (Opus NOTU) ──
  'mobile.queue.conflictFailDead':
    'Gönderilemeyen bir "Teslim edilemedi" kaydın var. Gönderilecekler ekranından silip teslimi yeniden yaz.',
  'mobile.queue.conflictFailWithdrawable':
    'Gönderilmemiş bir "Teslim edilemedi" kaydın var. Gönderilecekler ekranında "Geri çek" ile kaldırıp teslimi yeniden yaz.',
  'mobile.queue.pendingFailTitle': 'Teslim edilemedi kaydı',
  'mobile.queue.pendingFailReasonLine': 'Sebep: {reason}',
  'mobile.queue.pendingFailReasonEmpty': 'Sebep: belirtilmedi',
  'mobile.queue.pendingFailTried':
    'Gönderilmiş olabilir; geri çekilemez. Teslim edeceksen patronuna haber ver.',
  'mobile.queue.withdrawAction': 'Geri çek',
  'mobile.queue.withdrawConfirmTitle': 'Kaydı geri çek',
  'mobile.queue.withdrawConfirmBody':
    'Bu "Teslim edilemedi" kaydı Gönderilecekler’den kaldırılacak. Müşteri teslim almak isterse sipariş tekrar teslim edilebilir olacak.',
  'mobile.queue.withdrawDone': 'Kayıt geri çekildi; siparişi şimdi teslim edebilirsin.',
  'mobile.queue.withdrawTried':
    'Bu kayıt gönderilmeye çalışıldı, geri çekilemez. Teslim edeceksen patronuna haber ver, sipariş sana yeniden atansın.',
  'mobile.queue.withdrawNotAllowed': 'Bu kayıt geri çekilemez (ölü ya da başka bir kayıt).',
  // Saha SB1: teslim kaydı sunucuya ulaştı ama sipariş O SIRA teslim edilmiş. Ölü kalmak yerine
  // kayıt düşer (fail kaydıyla aynı çözüm), şoförün anlamsız "tekrar dene" denemesi biter.
  'mobile.queue.alreadyDeliveredInfo':
    'Bu sipariş zaten teslim edilmiş; bekleyen kayıt kaldırıldı.',
  'mobile.queue.redeliver': 'Yeniden teslim et',
  // ── Mobil: teslimat özeti paylaşımı (K2e) ──
  'mobile.receipt.shareTitle': 'Teslimat özeti',
  'mobile.receipt.shareAction': 'Özeti paylaş',
  'mobile.receipt.shareSubject': 'Teslimat özeti',
  'mobile.receipt.greeting': 'Sayın {name},',
  'mobile.receipt.dateLine': 'Tarih: {date}',
  'mobile.receipt.timeLine': 'Saat: {time}',
  'mobile.receipt.itemLine': '{name} × {qty}',
  'mobile.receipt.amountLine': 'Tutar: {amount}',
  'mobile.receipt.paymentLine': 'Ödeme: {payment}',
  'mobile.receipt.receiptLine': 'Makbuz: {no}',
  'mobile.receipt.footer': 'İyi günler dileriz.',
  'mobile.receipt.pendingNote': 'Bağlantı gelince kesinleşir.',
  'mobile.receipt.jugsTotal': 'Damacana × {n}',
  'mobile.receipt.casesTotal': 'Koli × {n}',
  'mobile.receipt.shareFailed': 'Paylaşım açılamadı.',
  // ── Mobil: patron özeti, siparişler, sefer, harita, bildirim, döküm, cihaz onayı (owner_home) ──
  'mobile.ownerHome.notAvailable': 'Bu özellik sunucuda henüz açık değil.',
  'mobile.ownerHome.orderDetail': 'Sipariş detayı',
  'mobile.ownerHome.sectionCustomer': 'Müşteri',
  'mobile.ownerHome.address': 'Adres',
  'mobile.ownerHome.addressNote': 'Adres tarifi',
  'mobile.ownerHome.region': 'Bölge',
  'mobile.ownerHome.vehicle': 'Araç',
  'mobile.ownerHome.source': 'Kaynak',
  'mobile.ownerHome.note': 'Not',
  'mobile.ownerHome.failReason': 'Teslim edilememe nedeni',
  'mobile.ownerHome.cancelReason': 'İptal nedeni',
  'mobile.ownerHome.cancelReasonHint': 'İptal nedeni (isteğe bağlı)',
  'mobile.ownerHome.payment': 'Ödeme',
  'mobile.ownerHome.externalStatus': 'Panel durumu',
  // Araç etiketi siparişin KAYNAĞININ panelinden gelir; Abant siparişi "Hayat'ta" derken
  // şoför yanlış bayi arar. Panel dışı kaynaklar için nötr karşılık.
  'mobile.panel.abantVehicle': "Abant'ta: {label}",
  'mobile.panel.panelVehicle': 'Panelde: {label}',
  'mobile.ownerHome.externalBadge': '{source} · {stage}',
  'mobile.ownerHome.stage.newStage': 'Yeni',
  'mobile.ownerHome.stage.onRoute': 'Yolda',
  'mobile.ownerHome.stage.onRouteLong': 'Uzun süredir yolda',
  'mobile.ownerHome.stage.delivered': 'Teslim edildi',
  'mobile.ownerHome.stage.cancelled': 'İptal',
  'mobile.ownerHome.stage.paymentFailed': 'Ödeme başarısız',
  'mobile.ownerHome.statusChangeTitle': 'Durum değişsin mi?',
  'mobile.ownerHome.statusChangeBody': 'Sipariş “{status}” durumuna alınacak.',
  'mobile.ownerHome.setStatusTo': '“{status}” durumuna al',
  'mobile.ownerHome.noVehicles': 'Atanabilecek aktif araç yok.',
  'mobile.ownerHome.noDrivers': 'Seçilebilecek şoför yok.',
  'mobile.ownerHome.pickDriver': 'Şoför seç',
  'mobile.ownerHome.loadMore': 'Daha fazla göster',
  'mobile.ownerHome.date.today': 'Bugün',
  'mobile.ownerHome.date.yesterday': 'Dün',
  'mobile.ownerHome.date.week': 'Bu hafta',
  'mobile.ownerHome.date.all': 'Tümü',
  'mobile.ownerHome.deliveredCount': 'Teslim edilen',
  'mobile.ownerHome.failedCount': 'Teslim edilemeyen',
  'mobile.ownerHome.carriedOverCount': 'Ertesi güne devreden',
  'mobile.ownerHome.tripCount': 'Sefer sayısı',
  'mobile.ownerHome.visitedCustomers': 'Ziyaret edilen müşteri',
  'mobile.ownerHome.jugsSold': 'Satılan damacana',
  'mobile.ownerHome.depositCollected': 'Alınan depozito',
  'mobile.ownerHome.depositOpenJugs': 'Müşteride açık damacana',
  'mobile.ownerHome.driverDaily': 'Şoför günlük dökümü',
  'mobile.ownerHome.prevDay': 'Önceki gün',
  'mobile.ownerHome.nextDay': 'Sonraki gün',
  'mobile.ownerHome.hasVariance': 'Fark var',
  'mobile.ownerHome.sourceOurs': 'Bizim',
  'mobile.ownerHome.sourceLine': '{source} · {orders} sipariş · {delivered} teslim',
  'mobile.ownerHome.kind.reload': 'Ara yükleme',
  'mobile.ownerHome.kind.cash': 'Nakit teslimi',
  'mobile.ownerHome.kind.transfer': 'Sipariş devri talebi',
  'mobile.ownerHome.kind.stock': 'Stok düzeltmesi',
  'mobile.ownerHome.kind.morning': 'Sabah yüklemesi',
  'mobile.ownerHome.transferTarget': 'Hangi araca devredilsin?',
  'mobile.ownerHome.transferConfirm': 'Sipariş seçilen araca devredilecek. Şoför artık göremez.',
  'mobile.ownerHome.failedOrders': 'Teslim edilemeyen siparişler',
  'mobile.ownerHome.failedOrdersHint':
    'Ertesi güne kendiliğinden devretmedi (müşteri iptali ya da yanlış ürün); atamak için aç.',
  'mobile.ownerHome.pendingDevices': 'Onay bekleyen telefonlar',
  'mobile.ownerHome.devices': 'Şoför telefonları',
  'mobile.ownerHome.unnamedDevice': 'Adsız telefon',
  'mobile.ownerHome.pairingCode': 'Eşleştirme kodu',
  'mobile.ownerHome.approveDeviceTitle': 'Telefon onaylansın mı?',
  'mobile.ownerHome.approveDeviceBody':
    'Bu telefon {driver} adına kaydedilecek; şoförün eski telefonu varsa iptal edilir.',
  'mobile.ownerHome.approvedDevices': 'Onaylı telefonlar',
  'mobile.ownerHome.noApprovedDevices': 'Henüz onaylı telefon yok.',
  'mobile.ownerHome.lastSeen': 'Son görülme {at}',
  'mobile.ownerHome.daySummary': 'Gün özeti',
  'mobile.ownerHome.deliveries': 'Teslimatlar',
  'mobile.ownerHome.reassignDriver': 'Seferi başka şoföre devret',
  'mobile.ownerHome.reassignPick': 'Hangi şoföre devredilsin?',
  'mobile.ownerHome.reassignTitle': 'Sefer devredilsin mi?',
  'mobile.ownerHome.reassignBody':
    'Sefer {from} şoföründen {to} şoförüne geçecek. Sunucu uygun değilse reddeder.',
  'mobile.ownerHome.reassignConfirm': 'Devret',
  // ── Patron MO-3a: onay kartları, filtre, sefer devri ──
  'mobile.ownerHome.approval.dirAdd': 'Araca ekleme',
  'mobile.ownerHome.approval.dirRemove': 'Araçtan boşaltma',
  'mobile.ownerHome.approval.reloadHead': '{plate} · {driver}',
  'mobile.ownerHome.approval.transferFrom': 'Kaynak araç: {plate}',
  'mobile.ownerHome.approval.transferTo': '{plate} aracına devredilecek',
  'mobile.ownerHome.approval.cashAmount': 'Teslim edilen tutar: {amount}',
  'mobile.ownerHome.tripDriverOpened': '{driver} · {time}',
  'mobile.ownerHome.approval.reason': 'Gerekçe: {reason}',
  'mobile.ownerHome.approval.approved': 'Onaylandı',
  'mobile.ownerHome.approval.rejected': 'Reddedildi',
  'mobile.ownerHome.approval.reloadPending': 'Ara yükleme onayı bekliyor',
  'mobile.ownerHome.pill.cancelled': 'İptal · {n}',
  'mobile.ownerHome.pill.failed': 'Teslim edilemedi · {n}',
  'mobile.ownerHome.pill.inProgress': 'Atandı / Yolda · {n}',
  'mobile.ownerHome.driverDailyHint': 'Bugün kim ne teslim etti',
  // ── P6b: patron kendi seferine çıkar; Personel akışı tek kapı ──
  'mobile.ownerHome.goOnRoad': 'Sefere çık',
  'mobile.ownerHome.goOnRoadOpen': 'Kendi seferini aç ve günü yönet',
  'mobile.ownerHome.goOnRoadReturn': 'Açık seferin var; şoför gününe geç',
  'mobile.ownerHome.backToOwnerScreen': 'Patron ekranına dön',
  'mobile.ownerHome.offlineTitle': 'Çevrimdışı · son kaydedilen bilgi',
  'mobile.ownerHome.offlineDayRevenue': '{date} cirosu',
  'mobile.ownerHome.offlineSavedAt': 'Son kayıt: {date} {time}',
  'mobile.ownerMsg.title': 'Patrona mesaj',
  'mobile.ownerMsg.hint': 'Kısa yaz. Müşteri adı, adres ya da telefon yazma.',
  'mobile.ownerMsg.sent': 'Mesaj patrona gönderildi.',
  'mobile.ownerMsg.offline': 'Bağlantı yok; mesaj gönderilmedi. Bağlantı gelince yeniden dene.',
  'mobile.ownerMsg.callDriver': 'Şoförü ara',
  'mobile.ownerMsg.noPhone': 'Şoförün telefonu kayıtlı değil.',
  'mobile.ownerMsg.dialFailed': 'Arama açılamadı.',
  'mobile.ownerHome.personnel': 'Personel',
  'mobile.ownerHome.personnelHint': 'Şoförler, telefonlar ve günlük döküm',
  'mobile.ownerHome.personnelPending': '{n} telefon onay bekliyor',
  'mobile.ownerHome.pendingDeviceAction': 'Onaylamak için Personel ekranını açın · {date}',
  'mobile.report.summaryHint': 'Ciro, tahsilat, stok',
  'mobile.ownerHome.filter.title': 'Filtre',
  'mobile.ownerHome.filter.status': 'Durum',
  'mobile.ownerHome.filter.channel': 'Kanal',
  'mobile.ownerHome.filter.date': 'Tarih',
  'mobile.ownerHome.bulkPickTitle': '{n} sipariş hangi araca atansın?',
  'mobile.ownerHome.bulkConfirmTitle': 'Toplu atama onayı',
  'mobile.ownerHome.bulkConfirmBody': '{n} sipariş {plate} aracına atanacak.',
  'mobile.ownerHome.bulkAssigned': '{n} sipariş atandı',
  'mobile.ownerHome.bulkSkipped': '{n} sipariş atlandı',
  'mobile.ownerHome.assignOther': 'Başka araca ata',
  'mobile.ownerHome.unassign': 'Atamayı kaldır',
  'mobile.ownerHome.cancelConfirm': 'Siparişi iptal et',
  'mobile.ownerHome.addressNoticeLine': 'Şoför adresi düzeltti: {address}',
  'mobile.ownerHome.callCustomer': 'Müşteriyi ara',
  'mobile.ownerHome.openInMap': 'Haritada aç',
  'mobile.ownerHome.reassignReasonHint': 'Devir gerekçesi (en az 10 karakter)',
  'mobile.ownerHome.floatAckTitle': 'Üstündeki nakit de devredilecek',
  'mobile.ownerHome.floatAckBody':
    '{from} şoförünün üzerindeki nakit {amount} araçla birlikte yeni şoföre geçecek. Onaylıyor musun?',
  'mobile.ownerHome.reassignDone': 'Sefer devredildi',
  'mobile.ownerHome.unattributed': 'Şoföre atanamayan kayıtlar',
  'mobile.ownerHome.noTransferVehicle': 'Devredilecek başka araç yok.',
  'mobile.ownerHome.failedMore':
    'Daha fazla teslim edilemeyen sipariş var; liste ilk {n} sayfayla sınırlı.',
  'mobile.ownerHome.floatAckBodyUnknown':
    '{from} şoförünün üzerindeki nakit araçla birlikte yeni şoföre geçecek. Onaylıyor musun?',
  'mobile.ownerHome.noVehiclesTracked': 'Takip edilen araç yok.',
  // Yaş metinleri: okunmayan "29988 dk önce" yerine saat/gün/tarih.
  'mobile.ownerHome.since': '{date} tarihinden beri',
  'mobile.ownerHome.pendingAgeHours': '{h} sa {m} dk',
  'mobile.ownerHome.pendingAgeDays': '{n} gün',
  // Patron özeti: "Uzun süredir almayanlar" grubu (dashboard/mobile -> dormant).
  'mobile.dormant.title': 'Uzun süredir almayanlar',
  'mobile.dormant.more': 've {n} kişi daha',
  // ── Personel (P6a): şoför günlük dökümü + cihaz ekranı tek akış ──
  'mobile.ownerPersonnel.title': 'Personel',
  'mobile.ownerPersonnel.emptyTitle': 'Henüz personel yok',
  'mobile.ownerPersonnel.emptyBody':
    'Şoför kaydı yönetim panelinden açılır. Kayıt açıldığında şoför burada listelenir.',
  'mobile.ownerPersonnel.dayStats': '{date} günü',
  'mobile.ownerPersonnel.deviceConnected': 'Telefon bağlı',
  'mobile.ownerPersonnel.devicePending': 'Onay bekliyor',
  'mobile.ownerPersonnel.deviceNone': 'Telefon yok',
  'mobile.ownerPersonnel.tabLedger': 'Defter',
  'mobile.ownerPersonnel.tabDevice': 'Cihaz & Giriş',
  'mobile.ownerPersonnel.newPhone': 'Yeni telefon',
  'mobile.ownerPersonnel.newPhoneTitle': 'Yeni telefon mu alınıyor?',
  'mobile.ownerPersonnel.newPhoneBody':
    'Bu telefonun girişi kapanacak. Şoför yeni telefondan girince onay isteyecek.',
  'mobile.ownerPersonnel.newPhoneConfirm': 'Evet, iptal et',
  'mobile.ownerPersonnel.reject': 'Reddet',
  'mobile.ownerPersonnel.rejectTitle': 'Eşleştirme reddedilsin mi?',
  // Red sunucuda revoke ucuyla yapılır: kayıt silinmez, bekleyen eşleştirme düşer ve
  // o şoförün AÇIK OTURUMLARI kapanır. "Yeni telefondan girince" ifadesi bekleyen
  // eşleştirme için yanıltıcıydı (ortada henüz onaylanmış telefon yok).
  'mobile.ownerPersonnel.rejectBody':
    'Bu bekleyen eşleştirme iptal edilir; telefon yeniden eşleştirilmeden giriş yapamaz. Bu şoförün açık oturumları da kapanır.',
  'mobile.ownerPersonnel.unmatchedTitle': 'Eşleşmemiş telefonlar',
  // Bölüm metni her satırı kapsamaz: bağlı şoförü olan satır "henüz bağlanmamış" değildir.
  'mobile.ownerPersonnel.unmatchedHint':
    'Bu telefonlar bekleyen eşleştirmelerdir. Reddederseniz telefon yeniden eşleştirmek zorunda kalır.',
  'mobile.ownerPersonnel.unmatchedNoDriver': 'Henüz bir şoföre bağlanmamış.',
  'mobile.ownerPersonnel.unmatchedOffList': 'Bu şoför bugün listede yok; telefonu onay bekliyor.',
  'mobile.ownerPersonnel.unmatchedRejectBody':
    'Bu bekleyen eşleştirme iptal edilir. Bu telefonu kullanan kişi yeniden eşleştirmek zorunda kalır.',
  'mobile.ownerPersonnel.rejectConfirm': 'Reddet',
  'mobile.ownerPersonnel.noPending': 'Onay bekleyen eşleştirme yok.',
  'mobile.ownerPersonnel.pairHint':
    'Şoförün telefonunda görünen 6 haneli kodu girin; kod bu şoföre bağlanır.',
  // Rozetler: aynı adı iki kişi varken ayırt etmek için (saha: mesaj yanlış kişiye gitti).
  'mobile.ownerPersonnel.openTripBadge': 'Seferde · {plate}',
  'mobile.ownerPersonnel.neverLoggedInBadge': 'Hiç giriş yapmadı',
  'mobile.driverMsg.title': 'Şoföre mesaj',
  'mobile.driverMsg.action': 'Mesaj gönder',
  'mobile.driverMsg.hint': 'Serbest mesaj yazın',
  'mobile.driverMsg.sent': 'Mesaj gönderildi.',
  'mobile.driverMsg.offline':
    'Bağlantı yok. Mesaj yalnız çevrimiçiyken gönderilir; kuyruğa alınmaz.',
  // Hedef şoför hiç giriş yapmamışsa mesajı göremeyebilir; gönderim ENGELLENMEZ.
  'mobile.driverMsg.neverLoggedIn':
    'Bu şoför hiç giriş yapmadı; mesajı göremeyebilir. Seferdeki şoförü seçtiğinizden emin olun.',
  // Hedef şoförün satırı OKUNAMADI (liste hatası, eski sunucu, argümansız rota):
  // kimin mesajı alacağı bilinmiyor. Gönderim ENGELLENMEZ, yalnız uyarılır.
  'mobile.driverMsg.unknownTarget':
    'Şoför bilgisi alınamadı; doğru kişiyi seçtiğinizden emin olun.',
  // Araç alt sayfası: varsayılan hedef seferi süren şoför.
  'mobile.ownerHome.messageTripDriver': 'Şoförüne mesaj',
  'mobile.owner_stock.foreignTitle': 'Yabancı markalar',
  'mobile.owner_stock.foreignEmpty': 'Kayıtlı yabancı marka yok.',
  'mobile.owner_stock.foreignEmptyBody':
    'Müşteriden teslimde alınan başka marka boşlar burada listelenir. Şoför teslimde yabancı marka boş aldığında kayıt otomatik yazılır; elle ekleme gerekmez.',
  'mobile.owner_stock.fullOnly': 'Dolu {full}',
  'mobile.owner_stock.caseCount': 'Koli {full}',
  'mobile.owner_stock.deactivateConfirm':
    'Ürün pasifleştirilsin mi? Geçmiş kayıtlar durur, yeni siparişlerde görünmez.',
  // ── Sokak haritası (P6) ──
  'streetMap.api.oneTarget': 'Hedef olarak yalnızca bir bölge ya da bir araç seçilmeli.',
  'streetMap.api.nothingToUpdate': 'Güncellenecek bir alan verilmedi.',
  'streetMap.api.regionNotFound': 'Seçilen bölge bulunamadı.',
  'streetMap.api.neighborhoodLength': 'Mahalle adı 2 ile 80 karakter arasında olmalı.',
  'streetMap.api.streetLength': 'Sokak adı 2 ile 120 karakter arasında olmalı.',
  'streetMap.api.streetSuffixOnly': 'Sokak adı yalnız "sokak", "cadde" gibi bir ek sözcük olamaz.',
  'streetMap.api.rangeOrder': 'Kapı numarası aralığında başlangıç, bitişten büyük olamaz.',
  'streetMap.api.segmentOverlap':
    'Bu sokakta aynı yan ve kapı numarası aralığını kapsayan başka bir aktif parça var. Önce onu kapatın.',
  'streetMap.tab.regions': 'Bölgeler',
  'streetMap.tab.map': 'Sokak haritası',
  'streetMap.intro':
    'Sokağa tıkla, adını yaz, bir araca ya da bölgeye ata. O sokaktan gelen sipariş otomatik o aracın şoförüne düşer.',
  // Harita altlığı atfı: tek kaynak (`apps/panel/src/lib/map-tiles.ts`); iki harita ekranı da buradan alır.
  'tiles.attribution.osm': '© OpenStreetMap katkıcıları — ODbL',
  'tiles.attribution.maptiler': '© MapTiler © OpenStreetMap katkıcıları — ODbL',
  'streetMap.loading': 'Harita verisi yükleniyor…',
  'streetMap.loadError': 'Harita verisi yüklenemedi.',
  'streetMap.search': 'Sokak ya da mahalle ara',
  'streetMap.search.hood': 'Mahalle ara',
  'streetMap.searchEmpty.hood': 'Eşleşen mahalle yok.',
  'streetMap.search.addTo': '{hood} mahallesini {region} bölgesine ekle',
  'streetMap.search.removeFrom': '{hood} mahallesini {region} bölgesinden çıkar',
  'streetMap.search.neighborhoods': 'Mahalleler',
  'streetMap.searchEmpty': 'Eşleşen sokak yok.',
  'streetMap.unnamed': 'Adsız yol',
  'streetMap.legend.unassigned': 'Atanmamış',
  'streetMap.mode.pan': 'Gez',
  'streetMap.mode.rect': 'Dikdörtgen seç',
  'streetMap.mode.poly': 'Alan çiz',
  'streetMap.mode.polyFinish': 'Alanı bitir',
  'streetMap.mode.hint': 'Shift + tık: seçime ekle. Alan modunda sürükle ya da köşeleri tıkla.',
  'streetMap.panel.title': 'Seçim',
  'streetMap.panel.empty': 'Haritadan bir sokak seç.',
  'streetMap.panel.count': '{lines} çizgi · {rules} sokak',
  'streetMap.panel.clear': 'Seçimi temizle',
  'streetMap.panel.streetName': 'Sokak adı',
  'streetMap.panel.streetNameHint': 'Adı olmayan çizgiler için yaz (örn. 4509 Sokak).',
  'streetMap.panel.neighborhood': 'Mahalle',
  'streetMap.panel.target': 'Hedef',
  'streetMap.panel.targetNone': 'Seç…',
  'streetMap.panel.vehicles': 'Araçlar',
  'streetMap.panel.regions': 'Bölgeler',
  'streetMap.panel.save': 'Kaydet',
  'streetMap.panel.close': 'Kuralı kapat',
  'streetMap.panel.current': 'Şu an: {target}',
  'streetMap.panel.skipped': '{count} çizgi adsız ya da mahallesiz olduğu için atlanacak.',
  'streetMap.panel.needName': 'Adsız çizgiler için sokak adı yaz.',
  'streetMap.saved': '{count} sokak kuralı kaydedildi.',
  'streetMap.closed': '{count} sokak kuralı kapatıldı.',
  'streetMap.target.vehicle': 'Araç {plate}',
  'streetMap.target.region': 'Bölge {name}',
  'streetMap.matcher.title': 'Adres dene',
  'streetMap.matcher.placeholder': 'Örn. Beşkavaklar Mah. 4509 Sk. No 12',
  'streetMap.matcher.try': 'Dene',
  'streetMap.matcher.streetVehicle': 'Sokak kuralı: araç {plate} (şoförüne düşer)',
  'streetMap.matcher.streetRegion': 'Sokak kuralı: {region} bölgesi, araç {plate}',
  'streetMap.matcher.streetRegionNoVehicle':
    'Sokak kuralı: {region} bölgesi; araç yok, elle atanacak',
  'streetMap.matcher.neighborhood': 'Mahalle kuralı: {region} bölgesi, araç {plate}',
  'streetMap.matcher.neighborhoodNoVehicle':
    'Mahalle kuralı: {region} bölgesi; araç yok, elle atanacak',
  'streetMap.matcher.manual': 'Belirsiz: tek bir araca düşmüyor, patron elle atar.',
  'streetMap.matcher.unmatched': 'Hiçbir bölge ya da sokakla eşleşmedi. Sipariş beklemede kalır.',
  // ── P6 sadeleştirme: mahalle-first harita ─────────────────────────────
  // Bölge lejantı (üstte 4 bölge) ve mahalle → bölge atama akışı.
  'streetMap.legend.title': 'Bölgeler',
  'streetMap.legend.empty': 'Henüz bölge yok.',
  'streetMap.legend.vehicleLine': '{plate}',
  'streetMap.legend.neighborhoodCount': '{count} mahalle',
  'streetMap.regionPicker.title': 'Bölge seç',
  'streetMap.regionPicker.current': 'Şu an: {name}',
  'streetMap.regionPicker.unassigned': 'Atanmamış',
  'streetMap.regionPicker.remove': 'Bu mahalleden çıkar',
  'streetMap.regionPicker.confirm': 'Onayla',
  'streetMap.regionPicker.cancel': 'Vazgeç',
  'streetMap.regionPicker.rollbackFailed': 'Mahalle bölgesiz kaldı; elle bir bölgeye ekleyin.',
  'streetMap.regionPicker.error': 'Kaydedilemedi. Sayfayı yenileyip tekrar dene.',
  'streetMap.paint.added': '{hood} mahallesi {region} bölgesine eklendi.',
  'streetMap.paint.removed': '{hood} mahallesi {region} bölgesinden çıkarıldı.',
  'streetMap.paint.busy': 'Önceki işlem sürüyor, bir an bekle.',
  'streetMap.paint.error': '{hood} mahallesi kaydedilemedi. Sayfayı yenileyip tekrar dene.',
  'streetMap.paint.rollbackFailed': '{hood} mahallesi bölgesiz kaldı; elle bir bölgeye ekle.',
  'streetMap.streetSuggestions.error': 'Bağlanamadı. Tekrar dene.',
  'streetMap.streetSuggestions.bind': 'Araca bağla',
  'streetMap.hint.simpleLanguage':
    'Bir mahalleye tıkla, onu bir bölgeye ata. Üstte bölgelerin rengini ve araçlarını görürsün.',
  'streetMap.streetSuggestions.title': 'Sokak istisnaları',
  'streetMap.streetSuggestions.empty': 'Son 180 günde bu mahalleden geçen sokak adı bulunamadı.',
  'streetMap.streetSuggestions.emptyTruncated':
    'Taranan son siparişlerde bu mahalleden sokak adı bulunamadı; daha eski siparişler taranmadı.',
  'streetMap.streetSuggestions.truncated':
    'Tarama sınırına ulaşıldı; daha eski siparişlerdeki sokaklar listede olmayabilir.',
  'streetMap.streetSuggestions.orderCount': '{count} sipariş',
  'streetMap.streetSuggestions.hasRule': 'Atanmış',
  // ── Paket P3: sipariş devri (tasarım §5) ──
  // Şoför kendi siparişini başka araca devretmek ister; patron onay kuyruğundan karar verir.
  // Şema hazır: `ApprovalKind.ORDER_TRANSFER` + `ApprovalItem.orderId/targetVehicleId`
  // (kısmi unique — sipariş başına tek PENDING talep). Şoför adı/telefonu/adresi YAZILMAZ (kural 7).
  'order.transfer.requestTitle': 'Sipariş devri · {label}',
  'order.transfer.requestTitleBare': 'Sipariş devri',
  'order.transfer.reasonRequired': 'Devir gerekçesi zorunlu.',
  'order.transfer.reasonTooShort': 'Devir gerekçesi en az 3 karakter olmalı.',
  'order.transfer.reasonTooLong': 'Devir gerekçesi en fazla 300 karakter olmalı.',
  'order.transfer.targetSameVehicle': 'Hedef araç şoförün kendi aracı olamaz.',
  'order.transfer.targetInactive': 'Hedef araç pasif; devir yapılamaz.',
  'order.transfer.targetRequired': 'Devir için hedef araç seçin.',
  'order.transfer.orderNotTransferable':
    'Bu sipariş devredilemez (teslim edilmiş, iptal ya da panelde kapatılmış).',
  'order.transfer.stale':
    'Sipariş bu arada başka bir işlemle değişti; bu talep onaylanamaz, reddedin.',
  'order.transfer.approvalNotFound': 'Devir talebi bulunamadı ya da karara bağlanmış.',
  'order.transfer.alreadyDecided': 'Bu devir talebi zaten karara bağlanmış.',
  'order.transfer.rejectNoteRequired': 'Ret gerekçesi zorunlu.',
  // Patron bildirimleri — yöneticilere gider, kişisel veri taşımaz (kural 7).
  'notification.transferRequest.title': 'Sipariş devri talebi · {label}',
  'notification.transferRequest.titleBare': 'Sipariş devri talebi',
  'notification.transferRequest.body': 'Bu sipariş için devir talebi açıldı.',
  'notification.transferDecided.title': 'Sipariş devri kararı · {label}',
  'notification.transferDecided.titleBare': 'Sipariş devri kararı',
  'notification.transferDecided.approvedBody': '{toPlate} plakalı araca devredildi.',
  'notification.transferDecided.rejectedBody': 'Devir talebi reddedildi.',
  // Defter olay metni — sipariş zaman çizelgesi panelinde okunur.
  'orderEvent.TRANSFERRED': 'Devredildi',
  // ── Paket P2: kapı sonucu fotoğraf kanıtı + sapma kararı ──
  // Şoförün teslimat sonrası çektiği fotoğraf + patron/menajer incelemesi.
  // Dosya UPLOAD_DIR altında; 90 gün sonra süpürülür (satır kalır).
  'deliveryPhoto.notFound': 'Fotoğraf kaydı bulunamadı.',
  'deliveryPhoto.notJpeg': 'Yalnız JPEG kabul edilir.',
  'deliveryPhoto.tooLarge': 'Fotoğraf 1,6 MB üstünde olamaz.',
  'deliveryPhoto.tripVoided': 'İptal edilen sefere fotoğraf yüklenemez.',
  'deliveryPhoto.tooMany': 'Bu teslimat için en fazla 4 fotoğraf yüklenebilir.',
  'deliveryPhoto.notUploader': 'Bu fotoğrafı yükleyen kişi değilsiniz.',
  'deliveryPhoto.deliveryNotFound': 'Teslimat kaydı bulunamadı.',
  'delivery.orderChanged': 'Sipariş bu sırada değişti (iptal ya da devir); listeyi yenileyin.',
  'kvkk.anonymizedText': 'Anonimleştirildi',
  'deliveryPhoto.clientIdConflict': 'Bu istemci anahtarı başka bir fotoğraf için kullanılmış.',
  'deliveryPhoto.purged': 'Fotoğraf saklama süresi doldu.',
  'deviation.approvalNotFound': 'Sapma kaydı bulunamadı.',
  'deviation.rejectNoteRequired': 'Red için en az 10 karakter açıklama zorunlu.',
  'deviation.floatCorrectionRange': 'Düzeltme tutarı sıfırdan büyük ve en çok {d} olabilir.',
  'deviation.alreadyDecided': 'Bu sapma kaydı zaten karara bağlanmış.',
  'deviation.floatCorrectionInvalid': 'Düzeltme tutarı geçersiz.',
  'notification.deviationReviewed.title': 'Sapma incelendi',
  'notification.deviationReviewed.body': 'Teslimat sapması incelendi olarak işaretlendi.',
  'notification.deviationRejected.title': 'Sapma reddedildi',
  'notification.deviationRejected.body': 'Teslimat sapması reddedildi.',
  // ── P3 kapı sonucu: sipariş beklentisi (kapı sonucu tasarımı §2.1) ──
  // Şoför kapıda kaç boş beklediğini gösterir; panel patron için öneri gösterir ve türetilen
  // `quotedTotal` (ürün + beklenen depozito) ile birlikte döner.
  'order.expected.emptyLabel': 'Beklenen boş',
  'order.expected.foreignLabel': 'Yabancı boş',
  'order.expected.foreignBrandLabel': 'Yabancı marka',
  'order.expected.suggestion': 'Müşterinin açık zimmeti: {n}',
  'order.expected.suggestionNone': 'Açık zimmet yok, öneri 0.',
  'order.expected.depositLine': 'Beklenen depozito: {amount}',
  'order.expected.quotedLine': 'Söylenen toplam: {amount}',
  'order.expected.locked': 'Teslim/iptal edilmiş siparişte beklenti alanları düzenlenemez.',
  'order.expected.brandForbiddenWithoutForeign':
    'Yabancı marka yalnız yabancı boş > 0 iken verilebilir.',
  'order.expected.invalidRange': 'Beklenen boş 0..{n} aralığında olmalı (sipariş damacana adedi).',
  'order.expected.foreignNeedsTotal': 'Yabancı boş girildiyse toplam beklenen boş da girilmeli.',
  'order.expected.foreignExceedsTotal': 'Yabancı boş toplam beklenenden büyük olamaz.',
  // ── P3 kapı sonucu: müşteri zimmet geçmişi (§3.6) ──
  'orderEvent.PAYMENT_CHANGED': 'Ödeme türü değişti',
  'newOrder.payment.onlineNote': 'Ödeme alındı olarak işaretlenir, şoför ödeme sormaz.',
  'orderEvent.CUSTOMER_LINKED': 'Müşteri bağlandı',
  'orderEvent.DELIVERY_ADDRESS_OVERRIDE': 'Farklı adrese teslim',
  'newOrder.otherAddress.toggle': 'Farklı adrese teslim',
  'newOrder.otherAddress.hint':
    'Yalnız bu sipariş için geçerli; müşterinin kayıtlı adresi değişmez.',
  'newOrder.otherAddress.label': 'Teslim adresi',
  'newOrder.otherAddress.required': 'Teslim adresi en az 3 karakter olmalı.',
  'orderEvent.EXPECTED_EMPTY': 'Beklenen boş güncellendi',
  'customer.depositHistory.title': 'Zimmet hareketleri',
  'customer.depositHistory.empty': 'Bu müşterinin zimmet hareketi yok.',
  // ── P3 kapı sonucu: rapor (§3.6) ──
  'rep.doorOutcomes.title': 'Kapı sonuçları',
  'rep.doorOutcomes.colDriver': 'Şoför',
  'rep.doorOutcomes.colDeliveries': 'Teslimat',
  'rep.doorOutcomes.colShort': 'Kısa boş',
  'rep.doorOutcomes.colRejected': 'Reddedilen boş',
  'rep.doorOutcomes.colForeignAccepted': 'Yabancı kabul',
  'rep.doorOutcomes.colDepositLeft': 'Zimmette',
  'rep.doorOutcomes.colDepositCollected': 'Tahsil edilen depozito',
  'rep.doorOutcomes.colReject': 'Red kararı',
  'rep.doorOutcomes.colDeviationRate': 'Sapma oranı',
  'rep.doorOutcomes.colFlag': 'Bayrak',
  'rep.doorOutcomes.fleetAverage': 'Filo ortalaması',
  'rep.doorOutcomes.alertFlag': 'Filonun {n}× üstünde',
  'rep.doorOutcomes.minDeliveries': 'En az {n} teslimat',
  // ── UX-C: patron özeti (blok sonu) ──
  'rep.ownerTitle': 'Patron özeti',
  'rep.ownerIntro':
    'Bugün, bu hafta ve bu ay için ana rakamlar. Aşağıdaki ayrıntılı rapor 7 gün, 30 gün ve bu ay seçicisini kullanır.',
  'rep.ownerRevenue': 'Ciro',
  'rep.ownerRevenueNote': 'Bizim araçlar {ours} · bayi panelleri {panel}',
  'rep.ownerJugs': 'Satılan damacana',
  'rep.ownerJugsNote': '{n} teslimat',
  'rep.ownerCollections': 'Nakit tahsilat',
  'rep.ownerCollectionsNote': 'Kart {card} · online {online} · veresiye {credit}',
  'rep.ownerCollectionsHint':
    'Tahsilat yalnız bizim araçlarla yapılan teslimatlardır; bayi panelinde kapanan siparişin parası kasamıza girmez.',
  'rep.ownerEmpties': 'Alınan boş damacana',
  'rep.ownerEmptiesNote': 'Bizim marka {own} · yabancı marka {foreign}',
  'rep.ownerDeposit': 'Müşterilerdeki zimmet',
  'rep.ownerDepositNote': '{jugs} damacana · {money} depozito · {n} müşteri',
  'rep.ownerDepositHint': 'Dönemden bağımsız, şu anki durumdur.',
  'rep.ownerSources': 'Hangi kaynaktan ne kadar',
  'rep.ownerStaff': 'Personel sıralaması',
  'rep.ownerStaffHint':
    'Teslimat sayısına göre ilk 10 kişi; nakit, şoförün sahada tahsil ettiği tutardır.',
  'rep.ownerColSource': 'Kaynak',
  'rep.ownerColCount': 'Teslim',
  'rep.ownerColRevenue': 'Ciro',
  'rep.ownerColShare': 'Pay',
  'rep.ownerColStaff': 'Personel',
  'rep.ownerColJugs': 'Damacana',
  'rep.ownerColCash': 'Nakit',
  'rep.ownerEmpty': 'Bu dönemde kayıt yok.',
  'rep.ownerLoadError': 'Patron özeti okunamadı.',
  'rep.ownerCsv': 'Özeti indir (CSV)',
  'rep.ownerCsvHint': 'Seçili dönemin özetini Excel için indirir.',
  'rep.ownerSrc.MANUAL': 'Telefon / elle giriş',
  'rep.ownerSrc.GETIR_SU': 'Getir',
  'rep.ownerSrc.HAYAT_PANEL': 'Hayat',
  'rep.ownerSrc.ABANT_PANEL': 'Abant',


  // Panel ataması (panel-assign)
  'panelAssign.tabAbant': 'Abant',
  'panelAssign.tabHayat': 'Hayat',
  'panelAssign.infoNote':
    'Atamalar yalnız bu panelde yapılır; şu an Hayat ve Abant paneline gönderilmez.',
  'panelAssign.sectionMapping': 'Numara → Şoför',
  'panelAssign.sectionOrders': 'Bekleyen siparişler',
  'panelAssign.noLabels': 'Henüz etiket yok.',
  'panelAssign.noOrders': 'Bekleyen panel siparişi yok.',
  'panelAssign.noMapping': '— eşleme yok —',
  'panelAssign.noVehicle': 'Araç yok',
  'panelAssign.tripOpen': 'açık sefer var',
  'panelAssign.pendingCount': '{n} bekliyor',
  'panelAssign.saveMap': 'Eşlemeyi kaydet',
  'panelAssign.assignableCount': '{n} atanabilir sipariş',
  'panelAssign.selectAll': 'Tümünü seç',
  'panelAssign.deselectAll': 'Seçimi kaldır',
  'panelAssign.applySelected': 'Seçilenleri ata ({n})',
  'panelAssign.applyAll': 'Hepsini ata ({n})',
  'panelAssign.applyConfirmTitle': 'Atamayı onaylıyor musunuz?',
  'panelAssign.applyConfirmBody': '{n} sipariş şoförlere atanacak.',
  'panelAssign.applyConfirmOk': 'Onayla',
  'panelAssign.resultSummary': '{assigned} sipariş atandı, {skipped} sipariş atlandı.',
  'panelAssign.skippedLabel': 'atlandı',
  'panelAssign.loadError': 'Liste yüklenemedi.',
  'panelAssign.retry': 'Tekrar dene',
  'panelAssign.reason.NO_LABEL': 'Bu sipariş numarası tanımsız.',
  'panelAssign.reason.UNMAPPED': 'Bu numara bir şoföre eşlenmemiş.',
  'panelAssign.reason.NO_VEHICLE': 'Şoföre eşleşen araç yok.',
  'panelAssign.reason.DRIVER_INACTIVE': 'Şoför pasif.',
  'panelAssign.reason.VEHICLE_BUSY': 'Aracı şu an başka bir şoförün seferinde.',
  'panelAssign.reason.STALE_TRIP': 'Aracın açık seferi bayat (eski güne ait); önce seferi kapat.',
  'panelAssign.reason.CONFLICT': 'Sipariş bulunamadı ya da aynı anda başka bir işlem yapıldı.',
  'panelAssign.reason.SOURCE_MISMATCH': 'Bu sipariş bu sekmeye ait değil.',
  'panelAssign.reason.NOT_ACTIVE': 'Sipariş artık bekleyen durumda değil (zaten atanmış olabilir).',
  'panelAssign.reason.ERROR': 'Atanamadı, tekrar deneyin.',
  // A1 (SA): Abant eşleme tablosu salt "etiket → şoför" + bugünkü araç; Hayat yalnız okunur "etiket = plaka".
  'panelAssign.colVehicleToday': 'Bugünkü araç',
  'panelAssign.sectionHayat': 'Etiket → plaka',
  'panelAssign.hayatHint':
    'Hayat etiketleri plakaya göre eşlenir; bu bölümde eşleme girişi yoktur.',
  'panelAssign.notPlate': 'plaka değil',
  'panelAssign.aliasBadge': 'geçiş takma adı → {plate}',
  'panelAssign.viaPlate': 'etiket = plaka',
  'panelAssign.rematchFailed':
    'Eşleme kaydedildi ancak bekleyen siparişler yeniden dağıtılamadı. Bölgeler ekranındaki "Bekleyen siparişleri yeniden dağıt" düğmesiyle deneyin.',
  'panelAssign.readOnlyNote': 'Siparişler bu ekranda yalnız listelenir; atamayı motor yapar.',
  // Bugün kartı (Araçlar): günün şoförü = görevlendirme (day-assignments).
  'dayRoster.title': 'Bugünün araç ve şoförleri',
  'dayRoster.hint':
    'Bir aracın günün şoförünü buradan seçersiniz. Sefer ya da görevlendirme varsa o kaynak önce gelir.',
  'dayRoster.tabToday': 'Bugün',
  'dayRoster.tabTomorrow': 'Yarın',
  'dayRoster.colVehicle': 'Araç',
  'dayRoster.colDriver': 'Günün şoförü',
  'dayRoster.noDriverOption': '— Şoför yok —',
  'dayRoster.noVehicles': 'Aktif araç yok.',
  'dayRoster.backups': 'Yedekler',
  'dayRoster.noBackups': 'Yedek şoför yok.',
  'dayRoster.lostDrivers': 'Aracını yarına bırakan şoförler: {names}',
  'dayRoster.fromTomorrow': 'Yarın satırı',
  'dayRoster.readOnly': 'Bu gün salt okunur.',
  'dayRoster.rematchFailed':
    'Görevlendirme kaydedildi ancak bekleyen siparişler yeniden dağıtılamadı. Bölgeler ekranındaki "Bekleyen siparişleri yeniden dağıt" düğmesiyle deneyin.',
  'dayRoster.loadError': 'Günün görevlendirmeleri yüklenemedi.',
  'dayRoster.restoreFailed': 'Eski görevlendirme geri yazılamadı; aracı elle atayın.',
  'dayRoster.saved': '{plate} için günün şoförü kaydedildi.',
  'dayRoster.cleared': '{plate} için günün şoförü kaldırıldı.',
  // Mahalle takma adları (Bölgeler): panel adı → gerçek mahalle. Yalnız patron yazar.
  'alias.title': 'Mahalle takma adları',
  'alias.hint':
    'Panelin kısa adını (ör. BAYSAL) gerçek mahalleye bağlar. Yalnız patron değiştirebilir.',
  'alias.key': 'Panel adı',
  'alias.keyPlaceholder': 'Örn. BAYSAL',
  'alias.target': 'Mahalle',
  'alias.add': 'Takma ad ekle',
  'alias.save': 'Takma adları kaydet',
  'alias.saved': 'Mahalle takma adları kaydedildi.',
  'alias.delete': 'Sil',
  'alias.empty': 'Takma ad tanımlı değil.',
  'alias.noTargets': 'Hedef seçmek için önce bir bölgeye mahalle ekleyin.',
  'alias.keyRequired': 'Panel adı ve mahalle seçilmeli.',
  'alias.duplicateKey': 'Bu panel adı zaten tanımlı.',
  'alias.readOnly': 'Yalnız patron değiştirebilir; burada yalnız görüntülenir.',
  'alias.warning': 'Kişi adı ya da adres yazmayın; yalnız mahalle yazımı.',
  // Gerekçe rozeti (sipariş listesi ve detay) kanıt metinleri.
  'assign.evidence.labelPlate': 'Panel etiketi → {plate}',
  'assign.evidence.labelOnly': 'Panel etiketi',
  'assign.evidence.history': 'geçmiş: {place} · {plate} · {ratio}',

  // Nav
  'nav.panelAssign': 'Panel ataması',

  // ── Bildirim sistemi (P0 sözleşmesi — 12.10.2026) ──
  // Şema/migration ana oturum tarafından hazır. Olay metinleri: kişisel veri yok
  // (bölge adı, plaka, ürün×adet, tutar, sipariş no serbest).

  // Stok olayları (yöneticilere)
  'notification.stock.shipmentReceivedTitle': 'Fabrika sevkiyatı işlendi',
  'notification.stock.shipmentReceivedBody': '{full} dolu girdi · {empty} boş çıktı · {brand}',
  'notification.stock.adjustedTitle': 'Stok düzeltmesi',
  'notification.stock.adjustedBodyIncrease': '{product} · {qty} eklendi',
  'notification.stock.adjustedBodyDecrease': '{product} · {qty} düşüldü',
  'notification.stock.foreignReceivedTitle': 'Yabancı marka boş kabul edildi',
  'notification.stock.foreignReceivedBody': '{qty} adet · {brand}',
  'notification.stock.foreignSettledTitle': 'Yabancı marka boş kapatıldı',
  'notification.stock.foreignSettledBody': '{qty} adet · {brand}',

  // Sefer olayları (yöneticilere)
  'notification.trip.loadedTitle': 'Araç yüklendi · {plate}',
  'notification.trip.loadedBody': '{qty} dolu damacana yüklendi',
  'notification.trip.closedTitle': 'Sefer kapandı · {plate}',
  'notification.trip.closedBody': 'Fark yok',
  // P7: Şoför devri. Gövdede kişisel veri yok (kural 7): plaka ve "devredildi" yeter.
  'notification.trip.reassignedTitle': 'Sefer devredildi · {plate}',
  'notification.trip.reassignedToBody': 'Sefer bu aracın sorumluluğuna geçti.',
  'notification.trip.lateRecordTitle': 'Eski şoförden geç kayıt · {plate}',
  'notification.trip.lateRecordBody': 'Devirden önce yazılmış bir kayıt sefere işlendi.',
  'notification.trip.reassignedFromBody': 'Sefer başka şoföre devredildi.',
  // Düşen mükerrer teslim: nakit izi. Gövdede kişisel veri yok (kural 7): yalnız adet ve tutar.
  'notification.delivery.droppedDuplicateTitle': 'Mükerrer teslim düştü · {plate}',
  'notification.delivery.droppedDuplicateBody':
    'Sipariş zaten teslim edilmişti; bu kayıt reddedildi. Dolu {sold}, boş {empty}, tahsilat {amount}. Şoförden tahsil edilen parayı teyit edin.',
  'notification.trip.lateRecordRejectedTitle': 'Eski şoförün geç kaydı reddedildi · {plate}',
  'notification.trip.lateRecordRejectedBody':
    'Devir sonrası gelen kayıt {time} itibarıyla reddedildi; şoförle teyit edin.',

  // Sipariş olayları (şoföre)
  'notification.order.assignedTitle': 'Yeni sipariş · {plate}',
  'notification.order.assignedBody': '{items} · {total}',
  'notification.order.unassignedTitle': 'Sipariş başka araca aktarıldı',
  'notification.order.unassignedBody': 'Bu sipariş artık senin seferinde değil.',
  'orders.worklistHistory.invalidDay': 'Geçersiz gün: bugünden en fazla 30 gün geri',
  'notification.order.unstaffedTitle': 'Araçta şoför yok',
  'notification.order.unstaffedBody': '{plate} aracına sipariş atandı ama şoförü yok.',
  'notification.order.cancelledTitle': 'Sipariş iptal edildi',
  'notification.order.cancelledBody': 'Sipariş iptal edildi; listeden kaldırıldı.',
  'notification.order.closedExternallyTitle': 'Sipariş panelden kapatıldı',
  'notification.order.closedExternallyBody': 'Bu sipariş marka panelinde kapatıldı.',

  // Ara yükleme (şoföre)
  'notification.reload.approvedTitle': 'Ara yükleme onaylandı · {plate}',
  'notification.reload.approvedBody': '{qty} damacana · onaylandı',
  'notification.reload.rejectedTitle': 'Ara yükleme reddedildi · {plate}',
  'notification.reload.rejectedBody': 'Ara yükleme reddedildi.',

  // Nakit teslimi (şoföre)
  'notification.cash.handoverConfirmedTitle': 'Nakit teslimin alındı · {plate}',
  'notification.cash.handoverConfirmedBody': 'Nakit kasaya işlendi.',

  // Sessiz saat sabah özeti (N1; kişisel veri yok, yalnız kategori sayıları)
  'notification.digest.morning.title': 'Gece boyunca {count} bildirim birikti',
  'notification.digest.morning.body': 'Sessiz saatte biriken: {parts}.',
  'notification.digest.part': '{n} {label}',
  'notification.digest.category.order': 'sipariş',
  'notification.digest.category.approval': 'onay',
  'notification.digest.category.stock': 'stok',
  'notification.digest.category.trip': 'sefer',
  'notification.digest.category.cash': 'kasa',
  'notification.digest.category.report': 'rapor',
  'notification.digest.category.staff': 'personel',
  'notification.digest.category.system': 'sistem',

  // Günlük rapor (yöneticilere)
  'notification.dailyReport.title': 'Günlük rapor hazır · {day}',
  'notification.dailyReport.body': '{revenue} ciro · {deliveries} teslimat · {jugs} damacana',
  'notification.dailyReport.reorderLine':
    'Depo azalıyor: günlük ortalama {avg}, eşik {threshold} ({days} gün) — sevkiyat iste',
  // O6: 19:00 günlük rapora şoför satırı. `{name}` şoför adıdır (alıcı: günlük rapor OWNER+MANAGER, haftalık karne yalnız OWNER; KVKK
  // spec'inde bu üç anahtara (driverLine, driverLineWarn, weeklyScorecard.line) dar istisna var). Hareketsiz şoför yazılmaz; farklı sefer > 0 ise `driverLineWarn`.
  // `{payments}` = `payments*` anahtarlarından: N nakit, K kart+online, V veresiye (yalnız > 0 ise).
  'notification.dailyReport.driverLine':
    '{name} · {delivered} teslim · {totalMoney} ({payments}) · {carriedOver} devreden · {empty} boş · {variance}',
  'notification.dailyReport.driverLineWarn':
    '⚠ {name} · {delivered} teslim · {totalMoney} ({payments}) · {carriedOver} devreden · {empty} boş · {variance}',
  'notification.dailyReport.payments': 'N {cash} / K {card}',
  'notification.dailyReport.paymentsCredit': 'N {cash} / K {card} / V {credit}',
  'notification.dailyReport.varianceTrips': 'farklı sefer {n}',
  'notification.dailyReport.openTrip': 'açık sefer',
  // Elle bağlanan kanal oturumu (Getir). Kaynak adı kısaltması — "Getir oturumu ...".
  'channelSession.source.HAYAT_PANEL': 'Hayat Su',
  'channelSession.source.ABANT_PANEL': 'Abant Su',
  'channelSession.source.GETIR_SU': 'Getir',
  // 19:00 günlük rapor satırı (oturum bitiyor / kapalı).
  'notification.dailyReport.sessionExpiring': '{source} oturumu bitiş: {time}',
  'notification.dailyReport.sessionClosed': '{source} oturumu kapalı — siparişler çekilmiyor',
  // Oturum uyarı bildirimi (yöneticilere, CRITICAL).
  'notification.channelSession.expiringTitle': '{source} oturumu bitiyor',
  'notification.channelSession.expiringBody':
    '{source} oturumu bitiş: {time}. Süre dolunca siparişler çekilmez — yeniden giriş yap.',
  'notification.channelSession.expiredTitle': '{source} oturumu kapandı',
  'notification.channelSession.expiredBody':
    '{source} oturumunun süresi doldu — siparişler çekilmiyor. Yeniden giriş yap.',
  // Panel şeridi (her sayfada üstte; kapatma düğmesi YOK).
  'panel.channelSession.expiring': '{source} oturumu {time} bitiyor',
  'panel.channelSession.unbound': '{source} oturumu kapalı — siparişler çekilmiyor',
  'panel.channelSession.relogin': 'Yeniden gir',
  // O6: Pazartesi 08:00 haftalık karne (OWNER'a). `delta` "+%12" / "-%8" gibi önceden biçimli;
  // `weeklyScorecard.empty` hafta boyunca teslimat yoksa gösterilir.
  'notification.weeklyScorecard.title': 'Haftalık karne',
  'notification.weeklyScorecard.line':
    '{name} · {delivered} teslim · {revenue} · farklı sefer {varianceTrips} · {delta}',
  'notification.weeklyScorecard.empty': 'Geçen hafta teslimat yok.',
  // Günlük sağlık raporu 08:00 (yöneticilere). Yalnız sayı ve saat; hata metni gövdeye girmez.
  'notification.healthReport.title': 'Günlük sağlık raporu · {day}',
  'notification.healthReport.ok': 'Her şey yolunda',
  'notification.healthReport.issues': '{n} sorun var',
  'notification.healthReport.source.HAYAT_PANEL': 'Hayat',
  'notification.healthReport.source.ABANT_PANEL': 'Abant',
  'notification.healthReport.source.GETIR_SU': 'Getir',
  'notification.healthReport.source.LUCA': 'Luca',
  'notification.healthReport.source.MANUAL': 'Elle',
  'notification.healthReport.fetchLine':
    '{source}: {total} çekim · {failed} başarısız · son başarılı {last}',
  'notification.healthReport.fetchLineNoSuccess':
    '{source}: {total} çekim · {failed} başarısız · başarılı çekim yok',
  'notification.healthReport.fetchNone': '{source}: çekim yok',
  'notification.healthReport.fetchStopped': '{source}: durduruldu',
  'notification.healthReport.fetchEmpty': 'Entegrasyon: aktif bağlantı yok',
  'notification.healthReport.deadJobs':
    'Ölü işler: bildirim gönderimi {push} · panele yazma {write}',
  'notification.healthReport.backupOk': 'Yedek: {time} · {mb} MB',
  'notification.healthReport.backupMissing': 'Yedek bilgisi yok',
  'notification.healthReport.backupStale': 'Son yedek {hours} saatten eski',
  'notification.healthReport.backupFailed': 'Son yedek başarısız',
  'notification.healthReport.hostRestarted':
    'Sunucu son 24 saatte yeniden başladı: {time} (Türkiye saati)',
  'notification.healthReport.processRestarted':
    'API süreci son 24 saatte yeniden başladı: {time} (Türkiye saati)',
  // S6: Akşam depo sayımı hatırlatması (OWNER'a, günde TEK bildirim; sayım varsa yazılmaz).
  'notification.depotCountReminder.title': 'Depo sayımı yapılmadı',
  'notification.depotCountReminder.body':
    'Bugün ({day}) depo sayımı yapılmadı. Sayım yapılmazsa gün kör sayılır.',

  // ── Mobil: rapor ekranı (P4) ──
  'mobile.report.title': 'Günlük rapor',
  'mobile.report.prevDay': 'Önceki gün',
  'mobile.report.nextDay': 'Sonraki gün',
  'mobile.report.dayPicker': 'Tarih seç',
  'mobile.report.card.revenue': 'Ciro',
  'mobile.report.card.deliveries': 'Teslimat',
  'mobile.report.card.jugs': 'Damacana',
  'mobile.report.card.customers': 'Müşteri',
  'mobile.report.card.foreign': 'Yabancı marka',
  'mobile.report.card.collections': 'Tahsilat',
  'mobile.report.card.trips': 'Seferler',
  'mobile.report.jugBreakdown': 'Ürün bazında',
  'mobile.report.foreignBreakdown': 'Marka bazında',
  'mobile.report.productSplit': 'Bizim {ours} · Panel {panel} · Toplam {total}',
  'mobile.report.error': 'Rapor yüklenemedi.',
  'mobile.report.summaryEntry': 'Günlük rapor',
  'mobile.report.card.ours': 'Bizim',
  'mobile.report.card.panel': 'Panel',
  'mobile.report.customerServed': 'Teslim alan',
  'mobile.report.customerNew': 'Yeni',
  'mobile.report.customerActive': 'Aktif',
  'mobile.report.foreignReceived': 'Alınan',
  'mobile.report.foreignOnShelf': 'Raftaki',
  'mobile.report.collection.cash': 'Nakit',
  'mobile.report.collection.card': 'Kart',
  'mobile.report.collection.online': 'Online',
  'mobile.report.collection.credit': 'Veresiye',
  'mobile.report.collection.deposit': 'Depozito',
  'mobile.report.collection.customerPayment': 'Müşteri tahsilatı',
  'mobile.report.collection.handover': 'Şoför teslim',
  'mobile.report.collection.expenses': 'Giderler',
  'mobile.report.collection.drawer': 'Kasa',
  'mobile.report.tripOpen': 'Açık',
  'mobile.report.tripClosed': 'Kapalı',
  'mobile.report.tripWithVariance': 'Farkla',
  'mobile.report.tripVoided': 'İptal',

  // ── Mobil: bildirimler ekranı (P4) ──
  'mobile.notifications.title': 'Bildirimler',
  'mobile.notifications.empty': 'Bildirim yok.',
  'mobile.notifications.markAllRead': 'Tümünü okundu işaretle',
  'mobile.notifications.filter.all': 'Tümü',
  'mobile.notifications.filter.order': 'Sipariş',
  'mobile.notifications.filter.reload': 'Yükleme',
  'mobile.notifications.filter.cash': 'Nakit',
  'mobile.notifications.summary': '{n} yeni bildirim',
  'mobile.notifications.dailyReportTitle': 'Günlük rapor hazır',
  'mobile.notifications.dailyReportBody': 'Günün özetini görmek için dokunun.',

  // Personel defteri (P1 API) — şoför kendi uçlarında ve patron DRIVER hariç uçlarda.
  // Tüm mesajlar şoförün ekranına ve patron ekranına çıkar; arka arkaya iki yerde aynı anahtar.
  'ledger.rangeTooWide': 'Aralık en fazla {n} gün olabilir.',
  'ledger.tooOld':
    'Bu deftere yalnız son {n} gün içinden bakabilirsin. Daha eski tarihi yalnız patron görebilir.',
  'ledger.noDriver': 'Bu hesaba bağlı bir şoför kaydı bulunamadı.',

  // Mobil: personel defteri sekmesi ve ekranları (P2 tasarımı).
  // Şoförün kendi geçmişi ("Defterim") ve patronun şoför-bazlı görünümü paylaşılan anahtarları kullanır.
  'mobile.tab.ledger': 'Defter',
  'mobile.ledger.title': 'Defterim',
  'mobile.ledger.ownerTitle': 'Şoför defteri',
  'mobile.ledger.range': 'Tarih aralığı',
  'mobile.ledger.rangeToday': 'Bugün',
  'mobile.ledger.rangeLast7': 'Son 7 gün',
  'mobile.ledger.rangeLast30': 'Son 30 gün',
  'mobile.ledger.rangeCustom': 'Özel aralık',
  'mobile.ledger.total': 'Toplam',
  'mobile.ledger.trips': 'Sefer sayısı',
  'mobile.ledger.delivered': 'Teslimat',
  'mobile.ledger.failed': 'Teslim edilemeyen',
  'mobile.ledger.carriedOver': 'Devrettiğim sipariş',
  'mobile.ledger.cases': 'Satılan koli',
  'mobile.ledger.empties': 'Alınan boş',
  'mobile.ledger.collected': 'Tahsilat',
  'mobile.ledger.cash': 'Nakit',
  'mobile.ledger.card': 'Kart',
  'mobile.ledger.online': 'Online',
  'mobile.ledger.credit': 'Veresiye',
  'mobile.ledger.deposit': 'Depozito',
  'mobile.ledger.floatCard': 'Üstündeki nakit',
  'mobile.ledger.floatOpening': 'Açılış',
  'mobile.ledger.floatCollection': 'Tahsilat',
  'mobile.ledger.floatHandover': 'Teslim',
  'mobile.ledger.floatExpense': 'Gider',
  'mobile.ledger.floatOther': 'Diğer',
  'mobile.ledger.floatClosing': 'Kapanış',
  'mobile.ledger.workCard': 'Günlük iş',
  'mobile.ledger.floatHint':
    'Üstündeki nakit: günlük tahsilat, teslim ve düzeltmelerin toplam bakiyesi.',
  'mobile.ledger.variance': 'Fark var',
  'mobile.ledger.empty': 'Henüz kayıt yok',

  // Mobil: şoför gün sonu karnesi (adım 7). YALNIZ sayı gösterilir; tutarlar
  // defter sekmesindedir. Şoförün kendi defterinden okur (patron uçları kullanılmaz).
  'mobile.scorecard.title': 'Karnem',
  'mobile.scorecard.today': 'Bugün',
  'mobile.scorecard.week': 'Bu hafta',
  'mobile.scorecard.delivered': 'Teslim',
  'mobile.scorecard.failed': 'Teslim edilemedi',
  'mobile.scorecard.jugsSold': 'Satılan damacana',
  'mobile.scorecard.empties': 'Alınan boş',
  'mobile.scorecard.openLedger': "Defterim'de aç",
  'mobile.scorecard.pendingNote':
    'Gönderilmeyi bekleyen kayıtlar karneye henüz dahil değil; bağlantı gelince güncellenir.',

  // Cihaz eşleştirme — patron bildirimleri ve mobil bekleme ekranı
  'device.pairingRequestedTitle': 'Yeni telefon onay bekliyor',
  'device.pairingRequestedBody':
    '{plate} plakasıyla giriş istendi. Kodu şoförün telefonundan alıp Cihazlar ekranında onayla.',
  'device.pairingNotFound':
    'Kod bulunamadı ya da süresi doldu. Şoför telefonunda yeni kodu görsün.',
  'device.driverNotFound': 'Şoför bulunamadı ya da pasif.',
  'device.alreadyDecided': 'Bu telefon için karar zaten verilmiş.',
  'device.takeoverTitle': '{plate} için devir isteği',
  'device.takeoverBody': '{driver} bu araçla girmek istiyor; araçta başka şoförün açık seferi var.',
  'device.vehicleChangedTitle': 'Şoför araç değiştirdi',
  'device.vehicleChangedBody': '{driver}, {plate} aracıyla giriş yaptı.',
  'mobile.device.pairTitle': 'Bu telefon henüz onaylı değil',
  'mobile.device.pairBody':
    'Aşağıdaki kodu patrona göster. Patron Cihazlar ekranından onaylayınca otomatik giriş yapacaksın.',
  'mobile.device.pairExpiresIn': 'Kod {minutes} dk geçerli',
  'mobile.device.pairExpired': 'Kodun süresi doldu.',
  'mobile.device.pairNewCode': 'Yeni kod al',
  'mobile.device.pairCancel': 'Vazgeç',
  'mobile.device.waiting': 'Onay bekleniyor…',
  'mobile.device.revokedTitle': 'Telefonun onayı kaldırıldı',
  // P1 (telefon girişi + tek cihaz kilidi, 21.10.2026)
  'auth.invalidPhone': 'Numara tanınmadı. Telefonunun son 4 hanesini kontrol et.',
  'auth.loginLocked': 'Çok fazla hatalı deneme. Biraz sonra tekrar dene.',
  'auth.deviceInUse':
    'Bu personelin onaylı başka bir telefonu var. Patron eski telefonu iptal etmeli.',
  'device.driverMismatch': 'Bu kod başka bir personel için istendi. Doğru personeli seçin.',
  'device.driverRequired': 'Bu telefon için personel seçilmeli.',
  'device.ownerProfileNotAllowed': 'Patron profiline telefon onayı verilemez.',
  'device.phonePairingRequestedBody':
    '{name} yeni telefondan giriş istedi. Kodu şoförün telefonundan alıp Cihazlar ekranında onayla.',
  'device.loginLockedTitle': 'Telefon kilitlendi: çok fazla hatalı deneme',
  'device.loginLockedBody': '{name} için hatalı deneme sınırı aşıldı; telefon 15 dakika kilitli.',
  'device.loginUnlockedTitle': 'Telefonun kilidi kaldırıldı',
  'device.loginUnlockedBody': '{name} için telefon kilidini {actor} kaldırdı.',
  'device.deviceInUseTitle': 'Onaylı telefonu olan personel yeni telefonla denedi',
  'device.deviceInUseBody':
    '{name} yeni bir telefondan giriş denedi. Yeni telefona geçecekse eskisini Cihazlar ekranında iptal et.',

  // Depo günü — MOBİL (akşam kör sayımı + sevkiyat teslim al; ADR 2026-10-21-depo-gunu).
  // Sayıların TAMAMI sunucudan gelir; bu metinler yalnız çerçeve, panel.* anahtarları kullanılmaz.
  'mobile.depot.entry': 'Depo sayımı',
  'mobile.depot.title': 'Depo günü',
  'mobile.depot.summaryTitle': 'Depo durumu',
  'mobile.depot.blindDay': 'Kör gün',
  'mobile.depot.blindDayHint':
    'Bugünün depo sayımı girilmedi; depo miktarı sayım girilene kadar gizli.',
  'mobile.depot.hidden': 'Sayım girilene kadar gizli',
  'mobile.depot.countedToday': 'Bugün sayım girildi',
  'mobile.depot.depotFull': 'Depoda dolu',
  'mobile.depot.depotEmpty': 'Depoda boş',
  'mobile.depot.depotCases': 'Depoda koli',
  'mobile.depot.customerDeposit': 'Müşteride zimmet',
  'mobile.depot.foreignOnShelf': 'Rafta yabancı boş',
  'mobile.depot.emptyToFactoryToday': 'Bugün fabrikaya giden boş',
  'mobile.depot.lastCount': 'Son depo sayımı: {at}, fark {diff}',
  'mobile.depot.noCount': 'Henüz sayım yok',
  'mobile.depot.reorderWarn': 'Sevkiyat iste',
  'mobile.depot.reorderDetail': 'Günlük ortalama {avg} damacana · eşik {threshold}',
  'mobile.depot.vehiclesTitle': 'Araçlar',
  'mobile.depot.vehicleStock': 'Dolu {full} · Boş {empty} · Koli {crates}',
  'mobile.depot.capacity': 'Kapasite {n}',
  'mobile.depot.freeSpace': 'Boş yer {n}',
  'mobile.depot.countOpen': 'Akşam sayımı',
  'mobile.depot.shipmentOpen': 'Sevkiyat teslim al',
  'mobile.depot.retry': 'Tekrar dene',
  'mobile.depot.count.title': 'Akşam sayımı',
  'mobile.depot.count.hint':
    'Depodaki damacanaları sayıp girin. Beklenen adet gösterilmez; fark kayıttan sonra görünür.',
  'mobile.depot.count.incomplete': 'Her ürün için dolu ve boş adedi tam sayı olarak girilmeli.',
  'mobile.depot.count.caseOnly': 'Koli boş dönmez',
  'mobile.depot.count.save': 'Sayımı kaydet',
  'mobile.depot.count.maybeSaved':
    'Bu sayım kaydedilmiş olabilir; depo özetini kontrol et. Sayılar kilitlendi.',
  'mobile.depot.count.saved': 'Sayım kaydedildi.',
  'mobile.depot.count.diffTitle': 'Beklenenden fark',
  'mobile.depot.count.diffRow': '{product} · {condition}: {diff}',
  'mobile.depot.count.noDiff': 'Fark yok.',
  'mobile.depot.count.movesTitle': 'Sayımdan bu yana hareketler',
  'mobile.depot.count.moveRow': '{plate} · {at} · {qty}',
  'mobile.depot.count.noActiveProducts': 'Aktif ürün yok. Önce ürün tanımlayın.',
  'mobile.depot.shipment.title': 'Sevkiyat teslim al',
  'mobile.depot.shipment.hint':
    'İrsaliye no zorunlu. Sayılan adet irsaliyeden farklıysa fark ayrı bir düzeltme satırı olarak yazılır.',
  'mobile.depot.shipment.product': 'Ürün',
  'mobile.depot.shipment.waybill': 'İrsaliye no',
  'mobile.depot.shipment.waybillFull': 'İrsaliyedeki dolu',
  'mobile.depot.shipment.waybillEmptyOut': 'İrsaliyedeki verilen boş',
  'mobile.depot.shipment.countedFull': 'Sayılan dolu (isteğe bağlı)',
  'mobile.depot.shipment.countedEmptyOut': 'Sayılan verilen boş (isteğe bağlı)',
  'mobile.depot.shipment.foreignTitle': 'Yabancı marka boş',
  'mobile.depot.shipment.foreignBrand': 'Marka',
  'mobile.depot.shipment.foreignAdd': 'Satır ekle',
  'mobile.depot.shipment.foreignMax': 'En fazla 10 satır.',
  'mobile.depot.shipment.waybillRequired': 'İrsaliye no girilmeden teslim alınamaz.',
  'mobile.depot.shipment.invalidQty': 'Adet tam sayı olmalı.',
  'mobile.depot.shipment.emptyBoth': 'Dolu ve boş adet birden sıfır olamaz.',
  'mobile.depot.shipment.save': 'Teslimi kaydet',
  'mobile.depot.shipment.confirmTitle': 'Sevkiyat teslim alınsın mı?',
  'mobile.depot.shipment.confirmBody':
    '{waybill} · {full} dolu · {empty} verilen boş. Bu kayıt deftere yazılır.',
  'mobile.depot.shipment.received': 'Sevkiyat teslim alındı.',
  'mobile.depot.shipment.adjustmentNote': 'Sayım farkı düzeltme olarak yazıldı.',
  'mobile.depot.shipment.adjustmentLine': 'Depo farkı: {condition} {qty}',
  'mobile.depot.shipment.noAdjustment':
    'Sayılan adetler irsaliyeyle uyumlu; fark satırı yazılmadı.',
  'mobile.depot.shipment.foreignReturned': 'Yabancı boş iade kaydı: {n}',
  'mobile.depot.shipment.maybeSaved':
    'Bu teslim zaten kaydedilmiş olabilir; depo özetini kontrol et.',

  // Patronun telefondan araca yükleme ekranı (seferi şoför açar, yüklemeyi patron yapar).
  'mobile.depot.load.open': 'Araca yükle',
  'mobile.depot.load.title': 'Araca yükleme',
  'mobile.depot.load.todayTitle': 'Bugün',
  'mobile.depot.load.todayDelivered': 'Teslim',
  'mobile.depot.load.todayShortfalls': 'Eksik boş',
  'mobile.depot.load.todayOpenVariance': 'Açık fark',
  'mobile.depot.load.vehicle': 'Araç',
  'mobile.depot.load.noTrip':
    'Yüklemeye açık sefer yok. Şoför seferi açınca araç burada görünür.',
  'mobile.depot.load.onVehicleNote':
    'Öneri, araçtaki toplam doluyu (kapanışta dönen artan dahil) düşer.',
  'mobile.depot.load.scopeAllDays': 'Tüm açık siparişler (ileri tarihli dahil)',
  'mobile.depot.load.capped': 'Öneri aracın boş yerine göre kısıldı.',
  'mobile.depot.load.planTitle': 'Önerilen yük',
  'mobile.depot.load.nothing': 'Bu araç için önerilen yük yok.',
  'mobile.depot.load.invalidQty': 'Adet 0 ile 400 arasında tam sayı olmalı.',
  'mobile.depot.load.submit': '{plate} aracına yükle',
  'mobile.depot.load.saved': 'Yükleme kaydedildi.',
  'mobile.depot.load.maybeSaved':
    'Yükleme yazılmış olabilir. Tekrar dene ya da güncel durumu yükle; adetler kilitli.',
  'mobile.depot.load.refresh': 'Güncel durumu yükle',

  // Patron canlı haritası (araç + açık sipariş + bölge poligonları).
  'mobile.ownerHome.map.ordersLine': 'Açık siparişler: {unassigned} atanmamış · {assigned} atanmış',
  'mobile.ownerHome.map.showingFirst':
    'İlk {shown} sipariş gösteriliyor ({total} açık sipariş var).',
  'mobile.ownerHome.map.notAssigned': 'Henüz araca atanmadı.',
  'mobile.ownerHome.map.vehiclePlate': 'Atandığı araç: {plate}',
  'mobile.ownerHome.map.regionLine': 'Bölge: {name}',
  'mobile.ownerHome.map.withTrip': 'Seferi var',
  'mobile.ownerHome.map.withoutTrip': 'Seferi yok',
  'mobile.ownerHome.map.nextStop': 'Sıradaki durak: {stop}',
  'mobile.ownerHome.map.pickVehicle': 'Araç seç ve ata',
  'mobile.ownerHome.map.assignTitle': 'Siparişi araca ata',
  'mobile.ownerHome.map.assignedTo': 'Sipariş {plate} aracına atandı.',
  'mobile.ownerHome.map.ordersUnavailable': 'Siparişler okunamadı; atama yapılamıyor.',
  // ── Mobil UX paketi (MX): "ne oldu + ne yap" hata metinleri, sade çipler ──
  'mobile.error.unauthorized': 'Oturumun kapandı. Yeniden giriş yap.',
  'mobile.error.forbidden': 'Bu işlem için yetkin yok. Patronuna haber ver.',
  'mobile.error.notFound': 'Kayıt bulunamadı. Listeyi yenileyip tekrar dene.',
  'mobile.error.validation': 'Bilgilerde eksik ya da hata var. Kontrol edip tekrar dene.',
  'mobile.error.conflict': 'Bu kayıt başka yerden değişmiş. Listeyi yenileyip tekrar dene.',
  'mobile.error.tooManyRequests': 'Çok fazla deneme oldu. Biraz bekleyip tekrar dene.',
  'mobile.error.serverUnavailable': 'Sunucuya şu an ulaşılamıyor. Biraz sonra tekrar dene.',
  'mobile.error.internal': 'Beklenmeyen bir sorun oldu. Tekrar dene; sürerse patronuna haber ver.',
  'mobile.error.upgradeRequired': 'Uygulamanın yeni sürümü gerekli. Güncelle, sonra devam et.',
  'mobile.delivery.sourceManual': 'Telefon',
  'mobile.ownerHome.devicesWaiting': '{n} cihaz onay bekliyor',
  'mobile.ownerHome.devicesApprove': 'Onayla',
  'mobile.close.varianceFull': '{n} dolu eksik',
  'mobile.close.varianceFullOver': '{n} dolu fazla',
  'mobile.close.varianceEmpty': '{n} boş eksik',
  'mobile.close.varianceEmptyOver': '{n} boş fazla',
  'mobile.close.varianceCase': '{n} koli fark',
  'mobile.close.varianceWrite': '{parts}: açıklama yaz',
  'mobile.delivery.claimedUndo': 'Üstlendin',
  'mobile.delivery.undo': 'Geri al',
  'mobile.delivery.busy': 'İşlem sürüyor, biraz sonra tekrar dene.',
  'mobile.delivery.unclaimDone': 'Sipariş geri bırakıldı.',
  'mobile.delivery.unclaimConflict': 'Sipariş artık geri bırakılamıyor.',

  // Depo günü (/depo, ADR 2026-10-21-depo-gunu). Sayılar sunucudan gelir; bu metinler yalnız çerçeve.
  'panel.depot.summaryTitle': 'Depo durumu',
  'panel.depot.blindDay': 'Kör gün',
  'panel.depot.blindDayHint':
    'Bugünün depo sayımı girilmedi; depo miktarı sayım girilene kadar gizli.',
  'panel.depot.hidden': 'Sayım girilene kadar gizli',
  'panel.depot.depotFull': 'Depoda dolu',
  'panel.depot.depotEmpty': 'Depoda boş',
  'panel.depot.depotCases': 'Depoda koli',
  'panel.depot.customerDeposit': 'Müşteride zimmet',
  'panel.depot.foreignOnShelf': 'Rafta yabancı boş',
  'panel.depot.emptyToFactoryToday': 'Bugün fabrikaya giden boş',
  'panel.depot.lastCount': 'Son depo sayımı: {at}, fark {diff}',
  'panel.depot.noCount': 'Henüz sayım yok',
  'panel.depot.reorderWarn': 'Sevkiyat iste',
  'panel.depot.reorderDetail': 'Günlük ortalama {avg} damacana · eşik {threshold}',
  'panel.depot.stepsLabel': 'Depo günü adımları',
  'panel.depot.step1': 'Akşam dolum',
  'panel.depot.step2': 'Sabah dağıtım',
  'panel.depot.step3': 'Ara yükleme',
  'panel.depot.step4': 'Sevkiyat',
  'panel.depot.vehicleStock': 'Dolu {full} · Boş {empty} · Koli {crates}',
  'panel.depot.capacity': 'Kapasite {n}',
  'panel.depot.noCapacity': 'Kapasite tanımlı değil',
  'panel.depot.freeSpace': 'Boş yer {n}',
  'panel.depot.overCapacity': 'Kapasite aşımı',
  'panel.depot.eveningCount': 'Akşam sayımı',
  'panel.depot.countTitle': 'Akşam sayımı',
  'panel.depot.countHint':
    'Depodaki damacanaları sayıp girin. Beklenen adet gösterilmez; fark kayıttan sonra görünür.',
  'panel.depot.countIncomplete': 'Her ürün için dolu ve boş adedi tam sayı olarak girilmeli.',
  'panel.depot.countSaved': 'Sayım kaydedildi.',
  'panel.depot.countDiffTitle': 'Beklenenden fark',
  'panel.depot.diffRow': '{product} · {condition}: {diff}',
  'panel.depot.noDiff': 'Fark yok.',
  'panel.depot.morningTitle': 'Araç başına sabah ihtiyacı',
  'panel.depot.needOk': '{plate}: {full} dolu · {needed} gerekli · yeter',
  'panel.depot.needShort':
    '{plate}: {full} dolu · {needed} gerekli · {short} eksik — ara yükleme öner',
  'panel.depot.needCrates': 'Koli ihtiyacı: {n}',
  'panel.depot.futureOrders': '{n} ileri tarihli sipariş (ihtiyaca katılmaz)',
  'panel.depot.toAssign': 'Atamaya git',
  'panel.depot.reloadAction': 'Ara yükleme aç',
  'panel.depot.reloadHint':
    'Açık seferi olan araca yazılır; kayıt onaylı işlenir ve şoföre bildirilir.',
  'panel.depot.reloadVehicle': 'Araç',
  'panel.depot.reloadDirection': 'Yön',
  'panel.depot.reloadAdd': 'Depodan araca',
  'panel.depot.reloadRemove': 'Araçtan depoya',
  'panel.depot.reloadNoTrip': 'Açık seferi olan araç yok.',
  'panel.depot.reloadNoLines': 'En az bir ürün adedi girin.',
  'panel.depot.reloadOpen': 'Ara yükleme ekle',
  'panel.depot.reloadTitle': 'Patron ara yüklemesi',
  'panel.depot.queueEmpty': 'Bekleyen ara yükleme yok.',
  'panel.depot.shipmentTitle': 'Sevkiyat teslim al',
  'panel.depot.shipmentHint':
    'İrsaliye no zorunlu. Sayılan adet irsaliyeden farklıysa fark ayrı bir düzeltme satırı olarak yazılır.',
  'panel.depot.shipmentOpen': 'Teslim al',
  'panel.depot.shipmentSave': 'Teslimi kaydet',
  'panel.depot.waybillRequired': 'İrsaliye no girilmeden teslim alınamaz.',
  'panel.depot.waybillFull': 'İrsaliyedeki dolu',
  'panel.depot.waybillEmptyOut': 'İrsaliyedeki verilen boş',
  'panel.depot.countedFull': 'Sayılan dolu (isteğe bağlı)',
  'panel.depot.countedEmptyOut': 'Sayılan verilen boş (isteğe bağlı)',
  'panel.depot.foreignTitle': 'Yabancı marka boş',
  'panel.depot.foreignBrand': 'Marka',
  'panel.depot.foreignAdd': 'Satır ekle',
  'panel.depot.foreignMax': 'En fazla 10 satır.',
  'panel.depot.invalidQty': 'Adet tam sayı olmalı.',
  'panel.depot.adjustmentLine': 'Depo farkı: {condition} {qty}',
  'panel.depot.reloadSaved': 'Ara yükleme kaydedildi.',
  'panel.depot.noActiveProducts': 'Aktif ürün yok. Önce ürün tanımlayın.',
  'panel.depot.tripNotReloadable': 'Sefer yolda değil',
  'panel.depot.vehicleNotReloadable':
    'Bu araç ara yükleme kabul etmiyor (sefer yolda değil). Başka araç seçin.',
  'panel.depot.movesTitle': 'Önceki sayımdan bu yana hareketler',
  'panel.depot.moveRow': '{plate} · {at} · {qty}',
  'panel.depot.noAdjustment': 'Sayılan adetler irsaliyeyle uyumlu; fark satırı yazılmadı.',
  'panel.depot.foreignReturned': 'Yabancı boş iade kaydı: {n}',
  'panel.depot.received': 'Sevkiyat teslim alındı.',
  // Bugün kartı ve akşam dolum yazma yüzü (STOK S3; sayılar sunucudan, panelde hesap yok)
  'panel.depot.todayTitle': 'Bugün',
  'panel.depot.todayDelivered': 'Teslim',
  'panel.depot.todayShortfall': 'Eksik boş',
  'panel.depot.todayPendingApprovals': 'Bekleyen onay',
  'panel.depot.todayOpenVariance': 'Açık fark',
  'panel.depot.loadTitle': 'Akşam dolum',
  'panel.depot.loadSuggested': 'Önerilen adet',
  'panel.depot.loadOnVehicleNote':
    'Öneri, araçtaki toplam doluyu (kapanışta dönen artan dahil) düşer.',
  'panel.depot.loadAction': 'Yükle',
  'panel.depot.loadSaved': 'Yükleme kaydedildi.',
  'panel.depot.loadNoTrip': 'Şoför seferi açmamış.',
  'panel.depot.loadNothing': 'Yüklenecek adet yok.',
  'panel.depot.loadScopeAllDays': 'Açık siparişler (tüm günler)',
  'panel.depot.loadCapped': 'Araç kapasitesi aşıldı; önerilen adet kesildi.',
  'panel.depot.loadRetry': 'Tekrar dene',
  'panel.depot.reloadOnRoadTitle': 'Ara yükleme (sefer yolda)',
  'panel.depot.reloadOnRoadSave': 'Ara yükleme kaydet',
  'depot.intro':
    'Depo günü: akşam depoyu sayıp araçlara ne yükleneceğini, sabah her aracın ihtiyacını ve gün içi yüklemeleri buradan yönetirsiniz.',
  'depot.stepHint1': 'Adım 1 — Depoyu sayın, beklenenden farkı görün, sonra araçlara yüklemeyi onaylayın.',
  'depot.stepHint2': 'Adım 2 — Her araca sabah kaç dolu damacana gerektiğini görün.',
  'depot.stepHint3': 'Adım 3 — Gün içinde araca ek damacana yükleyin ya da geri alın.',
  'approvals.intro':
    'Şoför ve sahadan gelen, kararınızı bekleyen işlemler. Her satırı onaylayın ya da gerekçesiyle reddedin.',
  'depot.stepHint4': 'Adım 4 — Fabrikadan gelen sevkiyatı teslim alıp depoya işleyin.',
  // Onay listesi ekranı (STOK S2)
  'panel.approvals.title': 'Onay bekleyenler',
  'panel.approvals.empty': 'Onay bekleyen kayıt yok.',
  'panel.approvals.colKind': 'Tür',
  'panel.approvals.colDetail': 'Ayrıntı',
  'panel.approvals.colRequestedAt': 'Talep',
  'panel.approvals.approve': 'Onayla',
  'panel.approvals.reject': 'Reddet',
  'panel.approvals.decided': 'Karar kaydedildi.',
  // Gölge atama (salt okunur karşılaştırma): panelin atadığı araç ↔ bizim bölge kuralı
  'panel.shadowAssign.title': 'Gölge atama',
  'panel.shadowAssign.subtitle':
    'Gölge görünüm panellere yazmaz. Kural tablosu değişince bekleyen siparişler yeniden dağıtılır.',
  'panel.shadowAssign.rateLine': 'Son {days} gün uyum {rate} ({agree}/{comparable})',
  'panel.shadowAssign.noRate': 'karşılaştırılabilir sipariş yok',
  'panel.shadowAssign.sourceHayat': 'Hayat',
  'panel.shadowAssign.sourceAbant': 'Abant',
  'panel.shadowAssign.window7': '7 gün',
  'panel.shadowAssign.window30': '30 gün',
  'panel.shadowAssign.rulesTitle': 'Bölge → araç kuralı',
  'panel.shadowAssign.rulesHint':
    'Varsayılan araç ve otomatik atama değişince sonraki eşleme yeni kurala göre yapılır.',
  'panel.shadowAssign.noRegions': 'Aktif bölge yok.',
  'panel.shadowAssign.noVehicle': 'Araç yok',
  'panel.shadowAssign.autoAssign': 'Otomatik ata',
  'panel.shadowAssign.ruleMatch': '{rate} ({agree}/{comparable})',
  'panel.shadowAssign.saved': '{name} kuralı kaydedildi',
  'panel.shadowAssign.savedRematch':
    '{name} kuralı kaydedildi; bekleyen {assigned} sipariş araca atandı.',
  'panel.shadowAssign.inactiveVehicle': '{plate} (pasif)',
  'panel.shadowAssign.saveError': '{name} kuralı kaydedilemedi',
  'panel.shadowAssign.mismatchTitle': 'Uyuşmayan siparişler (en yeni 50)',
  'panel.shadowAssign.noMismatch': 'Bu pencerede uyuşmayan sipariş yok.',
  'panel.shadowAssign.panelSide': 'Panel: {label}{who} → {plate}',
  'panel.shadowAssign.notMatched': 'eşleşmedi',
  'panel.shadowAssign.ourSide': 'Biz: {plate} ({via})',
  'panel.shadowAssign.orderLine': 'Panel: {label} · Biz: {plate} ({via})',
  'panel.shadowAssign.oursOnly': 'Biz: {plate} ({via})',
  'panel.shadowAssign.panelOnly': 'Panel: {label}',
  'panel.shadowAssign.dash': '—',
  // Kişi (şoför) bazlı görünüm — T4
  'panel.shadowAssign.panelSidePerson': 'Panel: {label} → {person}',
  'panel.shadowAssign.ourSidePerson': 'Biz (bölge): {person}',
  'panel.shadowAssign.agreeMatch': 'Uyuştu',
  'panel.shadowAssign.agreeDiff': 'Farklı',
  'panel.shadowAssign.personTableTitle': 'Panel uyumu (kişi bazında)',
  'panel.shadowAssign.personTableHint':
    'Panelin siparişi verdiği şoförün, bölge kuralımızla uyum oranı. Oran sunucudan gelir.',
  'panel.shadowAssign.colDriver': 'Şoför',
  'panel.shadowAssign.colPanelMatch': 'Panel uyumu 7g / 30g',
  'panel.shadowAssign.vehicleRate': 'Panel uyumu 7g: {rate}',
  'panel.shadowAssign.via.STREET_VEHICLE': 'Sokak kuralı',
  'panel.shadowAssign.via.STREET_REGION': 'Sokak → bölge',
  'panel.shadowAssign.via.NEIGHBORHOOD': 'Mahalle kuralı',
  'panel.shadowAssign.via.none': 'Kural yok',
  'panel.shadowAssign.loadError': 'Gölge atama verisi yüklenemedi.',

  // Alacak yaşlandırma (O3 — Cari sekmesi /aranacaklar)
  'aging.title': 'Yaşlandırma',
  'aging.subtitle': 'Bakiyesi pozitif olan müşteriler, en eski borçtan öne.',
  'aging.bucket.0_30': '0-30 gün',
  'aging.bucket.31_60': '31-60 gün',
  'aging.bucket.61_90': '61-90 gün',
  'aging.bucket.90p': '90+ gün',
  'aging.overdue90': '90+ gün aşımı var',
  'aging.callList': 'Aranacaklar',
  'aging.showAll': 'Tümünü göster',
  'aging.collapse': 'Listeyi topla',
  'aging.lastPaymentAt': 'Son tahsilat',
  'aging.neverCollected': 'Hiç tahsilat yok',
  'aging.colOldestDebt': 'En eski borç',
  'aging.oldestDays': '{n} gün',
  'aging.loadError': 'Yaşlandırma yüklenemedi.',

  // Ay sonu raporu (O4 — `GET /api/reports/monthly.pdf` + panel kartı)
  'monthlyReport.title': 'Ay Sonu Raporu',
  'monthlyReport.interim': 'Ay içi ara rapor',
  'monthlyReport.monthLabel': 'Dönem',
  'monthlyReport.issuedAt': 'Hazırlanma zamanı',
  'monthlyReport.sectionSummary': 'Özet',
  'monthlyReport.sectionChannels': 'Kanal bazlı',
  'monthlyReport.sectionProducts': 'Ürün bazlı',
  'monthlyReport.sectionDrivers': 'Personel',
  'monthlyReport.sectionCash': 'Kasa hareketleri özeti',
  'monthlyReport.sectionAging': 'Ay sonu alacak yaşlandırma',
  'monthlyReport.empty': 'Bu ay kayıt yok.',
  'monthlyReport.revenue': 'Ciro',
  'monthlyReport.deliveries': 'Teslimat adedi',
  'monthlyReport.jugs': 'Satılan damacana',
  'monthlyReport.empties': 'Toplanan boş',
  'monthlyReport.change': 'Önceki aya göre değişim',
  'monthlyReport.noChange': 'Önceki ay verisi yok',
  'monthlyReport.interimNoCompare': 'Ara rapor — ay bitmeden karşılaştırma yapılmaz.',
  'monthlyReport.productNote': 'Ürün cirosu sipariş tarihine, adet teslim gününe göredir.',
  'monthlyReport.colChannel': 'Kanal',
  'monthlyReport.colCount': 'Adet',
  'monthlyReport.colAmount': 'Tutar',
  'monthlyReport.colShare': 'Pay',
  'monthlyReport.colProduct': 'Ürün',
  'monthlyReport.colKind': 'Tür',
  'monthlyReport.colBucket': 'Dilim',
  'monthlyReport.colDirection': 'Yön',
  'monthlyReport.dirIn': 'Giren',
  'monthlyReport.dirOut': 'Çıkan',
  'monthlyReport.colQty': 'Adet',
  'monthlyReport.colDriver': 'Personel',
  'monthlyReport.colPlate': 'Plaka',
  'monthlyReport.colDeliveries': 'Teslimat',
  'monthlyReport.colCollected': 'Tahsilat',
  'monthlyReport.cashInflow': 'Kasaya giren',
  'monthlyReport.cashOutflow': 'Kasadan çıkan',
  'monthlyReport.cashNet': 'Fark',
  'monthlyReport.oldestDebtors': 'En eski 10 borçlu',
  'monthlyReport.colName': 'Ad',
  'monthlyReport.colBalance': 'Bakiye',
  'monthlyReport.colDays': 'Gün',
  'monthlyReport.page': 'Sayfa',
  'monthlyReport.download': 'Ay sonu raporu (PDF)',
  'monthlyReport.description': 'Kapanmış ayın ciro, kasa ve alacak özeti (PDF).',
  'monthlyReport.selectMonth': 'Rapor ayı',
  'monthlyReport.downloadFailed': 'Ay sonu raporu indirilemedi.',
  'monthlyReport.monthInvalid': 'Ay "YYYY-MM" biçiminde olmalı (ör. 2026-10).',
  'monthlyReport.futureMonth': 'Gelecek ay için rapor alınamaz.',

  // Gün tahtası (panel — siparişler araç sütunlarında, sürükle-bırak atama)
  'dayBoard.hint': 'Siparişi araç sütununa sürükleyin ya da kartta "Taşı" menüsünden araç seçin.',
  'dayBoard.unassigned': 'Atanmamış',
  'dayBoard.noVehicles': 'Aktif araç yok.',
  'dayBoard.noOrders': 'Sipariş yok',
  'dayBoard.itemCount': '{n} ürün',
  'dayBoard.selectFor': 'Siparişi seç: {name}',
  'dayBoard.moveFor': 'Taşı: {name}',
  'dayBoard.suggestion': 'Öneri: {plate}',
  'dayBoard.onRoute': 'Yolda: sürüklenemez, taşınamaz',
  'dayBoard.otherVehicles': 'Diğer araçlar',
  'dayBoard.dueOn': 'Teslim {date}',
  'dayBoard.truncated': '{shown} / {total} sipariş gösteriliyor — tamamı için Siparişler ekranı.',

  // Zimmet / depozito raporu (`GET /api/reports/deposits` + Raporlar kartı)
  'depositReport.title': 'Zimmet / depozito',
  'depositReport.subtitle': 'Müşteride duran damacanalar ve müşterilerden tahsil edilen depozito.',
  'depositReport.jugsOnHand': 'Zimmetteki damacana',
  'depositReport.depositHeld': 'Tahsil edilen depozito (toplam)',
  'depositReport.customers': 'Zimmetli müşteri',
  'depositReport.noJugs': 'Zimmet yok',
  'depositReport.panelNote':
    'Hayat/Abant panel siparişlerinde depozito tahsilatı bu rapora girmez; yalnız zimmet görünür.',
  'depositReport.colName': 'Müşteri',
  'depositReport.colJugs': 'Damacana',
  'depositReport.colDeposit': 'Depozito',
  'depositReport.colLastMove': 'Son hareket',
  'depositReport.colProduct': 'Ürün',
  'depositReport.byProductTitle': 'Ürüne göre zimmet',
  'depositReport.productNote': 'Depozito ürüne göre ayrılmaz; yalnız damacana adedi gösterilir.',
  'depositReport.customersTitle': 'Müşteriler',
  'depositReport.empty': 'Zimmetli müşteri yok.',
  'depositReport.loadError': 'Zimmet raporu yüklenemedi.',
  // Kasa sayımı / mutabakatı (çekmece sayımı → fark → tek ADJUSTMENT satırı)
  'cashCount.title': 'Kasa sayımı',
  'cashCount.hint': 'Çekmecedeki nakdi sayıp girin; defterdeki beklenen nakitle farkı görün.',
  'cashCount.counted': 'Sayılan nakit (₺)',
  'cashCount.preview': 'Önizle',
  'cashCount.expected': 'Defter nakdi',
  'cashCount.countedResult': 'Sayılan',
  'cashCount.variance': 'Fark',
  'cashCount.varianceZero': 'Fark yok, kayıt gerekmiyor.',
  'cashCount.note': 'Açıklama (fark varsa zorunlu)',
  'cashCount.save': 'Farkı deftere yaz',
  'cashCount.closingHintAdjusted': 'Giren + düzeltme − Çıkan',
  'cashCount.adjustment': 'Kasa sayımı düzeltmesi',
  'cashCount.saved': 'Kasa farkı deftere yazıldı.',
  'cashCount.savedZero': 'Sayım tuttu; sıfır farklı sayım kaydı deftere yazıldı.',
  'cashCount.reviewAgain': 'Tutar ya da defter değişti, yeniden önizleyin.',
  'cashCount.amountInvalid': 'Sayılan tutar geçersiz. Örnek: 1.240,50 (en çok ₺10.000.000).',
  'cashCount.noteRequired': 'Fark olduğunda açıklama yazmak zorunlu.',
  'cashCount.ledgerChanged': 'Sayımdan sonra kasa defteri değişti. Yeniden önizleyin.',
  'cashCount.retry': 'Kasa şu an başka bir işlemle çakıştı. Birkaç saniye sonra tekrar deneyin.',
  'cashCount.clientIdMismatch':
    'Bu sayım anahtarı farklı bir sayımla zaten kullanıldı. Yeniden önizleyin.',
  'cashCount.adjustmentNote': 'Kasa sayımı: sayılan {counted}, defter {expected}',
  'cashCount.openingNote': 'Kasa açılış sayımı: sayılan {counted}, defter {expected}',
  'cashCount.firstCountWarning':
    'Bu işletmedeki ilk sayım. Açılış sayımıysa işaretleyin; kaydettikten sonra bu seçim geri alınamaz ve bir daha açılış sayımı işaretlenemez.',
  'cashCount.openingCheckbox': 'Bu açılış sayımıdır',
  'cashCount.openingUsed':
    'Bu işletmede daha önce sayım yapılmış; açılış sayımı artık işaretlenemez.',
  'cashCount.matchedNote': 'Kasa sayımı: tutarlı, sayılan {counted}, defter {expected}',
  'cash.transfer': 'Transfer (çekim / yatırma)',
  'cash.closingHintTransfer': 'Giren + düzeltme + transfer − Çıkan',
  'cashTransfer.title': 'Kasadan çekim / Bankaya yatırma',
  'cashTransfer.hint': 'Çekmeceden çıkan para gider sayılmaz; ayrı transfer satırı olarak yazılır.',
  'cashTransfer.amount': 'Tutar (₺)',
  'cashTransfer.note': 'Not (isteğe bağlı)',
  'cashTransfer.save': 'Deftere yaz',
  'cashTransfer.saved': 'Transfer deftere yazıldı.',
  'cashTransfer.mismatch': 'Önceki işlem kaydedilmiş olabilir; hareket listesini kontrol edin.',
  'cashTransfer.sendAsNew': 'Yeni işlem olarak gönder',
  'cashTransfer.retry': 'Kasa şu an başka bir işlemle çakıştı. Birkaç saniye sonra tekrar deneyin.',
  'monthlyReport.dirAdjustment': 'Düzeltme',
  'monthlyReport.dirTransfer': 'Transfer',
  'monthlyReport.cashAdjustment': 'Kasa sayımı düzeltmesi',
  'monthlyReport.cashTransfer': 'Çekim / yatırma',
  // Patron "Günü gördüm" alındısı (day-close).
  'dayClose.futureDay': 'Gelecekteki bir gün için alındı verilemez.',
  'dayClose.tooOld': 'En fazla 60 gün öncesine kadar alındı verilebilir.',
  'dayClose.noteTooLong': 'Not en fazla 280 karakter olabilir.',
  'dayClose.invalidDay': 'Gün YYYY-AA-GG biçiminde geçerli bir tarih olmalı.',
  'dayClose.title': 'Günü gördüm',
  'dayClose.today': 'Bugün',
  'dayClose.yesterday': 'Dün',
  'dayClose.notSeen': 'Henüz görülmedi',
  'dayClose.seen': 'Patron gördü · {time}',
  'dayClose.seenBy': 'Gören: {name}',
  'dayClose.button': 'Günü gördüm',
  'dayClose.saving': 'Kaydediliyor…',
  'dayClose.noteLabel': 'Not (isteğe bağlı)',
  'dayClose.notePlaceholder': 'Müşteri bilgisi yazmayın',
  'dayClose.noteHint': 'Müşteri bilgisi yazmayın.',
  'dayClose.changedTrips': '{n} sefer kapanışı',
  'dayClose.changedCash': '{n} kasa teslimi',
  'dayClose.changedDeliveries': '{n} teslimat',
  'dayClose.changedVoided': '{n} iptal',
  'dayClose.alreadySeen':
    'Bu gün zaten {name} tarafından {time} saatinde görüldü; notunuz kaydedilmedi.',
  'dayClose.changedBadge': 'İmza sonrası: {parts}',
  'dayClose.loadError': 'Gün durumu yüklenemedi.',
  'dayClose.saveError': 'Alındı kaydedilemedi.',
  // ── BA2: sipariş → bölge eşleşme güveni ──
  'regionMatch.EXACT': 'Kesin',
  'regionMatch.ESTIMATED': 'Tahmini',
  'regionMatch.NONE': 'Bölge bulunamadı',
  'regionMatch.hint.EXACT': 'Bölge sokak kuralından ya da adres ile konumun uyuşmasından bulundu.',
  'regionMatch.hint.ESTIMATED': 'Bölge doğrulanmadı; adres metninden ya da konumdan çıkarıldı.',
  'regionMatch.hint.NONE': 'Bölge bulunamadı; elle atanmalı.',
  'regionMatch.by.STREET': 'Sokak kuralı',
  'regionMatch.by.TEXT': 'Adres metni',
  'regionMatch.by.COORDINATE': 'Konum',
  'orderEvent.REGION_MATCHED': 'Bölge eşleşti',
  // --- Y0: kanala geri yazma (ADR 2026-10-30; yalnız bu bölüme yaz) ---
  'channelWrite.state.none': 'Yazılacak bir şey yok',
  'channelWrite.state.pending': 'Kanala yazılması bekleniyor',
  'channelWrite.state.awaiting_approval': 'Patron onayı bekliyor',
  'channelWrite.state.written': 'Kanala yazıldı',
  'channelWrite.state.failed': 'Kanala yazılamadı',
  'channelWrite.state.disabled': 'Kanala yazma kapalı',
  'channelWrite.source.HAYAT_PANEL': 'Hayat',
  'channelWrite.source.ABANT_PANEL': 'Abant',
  'channelWrite.source.GETIR_SU': 'Getir',
  'channelWrite.error.writer-not-configured': 'Bu kanal için yazıcı henüz bağlı değil.',
  'channelWrite.error.writer-disabled': 'Bu kanala yazma yetkisi kapalı.',
  'channelWrite.error.scraper-disabled': 'Kanal çekimi durdurulduğu için yazma da durdu.',
  'channelWrite.error.tenant-restricted': 'Hesap askıda; yalnız açık işi kapatan eylemler yazılır.',
  'channelWrite.error.unknown-action': 'Eylem tanınmadı.',
  'channelWrite.error.session-not-ready': 'Kanal oturumu hazır değil; oturum gelince yazılır.',
  'channelWrite.error.session-rejected': 'Kanal oturumu reddedildi; yeniden bağlanmak gerekir.',
  'channelWrite.error.external-ahead': 'Kanalda durum bizden ileride; geri sarılmaz.',
  'channelWrite.error.already-done': 'Kanalda zaten yapılmış.',
  'channelWrite.error.last-attempt-uncertain': 'Son deneme belirsiz kaldı; elle kontrol edin.',
  'channelWrite.error.retry-limit': 'Deneme sınırı doldu; elle yeniden denenebilir.',
  'channelWrite.error.writer-threw': 'Yazıcı beklenmedik hata verdi.',
  'channelWrite.error.writer-failed': 'Kanal isteği kabul etmedi.',
  'channelWrite.error.employee-mapping-missing':
    'Şoförün kanal çalışan numarası eşleşmiyor; atama yapılamadı.',
  'channelWrite.error.send-not-done':
    'Sipariş kanala "yolda" olarak bildirilmeden teslim bildirilemez.',
  'channelWrite.error.payment-type-missing':
    'Siparişin ödeme tipi bilinmiyor; durum yazılamadı.',
  'channelWrite.error.order-not-found': 'Sipariş kanalda bulunamadı; yazma yapılmadı.',
  'channelWrite.error.external-id-invalid': 'Sipariş numarası geçersiz; yazma yapılmadı.',
  'channelWrite.error.live-access-blocked': 'Canlı panel erişimi kapalı; yazma yapılmadı.',
  'channelWrite.error.no-open-trip': 'Aracın açık seferi yok; sefer açılınca yazılır.',
  'channelWrite.error.expired-day-end': 'Gün bitti, sefer açılmadığı için yazılmadı.',
  'channelWrite.error.expired-stale': 'Yedi günden eski bekleyen iş süresi doldu, yazılmadı.',
  'hayatPush.error.actionMismatch':
    'Onay bekleyen iş ekrandakinden farklı; sayfayı yenileyip tekrar deneyin.',
  'channelWrite.error.needs-send-first':
    'Önce siparişin araca iletilmesi gerekir; sonra teslim yazılır.',
  // Y3 (Getir): kurye eşlemesi yok — bekler, hata değil.
  'channelWrite.error.courier-unmapped':
    'Şoförün Getir kurye eşlemesi yok; eşleme girilince yazılır.',
  'channelWrite.getir.connectionMissing':
    'Getir bağlantısı bulunamadı. Önce Getir panelini tanımlayıp oturumu bağlayın.',
  'channelWrite.getir.sessionRequired':
    'Getir oturumu bağlı değil ya da süresi dolmuş. Panelden yenileyin.',
  'channelWrite.getir.sessionRejected':
    'Getir oturumu reddetti. Panelden yeniden giriş yapın.',
  'channelWrite.getir.readFailed': 'Getir kurye listesi okunamadı.',
  'channelWrite.getir.noVendor': 'Getir mağaza kimliği bulunamadı.',
  'channelWrite.getir.onlyGetir': 'Bu uç yalnız Getir bağlantısı için geçerlidir.',
  'channelWrite.approval.title': '{source} kanalına yazılacak: {action}',
  'channelWrite.approval.detail': 'Hedef: {label}',
  'channelWrite.approval.detailNoLabel': 'Hedef etiketi yok',
  'tenant.flags.writeConflict':
    'Hayat için eski yazma bayrağı (hayatWriterEnabled) ile yeni yazma bayrağı (writeHayat) aynı anda açılamaz.',
  'channelWrite.notFound': 'Yazma işi bulunamadı.',
  'channelWrite.notAwaitingApproval': 'Bu iş onay beklemiyor.',
  'channelWrite.notCancellable': 'Bu iş artık iptal edilemez.',
  'channelWrite.alert.sessionRejectedTitle': '{source} oturumu reddedildi; yazma durdu',
  'channelWrite.alert.sessionRejectedBody': 'Oturumu yeniden bağlayınca bekleyen işler devam eder.',
  'channelWrite.alert.stoppedTitle': '{source} yazması durdu: {action}',
  'channelWrite.alert.stoppedBody': 'Sebep: {reason} Kanalda siparişi kontrol edin.',
  'channelWrite.alert.blockedTitle': '{source} yazması engellendi: {action}',
  'channelWrite.alert.blockedBody': 'Sebep: {reason} Engel kalkınca iş devam eder.',
  'channelWrite.alert.expiredTitle': '{source} yazmasının süresi doldu: {action}',
  'channelWrite.alert.expiredBody': 'Sebep: {reason} İş yazılmadı.',
  'notification.dailyReport.channelWriteLine':
    'Kanala yazma: {written} yazıldı · {waiting} bekliyor · {failed} durdu/engellendi · {expired} süresi doldu',
  // ── Luca e-Fatura/e-İrsaliye salt okuma (ADR 2026-10-31) ──
  'luca.consentNote':
    'Hesap sahibi, Luca web portalına salt okuma erişimine panelden açık onay verdi.',
  'luca.err.identificationInvalid': 'T.C. kimlik numarası 11 haneli olmalı.',
  'luca.err.passwordInvalid': 'Parola boş olamaz ve 200 karakteri geçemez.',
  'luca.err.consentRequired':
    'Devam etmek için hesap sahibi olduğunu ve erişime onay verdiğini işaretlemelisin.',
  'luca.err.rangeInvalid': 'Tarih aralığı geçersiz ya da 93 günden uzun.',
  'luca.err.disabled': 'Luca okuması kapalı. Önce Luca anahtarını aç.',
  'luca.err.notActive': 'Luca bağlantısı etkin değil. Önce bağlantıyı etkinleştir.',
  'luca.err.linkTargetNotFound': 'İrsaliye ya da sevkiyat kaydı bulunamadı.',
  'luca.err.linkConflict':
    'Bu sevkiyatın irsaliye numarası başka bir Luca belgesiyle eşleşiyor; eşleme yapılamaz.',
  'luca.err.linkExists': 'Bu sevkiyat zaten bir irsaliyeye bağlı. Önce mevcut bağı kaldır.',
  'luca.err.linkNotFound': 'Eşleme bulunamadı.',
  'luca.title': 'Luca',
  'luca.subtitle':
    'Luca web portalından e-İrsaliye ve e-Arşiv belgelerini salt okuma ile çeker; stok kayıtlarıyla karşılaştırır.',
  'luca.connection.title': 'Bağlantı',
  'luca.connection.connected': 'Bağlı',
  'luca.connection.notConnected': 'Bağlı değil',
  'luca.connection.status.PENDING': 'Etkinleştirme bekliyor',
  'luca.connection.status.ACTIVE': 'Etkin',
  'luca.connection.status.ERROR': 'Hata — yeniden etkinleştir',
  'luca.connection.status.DISABLED': 'Kapalı',
  'luca.connection.lastSuccess': 'Son başarılı çekim',
  'luca.connection.never': 'Henüz çekim yok',
  'luca.connection.coldTest': 'Canlı erişim kapalı olduğu için etkinleştirme yapılamıyor.',
  'luca.form.identification': 'T.C. kimlik no',
  'luca.form.password': 'Luca parolası',
  'luca.form.companyId': 'Firma no (birden çok firma varsa)',
  'luca.form.consent':
    'Bu Luca web portalı hesabının sahibiyim ve salt okuma erişimine açıkça onay veriyorum.',
  'luca.form.save': 'Kimliği kaydet',
  'luca.form.saved': 'Kimlik kaydedildi. Şimdi etkinleştir.',
  'luca.form.hint':
    'Kimlik şifreli saklanır ve bir daha gösterilmez. Her çekimde web portalına yeniden giriş yapılır. Yalnız patron girebilir.',
  'luca.action.activate': 'Etkinleştir',
  'luca.action.disconnect': 'Bağlantıyı kes ve kimliği sil',
  'luca.action.disconnectConfirm': 'Bağlantı kesilecek ve kayıtlı kimlik silinecek. Emin misin?',
  'luca.action.sync': 'Şimdi çek',
  'luca.action.synced': 'Çekim tamamlandı: {n} belge.',
  'luca.action.enable': 'Luca okumasını aç',
  'luca.action.disable': 'Luca okumasını kapat',
  'luca.enabled': 'Okuma açık',
  'luca.disabledFlag': 'Okuma kapalı',
  'luca.truncated': 'Belge sayısı üst sınıra ulaştı; pencere eksik olabilir.',
  'luca.error.generic': 'Luca ile iletişimde bir hata oluştu.',
  'luca.error.LUCA_LOGIN_FAILED': 'Luca girişi reddedildi. Kimliği kontrol edip yeniden kaydet.',
  'luca.error.loginHttp': 'Luca girişi reddedildi (HTTP {status})',
  'luca.error.loginForm': 'Luca giriş formu kabul edilmedi; kimlik ya da parola hatalı olabilir.',
  'luca.error.loginCaptcha':
    'Luca web portalında doğrulama kodu istendi. Elle giriş yapılmalı.',
  'luca.error.LUCA_SESSION_REJECTED': 'Luca oturumu reddedildi.',
  'luca.error.LUCA_HTTP_ERROR': 'Luca sunucusu hata verdi.',
  'luca.error.LUCA_BAD_RESPONSE': 'Luca yanıtı beklenen biçimde değil.',
  'luca.error.LUCA_NETWORK': 'Luca sunucusuna ulaşılamadı.',
  'luca.error.LUCA_PAGING_LOOP': 'Luca sayfalaması tutarsız; çekim iptal edildi.',
  'luca.error.LUCA_COMPANY_AMBIGUOUS': 'Birden çok firma var; firma no gir.',
  'luca.error.LUCA_COMPANY_NOT_FOUND': 'Girilen firma Luca hesabında bulunamadı.',
  'luca.error.LUCA_CREDENTIALS_UNREADABLE': 'Kayıtlı kimlik çözülemedi; yeniden kaydet.',
  'luca.error.LUCA_STORE_FAILED': 'Luca belgeleri kaydedilemedi.',
  'luca.error.LUCA_CREDENTIALS_EXPIRED': 'Bağlantı uzun süre kullanılmadığı için kayıtlı kimlik silindi. Gerekirse yeniden kaydet.',
  'luca.docs.hasMore': 'Yalnız ilk {n} belge gösteriliyor; tarih aralığını daralt.',
  'luca.error.LUCA_ENDPOINT_FORBIDDEN': 'İzin verilmeyen Luca adresi engellendi.',
  'luca.error.LUCA_TRUNCATED': 'Belge sayısı üst sınıra ulaştı; pencere eksik olabilir.',
  'luca.tab.documents': 'Belgeler',
  'luca.tab.reconciliation': 'Mutabakat',
  'luca.range.from': 'Başlangıç',
  'luca.range.to': 'Bitiş',
  'luca.range.apply': 'Göster',
  'luca.kind.DESPATCH_IN': 'Gelen e-irsaliye',
  'luca.kind.EARCHIVE_OUT': 'Giden e-arşiv',
  'luca.kind.all': 'Tümü',
  'luca.docs.empty': 'Bu aralıkta belge yok.',
  'luca.docs.col.kind': 'Tür',
  'luca.docs.col.number': 'Belge no',
  'luca.docs.col.day': 'Tarih',
  'luca.docs.col.amount': 'Tutar',
  'luca.docs.col.status': 'Durum',
  'luca.recon.despatch': 'İrsaliye – sevkiyat',
  'luca.recon.matched': 'Eşleşen',
  'luca.recon.lucaOnly': "Yalnız Luca'da",
  'luca.recon.oursOnly': 'Yalnız bizde',
  'luca.recon.conflicts': 'Çakışma',
  'luca.recon.candidates': 'Aday sevkiyatlar',
  'luca.recon.noCandidates': 'Aday yok',
  'luca.recon.via.AUTO': 'Numara eşleşmesi',
  'luca.recon.via.LINK': 'Onaylı bağ',
  'luca.recon.conflict.DUPLICATE_NUMBER': 'Aynı numara birden çok Luca belgesinde',
  'luca.recon.conflict.LINK_MISMATCH': 'Onaylı bağ numara eşleşmesiyle çelişiyor',
  'luca.recon.link': 'Bağla',
  'luca.recon.unlink': 'Bağı kaldır',
  'luca.recon.linked': 'Bağ kaydedildi.',
  'luca.recon.waybill': 'İrsaliye no',
  'luca.recon.qty': 'Dolu adet',
  'luca.recon.noWaybill': 'irsaliye no yok',
  'luca.recon.archive': 'e-Arşiv – teslimat (yan yana, hüküm yok)',
  'luca.recon.archiveNote':
    'Tutarlar KDV ve depozito kapsamı bakımından birebir karşılaştırılamaz.',
  'luca.recon.col.day': 'Gün',
  'luca.recon.col.lucaCount': 'Luca belge',
  'luca.recon.col.lucaCancelled': 'Luca iptal',
  'luca.recon.col.lucaTotal': 'Luca tutar',
  'luca.recon.col.ourCount': 'Teslimat',
  'luca.recon.col.ourTotal': 'Teslimat tutarı',
  'luca.recon.col.ourDeposit': 'Depozito',
  'luca.recon.col.ourJugs': 'Damacana',
  'luca.recon.empty': 'Bu aralıkta kayıt yok.',
  // ── Onaylar ekranı (panel): bekleyen bütün kalemler tek listede ──
  'panel.approvals.nav': 'Onaylar',
  'panel.approvals.filterLabel': 'Tür',
  'panel.approvals.filterAll': 'Tümü',
  'panel.approvals.colCustomer': 'Müşteri',
  'panel.approvals.colPlate': 'Plaka',
  'panel.approvals.colActions': 'Eylemler',
  'panel.approvals.rejectConfirm': 'Reddi kaydet',
  'panel.approvals.rejectReason': 'Reddetme gerekçesi',
  'panel.approvals.rejectReasonShort': 'Gerekçe en az {n} karakter olmalı.',
  'panel.approvals.goToOrder': 'Siparişe git',
  'panel.approvals.emptyHint':
    'Şu an onay bekleyen kalem yok; yeni bir talep geldiğinde burada görünecek.',
  'panel.approvals.loadError': 'Onaylar yüklenemedi.',
  'panel.approvals.retry': 'Tekrar dene',
  'panel.approvals.decisionError': 'Karar kaydedilemedi.',
  'panel.approvals.unknown': '—',
  'panel.approvals.morePending': '{count} kalem daha var',
  'panel.approvals.noDecisionEndpoint': 'Bu tür için karar ucu yok',
  'panel.approvals.noDecisionEndpointForItem': 'Bu kalem için karar ucu yok',
  // Duruş denetimi: onay "incelendi", ret "şüphe doğru" demektir — genel Onayla/Reddet
  // etiketleri bu türde anlamı taşımaz.
  'panel.approvals.tripAudit.approve': 'İncelendi',
  'panel.approvals.tripAudit.reject': 'Şüphe doğru',
  'panel.approvals.tripAudit.confirm': 'Şüpheyi doğrula',
  'panel.approvals.tripAudit.rejectReason': 'Şüphe gerekçesi',
  'panel.approvals.kind.RELOAD': 'Ara yükleme',
  'panel.approvals.kind.CASH_HANDOVER': 'Nakit teslimi',
  'panel.approvals.kind.STOCK_CORRECTION': 'Stok düzeltmesi',
  'panel.approvals.kind.MORNING_LOAD': 'Sabah yüklemesi',
  'panel.approvals.kind.ORDER_TRANSFER': 'Sipariş devri',
  'panel.approvals.kind.DELIVERY_DEVIATION': 'Teslimat sapması',
  'panel.approvals.kind.TRIP_AUDIT': 'Duruş denetimi',
  // UX-A: sipariş listesi tek satır araç / durum
  'orders.vehicleLabel.region': 'Bölge: {name}',
  'orders.vehicleLabel.unmapped': 'Personel eşlenmemiş',
  'orders.vehicleLabel.mapHint': 'Panel Atama’dan eşle',
  'orders.status.NEW': 'Yeni',
  'orders.status.PREPARING': 'Hazırlanıyor',
  'orders.status.ON_ROUTE': 'Yolda',
  'orders.status.DELIVERED': 'Teslim Edildi',
  'orders.status.CANCELLED': 'İptal',
  'orders.status.ON_HOLD': 'Beklemede',
  'orders.status.channelNote': '{brand}: {text}',
  'orders.shadow.differs': 'Bölge kuralı: {ours}',
  'orders.channel.viaPanel': '{brand} paneli',
  'orders.unclaim.event': 'Şoför Hayat siparişini geri bıraktı',
  'orders.unclaim.notAllowed': 'Sipariş artık geri bırakılamaz.',
  'fleet.tripOpen': 'Sefer açık',
  'fleet.tripClosed': 'Sefer kapandı',
  'fleet.tripNone': 'Bugün sefer yok',
  'fleet.todayDeliveries': 'Bugün {n} teslimat',
  'fleet.details': 'Ayrıntılar',
  'panelAssign.intro': 'Panelden gelen siparişin hangi personele yazılacağını belirler.',
  'panelAssign.sectionAbantTable': 'Abant çalışan no → Personel (plaka)',
  'panelAssign.sectionHayatTable': 'Hayat bölge → Araç',
  'panelAssign.ordersCollapsed': 'Bekleyen siparişler ({n})',
  // ── Sokak yanı / kapı no aralığı (ADR 2026-11-01-sokak-yani-bolge) ──
  'regions.split.action': 'Böl',
  'regions.split.title': 'Sokağı böl',
  'regions.split.sideLabel': 'Taraf',
  'regions.split.side.ALL': 'Tümü',
  'regions.split.side.ODD': 'Tek',
  'regions.split.side.EVEN': 'Çift',
  'regions.split.fromLabel': 'Kapı no (başlangıç)',
  'regions.split.toLabel': 'Kapı no (bitiş)',
  'regions.split.rangeHint': 'Boş bırakılan uç sınırsızdır.',
  'regions.split.targetLabel': 'Hedef',
  'regions.split.save': 'Parçayı kaydet',
  'regions.split.cancel': 'Vazgeç',
  'regions.split.close': 'Kapat',
  'regions.split.parts': 'Parçalar',
  'regions.split.errNumber': 'Kapı numarası 1 ile 9999 arasında bir sayı olmalı.',
  'regions.split.errOrder': 'Başlangıç kapı numarası bitişten büyük olamaz.',
  'regions.split.errNeedsRange': 'Tümü seçiliyken bir kapı numarası aralığı girmelisin.',
  'regions.split.errConflict':
    'Bu sokakta aynı taraf ve kapı numarası aralığını kapsayan başka bir parça var. Önce onu kapat.',
  'regions.split.errSave': 'Parça kaydedilemedi. Tekrar dene.',
  'regions.split.errClose': 'Parça kapatılamadı. Tekrar dene.',
  'regions.split.mapWarning':
    'Bu sokak bölünmüş ({names}). Haritadan atama yalnız tüm sokak satırını yazar; yan ve kapı numarası parçaları ayrı kalır; kaldırma da yalnız tüm sokak satırını kapatır, parçaları alt satırlardan kapat.',
  'regions.split.hoverTag': 'bölünmüş',
  // Giriş kolaylığı (ilk cihaz otomatik onay, 01.11.2026)
  'auth.phoneNotFound':
    'Bu numara kayıtlı değil. Patronundan telefon numaranı Personel ekranına kaydetmesini iste.',
  'mobile.auth.phoneNotFound':
    'Bu numara kayıtlı değil. Patronundan telefon numaranı Personel ekranına kaydetmesini iste.',
  'device.autoApprovedTitle': 'Yeni telefonla giriş yapıldı',
  'device.autoApprovedBody':
    '{name} yeni telefonla giriş yaptı. Tanımıyorsan Personel › Cihazlar ekranından iptal et; sonraki telefonlar onayına düşer.',
  'personnel.deviceAutoApproved': 'otomatik',
  'auth.deviceBoundToOther':
    'Bu telefon başka bir personele bağlı. Patron panelden değiştirebilir.',
  'mobile.auth.deviceBoundToOther':
    'Bu telefon başka bir personele bağlı; patron panelden değiştirebilir.',
} as const;
